import React, { useState, useRef, useEffect, Fragment as Fragment$1, createContext, PureComponent, useCallback } from 'react';
import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { NavLink, useNavigate, Routes, Route } from 'react-router-dom';
import { useSelector, useDispatch, batch, connect, Provider } from 'react-redux';
import { useTheme, ThemeProvider } from 'emotion-theming';
import styled from '@emotion/styled';
import { Global, css, keyframes } from '@emotion/core';
import dayjs from 'dayjs';
import isYesterday from 'dayjs/plugin/isYesterday';
import isToday from 'dayjs/plugin/isToday';
import { curry, isEqual, head, compose as compose$1, toPairs, values, isString, clamp, find, identity } from 'lodash/fp';
import { throttle } from 'lodash';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimesCircle, faCheckCircle, faThumbsUp, faFrown } from '@fortawesome/free-regular-svg-icons';
import { faChevronDown, faChevronUp, faExclamationCircle, faCheck, faLock, faFire, faBurn, faSnowflake, faCaretUp, faCaretDown, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import 'normalize.css';
import isPropValid from '@emotion/is-prop-valid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactSVG } from 'react-svg';
import axios from 'axios';
import { camelizeKeys } from 'humps';
import AnimateHeight from 'react-animate-height';
import { CircularProgressbar } from 'react-circular-progressbar';
import { DFPSlotsProvider } from 'react-dfp';
import 'sanitize-html';
import { css as css$1 } from '@emotion/core/';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var strings = {
  'global/loading/text': {
    en: 'Warm up in progress...',
    fr: 'Période de réchauffement...'
  },
  'global/legalText': {
    en: "<div style='text-align: center'>D\xC9FI DE HOCKEY DE LA LNH<sup style='font-size: 6px; top: -0.5em'>MD</sup>  DE TIM HORTONS<sup style='font-size: 6px; top: -0.5em'>\xAE</sup> \u2013 D\xC9FI DE LA SAISON R\xC9GULI\xC8RE 2025-2026</div><div style='text-align: center'>R\xC8GLEMENT ABR\xC9G\xC9 DU D\xC9FI</div> </br><p style='text-align: center; margin-top: 0'>AUCUN ACHAT REQUIS. Seuls les r\xE9sidents autoris\xE9s du Canada \xE2g\xE9s de 13 ans ou plus (14 ans ou plus au Qu\xE9bec) peuvent participer. Du 7 octobre 2025 \xE0 5 h (HE) jusqu\u2019\xE0 l\u2019heure (HE) de d\xE9but pr\xE9vue de la derni\xE8re partie de hockey de la LNHMD de la derni\xE8re journ\xE9e de la saison r\xE9guli\xE8re 2025-2026 de la LNHMD. Le d\xE9fi est divis\xE9 en 6 p\xE9riodes mensuelles. Chaque p\xE9riode mensuelle est constitu\xE9e de 3 \xE0 6 semaines, et chaque semaine est constitu\xE9e de p\xE9riodes quotidiennes de d\xE9fi. Chaque participant peut s\xE9lectionner jusqu\u2019\xE0 trois joueurs pour chaque p\xE9riode quotidienne de d\xE9fi. Pendant une p\xE9riode quotidienne de d\xE9fi (les r\xE9sultats suivants sont chacun un prix de semaine des points et sont mutuellement exclusifs) : (i) si 1 choix standard marque au moins 1 but, le participant sera admissible \xE0 recevoir 25 points Fid\xE9liTimMC; (ii) si 2 choix standards marquent chacun au moins 1 but, le participant sera admissible \xE0 recevoir 50 points Fid\xE9liTimMC; ou (iii) si les 3 choix standards marquent chacun au moins 1 but, le participant sera admissible \xE0 recevoir 100 points Fid\xE9liTimMC. La VAD de chaque prix en points Fid\xE9liTimMC d\xE9pend des r\xE9compenses obtenues \xE0 l\u2019aide des points Fid\xE9liTimMC, et variera en fonction du niveau de r\xE9compenses du gagnant et des choix de r\xE9compenses en vigueur au moment de l\u2019\xE9change (par exemple, au moment de publier les pr\xE9sents R\xE8glements abr\xE9g\xE9s, conform\xE9ment aux modalit\xE9s du programme en vigueur \xE0 partir du 21 f\xE9vrier 2023, 400 points pourraient \xEAtre \xE9chang\xE9s par un membre inscrit \xE0 Fid\xE9liTimMC participant pour un th\xE9, un caf\xE9 infus\xE9, un beigne de r\xEAveMC, un bagel ou une p\xE2tisserie admissible [VAD de 1,46 $ \xE0 3,99 $ CA chacun], selon la moyenne des prix du menu en Ontario, taxes en sus). Pendant la p\xE9riode du d\xE9fi, si, pour 7 p\xE9riodes quotidiennes de d\xE9fi cons\xE9cutives, 1 ou plusieurs choix standards marquent au moins 1 but pendant une partie ayant lieu lors de ces p\xE9riodes quotidiennes de d\xE9fi cons\xE9cutives, le participant sera admissible \xE0 recevoir un prix de victoires cons\xE9cutives de \xAB caf\xE9 gratuit pendant une semaine \xBB (permettant d\u2019obtenir un caf\xE9 chaud infus\xE9 ou un th\xE9 de n\u2019importe quel format par jour pendant une p\xE9riode de 7 jours cons\xE9cutifs), d\u2019une VAD de 10,22 $ \xE0 27,23 $ CA (selon le format choisi) chacun. La VAD de chaque prix de victoires cons\xE9cutives est bas\xE9e sur la moyenne des prix du menu en Ontario (taxes en sus). Chaque prix de victoires cons\xE9cutives expire sept (7) jours apr\xE8s la date o\xF9 il a \xE9t\xE9 ajout\xE9 au compte Fid\xE9liTimMC applicable du gagnant et doit \xEAtre d\u2019abord activ\xE9 avant de pouvoir \xEAtre r\xE9clam\xE9. Durant la p\xE9riode du d\xE9fi, les prix suivants sont offerts selon le nombre de points de classement mensuels obtenus par les participants : (a) 6 prix de 1re place mensuels (1 prix de 1re place mensuel par p\xE9riode mensuelle), chacun consistant en un ensemble de prix comprenant : (i) une carte-cadeau SkipTheDishes de 400 $ CA; (ii) une carte-cadeau Canadian Tire de 400 $ CA; (iii) une carte-cadeau Sports Experts de 400 $ CA; (iv) une carte-cadeau EssoMC de 400 $ CA; et (v) une Carte-cadeau TimMD de 400 $ CA (VAD totale de 2 000 $ CA chacun); (b) 6 prix de 2e place mensuels (1 prix de 2e place mensuel par p\xE9riode mensuelle), chacun consistant en un ensemble de prix comprenant : (i) une carte-cadeau SkipTheDishes de 250 $ CA; (ii) une carte-cadeau Canadian Tire de 250 $ CA; (iii) une carte-cadeau Sports Experts de 250 $ CA; (iv) une carte-cadeau EssoMC de 250 $ CA; et (v) une Carte-cadeau TimMD de 250 $ CA (VAD totale de 1 250 $ CA chacun); (c) 6 prix de 3e place mensuels (1 prix de 3e place mensuel par p\xE9riode mensuelle), chacun consistant en un ensemble de prix comprenant : (i) une carte-cadeau SkipTheDishes de 200 $ CA; (ii) une carte-cadeau Canadian Tire de 200 $ CA; (iii) une carte-cadeau Sports Experts de 200 $ CA; (iv) une carte-cadeau EssoMC de 200 $ CA; et (v) une Carte-cadeau TimMD de 200 $ CA (VAD totale de 1 000 $ CA chacun); (d) 6 prix de 4e place mensuels (1 prix de 4e place mensuel par p\xE9riode mensuelle), chacun consistant en un ensemble de prix comprenant : (i) une carte-cadeau SkipTheDishes de 150 $ CA; (ii) une carte-cadeau Canadian Tire de 150 $ CA; (iii) une carte-cadeau Sports Experts de 150 $ CA; (iv) une carte-cadeau EssoMC de 150 $ CA; et (v) une Carte-cadeau TimMD de 150 $ CA (VAD totale de 750 $ CA chacun); et (e) 6 prix de 5e place mensuels (1 prix de 5e place mensuel par p\xE9riode mensuelle), chacun consistant en un ensemble de prix comprenant : (i) une carte-cadeau SkipTheDishes de 100 $ CA; (ii) une carte-cadeau Canadian Tire de 100 $ CA; (iii) une carte-cadeau Sports Experts de 100 $ CA; (iv) une carte-cadeau EssoMC de 100 $ CA; et (v) une Carte-cadeau TimMD de 100 $ CA (VAD totale de 500 $ CA chacun). Durant la p\xE9riode du d\xE9fi, les 5 grands prix suivants sont offerts selon le nombre de points de classement obtenu durant toute la saison r\xE9guli\xE8re par les participants : (a) 1 grand prix de 1re place, consistant en un nouveau v\xE9hicule Tucson de Hyundai (VAD totale de 35 000 $ CA); (b) 1 grand prix de 2e place, consistant en : (i) une carte-cadeau de 100 $ CA de la boutique de la LNHMD; et (ii) une Carte-cadeau TimMD de 800 $ CA (VAD totale de 900 $ CA); (c) 1 grand prix de 3e place, consistant en : (i) une carte-cadeau de 100 $ CA de la boutique de la LNHMD; et (ii) une Carte-cadeau TimMD de 500 $ CA (VAD totale de 600 $ CA); (d) 1 grand prix de 4e place, consistant en : (i) une carte-cadeau de 100 $ CA de la boutique de la LNHMD; et (ii) une Carte-cadeau TimMD de 250 $ CA (VAD totale de 350 $ CA); et (e) 1 grand prix de 5e place, consistant en : (i) une carte-cadeau de 100 $ CA de la boutique de la LNHMD; et (ii) une Carte-cadeau TimMD de 150 $ CA (VAD totale de 250 $ CA). Les chances de gagner un prix de semaine des points, un prix de semaine des offres ou un prix de victoires cons\xE9cutives varieront tout au long de la p\xE9riode du d\xE9fi, et d\xE9pendront de la s\xE9lection de joueurs standards offerte, de leur allocation respective \xE0 un groupe de s\xE9lection (telle que d\xE9termin\xE9e par le commanditaire, \xE0 sa discr\xE9tion exclusive), du moment auquel le participant s\xE9lectionne des joueurs et des joueurs qu\u2019il s\xE9lectionne ainsi que du nombre de buts admissibles marqu\xE9s par les joueurs s\xE9lectionn\xE9s durant la ou les p\xE9riodes quotidiennes de d\xE9fi admissibles. Les chances de gagner un prix mensuel d\xE9pendront du nombre de participants et du nombre de points de classement mensuel obtenus par le participant pendant la p\xE9riode mensuelle applicable. Les chances de gagner un grand prix d\xE9pendront du nombre de participants et du nombre de points de classement de la saison compl\xE8te obtenus par le participant pendant la p\xE9riode du d\xE9fi. Les prix sont assujettis aux modalit\xE9s de toute offre applicable et \xE0 celles du programme Fid\xE9liTimMC, le cas \xE9ch\xE9ant. Maximum d\u2019un (1) prix de points ou prix d\u2019offres par participant/compte/p\xE9riode quotidienne de d\xE9fi, d\u2019un (1) prix mensuel par participant/compte/p\xE9riode mensuelle de d\xE9fi, et d\u2019un (1) prix de victoires cons\xE9cutives par participant/compte/semaine. Il demeure entendu que les points Fid\xE9liTimMC associ\xE9s \xE0 un prix sont soumis aux modalit\xE9s du programme Fid\xE9liTimMC en vigueur depuis le 21 f\xE9vrier 2023 \xE0 00 h 00 m 01 s (HE). Vous devez r\xE9pondre correctement \xE0 une question r\xE9glementaire. Consultez les modalit\xE9s de Fid\xE9liTimMC au timhortons.ca. Consultez la version int\xE9grale du r\xE8glement du d\xE9fi et les d\xE9tails relatifs \xE0 la participation au https://www.timhortons.ca/defi-de-hockey-de-la-lnh-de-tim-hortons. LNH et l\u2019embl\xE8me LNH sont des marques de commerce d\xE9pos\xE9es, et le nom et le logo du D\xE9fi de hockey de la LNH sont des marques de commerce de la Ligue nationale de hockey. \xA9 LNH 2025. Tous droits r\xE9serv\xE9s. AJLNH et le logo de l\u2019AJLNH sont des marques de commerce d\xE9pos\xE9es de l\u2019Association des joueurs de la Ligue nationale de hockey. \xA9 AJLNH. Tous droits r\xE9serv\xE9s. EssoMC est une marque de commerce de la Compagnie P\xE9troli\xE8re Imp\xE9riale Lt\xE9e. P\xE9troli\xE8re Imp\xE9riale, titulaire de licence. MobilMC est une marque de commerce d\u2019Exxon Mobil Corporation ou de l\u2019une de ses filiales. P\xE9troli\xE8re Imp\xE9riale, titulaire de licence. \xA9Tim Hortons, 2025.</div></br></br>D\xE9fi de hockey de la LNH<sup style='font-size: 6px; top: -0.5em'>MD</sup> de Tim Hortons\xAE n\u2019est aucunement commandit\xE9, endoss\xE9 ou administr\xE9 de quelque fa\xE7on que ce soit par Apple ou Google. </div></br><div style='text-align: center'> \xA9Tim Hortons, 2025.</div>\n\n    <div style='text-align: center'></br>TIM HORTONS NHL\xAE HOCKEY CHALLENGE\u2122 \u2013 2025/2026 REGULAR SEASON CHALLENGE</div><div style='text-align: center'>CHALLENGE MINI-RULES</div></br><p style='text-align: center; margin-top: 0'>NO PURCHASE NECESSARY. Open to legal residents of Canada ages 13+ (14+ in Quebec). Starts at 5:00 a.m. ET on October 7, 2025, and ends at the scheduled start time ET of the last NHL\xAE hockey game on the last date of the 2025/2026 NHL regular season. Challenge consists of 6 monthly periods. Each monthly period consists of 3 to 6 weeks and each week consists of daily challenge periods. Each participant may select up to 3 players in connection with each daily challenge period. During a daily challenge period (the following outcomes are each a points week prize and are mutually exclusive): (i) if 1 standard pick player scores at least 1 goal, the participant will be eligible to receive 25 Tims Rewards points; (ii) if 2 standard pick players each score at least 1 goal, the participant will be eligible to receive 50 Tims Rewards points; or, (iii) if all 3 standard pick players each score at least 1 goal, the participant will be eligible to receive 100 Tims Rewards points. ARV of each Tims Rewards point prize depends on reward(s) obtained using Tims Rewards points, and will vary depending on winner\u2019s redemption level and rewards options in effect at the time of redemption (for example, at the time of publishing these abbreviated rules, in accordance with the program terms effective February 21, 2023, 400 points may be redeemed by a registered Tims Rewards participant for an eligible brewed coffee, tea, Dream DonutTM, bagel or baked good ARV $1.46 \u2013 $3.99 CAD each, based on menu item prices in Ontario, excluding taxes). During the challenge period, if 1 or more standard pick players for 7 consecutive daily challenge periods score at least 1 goal during a game held within each of such consecutive daily challenge periods, the participant will be eligible to receive a \u201CFree Coffee for a Week\u201D hot streak prize (which may be redeemed for 1 hot brewed coffee or tea of any size per day for a consecutive period of 7 days), ARV $10.22-$27.23 CAD (depending on the size selected) each. ARV of each hot streak prize is based on average menu item prices in Ontario excluding taxes. Each hot streak prize offer expires 7 days from date allocated to the applicable winner\u2019s Tims Rewards account and must first be activated in order to be redeemed. During the challenge period, the following monthly prizes are available in connection with the number of monthly leaderboard point(s) obtained by participants: (a) 6 x 1st place monthly prizes (1 x 1st place monthly prize per monthly period), each consisting of a prize package including: (i) $400 CAD Skip the Dishes gift card; (ii) $400 CAD Canadian Tire gift card; (iii) $400 CAD Sport Chek gift card; (iv) $400 CAD Esso\u2122 gift card; and (v) a $400 Tims Gift Card (total ARV $2,000 CAD each); (b) 6 x 2nd place monthly prizes (1 x 2nd place monthly prize per monthly period), each consisting of a prize package including: (i) $250 CAD Skip the Dishes gift card; (ii) $250 CAD Canadian Tire gift card; (iii) $250 CAD Sport Chek gift card; (iv) $250 CAD Esso\u2122 gift card; and (v) a $250 Tims Gift Card (total ARV $1,250 CAD each); (c) 6 x 3rd place monthly prizes (1 x 3rd place monthly prize per monthly period), each consisting of a prize package including: (i) $200 CAD Skip the Dishes gift card; (ii) $200 CAD Canadian Tire gift card; (iii) $200 CAD Sport Chek gift card; (iv) $200 CAD Esso\u2122 gift card; and, (v) a $200 Tims Gift Card (total ARV $1,000 CAD each); (d) 6 x 4th place monthly prizes (1 x 4th place monthly prize per monthly period), each consisting of a prize package including: (i) $150 CAD Skip the Dishes gift card; (ii) $150 CAD Canadian Tire gift card; (iii) $150 CAD Sport Chek gift card; (iv) $150 CAD Esso\u2122 gift card; and, (v) a $150 Tims Gift Card (total ARV $750 CAD each); and (e) 6 x 5th place monthly prizes (1 x 5th place monthly prize per monthly period), each consisting of a prize package including: (i) $100 CAD Skip the Dishes gift card; (ii) a $100 CAD Canadian Tire gift card; (iii) a $100 CAD Sport Chek gift card; (iv) a $100 CAD Esso\u2122 gift card; and, (v) a $100 Tims Gift Card (total ARV $500 CAD each). During the challenge period, the following 5 grand prizes are available in connection with the number of full regular season leaderboard point(s) obtained by participants: (a) 1 x 1st place grand prize, consisting of a New Hyundai Tucson (total ARV $35,000 CAD); (b) 1 x 2nd place grand prize, consisting of: (i) $100 CAD NHL\xAE Shop gift card; and (ii) $800 CAD Tims Gift Card (total ARV $900 CAD); (c) 1 x 3rd place grand prize, consisting of: (i) $100 CAD NHL\xAE Shop gift card; and (ii) $500 CAD Tims Gift Card (total ARV $600 CAD); (d) 1 x 4th place grand prize, consisting of: (i) $100 CAD NHL\xAE Shop gift card; and (ii) $250 CAD Tims Gift Card (total ARV $350 CAD); and (e) 1 x 5th place grand prize, consisting of: (i) $100 CAD NHL\xAE Shop gift card; and (ii) $150 CAD Tims Gift Card (total ARV $250 CAD). Odds of winning a points week prize, offers week prize or hot streak prize will vary throughout the challenge period and will depend on the players made available for standard selection, their respective allocations to a selection group (as determined by the sponsor in its sole and absolute discretion), a participant\u2019s timing and selection of players, and the number of eligible goals scored by the selected players during the applicable daily challenge period(s). Odds of winning a monthly prize depend on the number of participants and number of monthly leaderboard point(s) earned per participant during the applicable monthly period. Odds of winning a grand prize depend on the number of participants and number of full regular season leaderboard point(s) earned per participant during the challenge period. Prizes are subject to all applicable offer or Tims Rewards program terms, as applicable. Maximum 1 points prize or offers prize per participant/ account/ daily challenge period, 1 monthly prize per participant/ account/ monthly challenge period, 1 grand prize per participant/ account, and 1 hot streak prize per participant/ account /week. For certainty, Tims Rewards points associated with a prize are subject to the Tims Rewards program terms effective as of February 21, 2023 at 12:00:01 am ET. Math skill-testing question required. For Tims Rewards terms and conditions, visit timhortons.ca. For full challenge rules and entry details, visit https://www.timhortons.ca/tims-nhl-hockey-challenge. NHL and the NHL Shield are registered trademarks and NHL Hockey Challenge name and logo are trademarks of the National Hockey League. \xA9 NHL 2025. All Rights Reserved. NHLPA and the NHLPA logo are registered trademarks of the National Hockey League Players\u2019 Association. \xA9 NHLPA. All Rights Reserved. Esso\u2122 is a trademark of Imperial Oil Limited. Imperial Oil, licensee. Mobil\u2122 is a trademark of Exxon Mobil Corporation or one of its subsidiaries. Imperial Oil, licensee. \xA9Tim Hortons, 2025.</div></br></br> The Tim Hortons NHL Hockey Challenge is in no way sponsored, endorsed, or administered by Apple and/or Google.  </br><div style='text-align: center'> \xA9Tim Hortons, 2025.</div>",
    fr: "<div style='text-align: center'>D\xC9FI DE HOCKEY DE LA LNH<sup style='font-size: 6px; top: -0.5em'>MD</sup>  DE TIM HORTONS<sup style='font-size: 6px; top: -0.5em'>\xAE</sup> \u2013 D\xC9FI DE LA SAISON R\xC9GULI\xC8RE 2025-2026</div><div style='text-align: center'>R\xC8GLEMENT ABR\xC9G\xC9 DU D\xC9FI</div> </br><p style='text-align: center; margin-top: 0'>AUCUN ACHAT REQUIS. Seuls les r\xE9sidents autoris\xE9s du Canada \xE2g\xE9s de 13 ans ou plus (14 ans ou plus au Qu\xE9bec) peuvent participer. Du 7 octobre 2025 \xE0 5 h (HE) jusqu\u2019\xE0 l\u2019heure (HE) de d\xE9but pr\xE9vue de la derni\xE8re partie de hockey de la LNHMD de la derni\xE8re journ\xE9e de la saison r\xE9guli\xE8re 2025-2026 de la LNHMD. Le d\xE9fi est divis\xE9 en 6 p\xE9riodes mensuelles. Chaque p\xE9riode mensuelle est constitu\xE9e de 3 \xE0 6 semaines, et chaque semaine est constitu\xE9e de p\xE9riodes quotidiennes de d\xE9fi. Chaque participant peut s\xE9lectionner jusqu\u2019\xE0 trois joueurs pour chaque p\xE9riode quotidienne de d\xE9fi. Pendant une p\xE9riode quotidienne de d\xE9fi (les r\xE9sultats suivants sont chacun un prix de semaine des points et sont mutuellement exclusifs) : (i) si 1 choix standard marque au moins 1 but, le participant sera admissible \xE0 recevoir 25 points Fid\xE9liTimMC; (ii) si 2 choix standards marquent chacun au moins 1 but, le participant sera admissible \xE0 recevoir 50 points Fid\xE9liTimMC; ou (iii) si les 3 choix standards marquent chacun au moins 1 but, le participant sera admissible \xE0 recevoir 100 points Fid\xE9liTimMC. La VAD de chaque prix en points Fid\xE9liTimMC d\xE9pend des r\xE9compenses obtenues \xE0 l\u2019aide des points Fid\xE9liTimMC, et variera en fonction du niveau de r\xE9compenses du gagnant et des choix de r\xE9compenses en vigueur au moment de l\u2019\xE9change (par exemple, au moment de publier les pr\xE9sents R\xE8glements abr\xE9g\xE9s, conform\xE9ment aux modalit\xE9s du programme en vigueur \xE0 partir du 21 f\xE9vrier 2023, 400 points pourraient \xEAtre \xE9chang\xE9s par un membre inscrit \xE0 Fid\xE9liTimMC participant pour un th\xE9, un caf\xE9 infus\xE9, un beigne de r\xEAveMC, un bagel ou une p\xE2tisserie admissible [VAD de 1,46 $ \xE0 3,99 $ CA chacun], selon la moyenne des prix du menu en Ontario, taxes en sus). Pendant la p\xE9riode du d\xE9fi, si, pour 7 p\xE9riodes quotidiennes de d\xE9fi cons\xE9cutives, 1 ou plusieurs choix standards marquent au moins 1 but pendant une partie ayant lieu lors de ces p\xE9riodes quotidiennes de d\xE9fi cons\xE9cutives, le participant sera admissible \xE0 recevoir un prix de victoires cons\xE9cutives de \xAB caf\xE9 gratuit pendant une semaine \xBB (permettant d\u2019obtenir un caf\xE9 chaud infus\xE9 ou un th\xE9 de n\u2019importe quel format par jour pendant une p\xE9riode de 7 jours cons\xE9cutifs), d\u2019une VAD de 10,22 $ \xE0 27,23 $ CA (selon le format choisi) chacun. La VAD de chaque prix de victoires cons\xE9cutives est bas\xE9e sur la moyenne des prix du menu en Ontario (taxes en sus). Chaque prix de victoires cons\xE9cutives expire sept (7) jours apr\xE8s la date o\xF9 il a \xE9t\xE9 ajout\xE9 au compte Fid\xE9liTimMC applicable du gagnant et doit \xEAtre d\u2019abord activ\xE9 avant de pouvoir \xEAtre r\xE9clam\xE9. Durant la p\xE9riode du d\xE9fi, les prix suivants sont offerts selon le nombre de points de classement mensuels obtenus par les participants : (a) 6 prix de 1re place mensuels (1 prix de 1re place mensuel par p\xE9riode mensuelle), chacun consistant en un ensemble de prix comprenant : (i) une carte-cadeau SkipTheDishes de 400 $ CA; (ii) une carte-cadeau Canadian Tire de 400 $ CA; (iii) une carte-cadeau Sports Experts de 400 $ CA; (iv) une carte-cadeau EssoMC de 400 $ CA; et (v) une Carte-cadeau TimMD de 400 $ CA (VAD totale de 2 000 $ CA chacun); (b) 6 prix de 2e place mensuels (1 prix de 2e place mensuel par p\xE9riode mensuelle), chacun consistant en un ensemble de prix comprenant : (i) une carte-cadeau SkipTheDishes de 250 $ CA; (ii) une carte-cadeau Canadian Tire de 250 $ CA; (iii) une carte-cadeau Sports Experts de 250 $ CA; (iv) une carte-cadeau EssoMC de 250 $ CA; et (v) une Carte-cadeau TimMD de 250 $ CA (VAD totale de 1 250 $ CA chacun); (c) 6 prix de 3e place mensuels (1 prix de 3e place mensuel par p\xE9riode mensuelle), chacun consistant en un ensemble de prix comprenant : (i) une carte-cadeau SkipTheDishes de 200 $ CA; (ii) une carte-cadeau Canadian Tire de 200 $ CA; (iii) une carte-cadeau Sports Experts de 200 $ CA; (iv) une carte-cadeau EssoMC de 200 $ CA; et (v) une Carte-cadeau TimMD de 200 $ CA (VAD totale de 1 000 $ CA chacun); (d) 6 prix de 4e place mensuels (1 prix de 4e place mensuel par p\xE9riode mensuelle), chacun consistant en un ensemble de prix comprenant : (i) une carte-cadeau SkipTheDishes de 150 $ CA; (ii) une carte-cadeau Canadian Tire de 150 $ CA; (iii) une carte-cadeau Sports Experts de 150 $ CA; (iv) une carte-cadeau EssoMC de 150 $ CA; et (v) une Carte-cadeau TimMD de 150 $ CA (VAD totale de 750 $ CA chacun); et (e) 6 prix de 5e place mensuels (1 prix de 5e place mensuel par p\xE9riode mensuelle), chacun consistant en un ensemble de prix comprenant : (i) une carte-cadeau SkipTheDishes de 100 $ CA; (ii) une carte-cadeau Canadian Tire de 100 $ CA; (iii) une carte-cadeau Sports Experts de 100 $ CA; (iv) une carte-cadeau EssoMC de 100 $ CA; et (v) une Carte-cadeau TimMD de 100 $ CA (VAD totale de 500 $ CA chacun). Durant la p\xE9riode du d\xE9fi, les 5 grands prix suivants sont offerts selon le nombre de points de classement obtenu durant toute la saison r\xE9guli\xE8re par les participants : (a) 1 grand prix de 1re place, consistant en un nouveau v\xE9hicule Tucson de Hyundai (VAD totale de 35 000 $ CA); (b) 1 grand prix de 2e place, consistant en : (i) une carte-cadeau de 100 $ CA de la boutique de la LNHMD; et (ii) une Carte-cadeau TimMD de 800 $ CA (VAD totale de 900 $ CA); (c) 1 grand prix de 3e place, consistant en : (i) une carte-cadeau de 100 $ CA de la boutique de la LNHMD; et (ii) une Carte-cadeau TimMD de 500 $ CA (VAD totale de 600 $ CA); (d) 1 grand prix de 4e place, consistant en : (i) une carte-cadeau de 100 $ CA de la boutique de la LNHMD; et (ii) une Carte-cadeau TimMD de 250 $ CA (VAD totale de 350 $ CA); et (e) 1 grand prix de 5e place, consistant en : (i) une carte-cadeau de 100 $ CA de la boutique de la LNHMD; et (ii) une Carte-cadeau TimMD de 150 $ CA (VAD totale de 250 $ CA). Les chances de gagner un prix de semaine des points, un prix de semaine des offres ou un prix de victoires cons\xE9cutives varieront tout au long de la p\xE9riode du d\xE9fi, et d\xE9pendront de la s\xE9lection de joueurs standards offerte, de leur allocation respective \xE0 un groupe de s\xE9lection (telle que d\xE9termin\xE9e par le commanditaire, \xE0 sa discr\xE9tion exclusive), du moment auquel le participant s\xE9lectionne des joueurs et des joueurs qu\u2019il s\xE9lectionne ainsi que du nombre de buts admissibles marqu\xE9s par les joueurs s\xE9lectionn\xE9s durant la ou les p\xE9riodes quotidiennes de d\xE9fi admissibles. Les chances de gagner un prix mensuel d\xE9pendront du nombre de participants et du nombre de points de classement mensuel obtenus par le participant pendant la p\xE9riode mensuelle applicable. Les chances de gagner un grand prix d\xE9pendront du nombre de participants et du nombre de points de classement de la saison compl\xE8te obtenus par le participant pendant la p\xE9riode du d\xE9fi. Les prix sont assujettis aux modalit\xE9s de toute offre applicable et \xE0 celles du programme Fid\xE9liTimMC, le cas \xE9ch\xE9ant. Maximum d\u2019un (1) prix de points ou prix d\u2019offres par participant/compte/p\xE9riode quotidienne de d\xE9fi, d\u2019un (1) prix mensuel par participant/compte/p\xE9riode mensuelle de d\xE9fi, et d\u2019un (1) prix de victoires cons\xE9cutives par participant/compte/semaine. Il demeure entendu que les points Fid\xE9liTimMC associ\xE9s \xE0 un prix sont soumis aux modalit\xE9s du programme Fid\xE9liTimMC en vigueur depuis le 21 f\xE9vrier 2023 \xE0 00 h 00 m 01 s (HE). Vous devez r\xE9pondre correctement \xE0 une question r\xE9glementaire. Consultez les modalit\xE9s de Fid\xE9liTimMC au timhortons.ca. Consultez la version int\xE9grale du r\xE8glement du d\xE9fi et les d\xE9tails relatifs \xE0 la participation au https://www.timhortons.ca/defi-de-hockey-de-la-lnh-de-tim-hortons. LNH et l\u2019embl\xE8me LNH sont des marques de commerce d\xE9pos\xE9es, et le nom et le logo du D\xE9fi de hockey de la LNH sont des marques de commerce de la Ligue nationale de hockey. \xA9 LNH 2025. Tous droits r\xE9serv\xE9s. AJLNH et le logo de l\u2019AJLNH sont des marques de commerce d\xE9pos\xE9es de l\u2019Association des joueurs de la Ligue nationale de hockey. \xA9 AJLNH. Tous droits r\xE9serv\xE9s. EssoMC est une marque de commerce de la Compagnie P\xE9troli\xE8re Imp\xE9riale Lt\xE9e. P\xE9troli\xE8re Imp\xE9riale, titulaire de licence. MobilMC est une marque de commerce d\u2019Exxon Mobil Corporation ou de l\u2019une de ses filiales. P\xE9troli\xE8re Imp\xE9riale, titulaire de licence. \xA9Tim Hortons, 2025.</div></br></br>D\xE9fi de hockey de la LNH<sup style='font-size: 6px; top: -0.5em'>MD</sup> de Tim Hortons\xAE n\u2019est aucunement commandit\xE9, endoss\xE9 ou administr\xE9 de quelque fa\xE7on que ce soit par Apple ou Google. </div></br><div style='text-align: center'> \xA9Tim Hortons, 2025.</div>\n\n    <div style='text-align: center'></br>TIM HORTONS NHL\xAE HOCKEY CHALLENGE\u2122 \u2013 2025/2026 REGULAR SEASON CHALLENGE</div><div style='text-align: center'>CHALLENGE MINI-RULES</div></br><p style='text-align: center; margin-top: 0'>NO PURCHASE NECESSARY. Open to legal residents of Canada ages 13+ (14+ in Quebec). Starts at 5:00 a.m. ET on October 7, 2025, and ends at the scheduled start time ET of the last NHL\xAE hockey game on the last date of the 2025/2026 NHL regular season. Challenge consists of 6 monthly periods. Each monthly period consists of 3 to 6 weeks and each week consists of daily challenge periods. Each participant may select up to 3 players in connection with each daily challenge period. During a daily challenge period (the following outcomes are each a points week prize and are mutually exclusive): (i) if 1 standard pick player scores at least 1 goal, the participant will be eligible to receive 25 Tims Rewards points; (ii) if 2 standard pick players each score at least 1 goal, the participant will be eligible to receive 50 Tims Rewards points; or, (iii) if all 3 standard pick players each score at least 1 goal, the participant will be eligible to receive 100 Tims Rewards points. ARV of each Tims Rewards point prize depends on reward(s) obtained using Tims Rewards points, and will vary depending on winner\u2019s redemption level and rewards options in effect at the time of redemption (for example, at the time of publishing these abbreviated rules, in accordance with the program terms effective February 21, 2023, 400 points may be redeemed by a registered Tims Rewards participant for an eligible brewed coffee, tea, Dream DonutTM, bagel or baked good ARV $1.46 \u2013 $3.99 CAD each, based on menu item prices in Ontario, excluding taxes). During the challenge period, if 1 or more standard pick players for 7 consecutive daily challenge periods score at least 1 goal during a game held within each of such consecutive daily challenge periods, the participant will be eligible to receive a \u201CFree Coffee for a Week\u201D hot streak prize (which may be redeemed for 1 hot brewed coffee or tea of any size per day for a consecutive period of 7 days), ARV $10.22-$27.23 CAD (depending on the size selected) each. ARV of each hot streak prize is based on average menu item prices in Ontario excluding taxes. Each hot streak prize offer expires 7 days from date allocated to the applicable winner\u2019s Tims Rewards account and must first be activated in order to be redeemed. During the challenge period, the following monthly prizes are available in connection with the number of monthly leaderboard point(s) obtained by participants: (a) 6 x 1st place monthly prizes (1 x 1st place monthly prize per monthly period), each consisting of a prize package including: (i) $400 CAD Skip the Dishes gift card; (ii) $400 CAD Canadian Tire gift card; (iii) $400 CAD Sport Chek gift card; (iv) $400 CAD Esso\u2122 gift card; and (v) a $400 Tims Gift Card (total ARV $2,000 CAD each); (b) 6 x 2nd place monthly prizes (1 x 2nd place monthly prize per monthly period), each consisting of a prize package including: (i) $250 CAD Skip the Dishes gift card; (ii) $250 CAD Canadian Tire gift card; (iii) $250 CAD Sport Chek gift card; (iv) $250 CAD Esso\u2122 gift card; and (v) a $250 Tims Gift Card (total ARV $1,250 CAD each); (c) 6 x 3rd place monthly prizes (1 x 3rd place monthly prize per monthly period), each consisting of a prize package including: (i) $200 CAD Skip the Dishes gift card; (ii) $200 CAD Canadian Tire gift card; (iii) $200 CAD Sport Chek gift card; (iv) $200 CAD Esso\u2122 gift card; and, (v) a $200 Tims Gift Card (total ARV $1,000 CAD each); (d) 6 x 4th place monthly prizes (1 x 4th place monthly prize per monthly period), each consisting of a prize package including: (i) $150 CAD Skip the Dishes gift card; (ii) $150 CAD Canadian Tire gift card; (iii) $150 CAD Sport Chek gift card; (iv) $150 CAD Esso\u2122 gift card; and, (v) a $150 Tims Gift Card (total ARV $750 CAD each); and (e) 6 x 5th place monthly prizes (1 x 5th place monthly prize per monthly period), each consisting of a prize package including: (i) $100 CAD Skip the Dishes gift card; (ii) a $100 CAD Canadian Tire gift card; (iii) a $100 CAD Sport Chek gift card; (iv) a $100 CAD Esso\u2122 gift card; and, (v) a $100 Tims Gift Card (total ARV $500 CAD each). During the challenge period, the following 5 grand prizes are available in connection with the number of full regular season leaderboard point(s) obtained by participants: (a) 1 x 1st place grand prize, consisting of a New Hyundai Tucson (total ARV $35,000 CAD); (b) 1 x 2nd place grand prize, consisting of: (i) $100 CAD NHL\xAE Shop gift card; and (ii) $800 CAD Tims Gift Card (total ARV $900 CAD); (c) 1 x 3rd place grand prize, consisting of: (i) $100 CAD NHL\xAE Shop gift card; and (ii) $500 CAD Tims Gift Card (total ARV $600 CAD); (d) 1 x 4th place grand prize, consisting of: (i) $100 CAD NHL\xAE Shop gift card; and (ii) $250 CAD Tims Gift Card (total ARV $350 CAD); and (e) 1 x 5th place grand prize, consisting of: (i) $100 CAD NHL\xAE Shop gift card; and (ii) $150 CAD Tims Gift Card (total ARV $250 CAD). Odds of winning a points week prize, offers week prize or hot streak prize will vary throughout the challenge period and will depend on the players made available for standard selection, their respective allocations to a selection group (as determined by the sponsor in its sole and absolute discretion), a participant\u2019s timing and selection of players, and the number of eligible goals scored by the selected players during the applicable daily challenge period(s). Odds of winning a monthly prize depend on the number of participants and number of monthly leaderboard point(s) earned per participant during the applicable monthly period. Odds of winning a grand prize depend on the number of participants and number of full regular season leaderboard point(s) earned per participant during the challenge period. Prizes are subject to all applicable offer or Tims Rewards program terms, as applicable. Maximum 1 points prize or offers prize per participant/ account/ daily challenge period, 1 monthly prize per participant/ account/ monthly challenge period, 1 grand prize per participant/ account, and 1 hot streak prize per participant/ account /week. For certainty, Tims Rewards points associated with a prize are subject to the Tims Rewards program terms effective as of February 21, 2023 at 12:00:01 am ET. Math skill-testing question required. For Tims Rewards terms and conditions, visit timhortons.ca. For full challenge rules and entry details, visit https://www.timhortons.ca/tims-nhl-hockey-challenge. NHL and the NHL Shield are registered trademarks and NHL Hockey Challenge name and logo are trademarks of the National Hockey League. \xA9 NHL 2025. All Rights Reserved. NHLPA and the NHLPA logo are registered trademarks of the National Hockey League Players\u2019 Association. \xA9 NHLPA. All Rights Reserved. Esso\u2122 is a trademark of Imperial Oil Limited. Imperial Oil, licensee. Mobil\u2122 is a trademark of Exxon Mobil Corporation or one of its subsidiaries. Imperial Oil, licensee. \xA9Tim Hortons, 2025.</div></br></br> The Tim Hortons NHL Hockey Challenge is in no way sponsored, endorsed, or administered by Apple and/or Google.<div style='text-align: center'> \xA9Tim Hortons, 2025.</div>"
  },
  'global/games/status/started/text': {
    en: 'Started',
    fr: 'Commencé'
  },
  'global/slots/playerSelect/text': {
    en: "Select 1 Player",
    fr: "S\xE9lectionnez 1 joueur"
  },
  'global/slots/number/text': {
    en: function en(number) {
      return "Pick #" + number;
    },
    fr: function fr(number) {
      return "Choix n<sup style='font-size: 0.5em;'>o</sup> " + number;
    }
  },
  'global/termsAndPrivacy/text': {
    en: function en(termsUrl, privacyUrl) {
      return "By submitting your picks, you agree to the\n          <a target=\"_parent\" href=\"https://www.timhortons.ca/tnhc-rules\">contest terms</a> and our <a target=\"_parent\" href=\"" + privacyUrl + "\">Privacy Policy</a>.";
    },
    fr: function fr(termsUrl, privacyUrl) {
      return "En soumettant vos choix, vous acceptez les\n      <a target=\"_parent\" href=\"https://www.timhortons.ca/reglements-dhlt\">modalit\xE9s du concours</a>, ainsi que notre <a target=\"_parent\" href=\"" + privacyUrl + "\">politique de confidentialit\xE9</a>.";
    }
  },
  'global/date/days/text': {
    en: "Days",
    fr: "Jours"
  },
  'global/date/hours/text': {
    en: "Hours",
    fr: "Heures"
  },
  'global/date/mins/text': {
    en: "Mins",
    fr: "Minutes"
  },
  'global/fetchError/title': {
    en: "We're sorry, we've encountered a problem.",
    fr: 'Désolé, nous avons rencontré un problème.'
  },
  'global/fetchError/text': {
    en: "We're having some issues loading the game for you. Please try again later.",
    fr: "Nous n'arrivons pas \xE0 charger le jeu. Veuillez r\xE9essayer plus tard."
  }
};

var strings$1 = {
  'routes/playNow/label': {
    en: 'Play Now',
    fr: 'Jouer'
  },
  'routes/gameInfo/label': {
    en: 'Game Info',
    fr: 'Infos sur le jeu'
  },
  'routes/history/label': {
    en: 'History',
    fr: 'Historique'
  },
  'routes/leaderboard/label': {
    en: 'Leaderboard',
    fr: 'Classement'
  }
};

var strings$2 = {
  'notifications/submission/badPlayerData/title': {
    en: 'Player unavailable',
    fr: 'Joueur non disponible'
  },
  'notifications/submission/badPlayerData/text': {
    en: 'Sorry, some of your picks have already hit the ice and are no longer available. Please update your picks and try again.',
    fr: 'Désolé, certaines de vos sélections ne sont plus disponibles. Veuillez modifier vos choix et réessayer.'
  },
  'notifications/games/inProgress/title': {
    en: 'Games in progress.',
    fr: 'Matchs en cours.'
  },
  'notifications/games/allInProgress/title': {
    en: 'Selection period closed.',
    fr: 'La période de sélection est fermée.'
  },
  'notifications/games/inProgress/text': {
    en: 'You will not be able to pick players in games that have started.',
    fr: 'Vous ne pourrez pas sélectionner de joueurs pour les matchs qui sont commencés.'
  },
  'notifications/games/allInProgress/text': {
    en: "All of today's games have started. Picks will not be accepted at this time.",
    fr: 'Tous les matchs d’aujourd’hui sont commencés. Les choix ne sont pas acceptés à ce stade-ci.'
  },
  'notifications/games/welcome/title': {
    en: 'Welcome to the Tim Hortons NHL Hockey Challenge™',
    fr: 'Voici le Défi de hockey de la LNH<sup>MD</sup> de Tim Hortons'
  },
  'notifications/games/welcome/text': {
    en: "Pick 3 players who you think will score in today's games. If they find the back of the net, you score!",
    fr: 'Choisissez 3 joueurs qui, selon vous, marqueront un but durant les matchs d’aujourd’hui. S’ils mettent la rondelle dans le filet, vous gagnez!'
  },
  'notifications/games/picksFilled/title': {
    en: 'Your lineup has been filled!',
    fr: 'Votre sélection est complète!'
  },
  'notifications/games/picksFilled/text': {
    en: "Tap 'Submit picks' to lock in your picks.",
    fr: 'Enregistrez vos choix en appuyant sur ”Soumettre vos choix”'
  },
  'notifications/games/noGames/title': {
    en: 'No games today.',
    fr: 'Il n’y a aucun match aujourd’hui.'
  },
  'notifications/games/noGames/text': {
    en: 'There are no games today',
    fr: 'Aucun match n’est prévu aujourd’hui'
  },
  'notifications/games/noGames/sub-text': {
    en: 'Come back on game day to make your picks!',
    fr: 'Revenez le jour du match pour faire vos choix!'
  },
  'notifications/confirmPicks/text': {
    en: 'Picks cannot be changed once submitted.',
    fr: 'Les choix de joueurs ne peuvent pas être modifiés une fois soumis.'
  },
  'notifications/submitted/text': {
    en: 'See which players have scored <a target="_parent" href="https://www.nhl.com/scores/">on NHL.com</a>!',
    fr: 'Découvrez les joueurs qui ont marqué un but à <a target="_parent" href="https://www.nhl.com//fr/scores/">NHL.com</a>!'
  },
  'notifications/quiz/wrongAnswer/title': {
    en: 'Wrong answer',
    fr: 'Mauvaise réponse'
  },
  'notifications/quiz/wrongAnswer/text': {
    en: 'Please try solving the new question below',
    fr: 'Veuillez résoudre la nouvelle question ci-dessous'
  },
  'notifications/quiz/gameLocked/title': {
    en: 'Better luck next time',
    fr: 'Meilleure chance la prochaine fois'
  },
  'notifications/quiz/gameLocked/text': {
    en: "Looks like your answers missed the net and you weren\u2019t able to provide the\n      correct answer.",
    fr: "Vos r\xE9ponses semblent avoir rat\xE9 le filet. Vous n\u2019avez pas correctement r\xE9pondu \xE0 la question d\u2019habilet\xE9."
  },
  'notifications/quiz/gameLocked/checkBack/text': {
    en: 'Check back soon',
    fr: 'Revenez voir bientôt'
  },
  'notifications/tierSelection/success/text': {
    en: 'Your entry was submitted successfully. Good luck!',
    fr: 'Votre participation a été soumise avec succès. Bonne chance!'
  },
  'notifications/tierSelection/error/text': {
    en: 'An unknown error has occurred. Please please try again later or contact support.',
    fr: 'Une erreur inconnue est survenue. Veuillez réessayer plus tard ou contacter le service de soutien.'
  },
  'notifications/gameplay/success/text': {
    en: 'No purchase necessary, gameplay request submitted.',
    fr: 'Demande de participation sans achat soumise.'
  },
  'notifications/reminders/header': {
    en: 'Do you want to turn on notifications?',
    fr: 'Voulez-vous activer les notifications?'
  },
  'notifications/reminders/body': {
    en: 'This will allow you to receive ongoing game reminders and stay informed on your progress throughout the season.',
    fr: 'Vous recevrez des rappels concernant les matchs et pourrez consulter vos progrès tout au long de la saison.'
  },
  'notifications/reminders/text': {
    en: 'I’d like reminders on upcoming games and prizes I’ve won.',
    fr: 'Je souhaite recevoir des rappels concernant les matchs à venir et mes prix.'
  },
  'notifications/reminders/button': {
    en: 'Save',
    fr: 'Enregistrer'
  },
  'notifications/error/playnow/text': {
    en: 'We’re having trouble displaying today’s games. Please check back later.',
    fr: 'Nous éprouvons des difficultés à afficher les parties du jour. Veuillez revenir plus tard.'
  },
  'notifications/errormodal/header': {
    en: 'Sorry, we ran into an issue',
    fr: 'Nous sommes désolés, un problème est survenu'
  },
  'notifications/errormodal/text': {
    en: 'We’re having trouble loading the game for you. Please try again later.',
    fr: 'Un problème est survenu lors du chargement du Défi. Veuillez réessayer plus tard.'
  },
  'notifications/errormodal/button': {
    en: 'Okay',
    fr: 'Ok'
  },
  'notifications/incompletePicks/title': {
    en: "Don't forget to submit your picks!",
    fr: "N'oubliez pas de soumettre vos choix!"
  },
  'notifications/incompletePicks/text': {
    en: "You haven't submitted your picks yet, are you sure you want to leave?",
    fr: "Vous n'avez pas encore soumis vos choix, voulez-vous vraiment quitter?"
  },
  'notifications/incompletePicks/leaveButton': {
    en: 'Leave',
    fr: 'Quitter'
  },
  'notifications/incompletePicks/cancelButton': {
    en: 'Cancel',
    fr: 'Annuler'
  },
  'notifications/picks/submission/error/title': {
    en: 'Something went wrong',
    fr: 'Une erreur est survenue'
  },
  'notifications/picks/submission/error/text': {
    en: "Sorry, your picks couldn't be submitted. Please try again.",
    fr: "Désolé, vos sélections n'ont pas été enregistrées. Veuillez réessayer."
  }
};

var strings$3 = {
  'titles/banner/play/text': {
    en: 'Play',
    fr: 'Jouer'
  },
  'titles/banner/info/text': {
    en: 'Info',
    fr: 'Infos'
  },
  'titles/section/games/text': {
    en: 'TODAY’S GAMES',
    fr: 'LES MATCHS D’AUJOURD’HUI'
  },
  'titles/section/picks/text': {
    en: 'YOUR PICKS',
    fr: 'VOS CHOIX'
  },
  'titles/section/howToPlay/text': {
    en: 'How To Play',
    fr: 'Comment jouer'
  },
  'titles/section/yourPicks/text': {
    en: '<span>Your Picks</span>',
    fr: '<span>Vos Choix</span>'
  },
  'titles/section/prizes/text': {
    en: 'Daily Prizes',
    fr: 'Prix quotidiens'
  },
  'titles/section/streaks/text': {
    en: 'Hot Streaks',
    fr: 'Victoires consécutives'
  },
  'titles/section/challenges/text': {
    en: 'Challenges',
    fr: 'Défis'
  },
  'titles/onboarding/quiz/text': {
    en: 'Skill Testing Question',
    fr: 'Question réglementaire'
  },
  'titles/onboarding/username/text': {
    en: 'Display Name Creation',
    fr: 'Création d’un nom d’utilisateur'
  },
  'titles/onboarding/notifications/text': {
    en: 'Notifications Opt-in',
    fr: 'Activation des notifications'
  },
  'titles/onboarding/done/text': {
    en: 'YOU’RE READY TO PLAY!',
    fr: 'C’EST L’HEURE DE JOUER!'
  }
};

var strings$4 = {
  'quiz/sectionTitle/faceOff/text': {
    en: 'The Face Off',
    fr: 'La mise au jeu'
  },
  'quiz/helpInfo/text': {
    en: 'Please solve the math problem below to continue',
    fr: 'Veuillez répondre correctement à la question d’habileté suivante pour continuer'
  },
  'quiz/question/multiply/text': {
    en: "Multiply by",
    fr: "Multipliez par"
  },
  'quiz/question/divideBy/text': {
    en: "Divide by",
    fr: "Divisez par"
  },
  'quiz/question/add/text': {
    en: "Add",
    fr: "Additionnez"
  },
  'quiz/question/subtract/text': {
    en: "Subtract",
    fr: "Soustrayez"
  },
  'quiz/answerTitle/text': {
    en: 'Select the correct answer',
    fr: 'Sélectionnez la bonne réponse'
  },
  'quiz/failedTitle/text': {
    en: 'Better luck next time',
    fr: 'Meilleure chance la prochaine fois'
  },
  'quiz/failedInfo/text': {
    en: "Looks like your answers missed the net and you weren\u2019t able to provide the\n      correct answer.",
    fr: "Vos r\xE9ponses semblent avoir rat\xE9 le filet. Vous n\u2019avez pas correctement r\xE9pondu \xE0 la question d\u2019habilit\xE9."
  }
};

var strings$5 = {
  'howTo/hockeyChallenge/header/image/src': {
    en: '2025_tnhc_reversed_en.png',
    fr: '2025_tnhc_reversed_fr.png'
  },
  'howTo/hockeyChallenge/blurb/text': {
    en: ['Playing the Tims NHL Hockey', ' Challenge<sup>TM</sup> is as easy as 1-2-3!'],
    fr: ['Jouer au Défi de hockey de la LNH,', ' c’est simple comme bonjour!']
  },
  'howTo/hockeyChallenge/blurb/button/text': {
    en: 'Make your picks',
    fr: 'Faites vos choix'
  },
  'howTo/hockeyChallenge/blurb/steps': {
    en: ['Choose 3 NHL players to score.', 'Not sure who to pick? Choose Scout’s Picks to fill in players for you!', 'Submit your picks, watch the games, and enjoy!', 'After the games are done, check the leaderboard to see where you rank or your history to see how well you did.'],
    fr: ['Choisissez 3 joueurs de la LNH qui marqueront un but.', 'Vous ne savez pas trop quels joueurs choisir? Utilisez les choix des recruteurs et votre alignement sera déterminé pour vous!', 'Soumettez vos choix, puis regardez les matchs et passez du bon temps!', 'Après les matchs, consultez le classement pour connaître votre rang ou affichez votre historique pour voir vos résultats.']
  },
  'howTo/hockeyChallenge/steps/image/src': {
    en: ['gameinfo_steps_img1.png', 'gameinfo_steps_img2.png', 'gameinfo_steps_img3.png', 'gameinfo_steps_img4.png'],
    fr: ['gameinfo_steps_img1.png', 'gameinfo_steps_img2.png', 'gameinfo_steps_img3.png', 'gameinfo_steps_img4.png']
  },
  'howTo/hockeyChallenge/blurb/text/line/1': {
    en: 'Choose 3 NHL players to score a goal and submit your picks.',
    fr: 'Choisissez 3 joueurs de la LNH qui marqueront un but et soumettez vos choix.'
  },
  'howTo/hockeyChallenge/blurb/text/line/2': {
    en: "It's as easy as 1-2-3.",
    fr: 'C’est aussi simple que cela!'
  },
  'howTo/hockeyChallenge/step/1/title/text': {
    en: 'Pick 3 NHL® players to score a goal',
    fr: 'Sélectionnez 3 joueurs de la LNH qui marqueront un but'
  },
  'howTo/hockeyChallenge/step/2/title/text': {
    en: 'Submit Your Picks!',
    fr: 'Soumettez vos choix!'
  },
  'howTo/hockeyChallenge/step/3/title/text': {
    en: 'If your NHL® players score, you score sweet prizes!',
    fr: 'Si vos joueurs de la LNH marquent un but, vous récoltez de délicieux prix!'
  }
};

var strings$6 = {
  'prizes/hockeyChallenge/blurb': {
    en: "If your NHL players score,<br/> you'll win a sweet daily prize or offer!",
    fr: 'Si vos joueurs de la LNH marquent des buts, vous gagnez un délicieux prix quotidien ou une offre!'
  },
  'prizes/hockeyChallenge/1/title': {
    en: 'If 1 of your picks score,',
    fr: 'Si 1 de vos joueurs marque un but,'
  },
  'prizes/hockeyChallenge/2/title': {
    en: 'If 2 of your picks score,',
    fr: 'Si 2 de vos joueurs marquent chacun un but,'
  },
  'prizes/hockeyChallenge/3/title': {
    en: 'If 3 of your picks score,',
    fr: 'Si 3 de vos joueurs marquent chacun un but,'
  },
  'prizes/hockeyChallenge/1/reward': {
    en: 'Win 25 Tims Rewards Points',
    fr: 'Vous gagnez 25 points FidéliTim'
  },
  'prizes/hockeyChallenge/2/reward': {
    en: 'Win 50 Tims Rewards Points',
    fr: 'Vous gagnez 50 points FidéliTim'
  },
  'prizes/hockeyChallenge/3/reward': {
    en: 'Win 100 Tims Rewards Points',
    fr: 'Vous gagnez 100 points FidéliTim'
  },
  'prizes/hockeyChallenge/pointHeader/or': {
    en: 'or',
    fr: 'ou'
  },
  'prizes/hockeyChallenge/pointHeader/an': {
    en: 'an',
    fr: 'une'
  },
  'prizes/hockeyChallenge/pointHeader/offer': {
    en: 'Offer',
    fr: 'Offre'
  },
  'prizes/hockeyChallenge/pointHeader/points': {
    en: 'points',
    fr: 'Points'
  }
};

var strings$7 = {
  'banners/gameInfo/autoPicks/title': {
    en: 'Scout’s Picks',
    fr: 'Choix des recruteurs'
  },
  'banners/gameInfo/autoPicks/text': {
    en: 'Not sure who to pick and need help?',
    fr: 'Vous avez besoin d’aide pour choisir vos joueurs?'
  }
};

var strings$8 = {
  'button/confirmPlayers/text': {
    en: "Submit picks",
    fr: "Soumettre vos choix"
  },
  'button/entered/text': {
    en: 'LOCK ICON',
    fr: 'LOCK ICON'
  },
  'button/submitted/text': {
    en: "Your picks are locked in \u2014 good luck! Check out the leaderboard after the game to see how you did.",
    fr: "Vos choix sont enregistr\xE9s \u2013 Bonne chance! Consultez le classement apr\xE8s le match pour voir vos r\xE9sultats"
  },
  'button/submitAnswer/text': {
    en: "Submit Answer",
    fr: "Soumettez votre r\xE9ponse"
  },
  'button/loadMore/text': {
    en: "Load More",
    fr: "Charger plus"
  },
  'button/submit/text': {
    en: "Submit",
    fr: "Soumettre"
  },
  'button/next/text': {
    en: "Next",
    fr: "Suivant"
  },
  'button/done/text': {
    en: "Done",
    fr: "Termin\xE9"
  },
  'button/autoPicks/text': {
    en: 'Randomly select players',
    fr: 'Sélectionnez des joueurs au hasard'
  },
  'button/leaderboard/showPosition': {
    en: 'See your position',
    fr: 'Voir mon rang'
  },
  'button/leaderboard/scrollToTop': {
    en: 'Scroll to top',
    fr: 'Défiler vers le haut'
  },
  'button/heatstreak/panel1': {
    en: 'View Your NHL Regular Season Challenge Stats',
    fr: 'Consultez vos statistiques sur les défis de la saison régulière de la LNH'
  },
  'button/heatstreak/panel2': {
    en: 'View Your Monthly Challenge Stats',
    fr: 'Consultez les statistiques de vos défis mensuels'
  },
  'button/heatstreak/panel3': {
    en: 'View Your NHL Stanley Cup® Playoff Challenge Stats',
    fr: 'Consultez vos statistiques sur le défi des séries éliminatoires de la Coupe Stanley<sup>MC</sup> de la LNH'
  }
};

var strings$9 = {
  'heatstreak/correct/text': {
    en: function en(points) {
      return "<span>Daily Prize:</span> " + points + "pts";
    },
    fr: function fr(points) {
      return "<span>Prix quotidien :</span> " + points + " pts";
    }
  },
  'heatstreak/offers/text': {
    en: '<span>Daily Prize:</span> Offer',
    fr: '<span>Prix quotidien :</span> Offre'
  },
  'heatstreak/incorrect/text': {
    en: 'None of your picks were correct. Play again.',
    fr: 'Aucun de vos choix n’a marqué de but. Rejouez'
  },
  'heatstreak/noPicks/text': {
    en: "You haven't selected picks for the past 7 days.",
    fr: "Vous n\u2019avez pas s\xE9lectionn\xE9 de joueurs au cours des 7 derniers jours."
  },
  'heatstreak/banner/gold/text': {
    en: function en(percentage) {
      return "You\u2019re playing better than <span>" + percentage + "</span> of the other players right now. Keep it up!";
    },
    fr: function fr(percentage) {
      return "Vous jouez mieux que <span>" + percentage + "</span> des autres participants en ce moment. Continuez comme \xE7a!";
    }
  },
  'heatstreak/banner/silver/text': {
    en: function en(percentage) {
      return "You\u2019re playing better than <span>" + percentage + "</span> of the other players right now. Keep playing!";
    },
    fr: function fr(percentage) {
      return "Vous jouez mieux que <span>" + percentage + "</span> des autres participants en ce moment. Continuez \xE0 jouer!";
    }
  },
  'heatstreak/banner/bronze/text': {
    en: function en(percentage) {
      return "You\u2019re playing better than <span>" + percentage + "</span> of the other players right now. Step your game up!";
    },
    fr: function fr(percentage) {
      return "Vous jouez mieux que <span>" + percentage + "</span> des autres participants en ce moment. Sortez le grand jeu!";
    }
  },
  'heatstreak/panel/winStreak/header': {
    en: 'My streak',
    fr: 'Ma série de victoires'
  },
  'heatstreak/panel/winStreak/title': {
    en: function en(streak) {
      return streak + " Day Win Streak";
    },
    fr: function fr(streak) {
      return "S\xE9rie de victoires cons\xE9cutives de " + streak + " jours";
    }
  },
  'heatstreak/panel/winStreak/badge': {
    en: 'DAY',
    fr: 'Jour'
  },
  'heatstreak/panel/winStreak/text': {
    en: function en(streak) {
      return "Keep your streak alive for " + streak + " more days to win a week of FREE* coffee!";
    },
    fr: function fr(streak) {
      return "Maintenez votre s\xE9rie de victoires cons\xE9cutives pendant encore " + streak + " jours pour gagner une semaine de caf\xE9 GRATUIT!";
    }
  },
  'heatstreak/panel/winStreak/complete/text': {
    en: "Congratulations on your 7 day win streak! Keep playing for your chance to get an additional streak and win another week of free coffee.",
    fr: "F\xE9licitations pour votre s\xE9rie de 7 victoires cons\xE9cutives! Tentez de r\xE9aliser une nouvelle s\xE9rie de victoires pour courir la chance de gagner une autre semaine de caf\xE9 gratuit."
  },
  'heatstreak/statistic/challengeStats/title': {
    en: 'Monthly Challenge',
    fr: "Statistiques du d\xE9fi mensuel"
  },
  'heatstreak/statistic/seasonStats/title': {
    en: 'NHL® 2025/2026 Regular Season Challenge Stats',
    fr: 'Statistiques du Défi de la saison régulière 2025-2026 de la LNH<sup>MD</sup>'
  },
  'heatstreak/statistic/postseasonStats/title': {
    en: 'Stanley Cup®<br /> Playoffs Challenge',
    fr: 'Défi séries éliminatoires de la Coupe Stanley<sup style="font-size: 10px; top: -0.5em">MC</sup>'
  },
  'heatstreak/statistic/pickAccuracy/title': {
    en: 'pick<br />accuracy',
    fr: 'Taux de réussite'
  },
  'heatstreak/statistic/correctPicks/title': {
    en: 'number of<br />correct picks',
    fr: 'Nombre de<br />prédictions<br />réussies'
  },
  'heatstreak/statistic/daysPlayed/title': {
    en: 'number of<br />days played',
    fr: 'Nombre de<br />jours de<br />participation'
  },
  'heatstreak/statistic/mychallenges/title': {
    en: 'My challenges',
    fr: 'Mes défis'
  },
  'heatstreak/statistic/status/progress': {
    en: 'In Progress',
    fr: 'En Cours'
  },
  'heatstreak/statistic/status/completed': {
    en: 'Completed',
    fr: 'Terminé'
  },
  'heatstreak/gameinfo/blurb': {
    en: "Guessed correctly for 7 consecutive days? You'll win free coffee for a week!*",
    fr: 'Vos choix marquent pendant 7 jours consécutifs? Vous gagnez du café gratuit pendant une semaine*!'
  },
  'heatstreak/gameinfo/disclaimer': {
    en: '*Terms and conditions apply.',
    fr: '* Des conditions s’appliquent.'
  },
  'heatstreak/gameinfo/disclaimerTerms': {
    en: 'View terms and conditions (<a target="_parent" href="https://www.timhortons.ca/defi-de-hockey-de-la-lnh-de-tim-hortons">FR</a> | <a target="_parent" href="https://www.timhortons.ca/tims-nhl-hockey-challenge">EN</a>)',
    fr: '<a target="_parent" href="https://www.timhortons.ca/defi-de-hockey-de-la-lnh-de-tim-hortons">Voir les modalités</a>'
  },
  'heatstreak/gameinfo/image': {
    en: '2025_streak_card_en.png',
    fr: '2025_streak_card_fr.png'
  },
  'heatstreak/minibanner/title': {
    en: 'Stanley Cup® Playoffs Challenge',
    fr: 'Défi séries éliminatoires de la Coupe Stanley<sup>MC</sup>'
  },
  'heatstreak/minibanner/playoffs/date': {
    en: 'April 19',
    fr: '19 avril'
  },
  'heatstreak/minibanner/monthly/date': {
    en: 'Nov - Dec',
    fr: 'Nov - Déc'
  },
  'heatstreak/minibanner/text': {
    en: 'Put your playoff knowledge to the test for a chance to win an <b>Ultimate VIP Prince Edward Island Vacation for 2</b> and more! ',
    fr: 'Testez vos connaissances des séries éliminatoires et courez la chance de gagner <b>Séjour VIP ultime à l’Île‑du‑Prince‑Édouard pour 2</b>, et plus encore!'
  },
  'heatstreak/minibanner/link': {
    en: 'View prize info',
    fr: 'Voir les informations sur les prix'
  },
  'heatstreak/minibanner/route': {
    en: '/game-info',
    fr: '/game-info'
  }
};

var strings$a = {
  'dates/month/1/text': {
    en: 'Jan',
    fr: 'Janv.'
  },
  'dates/month/2/text': {
    en: 'Feb',
    fr: 'Févr.'
  },
  'dates/month/3/text': {
    en: 'Mar',
    fr: 'Mars'
  },
  'dates/month/4/text': {
    en: 'Apr',
    fr: 'Avr.'
  },
  'dates/month/5/text': {
    en: 'May',
    fr: 'Mai'
  },
  'dates/month/6/text': {
    en: 'June',
    fr: 'Juin'
  },
  'dates/month/7/text': {
    en: 'July',
    fr: 'Juil.'
  },
  'dates/month/8/text': {
    en: 'Aug',
    fr: 'Août'
  },
  'dates/month/9/text': {
    en: 'Sept',
    fr: 'Sept.'
  },
  'dates/month/10/text': {
    en: 'Oct',
    fr: 'Oct.'
  },
  'dates/month/11/text': {
    en: 'Nov',
    fr: 'Nov.'
  },
  'dates/month/12/text': {
    en: 'Dec',
    fr: 'Déc.'
  },
  'dates/yesterday/text': {
    en: 'Yesterday',
    fr: 'Hier'
  },
  'dates/today/text': {
    en: 'Today',
    fr: 'Aujourd’hui'
  }
};

var strings$b = {
  'history/inProgress/text': {
    en: 'In Progress',
    fr: 'En cours'
  },
  'history/noPicks/title': {
    en: 'No Player Selected',
    fr: 'Vous n’avez pas choisi de joueur'
  },
  'history/noPicks/text': {
    en: 'Sorry, you didn’t submit picks on this date.',
    fr: 'Désolé, vous n’avez pas soumis de choix à cette date.'
  },
  'history/resultsPending/text': {
    en: '<span>Results are pending. Please check back later.</span>',
    fr: '<span>Les résultats ne sont pas prêts. Veuillez revenir plus tard.</span>'
  },
  'history/noPicksAggregated/text': {
    en: function en(days) {
      return "You haven't selected picks for the past " + days + " days.";
    },
    fr: function fr(days) {
      return "Vous n'avez pas choisi de joueurs pour les derniers " + days + " jours.";
    }
  },
  'history/notification/loyalty3/title': {
    en: 'Updates To Tim’s Rewards',
    fr: 'Changements à FidéliTim<sup>MC</sup>'
  },
  'history/notification/loyalty3/text': {
    en: "<span>With the new updates to our Tim's Rewards Program, the number of points you earn for each pick has changed! </span><a style=\"color: #FFFF;\" target=\"_parent\" href=\"https://www.timhortons.ca/newtimsrewards\">Learn More</a>",
    fr: '<span>Dans le cadre des changements au programme FidéliTim<sup>MC</sup>, vous obtenez un nombre de points différent pour chaque choix gagnant! </span><a style="color: #FFFF;" target="_parent" href="https://www.timhortons.ca/nouveaufidelitim">En savoir plus</a>'
  },
  'history/error/gameResults/text': {
    en: 'We’re having trouble displaying recent game results. Please check back later.',
    fr: 'Nous éprouvons des difficultés à afficher les résultats des dernières parties. Veuillez revenir plus tard.'
  },
  'history/empty/title': {
    en: "It looks like you haven't played yet. <br/> Please make some picks to </br> get started!",
    fr: "On dirait que vous n\u2019avez pas encore jou\xE9. <br/> Faites vos choix </br> pour commencer!"
  }
};

var strings$c = {
  'leaderboard/nav/pill': {
    en: 'Challenge',
    fr: 'Défi no'
  },
  'leaderboard/table/rank': {
    en: 'Rank',
    fr: 'Rang'
  },
  'leaderboard/table/localPos': {
    en: function en(numOfPlayers) {
      return "There are " + numOfPlayers + " Players Ranked Above You";
    },
    fr: function fr(numOfPlayers) {
      return "Il y a " + numOfPlayers + " participants devant vous dans le classement";
    }
  },
  'leaderboard/table/endOfPlayerResults': {
    en: function en(numOfRemainingPlayers) {
      return numOfRemainingPlayers + " Players Ranked Below You";
    },
    fr: function fr(numOfRemainingPlayers) {
      return "Il y a " + numOfRemainingPlayers + " participants derri\xE8re vous dans le classement";
    }
  },
  'leaderboard/table/localPosPep': {
    en: "Keep making the right picks to rank up!",
    fr: "Continuez de faire les bons choix pour monter dans le classement!"
  },
  'leaderboard/table/player': {
    en: 'Player',
    fr: 'Participant'
  },
  'leaderboard/table/correct': {
    en: 'Correct',
    fr: 'Choix gagnants'
  },
  'leaderboard/table/pick': {
    en: 'Pick %',
    fr: '% de choix gagnants'
  },
  'leaderboard/table/streak': {
    en: 'Streak',
    fr: 'Victoires consécutives'
  },
  'leaderboard/error/error-state': {
    en: 'We’re experiencing technical difficulties with displaying prizes and are working on a fix. In the meantime, you can still play for your chance to win.',
    fr: 'Nous éprouvons des difficultés techniques avec l’affichage des prix. Nous corrigeons la situation. En attendant, vous pouvez toujours participer pour courir la chance de gagner un prix.'
  },
  'leaderboard/error/no-completed-days': {
    en: 'This challenge just started! Check back soon to see the leaderboard results.',
    fr: 'Ce défi est commencé! Revenez bientôt pour voir le tableau des résultats.'
  },
  'leaderboard/personal-ranking/rank-change': {
    en: 'Since last game:',
    fr: 'Depuis le dernier match'
  },
  'leaderboard/personal-ranking/caret-tooltip/up': {
    en: 'up',
    fr: 'hausse'
  },
  'leaderboard/personal-ranking/caret-tooltip/down': {
    en: 'down',
    fr: 'baisse'
  },
  'leaderboard/personal-ranking/caret-tooltip/none': {
    en: 'none',
    fr: 'rien'
  },
  'leaderboard/toggle/season': {
    en: 'Regular Season',
    fr: 'Saison régulière'
  },
  'leaderboard/toggle/monthly': {
    en: 'Monthly',
    fr: 'Mensuel'
  },
  'leaderboard/toggle/playoffs': {
    en: 'Playoffs',
    fr: 'Séries éliminatoires'
  },
  'leaderboard/playoffs/coming-soon/title': {
    en: 'Coming soon',
    fr: 'À venir sous peu'
  },
  'leaderboard/playoffs/coming-soon/text': {
    en: 'Regular season in progress. Check back later to see the awesome prizes we give away once the Stanley Cup® Playoffs start!',
    fr: 'Saison régulière en cours. Revenez plus tard pour voir les superbes prix que nous proposerons dès le début des séries éliminatoires de la Coupe Stanley<sup style="font-size: 10px; top: -0.5em">MC</sup>!'
  },
  'leaderboard/playoffs/coming-soon/img/src': {
    en: 'stanley-cup-logo.png',
    fr: 'stanley-cup-logo.png'
  },
  'leaderboard/playoffs/coming-soon/btn1': {
    en: 'Make your picks',
    fr: 'Faites vos choix'
  },
  'leaderboard/playoffs/coming-soon/btn2': {
    en: 'Check your stats',
    fr: 'Vérifiez vos statistiques'
  },
  'leaderboard/banner/season/header': {
    en: 'NHL® 2025/2026 Regular Season Challenge',
    fr: 'Défi de la saison régulière 2025-2026 de la LNH<sup>MD</sup>'
  },
  'leaderboard/banner/season/date': {
    en: 'Oct 7 - Apr 16',
    fr: '7 oct - 16 avril'
  },
  'leaderboard/inProgress/text': {
    en: 'IN PROGRESS',
    fr: 'EN COURS'
  },
  'leaderboard/completed/text': {
    en: 'COMPLETED',
    fr: 'TERMINÉ'
  },
  'leaderboard/banner/season/paragraph': {
    en: 'Put your hockey knowledge to the test for a chance to win a Hyundai TUCSON and more!',
    fr: 'Testez vos connaissances en matière de hockey pour courir la chance de gagner une Hyundai TUCSON, et plus encore!'
  },
  'leaderboard/banner/season/link': {
    en: 'View prize info',
    fr: 'Voir les informations sur les prix'
  },
  'leaderboard/banner/monthly/header': {
    en: 'Monthly Challenge',
    fr: 'Défi mensuel'
  },
  'leaderboard/banner/monthly/date': {
    en: ['Oct 7 - Oct 31', 'Nov 1 - Nov 30', 'Dec 1 - Dec 31', 'Jan 1 - Jan 31', 'Feb 1 - Feb 28', 'Mar 1 - Apr 16', 'Playoffs'],
    fr: ['7 oct. - 31 oct.', '1<sup style="font-size: 0.8em">er</sup> nov. - 30 nov.', '1<sup style="font-size: 0.8em">er</sup> déc. - 31 déc.', '1<sup style="font-size: 0.8em">er</sup> janv. - 31 janv.', '1<sup style="font-size: 0.8em">er</sup> févr. - 28 févr.', '1<sup style="font-size: 0.8em">er</sup> mars - 16 avr.', 'Séries éliminatoires']
  },
  'leaderboard/banner/monthly/paragraph': {
    en: 'A chance to win prizes from these top brands every month!',
    fr: 'Une chance de gagner des prix de ces grandes marques chaque mois!'
  },
  'leaderboard/banner/playoffs/header': {
    en: 'Stanley Cup® Playoffs Challenge',
    fr: 'Défi séries éliminatoires de la Coupe Stanley<sup>MC</sup>'
  },
  'leaderboard/banner/playoffs/date': {
    en: 'Apr 19',
    fr: '19 avril'
  },
  'leaderboard/banner/playoffs/paragraph': {
    en: 'Put your playoff knowledge to the test for a chance to win an <b>Ultimate VIP Prince Edward Island Vacation for 2</b> and more!',
    fr: 'Testez vos connaissances des séries éliminatoires et courez la chance de gagner un <b>Séjour VIP ultime à l’Île‑du‑Prince‑Édouard pour 2</b>, et plus encore!'
  },
  'leaderboard/banner/playoffs/link': {
    en: 'View prize info',
    fr: 'Voir les informations sur les prix'
  },
  'leaderboard/banner/playoffs/route': {
    en: '/game-info',
    fr: '/game-info'
  },
  'leaderboard/season/season-ended/title': {
    en: 'Congrats to the regular season winners!',
    fr: 'Félicitations aux <br /> gagnants de la saison <br /> régulière!'
  },
  'leaderboard/season/season-ended/text': {
    en: 'Winners of the regular season prizes have been contacted. Didn’t win? You’ve got another shot! Put your playoff knowledge to the test for a chance to win new prizes.',
    fr: 'Nous avons communiqué avec les gagnants des prix de la saison régulière. Vous n’avez pas gagné? Voilà votre seconde chance! Testez vos connaissances des séries éliminatoires et courez la chance de gagner de nouveaux prix.'
  },
  'leaderboard/season/season-ended/btn1': {
    en: 'Make your picks',
    fr: 'Faites Vos Choix'
  },
  'leaderboard/season/season-ended/btn2': {
    en: 'Check your stats',
    fr: 'Vérifiez Vos Statistiques'
  },
  'leaderboard/monthly/challenge-ended/title': {
    en: 'Congrats to the Monthly Challenge winners!',
    fr: 'Félicitations aux<br /> gagnants du défi<br /> mensuel!'
  },
  'leaderboard/monthly/challenge-ended/text': {
    en: 'Winners of our last Monthly Challenge prizes have been contacted. Didn’t win? You’ve got another shot! Put your playoff knowledge to the test for a chance to win new prizes.',
    fr: 'Nous avons communiqué avec les gagnants des prix du défi mensuel. Vous n’avez pas gagné? Voilà votre seconde chance! Testez vos connaissances des séries éliminatoires et courez la chance de gagner de nouveaux prix.'
  },
  'leaderboard/monthly/challenge-ended/btn1': {
    en: 'Make your picks',
    fr: 'Faites Vos Choix'
  },
  'leaderboard/monthly/challenge-ended/btn2': {
    en: 'Check your stats',
    fr: 'Vérifiez Vos Statistiques'
  }
};

var strings$d = {
  'challenges/season/title': {
    en: 'NHL® 2025/2026<br /> REGULAR SEASON<br /> CHALLENGE',
    fr: 'DÉFI DE LA SAISON<br /> RÉGULIÈRE 2025-2026<br /> DE LA LNH<sup>MD</sup>'
  },
  'challenges/season/heatstreak/title': {
    en: 'NHL® 2025/2026<br /> Regular Season<br /> Challenge',
    fr: 'Défi de la saison régulière 2025-2026 de la LNH<sup>MD</sup>'
  },
  'challenges/season/title/playnow': {
    en: 'NHL® 2025/2026<br /> REGULAR SEASON<br /> CHALLENGE',
    fr: 'DÉFI DE LA SAISON<br /> RÉGULIÈRE 2025-2026<br /> DE LA LNH<sup>MD</sup>'
  },
  'challenges/playoff/title': {
    en: 'Stanley Cup® <br /> Playoffs Challenge',
    fr: 'Défi séries </br>éliminatoires de la </br>Coupe Stanley<sup>MC</sup>'
  },
  'challenges/playoffcomingsoon/title': {
    en: 'STANLEY CUP®<br /> PLAYOFFS EDITION',
    fr: 'SÉRIES ÉLIMINATOIRES DE<br /> LA COUPE STANLEY<sup>MC</sup> '
  },
  'challenges/season/text': {
    en: '<span>NHL® 2025/2026<br/> Regular Season <br/> Grand Prize</span>Make the right picks and earn points throughout the NHL® 2025/2026 Regular Season for the chance to win a Hyundai TUCSON!',
    fr: '<span>Grand prix de la saison régulière 2025-2026 de la LNH<sup>MD</sup></span>Faites les bons choix et accumulez des points pendant toute la saison régulière 2025-2026 de la LNH<sup>MD</sup> pour gagner une Hyundai TUCSON!'
  },
  'challenges/season/prizes': {
    en: ['A Hyundai TUCSON', 'One $800 Tims Gift Card + One $100 NHL® Shop Gift Card', 'One $500 Tims Gift Card + One $100 NHL® Shop Gift Card', 'One $250 Tims Gift Card + One $100 NHL® Shop Gift Card', 'One $150 Tims Gift Card + One $100 NHL® Shop Gift Card'],
    fr: ['Une Hyundai TUCSON', 'Une carte-cadeau Tim Hortons® de 800 $ + une carte-cadeau de 100 $ de la boutique de la LNH<sup>MD</sup>', 'Une carte-cadeau Tim Hortons® de 500 $ + une carte-cadeau de 100 $ de la boutique de la LNH<sup>MD</sup>', 'Une carte-cadeau Tim Hortons® de 250 $ + une carte-cadeau de 100 $ de la boutique de la LNH<sup>MD</sup>', 'Une carte-cadeau Tim Hortons® de 150 $ + une carte-cadeau de 100 $ de la boutique de la LNH<sup>MD</sup>']
  },
  'challenges/playoff/text': {
    en: '<span>Stanley Cup® Playoffs Challenge</span> Make the right picks and earn streaks throughout the Stanley Cup® Playoffs for a chance to win an Ultimate VIP Prince Edward Island Vacation for 2—and more!',
    fr: '<span>Défi séries éliminatoires de la Coupe Stanley<sup>MC</sup></span> Faites les bons choix et réalisez des victoires consécutives pendant les séries éliminatoires de la Coupe Stanley<sup>MC</sup> pour courir la chance de gagner un Séjour VIP ultime à l’Île‑du‑Prince‑Édouard pour 2, et plus encore!'
  },
  'challenges/playoffcomingsoon/text': {
    en: '<span>Stanley Cup® Playoffs Edition</span>Playoffs are coming and we’ve got new prizes! Winners are picked at the end of the Stanley Cup® Playoffs!',
    fr: '<span>Édition des séries éliminatoires de la Coupe Stanley<sup>MC</sup></span>Les séries éliminatoires commencent bientôt, et nous avons de nouveaux prix! Les gagnants seront déterminés à la fin des séries éliminatoires de la Coupe Stanley<sup>MC</sup>!'
  },
  'challenges/blurb/text/line/1': {
    en: 'The top 5 players in each challenge will win amazing prizes!</br> Be sure to see how you stack up against others on the leaderboard.',
    fr: 'Pour chacun des défis, de superbes prix seront remis aux 5 meilleurs participants! Ne manquez pas de vérifier où vous vous situez dans le classement.'
  },
  'challenges/blurb/text/line/2': {
    en: '',
    fr: ''
  },
  'challenges/challenge1/img/src': {
    en: 'img-challenge-1.png',
    fr: 'img-challenge-1.png'
  },
  'challenges/heatstreak/banner/img': {
    en: '2025_heatstreak_banner_img_en.png',
    fr: '2025_heatstreak_banner_img_fr.png'
  },
  'challenges/heatstreak/banner/text': {
    en: "Guess a player correctly for 7 consecutive days to win free coffee for a week!*",
    fr: "Devinez correctement un joueur pendant 7 jours cons\xE9cutifs et gagnez un caf\xE9 gratuit pendant une semaine!*."
  },
  'challenges/heatstreak/banner/title': {
    en: "7-Day Hot Streak Prize",
    fr: "Ma s\xE9rie de victoires"
  },
  'challenges/monthly/title': {
    en: 'MONTHLY CHALLENGE',
    fr: 'DÉFI MENSUEL'
  },
  'challenges/monthly/heatstreak/title': {
    en: 'Monthly Challenge',
    fr: 'Défi Mensuel'
  },
  'challenges/inProgress/text': {
    en: 'IN PROGRESS',
    fr: 'EN COURS'
  },
  'challenges/completed/text': {
    en: 'COMPLETED',
    fr: 'TERMINÉ'
  },
  'challenges/grandprize/title': {
    en: 'Grand Prize Challenge',
    fr: 'Défi de la saison régulière de la LNHmd Saison régulière'
  },
  'challenges/dates': {
    en: ['Oct 7 - Oct 31', 'Nov 1 - Nov 30', 'Dec 1 - Dec 31', 'Jan 1 - Jan 31', 'Feb 1 - Feb 28', 'Mar 1 - Apr 16'],
    fr: ['7 oct. - 31 oct.', '1<sup style="font-size: 0.8em">er</sup> nov. - 30 nov.', '1<sup style="font-size: 0.8em">er</sup> déc. - 31 déc.', '1<sup style="font-size: 0.8em">er</sup> janv. - 31 janv.', '1<sup style="font-size: 0.8em">er</sup> févr. - 28 févr.', '1<sup style="font-size: 0.8em">er</sup> mars - 16 avr.']
  },
  'challenges/season/dates': {
    en: 'Oct 7 - Apr 16',
    fr: '7 oct. - 16 avr.'
  },
  'challenges/playoffs/dates': {
    en: 'Apr 19',
    fr: '19 avr.'
  },
  'challenges/pasts': {
    en: ['<span>Prizing Info</span> Top 5 participants won grand prizes from EA SPORTS.', '<span>Prizing Info</span> Top 5 participants won grand prizes from Canadian Tire and Sport Check.', '<span>Prizing Info</span> The top 5 participants won prizes from Tim Hortons and the NHL.', '<span>Prizing Info</span> The top 5 participants won prizes from Clorox.', '<span>Prizing Info</span> The top 5 participants won prizes from Sobeys.', '<span>Prizing Info</span> Top 5 participants won grand prizes from Esso.', '<span>Prizing Info</span> Top 5 participants won grand prizes from Tim Hortons and FunRideBikes.com!'],
    fr: ['<span>Prix</span> Les 5 meilleurs participants ont remporté des prix de EA SPORTS.', '<span>Prix</span> Les 5 meilleurs participants ont remporté des prix de Canadian Tire et Sport Check.', '<span>Prix</span> Les 5 meilleurs participants ont remporté des prix de Tim Hortons et de la LNH.', '<span>Prix</span> Les 5 meilleurs participants ont remporté des prix de Clorox.', '<span>Prix</span> Les 5 meilleurs participants ont remporté des prix de IGA.', '<span>Prix</span> Les 5 meilleurs participants ont remporté des prix de Esso.', '<span>Prix</span> Les 5 meilleurs participants ont remporté des Tim Hortons et de FunRideBikes.com!']
  },
  'challenges/text': {
    en: 'The top five players at the end of each month have a chance to win a prize in the Monthly Challenge. Check out the prizes below!',
    fr: 'Les cinq participants ayant accumulé le plus de points à la fin de chaque défi mensuel courront la chance de gagner un prix du défi mensuel. Découvrez les prix ci-dessous!'
  },
  'challenges/prizes': {
    en: ['One $400 Esso™ and Mobil™ Gift Card + One $400 Canadian Tire Gift Card + One $400 Sport Chek Gift Card + One $400 Skip Gift Card + $400 Tims Gift Card', 'One $250 Esso™ and Mobil™ Gift Card + One $250 Canadian Tire Gift Card + One $250 Sport Chek Gift Card + One $250 Skip Gift Card + $250 Tims Gift Card', 'One $200 Esso™ and Mobil™ Gift Card + One $200 Canadian Tire Gift Card + One $200 Sport Chek Gift Card + One $200 Skip Gift Card + $200 Tims Gift Card', 'One $150 Esso™ and Mobil™ Gift Card + One $150 Canadian Tire Gift Card + One $150 Sport Chek Gift Card + One $150 Skip Gift Card + $150 Tims Gift Card', 'One $100 Esso™ and Mobil™ Gift Card + One $100 Canadian Tire Gift Card + One $100 Sport Chek Gift Card + One $100 Skip Gift Card + $100 Tims Gift Card'],
    fr: ['Une carte-cadeau Esso<sup>MC</sup> Mobil<sup>MC</sup> de 400 $ + une carte-cadeau Canadian Tire de 400 $ + une carte-cadeau Sports Experts de 400 $ + une carte-cadeau SkipTheDishes de 400 $ + une carte-cadeau Tim Hortons® de 400 $', 'Une carte-cadeau Esso<sup>MC</sup> Mobil<sup>MC</sup> de 250 $ + une carte-cadeau Canadian Tire de 250 $ + une carte-cadeau Sports Experts de 250 $ + une carte-cadeau SkipTheDishes de 250 $ + une carte-cadeau Tim Hortons® de 250 $', 'Une carte-cadeau Esso<sup>MC</sup> Mobil<sup>MC</sup> de 200 $ + une carte-cadeau Canadian Tire de 200 $ + une carte-cadeau Sports Experts de 200 $ + une carte-cadeau SkipTheDishes de 200 $ + une carte-cadeau Tim Hortons® de 200 $', 'Une carte-cadeau Esso<sup>MC</sup> Mobil<sup>MC</sup> de 150 $ + une carte-cadeau Canadian Tire de 150 $ + une carte-cadeau Sports Experts de 150 $ + une carte-cadeau SkipTheDishes de 150 $ + une carte-cadeau Tim Hortons® de 150 $', 'Une carte-cadeau Esso<sup>MC</sup> Mobil<sup>MC</sup> de 100 $ + une carte-cadeau Canadian Tire de 100 $ + une carte-cadeau Sports Experts de 100 $ + une carte-cadeau SkipTheDishes de 100 $ + une carte-cadeau Tim Hortons® de 100 $']
  },
  'challenges/future/src': {
    en: 'tnhc_en_white.png',
    fr: 'tnhc_fr_white.png'
  },
  'challenges/future/text': {
    en: '<span>Challenge Awaits</span> Prizing info will be released once this challenge begins.',
    fr: '<span>Le défi vous attend</span> Les informations sur les prix seront publiées une fois ce défi commencé.'
  },
  'challenges/footer/disclaimer': {
    en: 'View terms and conditions (<a target="_parent" href="https://www.timhortons.ca/reglements-dhlt">FR</a> | <a target="_parent" href="https://www.timhortons.ca/tnhc-rules">EN</a>)',
    fr: '<a target="_parent" href="https://www.timhortons.ca/reglements-dhlt">Voir les modalités</a>'
  },
  'challenges/playoffs/prizes': {
    en: ['Ultimate VIP Prince Edward Island Vacation for 2', 'FREE Tim Hortons Coffee for a Year​', '$500 Tims Gift Card​', '$300 Tims Gift Card​', '$200 Tims Gift Card'],
    fr: ['Séjour VIP ultime à l’Île‑du‑Prince‑Édouard pour 2', 'Café Tim GRATUIT pendant un an​', 'Carte-Cadeau Tim de 500 $', 'Carte-Cadeau Tim de 300 $', 'Carte-Cadeau Tim de 200 $']
  },
  'challenges/playoffs/heatstreakbanner/title': {
    en: '7 Day Win Streak',
    fr: 'Série victorieuse de 7 jours'
  },
  'challenges/playoffs/heatstreakbanner/text': {
    en: 'Guess a player correctly for 7 consecutive days to win free coffee for a week!*',
    fr: 'Faites le bon choix pour 7 jours consécutifs et gagnez du café gratuit pendant une semaine!*'
  },
  'challenges/nochallenge/title': {
    en: 'Thank you for playing!',
    fr: 'Merci de vous prêter au jeu!'
  },
  'challenges/nochallenge/description': {
    en: 'We hope you enjoyed the Tim Hortons NHL Hockey Challenge<sup>TM</sup>. Check your stats to see how you did!',
    fr: 'Nous espérons que vous avez aimé le Défi de hockey de la LNH<sup>MD</sup> de Tim Hortons®. Consultez vos statistiques pour voir vos performances!'
  },
  'challenges/nochallenge/buttonText': {
    en: 'Check your stats',
    fr: 'Vérifiez vos statistiques'
  }
};

var strings$e = {
  'username/sectionBanner/text': {
    en: 'DISPLAY NAME CREATION',
    fr: 'CRÉATION D’UN NOM D’UTILISATEUR'
  },
  'username/header/text': {
    en: 'Create your display name for NHL Hockey Challenge Leaderboard',
    fr: 'Choisissez un nom d’utilisateur pour le classement du Défi de hockey de la LNH'
  },
  'username/blurb/text': {
    en: "In this year's Hockey Challenge, your display name will be used as your identifier in the leaderboard.",
    fr: "Nouveaut\xE9 cette ann\xE9e : votre nom d\u2019utilisateur sera celui utilis\xE9 pour vous identifier dans le classement."
  },
  'username/saveButton/text': {
    en: "Save",
    fr: "Enregistrer"
  },
  'username/usernameLengthError/text': {
    en: "Please enter a name between 3-15 characters, using only letters, numbers or underscores (_).",
    fr: "Veuillez saisir un nom qui comprend de 3 \xE0 15 caract\xE8res, en utilisant uniquement des lettres, des chiffres ou des traits de soulignement (_)."
  },
  'username/boomError/text': {
    en: function en(code) {
      switch (code) {
        case 'hc.40':
          return 'Please enter an appropriate display name.';

        case 'hc.41':
          return 'That name is already in use. Please enter a different name.';

        default:
          return 'Error';
      }
    },
    fr: function fr(code) {
      switch (code) {
        case 'hc.40':
          return 'Veuillez saisir un nom d’utilisateur approprié.';

        case 'hc.41':
          return 'Ce nom d’utilisateur est déjà utilisé. Veuillez saisir un nom d’utilisateur différent.';

        default:
          return 'Error';
      }
    }
  },
  'success/header/text': {
    en: "Lace your skates up, you're ready to play!",
    fr: 'Attachez vos patins, c’est l’heure de jouer!'
  },
  'success/button/text': {
    en: "Let's play!",
    fr: 'Jouer'
  },
  'success/blurb/text': {
    en: 'You can start by selecting players for the first game day.',
    fr: 'Commencez par sélectionner des joueurs pour le premier jour de match.'
  },
  'success/logo/src': {
    en: '2025_tnhc_en.png',
    fr: '2025_tnhc_fr.png'
  },
  'update/username/heading': {
    en: 'Display name',
    fr: "Nom d'affichage"
  },
  'update/username/buttonText': {
    en: 'Update',
    fr: 'Mise à jour'
  },
  'update/username/success': {
    en: 'Display Name has been updated. You should see the change within the next 24 hours.',
    fr: 'Le nom d’affichage a été mis à jour. Vous devriez voir le changement dans les prochaines 24 heures.'
  }
};

var strings$f = {
  'roles/img/hockeyChallengeLogo/alt': {
    en: 'Hockey Challenge Logo',
    fr: 'Logo du Défi de hockey'
  },
  'roles/button/close/aria': {
    en: 'Close',
    fr: 'Fermer'
  }
};

var strings$g = {
  'getNewApp/header1': {
    en: 'The same',
    fr: 'La même appli'
  },
  'getNewApp/header2': {
    en: 'app you love-now with a new look.',
    fr: 'que vous aimez - maintenant avec un nouveau look.'
  },
  'getNewApp/text': {
    en: 'You’ll need to update to the latest version of the app in order to play the Tims NHL Hockey Challenge<sup>TM</sup>.',
    fr: 'Vous devez mettre à jour l’appli pour participer au Défi de hockey de la LNH de Tim Hortons.'
  },
  'getNewApp/googleLink': {
    en: 'https://play.google.com/store/apps/details?id=digital.rbi.timhortons&hl=en_CA&gl=CA&pli=1',
    fr: 'https://play.google.com/store/apps/details?id=digital.rbi.timhortons&hl=fr_CA&gl=CA&pli=1'
  },
  'getNewApp/appleLink': {
    en: 'https://apps.apple.com/ca/app/tim-hortons/id1143883086',
    fr: 'https://apps.apple.com/ca/app/tim-hortons/id1143883086?l=fr'
  },
  'getNewApp/timsLogo': {
    en: 'Tims_en.png',
    fr: 'Tims_fr.png'
  },
  'getNewApp/appleLogo': {
    en: 'Apple_en.png',
    fr: 'Apple_fr.png'
  },
  'getNewApp/googleLogo': {
    en: 'Google_en.png',
    fr: 'Google_fr.png'
  }
};

var strings$h = _extends({}, strings, strings$1, strings$2, strings$3, strings$4, strings$5, strings$6, strings$7, strings$8, strings$9, strings$b, strings$a, strings$c, strings$d, strings$e, strings$f, strings$g);

var getStringsByLanguage = function getStringsByLanguage(strings) {
  var language = (arguments.length <= 1 ? 0 : arguments.length - 1) > 0 && (arguments.length <= 1 ? undefined : arguments[1]) !== undefined ? arguments.length <= 1 ? undefined : arguments[1] : 'en';
  return Object.entries(strings).reduce(function (acc, curr) {
    acc[curr[0]] = curr[1][language];
    return acc;
  }, {});
};

var stringsReducer = function stringsReducer(state, action) {
  if (state === void 0) {
    state = getStringsByLanguage(strings$h);
  }

  switch (action.type) {
    case 'SET_LANGUAGE':
      return getStringsByLanguage(strings$h, action.resp);

    default:
      return state;
  }
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var allRoutes = {
  onboarding: {
    id: 'onboarding',
    path: '/onboarding',
    label: 'Onboarding',
    hideInNav: true,
    displaySettings: {
      showClose: true,
      showLogo: true,
      showPrefix: false,
      showNavLinks: false,
      showFooter: false
    }
  },
  playNow: {
    id: 'playNow',
    path: '/',
    label: 'Play Now',
    exclude: true,
    hideInNav: false,
    displaySettings: {
      showClose: true,
      showLogo: true,
      showPrefix: true,
      showNavLinks: true,
      showFooter: true
    }
  },
  history: {
    id: 'history',
    path: '/history',
    label: 'History',
    hideInNav: false,
    displaySettings: {
      showClose: true,
      showLogo: true,
      showPrefix: true,
      showNavLinks: true,
      showFooter: true
    }
  },
  leaderboard: {
    id: 'leaderboard',
    path: '/leaderboard',
    label: 'Leaderboard',
    hideInIav: false,
    displaySettings: {
      showClose: true,
      showLogo: true,
      showPrefix: true,
      showNavLinks: true,
      showFooter: true
    }
  },
  gameInfo: {
    id: 'gameInfo',
    path: '/game-info',
    label: 'Game Info',
    hideInNav: false,
    displaySettings: {
      showClose: true,
      showLogo: true,
      showPrefix: true,
      showNavLinks: true,
      showFooter: true
    }
  }
};
var showHeaderMap = ['onboarding', 'playNow', 'gameInfo', 'history', 'leaderboard'];

var allRouteIds = function allRouteIds(state) {
  if (state === void 0) {
    state = Object.keys(allRoutes);
  }

  return state;
};

var routeById = function routeById(state) {
  if (state === void 0) {
    state = allRoutes;
  }

  return state;
};

var currentRoute = function currentRoute(state, action) {
  if (state === void 0) {
    state = 'onboarding';
  }

  switch (action.type) {
    case 'SET_CURRENT_ROUTE':
      return (action === null || action === void 0 ? void 0 : action.resp) || state;

    case 'FETCH_QUIZ_DATA_FAILURE':
      return 'playNow';

    default:
      return state;
  }
};

var menuLinkClicked = function menuLinkClicked(state, action) {
  if (state === void 0) {
    state = null;
  }

  switch (action.type) {
    case 'SET_MENU_LINK_CLICK':
      return action.resp;

    default:
      return state;
  }
};

var routing = combineReducers({
  allRouteIds: allRouteIds,
  routeById: routeById,
  currentRoute: currentRoute,
  menuLinkClicked: menuLinkClicked
});

var notificationBarOpen = function notificationBarOpen(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SET_NOTIFICATION_BAR_OPEN':
    case 'SET_NOTIFICATION_BAR_CLOSED':
      return !state;

    case 'SEND_PLAYER_PICKS_SUCCESS':
      return false;

    default:
      return state;
  }
};

var heatStreakPanelOpen = function heatStreakPanelOpen(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SET_HEATSTREAK_PANEL_OPEN':
      return !state;

    case 'SET_HEATSTREAK_PANEL_CLOSED':
      return !state;

    case 'SET_CURRENT_ROUTE':
    case 'SET_RANDOM_PLAYER_PICKS':
    case 'SET_PLAYER_TO_PICKED':
    case 'SET_SLOT_TO_OPEN':
      return false;

    default:
      return state;
  }
};

var isFetching = function isFetching(state, action) {
  if (state === void 0) {
    state = 1;
  }

  switch (action.type) {
    case 'SET_UI_IS_FETCHING':
      return state + 1;

    case 'SET_UI_IS_NOT_FETCHING':
      return state - 1;

    default:
      return state;
  }
};

var showNavLinks = function showNavLinks(state, action) {
  if (state === void 0) {
    state = true;
  }

  switch (action.type) {
    case 'FETCH_QUIZ_DATA_SUCCESS':
      return action.resp;

    default:
      return state;
  }
};

var showHeader = function showHeader(state, action) {
  if (state === void 0) {
    state = true;
  }

  switch (action.type) {
    case 'SET_CURRENT_ROUTE':
      return showHeaderMap.includes(action.resp);

    default:
      return state;
  }
};

var componentSize = function componentSize(state, action) {
  if (state === void 0) {
    state = {
      notificationBar: 0,
      gameList: 0,
      picksScrollPosition: {
        withNotification: 0,
        withoutNotification: 0
      }
    };
  }

  switch (action.type) {
    case 'SET_ELEMENT_HEIGHT':
      {
        var _action$resp = action.resp,
            notificationBar = _action$resp.notificationBar,
            gameList = _action$resp.gameList;

        if (!notificationBarOpen || !gameList) {
          return state;
        }

        return _extends({}, state, {
          picksScrollPosition: {
            withNotification: notificationBar + gameList,
            withoutNotification: gameList
          }
        });
      }

    default:
      return state;
  }
};

var isScrolling = function isScrolling(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SET_UI_SCROLLING':
      return true;

    case 'SET_UI_NOT_SCROLLING':
      return false;

    default:
      return state;
  }
};

var browserIsActive = function browserIsActive(state, action) {
  if (state === void 0) {
    state = true;
  }

  switch (action.type) {
    case 'SET_APP_FOCUS_STATE':
      return action.resp.focusState;

    default:
      return state;
  }
};

var showFooter = function showFooter(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'FETCH_QUIZ_DATA_SUCCESS':
      return action.resp;

    default:
      return state;
  }
};

var isFocused = function isFocused(state, action) {
  if (state === void 0) {
    state = {
      picks: false
    };
  }

  switch (action.type) {
    case 'SET_ELEMENT_IN_VIEW':
      return _extends({}, state, action.resp);

    default:
      return state;
  }
};

var hasFetchError = function hasFetchError(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'FETCH_QUIZ_DATA_SUCCESS':
      return false;

    case 'FETCH_QUIZ_DATA_FAILURE':
    case 'FETCH_PLAYER_DATA_FAILURE':
    case 'FETCH_HISTORY_DATA_FAILURE':
    case 'FETCH_AUTH_FAILURE':
      return true;

    case 'FETCH_RESET':
      return false;

    default:
      return state;
  }
};

var adConfig = function adConfig(state, action) {
  if (state === void 0) {
    state = {};
  }

  switch (action.type) {
    case 'FETCH_AD_CONFIG_SUCCESS':
      return action.resp;

    default:
      return state;
  }
};

var fetchErrorCount = function fetchErrorCount(state, action) {
  if (state === void 0) {
    state = 0;
  }

  switch (action.type) {
    case 'SET_INCREMENT_FETCH_ERROR_COUNT':
      return action.resp;

    case 'FETCH_QUIZ_DATA_SUCCESS':
    case 'FETCH_PLAYER_DATA_SUCCESS':
    case 'FETCH_HISTORY_DATA_SUCCESS':
    case 'FETCH_LEADERBOARD_DATA_SUCCESS':
      return 0;

    default:
      return state;
  }
};

var crashError = function crashError(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'FETCH_DATA_500_FAILURE':
      return true;

    default:
      return state;
  }
};

var ui = combineReducers({
  isFetching: isFetching,
  componentSize: componentSize,
  hasFetchError: hasFetchError,
  isScrolling: isScrolling,
  notificationBarOpen: notificationBarOpen,
  heatStreakPanelOpen: heatStreakPanelOpen,
  showNavLinks: showNavLinks,
  showHeader: showHeader,
  showFooter: showFooter,
  isFocused: isFocused,
  adConfig: adConfig,
  browserIsActive: browserIsActive,
  fetchErrorCount: fetchErrorCount,
  crashError: crashError
});

var prizes = [{
  id: 1,
  points: 25,
  isOffer: false
}, {
  id: 2,
  points: 50,
  isOffer: false
}, {
  id: 3,
  points: 100,
  isOffer: false
}];

var rewards = function rewards(state) {
  if (state === void 0) {
    state = prizes;
  }

  return state;
};

var prizeList = combineReducers({
  rewards: rewards
});

var initialState = {
  regular: {
    questions: [['3x10', 6, 2, 4], ['2x7', 2, 6, 2], ['5x6', 2, 7, 2], ['8x4', 2, 4, 9]],
    options: [[2, 3, 4, 10], [2, 11, 5, 14], [7, 14, 20, 5], [6, 9, 11, 19]],
    answers: [3, 11, 20, 11]
  },
  playoffs: {
    questions: [['2x8', 2, 5, 3], ['5x3', 5, 7, 4], ['6x2', 3, 9, 2], ['12x1', 4, 10, 6]],
    options: [[10, 4, 8, 20], [4, 6, 2, 30], [2, 11, 5, 14], [30, 7, 2, 18]],
    answers: [10, 6, 11, 7]
  }
};

var isFetching$1 = function isFetching(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'FETCH_QUIZ_DATA_START':
    case 'SEND_QUIZ_ANSWER_START':
    case 'SEND_USERNAME_START':
    case 'FETCH_NOTIFICATIONS_START':
    case 'SEND_NOTIFICATIONS_START':
      return true;

    case 'FETCH_QUIZ_DATA_SUCCESS':
    case 'FETCH_QUIZ_DATA_FAILURE':
    case 'SEND_QUIZ_ANSWER_SUCCESS':
    case 'SEND_QUIZ_ANSWER_FAILURE':
    case 'SEND_USERNAME_SUCCESS':
    case 'SEND_USERNAME_FAILURE':
    case 'FETCH_NOTIFICATIONS_SUCCESS':
    case 'FETCH_NOTIFICATIONS_FAILURE':
    case 'SEND_NOTIFICATIONS_SUCCESS':
    case 'SEND_NOTIFICATIONS_FAILURE':
      return false;

    default:
      return state;
  }
};

var questions = function questions(state, action) {
  if (state === void 0) {
    state = initialState.regular.questions;
  }

  switch (action.type) {
    case 'SET_IS_PLAYOFFS':
      return action.payload ? initialState.playoffs.questions : initialState.regular.questions;

    default:
      return state;
  }
};

var options = function options(state, action) {
  if (state === void 0) {
    state = initialState.regular.options;
  }

  switch (action.type) {
    case 'SET_IS_PLAYOFFS':
      return action.payload ? initialState.playoffs.options : initialState.regular.options;

    default:
      return state;
  }
};

var answers = function answers(state, action) {
  if (state === void 0) {
    state = initialState.regular.answers;
  }

  switch (action.type) {
    case 'SET_IS_PLAYOFFS':
      return action.payload ? initialState.playoffs.answers : initialState.regular.answers;

    default:
      return state;
  }
};

var onboardingStep = function onboardingStep(state, action) {
  if (state === void 0) {
    state = 0;
  }

  switch (action.type) {
    case 'FETCH_QUIZ_DATA_SUCCESS':
      return state + (action.resp ? 1 : 0);

    case 'FETCH_USER_SUCCESS':
      return state + (action.resp.user.username ? 1 : 0);

    case 'FETCH_NOTIFICATIONS_SUCCESS':
      return state + (action.resp.tnhcUserReminders !== undefined ? 1 : 0);

    case 'SET_CORRECT_ANSWER':
    case 'SET_USERNAME':
    case 'SET_COMPLETED_ONBOARDING':
    case 'SEND_NOTIFICATIONS_SUCCESS':
    case 'SEND_NOTIFICATIONS_FAILURE':
      return state + 1;

    default:
      return state;
  }
};

var initialStep = function initialStep(state, action) {
  if (state === void 0) {
    state = 0;
  }

  switch (action.type) {
    case 'FETCH_QUIZ_DATA_SUCCESS':
      return state + (action.resp ? 1 : 0);

    case 'FETCH_USER_SUCCESS':
      return state + (action.resp.user.username ? 1 : 0);

    case 'FETCH_NOTIFICATIONS_SUCCESS':
      return state + (action.resp.tnhcUserReminders !== undefined ? 1 : 0);

    default:
      return state;
  }
};

var hasAnswered = function hasAnswered(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'FETCH_QUIZ_DATA_SUCCESS':
      return action.resp;

    case 'SET_CORRECT_ANSWER':
      return true;

    case 'FETCH_QUIZ_DATA_FAILURE':
      return false;

    default:
      return state;
  }
};

var lockout = function lockout(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SET_LOCKOUT':
      return true;

    default:
      return state;
  }
};

var hasUsername = function hasUsername(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'FETCH_USER_SUCCESS':
      return !!action.resp.user.username;

    case 'SET_USERNAME':
      return true;

    case 'FETCH_USER_FAILURE':
      return false;

    default:
      return state;
  }
};

var hasNotificationPref = function hasNotificationPref(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'FETCH_NOTIFICATIONS_SUCCESS':
      return action.resp.tnhcUserReminders !== undefined;

    case 'SEND_NOTIFICATIONS_SUCCESS':
      return true;

    case 'FETCH_NOTIFICATIONS_FAILURE':
      return false;

    default:
      return state;
  }
};

var attempts = function attempts(state, action) {
  if (state === void 0) {
    state = 0;
  }

  switch (action.type) {
    case 'SET_INCORRECT_ANSWER':
      return state + 1;

    default:
      return state;
  }
};

var selectedAnswer = function selectedAnswer(state, action) {
  if (state === void 0) {
    state = null;
  }

  switch (action.type) {
    case 'SET_SELECTED_ANSWER':
      return action.resp;

    case 'SET_INCORRECT_ANSWER':
      return null;

    default:
      return state;
  }
};

var correctAnswer = function correctAnswer(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SET_CORRECT_ANSWER':
      return true;

    case 'FETCH_QUIZ_DATA_SUCCESS':
      return action.resp;

    default:
      return state;
  }
};

var errorCode = function errorCode(state, action) {
  if (state === void 0) {
    state = '';
  }

  switch (action.type) {
    case 'SEND_USERNAME_FAILURE':
      return action.err;

    case 'SEND_ERROR_CODE_RESET':
    case 'SEND_USERNAME_SUCCESS':
      return '';

    default:
      return state;
  }
};

var usernameValidationErr = function usernameValidationErr(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SET_USERNAME_VALIDATION_ERR':
      return action.resp;

    default:
      return state;
  }
};

var username = function username(state, action) {
  if (state === void 0) {
    state = '';
  }

  switch (action.type) {
    case 'FETCH_USER_SUCCESS':
      return action.resp.user.username;

    case 'SET_USERNAME':
      return action.resp;

    default:
      return state;
  }
};

var updateUsernameStatus = function updateUsernameStatus(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SEND_USERNAME_SUCCESS':
      return true;

    case 'RESET_USERNAME_STATUS':
      return false;

    default:
      return state;
  }
};

var resetUserNameAttemptStatus = function resetUserNameAttemptStatus(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SET_USERNAME_ATTEMPT_FAILURE':
      return true;

    case 'SET_USERNAME_ATTEMPT_SUCCESS':
      return false;

    default:
      return state;
  }
};

var onboarding = combineReducers({
  questions: questions,
  options: options,
  answers: answers,
  isFetching: isFetching$1,
  initialStep: initialStep,
  onboardingStep: onboardingStep,
  hasAnswered: hasAnswered,
  hasUsername: hasUsername,
  hasNotificationPref: hasNotificationPref,
  attempts: attempts,
  selectedAnswer: selectedAnswer,
  correctAnswer: correctAnswer,
  usernameValidationErr: usernameValidationErr,
  errorCode: errorCode,
  username: username,
  lockout: lockout,
  updateUsernameStatus: updateUsernameStatus,
  resetUserNameAttemptStatus: resetUserNameAttemptStatus
});

var parseTeam = function parseTeam(team) {
  return team || '';
};

var getTeamsById = function getTeamsById(resp) {
  var allTeams = [];
  resp.forEach(function (_ref) {
    var teams = _ref.teams;
    return allTeams.push(teams);
  });
  return allTeams.reduce(function (acc, curr) {
    var _extends2;

    var homeTeam = curr.home;
    var awayTeam = curr.away;
    return _extends({}, acc, (_extends2 = {}, _extends2[homeTeam.id] = _extends({}, homeTeam, {
      abbr: parseTeam(homeTeam.abbr),
      city: parseTeam(homeTeam.city),
      id: parseTeam(homeTeam.id),
      logo: parseTeam(homeTeam.logo),
      name: parseTeam(homeTeam.name)
    }), _extends2[awayTeam.id] = _extends({}, awayTeam, {
      abbr: parseTeam(awayTeam.abbr),
      city: parseTeam(awayTeam.city),
      id: parseTeam(awayTeam.id),
      logo: parseTeam(awayTeam.logo),
      name: parseTeam(awayTeam.name)
    }), _extends2));
  }, {});
};

var byTeamId = function byTeamId(state, action) {
  if (state === void 0) {
    state = [];
  }

  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return getTeamsById(action.resp.games);

    default:
      return state;
  }
};

var teams = combineReducers({
  byTeamId: byTeamId
});

var some = [{
  startTime: '2020-08-01T20:00:00.000Z',
  venue: 'Scotiabank Arena',
  teams: [{
    id: '693f5a142bed6174b9f84ce91daf77760a50b202',
    name: 'Islanders',
    city: 'New York',
    logo: 'https://assets.boomfantasy.com/timHortons/teams/ny_islanders.svg',
    abbr: 'NYI'
  }, {
    id: '9448e06a93e22faf9960a61c2bc5f59a2333a3ea',
    name: 'Panthers',
    city: 'Florida',
    logo: 'https://assets.boomfantasy.com/timHortons/teams/florida.svg',
    abbr: 'FLA'
  }],
  started: false
}, {
  startTime: '2020-08-01T19:00:00.000Z',
  venue: 'Rogers Place',
  teams: [{
    id: 'd5cec58442d75d8010bbe065fa380bbb65a9e9d4',
    name: 'Oilers',
    city: 'Edmonton',
    logo: 'https://assets.boomfantasy.com/timHortons/teams/edmonton.svg',
    abbr: 'EDM'
  }, {
    id: 'd9c513e7ed81b7001f9a8e147da8a978b2e50e59',
    name: 'Blackhawks',
    city: 'Chicago',
    logo: 'https://assets.boomfantasy.com/timHortons/teams/chicago.svg',
    abbr: 'CHI'
  }],
  started: false
}, {
  startTime: '2020-08-01T16:00:00.000Z',
  venue: 'Scotiabank Arena',
  teams: [{
    id: 'b184c1e18582d910757b0a71cb1d813dbae85a44',
    name: 'Hurricanes',
    city: 'Carolina',
    logo: 'https://assets.boomfantasy.com/timHortons/teams/carolina.svg',
    abbr: 'CAR'
  }, {
    id: '35c8db3619ac07ce4abdba85635fc26f77d2ef03',
    name: 'Rangers',
    city: 'New York',
    logo: 'https://assets.boomfantasy.com/timHortons/teams/ny_rangers.svg',
    abbr: 'NYR'
  }],
  started: false
}];

var getStartedGames = function getStartedGames(resp) {
  return resp.filter(function (_ref) {
    var started = _ref.started;
    return started;
  });
};

var all = function all(state, action) {
  if (state === void 0) {
    state = some;
  }

  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return action.resp.games;

    default:
      return state;
  }
};

var noGamesStarted = function noGamesStarted(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return getStartedGames(action.resp.games).length === 0;

    default:
      return state;
  }
};

var allGamesStarted = function allGamesStarted(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return getStartedGames(action.resp.games).length === action.resp.games.length;

    default:
      return state;
  }
};

var hasGamesToday = function hasGamesToday(state, action) {
  if (state === void 0) {
    state = true;
  }

  switch (action.type) {
    case 'SET_NO_CONTEST_TODAY':
      return false;

    default:
      return state;
  }
};

var games = combineReducers({
  all: all,
  noGamesStarted: noGamesStarted,
  allGamesStarted: allGamesStarted,
  hasGamesToday: hasGamesToday
});

var getRandomNumber = function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

var getRandomPlayerIndex = function getRandomPlayerIndex(arr) {
  return getRandomNumber(1, arr.length - 1);
};

var slotCount = function slotCount(state) {
  if (state === void 0) {
    state = 3;
  }

  return state;
};

var isPlaceholder = function isPlaceholder(state, action) {
  var _extends2;

  if (state === void 0) {
    state = {
      1: false,
      2: false,
      3: false
    };
  }

  switch (action.type) {
    case 'SET_RANDOM_PLAYER_PICKS':
      return {
        1: true,
        2: true,
        3: true
      };

    case 'SET_PLACEHOLDER_STATE':
      return _extends({}, state, (_extends2 = {}, _extends2[action.resp] = false, _extends2));

    default:
      return state;
  }
};

var slotOpenId = function slotOpenId(state, action) {
  if (state === void 0) {
    state = null;
  }

  switch (action.type) {
    case 'SET_SLOT_TO_OPEN':
      return state === action.resp ? null : action.resp;

    case 'SET_SLOT_TO_CLOSED':
    case 'SEND_PLAYER_PICKS_SUCCESS':
      return null;

    default:
      return state;
  }
};

var slotClosed = function slotClosed(state, action) {
  var _extends3, _extends4;

  if (state === void 0) {
    state = {};
  }

  switch (action.type) {
    case 'SET_SLOT_TO_CLOSED':
      return _extends({}, state, (_extends3 = {}, _extends3[action.resp] = true, _extends3));

    case 'SET_SLOT_TO_OPEN':
      return _extends({}, state, (_extends4 = {}, _extends4[action.resp] = false, _extends4));

    default:
      return state;
  }
};

var picked = function picked(state, action) {
  if (state === void 0) {
    state = {
      1: null,
      2: null,
      3: null
    };
  }

  switch (action.type) {
    case 'SET_PLAYER_TO_PICKED':
      {
        var _extends5;

        var resp = action.resp;
        return _extends({}, state, (_extends5 = {}, _extends5[resp.id] = state[resp.id] === resp.playerId ? null : resp.playerId, _extends5));
      }

    case 'SET_PLAYER_PICKS_SUBMITTED':
      {
        return action.resp.picks.reduce(function (acc, _ref, index) {
          var _extends6;

          var player = _ref.player;
          var indexCounter = index + 1;
          return _extends({}, acc, (_extends6 = {}, _extends6[indexCounter] = player.id, _extends6));
        }, {});
      }

    case 'SET_RANDOM_PLAYER_PICKS':
      {
        var playersBySlot = action.resp.playersBySlot;
        var pickOne = getRandomPlayerIndex(playersBySlot[1]);
        var pickTwo = getRandomPlayerIndex(playersBySlot[2]);
        var pickThree = getRandomPlayerIndex(playersBySlot[3]);
        return {
          1: playersBySlot[1][pickOne].id,
          2: playersBySlot[2][pickTwo].id,
          3: playersBySlot[3][pickThree].id
        };
      }

    case 'CLEAR_ALL_PICKS':
      {
        return {
          1: null,
          2: null,
          3: null
        };
      }

    case 'SEND_PLAYER_PICKS_FAILURE':
      return {};

    default:
      return state;
  }
};

var fetchError = function fetchError(state, action) {
  if (state === void 0) {
    state = null;
  }

  switch (action.type) {
    case 'SEND_PLAYER_PICKS_SUCCESS':
    case 'SET_RANDOM_PLAYER_PICKS':
      return null;

    case 'SEND_PLAYER_PICKS_FAILURE':
      return action.err;

    default:
      return state;
  }
};

var picksLocked = function picksLocked(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SEND_PLAYER_PICKS_SUCCESS':
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return true;

    case 'CLEAR_ALL_PICKS':
      return false;

    default:
      return state;
  }
};

var picksSubmitted = function picksSubmitted(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SEND_PLAYER_PICKS_SUCCESS':
      return true;

    case 'CLEAR_ALL_PICKS':
      return false;

    default:
      return state;
  }
};

var randomPicksSelected = function randomPicksSelected(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SET_RANDOM_PLAYER_PICKS':
      return true;

    case 'SEND_PLAYER_PICKS_SUCCESS':
    case 'SET_PLAYER_TO_PICKED':
    case 'SET_CURRENT_ROUTE':
      return false;

    default:
      return state;
  }
};

var randomPickCount = function randomPickCount(state, action) {
  if (state === void 0) {
    state = 0;
  }

  switch (action.type) {
    case 'SET_RANDOM_PLAYER_PICKS':
      return state + 1;

    case 'SEND_PLAYER_PICKS_SUCCESS':
      return 0;

    default:
      return state;
  }
};

var pickClicked = function pickClicked(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SET_PLAYER_TO_PICKED':
      return true;

    case 'SET_SLOT_TO_CLOSED':
      return false;

    default:
      return state;
  }
};

var picksSentAlready = function picksSentAlready(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return true;

    default:
      return state;
  }
};

var incompletePicksModalOpen = function incompletePicksModalOpen(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SET_INCOMPLETE_PICKS_MODAL_OPEN':
      return true;

    case 'SET_INCOMPLETE_PICKS_MODAL_CLOSED':
      return false;

    case 'RESET_NAVIGATION_MODAL_STATE':
      return false;

    default:
      return state;
  }
};

var pendingNavigation = function pendingNavigation(state, action) {
  if (state === void 0) {
    state = null;
  }

  switch (action.type) {
    case 'SET_PENDING_NAVIGATION':
      return action.payload;

    case 'CLEAR_PENDING_NAVIGATION':
      return null;

    case 'RESET_NAVIGATION_MODAL_STATE':
      return null;

    default:
      return state;
  }
};

var submissionError = function submissionError(state, action) {
  if (state === void 0) {
    state = null;
  }

  switch (action.type) {
    case 'SEND_PLAYER_PICKS_SUCCESS':
    case 'CLEAR_SUBMISSION_ERROR':
      return null;

    case 'SEND_PLAYER_PICKS_FAILURE':
      return action.err || null;

    case 'CLEAR_ALL_PICKS':
      return null;

    default:
      return state;
  }
};

var picks = combineReducers({
  fetchError: fetchError,
  isPlaceholder: isPlaceholder,
  slotCount: slotCount,
  slotOpenId: slotOpenId,
  slotClosed: slotClosed,
  picked: picked,
  picksLocked: picksLocked,
  picksSubmitted: picksSubmitted,
  picksSentAlready: picksSentAlready,
  randomPicksSelected: randomPicksSelected,
  randomPickCount: randomPickCount,
  pickClicked: pickClicked,
  incompletePicksModalOpen: incompletePicksModalOpen,
  pendingNavigation: pendingNavigation,
  submissionError: submissionError
});

var parsePlayer = function parsePlayer(player) {
  return player || {
    id: null,
    firstName: null,
    lastName: null,
    number: null,
    position: null,
    teamId: null
  };
};
var getPlayersById = function getPlayersById(resp) {
  var allPlayers = [];
  resp.forEach(function (_ref) {
    var players = _ref.players;
    return allPlayers.push.apply(allPlayers, players);
  });
  return allPlayers.reduce(function (acc, curr) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[curr.id] = _extends({}, curr, {
      firstName: parsePlayer(curr).firstName,
      id: parsePlayer(curr).id,
      lastName: parsePlayer(curr).lastName,
      fullName: parsePlayer(curr).firstName + " " + parsePlayer(curr).lastName,
      number: parsePlayer(curr).number,
      position: parsePlayer(curr).position,
      teamId: parsePlayer(curr).teamId
    }), _extends2));
  }, {});
};

var getPlayersBySlotId = function getPlayersBySlotId(resp) {
  return resp.reduce(function (acc, curr) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[curr.id] = curr.players, _extends2));
  }, {});
};

var isFetching$2 = function isFetching(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'FETCH_PLAYER_DATA_START':
      return true;

    case 'FETCH_QUIZ_DATA_SUCCESS':
    case 'FETCH_PLAYER_DATA_FAILURE':
    case 'FETCH_PLAYER_DATA_NO_CONTEST':
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return false;

    default:
      return state;
  }
};

var byPlayerId = function byPlayerId(state, action) {
  if (state === void 0) {
    state = [];
  }

  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
      return getPlayersById(action.resp.sets);

    case 'SET_PLAYER_PICKS_SUBMITTED':
      return action.resp.picks.reduce(function (acc, _ref) {
        var _extends3;

        var player = _ref.player;
        return _extends({}, acc, (_extends3 = {}, _extends3[player.id] = _extends({}, player, {
          fullName: parsePlayer(player).firstName + " " + parsePlayer(player).lastName
        }), _extends3));
      }, {});

    default:
      return state;
  }
};

var bySlotId = function bySlotId(state, action) {
  if (state === void 0) {
    state = {};
  }

  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
      return getPlayersBySlotId(action.resp.sets);

    default:
      return state;
  }
};

var bySlotPlayerCount = function bySlotPlayerCount(state, action) {
  if (state === void 0) {
    state = {};
  }

  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
      {
        var playersBySlot = getPlayersBySlotId(action.resp.sets);
        return Object.keys(playersBySlot).reduce(function (acc, id) {
          var _extends4;

          var players = playersBySlot[id];
          return _extends({}, acc, (_extends4 = {}, _extends4[id] = players.length, _extends4));
        }, {});
      }

    default:
      return state;
  }
};

var playersPicked = function playersPicked(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return true;

    default:
      return state;
  }
};

var players = combineReducers({
  isFetching: isFetching$2,
  byPlayerId: byPlayerId,
  bySlotId: bySlotId,
  bySlotPlayerCount: bySlotPlayerCount,
  playersPicked: playersPicked
});

var howToGuide = {
  1: {
    id: 'howto-step-1',
    title: 'Scan for Tims Rewards',
    filename: 'howToPick',
    variant: 1,
    assetSize: '95'
  },
  2: {
    id: 'howto-step-2',
    title: 'Purchase a pack of digital hockey cards',
    filename: 'howToSubmit',
    variant: 0,
    assetSize: '50'
  },
  3: {
    id: 'howto-step-3',
    title: 'Earn card pack unwraps to win!',
    filename: 'howToWin',
    variant: 1,
    isLast: true,
    assetSize: '95'
  }
};

var byId = function byId(state) {
  if (state === void 0) {
    state = howToGuide;
  }

  return state;
};

var allIds = function allIds(state) {
  if (state === void 0) {
    state = Object.keys(howToGuide);
  }

  return state;
};

var howTo = combineReducers({
  byId: byId,
  allIds: allIds
});

var parseTeam$1 = function parseTeam(team) {
  return team || '';
};

var getTeamsById$1 = function getTeamsById(teams) {
  return teams.reduce(function (acc, curr) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[curr.id] = {
      abbr: parseTeam$1(curr.abbr),
      city: parseTeam$1(curr.city),
      id: parseTeam$1(curr.id),
      logo: parseTeam$1(curr.logo),
      name: parseTeam$1(curr.name)
    }, _extends2));
  }, {});
};

var getCurrentChallenge = function getCurrentChallenge(challenges) {
  if (challenges === void 0) {
    challenges = {};
  }

  for (var _i = 0, _Object$keys = Object.keys(challenges); _i < _Object$keys.length; _i++) {
    var _Object$keys$_i = _Object$keys[_i],
        challenge = _Object$keys$_i[0];

    if (challenges[challenge].status === 'current') {
      return challenges[challenge];
    }
  }

  return challenges[Object.keys(challenges).length.toString()];
};

var data = function data(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'FETCH_HISTORY_DATA_SUCCESS':
      return action.resp;

    default:
      return state;
  }
};

var byDate = function byDate(state, action) {
  if (state === void 0) {
    state = {};
  }

  switch (action.type) {
    case 'FETCH_HISTORY_DATA_SUCCESS':
      return action.resp.history.reduce(function (acc, curr) {
        var _extends2;

        var getMonth = parseFloat(curr.contestDate.substring(5, 6));
        var getDay = parseFloat(curr.contestDate.substring(8, 9));
        var month = !getMonth ? curr.contestDate.substring(6, 7) : curr.contestDate.substring(5, 7);
        var day = !getDay ? curr.contestDate.substring(9, 10) : curr.contestDate.substring(8, 10);
        return _extends({}, acc, (_extends2 = {}, _extends2[curr.contestDate] = _extends({}, curr, {
          month: month,
          day: day
        }), _extends2));
      }, []);

    default:
      return state;
  }
};

var streak = function streak(state, action) {
  if (state === void 0) {
    state = 0;
  }

  switch (action.type) {
    case 'FETCH_USER_STATS_SUCCESS':
      {
        return action.resp.scoringStreak || 0;
      }

    default:
      return state;
  }
};

var percentage = function percentage(state, action) {
  if (state === void 0) {
    state = 0;
  }

  switch (action.type) {
    case 'FETCH_USER_STATS_SUCCESS':
      {
        var _streak = action.resp.scoringStreak || 0;

        return _streak / 7 * 100;
      }

    default:
      return state;
  }
};

var challengeStats = function challengeStats(state, action) {
  if (state === void 0) {
    state = {};
  }

  switch (action.type) {
    case 'FETCH_USER_STATS_SUCCESS':
      {
        var currentChallenge = getCurrentChallenge(action.resp.challenges);

        if (currentChallenge) {
          return {
            challenge: currentChallenge.challengeNumber,
            pickAccuracy: currentChallenge.pickAccuracy,
            daysPlayed: currentChallenge.daysPlayed,
            correctPicks: currentChallenge.correctPicks,
            rank: currentChallenge.rank,
            rankChange: currentChallenge.rankChange
          };
        } else {
          return state;
        }
      }

    default:
      return state;
  }
};

var challenges = function challenges(state, action) {
  if (state === void 0) {
    state = null;
  }

  switch (action.type) {
    case 'FETCH_USER_STATS_SUCCESS':
      {
        return action.resp.challenges;
      }

    default:
      return state;
  }
};

var byPlayerId$1 = function byPlayerId(state, action) {
  if (state === void 0) {
    state = [];
  }

  switch (action.type) {
    case 'FETCH_HISTORY_DATA_SUCCESS':
      return getPlayersById(action.resp.teams);

    default:
      return state;
  }
};

var byTeamId$1 = function byTeamId(state, action) {
  if (state === void 0) {
    state = [];
  }

  switch (action.type) {
    case 'FETCH_HISTORY_DATA_SUCCESS':
      return getTeamsById$1(action.resp.teams);

    default:
      return state;
  }
};

var heatStreak = combineReducers({
  data: data,
  byDate: byDate,
  streak: streak,
  percentage: percentage,
  challengeStats: challengeStats,
  challenges: challenges,
  byPlayerId: byPlayerId$1,
  byTeamId: byTeamId$1
});

var isActive = function isActive(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'FETCH_NOTIFICATIONS_SUCCESS':
      {
        var isRemindersSet = action.resp.tnhcUserReminders === 'true';
        return isRemindersSet;
      }

    case 'SEND_NOTIFICATIONS_SUCCESS':
      return action.resp;

    default:
      return state;
  }
};

var reminderHasUpdated = function reminderHasUpdated(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SEND_NOTIFICATIONS_SUCCESS':
      return true;

    case 'FETCH_NOTIFICATIONS_FAILURE':
      return true;

    default:
      return state;
  }
};

var reminders = combineReducers({
  isActive: isActive,
  reminderHasUpdated: reminderHasUpdated
});

var isClicked = function isClicked(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'SET_OFFER_CLICKED':
      return true;

    default:
      return state;
  }
};

var offers = combineReducers({
  isClicked: isClicked
});

var TOP = 'top';
var BOTTOM = 'bottom';
var LEFT = 'left';
var RIGHT = 'right';
var START = 'start';
var END = 'end';
var CENTER = 'center';
var SEASON_END_DATE = '2025-04-16';
var SEASON_CODE = '2025-26 REG';
var MPARTICLE_LOG_MESSAGE_TYPE = 'MPARTICLE_LOG';
var SKILL_TEST_OPEN = 'Skills Test Screen Displayed';
var SKILL_TEST_OPTION_SELECTED = 'Skills Test Option Selected';
var PLAY_NOW_CLICK = 'Play Now Screen Clicked';
var GAME_INFO_CLICK = 'Game Info Screen Clicked';
var HISTORY_CLICK = 'History Screen Clicked';
var LEADERBOARD_CLICK = 'Leaderboard Screen Clicked';
var PLAY_NOW_OPEN = 'Play Now Screen Displayed';
var GAME_INFO_OPEN = 'Game Info Screen Displayed';
var HISTORY_OPEN = 'History Screen Displayed';
var LEADERBOARD_OPEN = 'Leaderboard Screen Displayed';
var PICKS_SUBMITTED = 'Player Picks Submitted';
var PICKS_AUTO_SELECTED = 'Player Picks Auto Selected';
var HEAT_STREAK_PANEL_SELECTED = 'heat_streak';
var LEADERBOARD_SEASON_TAB_SELECTED = 'Leaderboard Season Tab Selected';
var LEADERBOARD_MONTHLY_TAB_SELECTED = 'Leaderboard Monthly Tab Selected';
var LEADERBOARD_PLAYOFFS_TAB_SELECTED = 'Leaderboard Playoffs Tab Selected';
var MONTHLY_CHALLENGE_TAB_SELECTED = function MONTHLY_CHALLENGE_TAB_SELECTED(challengeNumber) {
  return "Monthly Challenge " + challengeNumber + " Selected";
};
var GAME_INFO_TERMS_AND_CONDITIONS_CLICKED = 'Game Info See Terms and Conditions Clicked';
var PLAY_NOW_TERMS_AND_CONDITIONS_CLICKED = 'Play Now See Terms and Conditions Clicked';
var CLICKED_TYPE = 'element_clicked';
var VIEWED_TYPE = 'page_view';
var SKILL_TEST_ANSWERED = 'skills_test_answered';
var MODAL_OPENED_TYPE = 'modal_opened';
var SKILL_TESTING_QUESTION = 'skill_testing_question';
var NOTIFICATIONS = 'notifications';
var ONBOARDING = 'onboarding';
var SUBMIT_ELEMENT = 'submit';
var ANSWER_ELEMENT = 'answer';
var PLAY_NOW_ELEMENT = 'play_now';
var SUBMIT_PICKS_ELEMENT = 'submit_picks';
var RANDOMLY_SELECT_PLAYERS_ELEMENT = 'randomly_select_players';
var HISTORY_ELEMENT = 'history';
var LEADERBOARD_ELEMENT = 'leaderboard';
var LEADERBOARD_SEASON_ELEMENT = 'leaderboard_season';
var LEADERBOARD_MONTHLY_ELEMENT = 'leaderboard_monthly';
var LEADERBOARD_PLAYOFFS_ELEMENT = 'leaderboard_playoffs';
var GAME_INFO_ELEMENT = 'game_info';
var USER_STATS_ELEMENT = 'user_stats';
var MAKE_YOUR_PICKS_ELEMENT = 'make_your_picks';
var SEE_YOUR_POSITION = 'see_your_position';
var SCROLL_TO_TOP = 'scroll_to_top';
var BUTTON_TYPE = 'button';
var TOGGLE_TYPE = 'toggle';
var TAB_TYPE = 'tab';
var POPUP_TYPE = 'popup';
var ON_VALUE = 'turn_on';
var OFF_VALUE = 'turn_off';
var CORRECT_VALUE = 'correct';
var INCORRECT_VALUE = 'wrong';
var PATH = '/hockey_challenge';

dayjs.extend(isYesterday);
dayjs.extend(isToday);

var removePeriods = function removePeriods(str) {
  return str.replace(/\./g, '');
};

var getFormattedTimestamp = function getFormattedTimestamp(timestamp, language) {
  var currentDate = new Date(timestamp);
  var lang = language || 'en';
  var localeConfigs = {
    en: {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    },
    fr: {
      hour: 'numeric',
      minute: 'numeric'
    }
  };
  var formatted = "" + removePeriods(currentDate.toLocaleString(lang + "-CA", localeConfigs[lang]));

  if (lang === 'fr') {
    return formatted;
  }

  return formatted.toUpperCase();
};
var isDateYesterday = function isDateYesterday(date) {
  return dayjs(date).isYesterday();
};
var isDateToday = function isDateToday(date) {
  return dayjs(date).isToday();
};
var getPreviousDay = function getPreviousDay(date) {
  return dayjs(date).subtract(1, 'day').format('YYYY-MM-DD');
};
var getNextDay = function getNextDay(date) {
  return dayjs(date).add(1, 'day').format('YYYY-MM-DD');
};
var getMonthDayDate = function getMonthDayDate(date) {
  return dayjs(date).format('MMM D');
};
var getDayDate = function getDayDate(date) {
  return dayjs(date).format('D');
};
var isDateAfter = function isDateAfter(date) {
  return dayjs().isAfter(date);
};

var leaderboardData = function leaderboardData(state, action) {
  if (state === void 0) {
    state = {};
  }

  switch (action.type) {
    case 'FETCH_LEADERBOARD_SUCCESS':
      return action.resp;

    case 'FETCH_LEADERBOARD_FAILURE':
      return {};

    default:
      return state;
  }
};

var isCurrentlySeason = function isCurrentlySeason(state, action) {
  if (state === void 0) {
    state = {};
  }

  switch (action.type) {
    case 'FETCH_SEASON_STATUS_SUCCESS':
      return action.resp;

    case 'FETCH_SEASON_STATUS_FAILURE':
      return {};

    default:
      return state;
  }
};

var isCurrentlyPlayoffs = function isCurrentlyPlayoffs(state, action) {
  if (state === void 0) {
    state = {};
  }

  switch (action.type) {
    case 'FETCH_PLAYOFFS_STATUS_SUCCESS':
      return action.resp;

    case 'FETCH_PLAYOFFS_STATUS_FAILURE':
      return {};

    default:
      return state;
  }
};

var localLeaderboardData = function localLeaderboardData(state, action) {
  if (state === void 0) {
    state = {};
  }

  switch (action.type) {
    case 'FETCH_LOCAL_LEADERBOARD_SUCCESS':
      return action.resp;

    case 'FETCH_LOCAL_LEADERBOARD_FAILURE':
      return {};

    default:
      return state;
  }
};

var error = function error(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'FETCH_LEADERBOARD_SUCCESS':
      return false;

    case 'FETCH_LEADERBOARD_FAILURE':
      return true;

    default:
      return state;
  }
};

var currentChallenge = function currentChallenge(state, action) {
  if (state === void 0) {
    state = 1;
  }

  var seasonEnded = isDateAfter(SEASON_END_DATE);
  var maxChallenges = strings$h['challenges/dates'].en.length;

  switch (action.type) {
    case 'FETCH_USER_STATS_SUCCESS':
      if (seasonEnded && Object.keys(action.resp.challenges).length > maxChallenges) {
        return maxChallenges;
      }

      return Object.keys(action.resp.challenges).length;

    default:
      return state;
  }
};

var isLoading = function isLoading(state, action) {
  if (state === void 0) {
    state = true;
  }

  switch (action.type) {
    case 'FETCH_LEADERBOARD_SUCCESS':
    case 'FETCH_LEADERBOARD_FAILURE':
    case 'FETCH_LOCAL_LEADERBOARD_SUCCESS':
    case 'FETCH_LOCAL_LEADERBOARD_FAILURE':
    case 'FETCH_PLAYOFFS_STATUS_SUCCESS':
    case 'FETCH_PLAYOFFS_STATUS_FAILURE':
      return false;

    case 'FETCH_LEADERBOARD_START':
    case 'FETCH_LOCAL_LEADERBOARD_START':
      return true;

    default:
      return state;
  }
};

var challengeErrorCode = function challengeErrorCode(state, action) {
  if (state === void 0) {
    state = '';
  }

  switch (action.type) {
    case 'FETCH_LEADERBOARD_SUCCESS':
      if (action.resp.totalDaysCompleted === 0) {
        return 'leaderboard/error/no-completed-days';
      }

      return '';

    default:
      return state;
  }
};

var hasUserStats = function hasUserStats(state, action) {
  if (state === void 0) {
    state = false;
  }

  switch (action.type) {
    case 'FETCH_USER_STATS_SUCCESS':
      return true;

    case 'FETCH_USER_STATS_START':
      return false;

    default:
      return state;
  }
};

var userStats = function userStats(state, action) {
  if (state === void 0) {
    state = {};
  }

  switch (action.type) {
    case 'FETCH_USER_STATS_SUCCESS':
      return action.resp;

    default:
      return state;
  }
};

var selectedChallenge = function selectedChallenge(state, action) {
  if (state === void 0) {
    state = null;
  }

  switch (action.type) {
    case 'SET_CHALLENGE_NUMBER':
      return action.resp;

    case 'FETCH_LEADERBOARD_SUCCESS':
    case 'FETCH_LOCAL_LEADERBOARD_SUCCESS':
      if (action.resp.status === 'current' && action.resp.board === 'monthly' && !state) {
        return action.resp.challengeNumber;
      }

      return state;

    case 'SET_MENU_LINK_CLICK':
      return null;

    default:
      return state;
  }
};

var selectedBoard = function selectedBoard(state, action) {
  if (state === void 0) {
    state = 'season';
  }

  switch (action.type) {
    case 'SET_BOARD_VIEW':
      return action.resp;

    default:
      return state;
  }
};

var leaderboard = combineReducers({
  leaderboardData: leaderboardData,
  isCurrentlySeason: isCurrentlySeason,
  isCurrentlyPlayoffs: isCurrentlyPlayoffs,
  localLeaderboardData: localLeaderboardData,
  currentChallenge: currentChallenge,
  isLoading: isLoading,
  challengeErrorCode: challengeErrorCode,
  error: error,
  userStats: userStats,
  hasUserStats: hasUserStats,
  selectedChallenge: selectedChallenge,
  selectedBoard: selectedBoard
});

var config = function config(state, action) {
  if (state === void 0) {
    state = {};
  }

  var resp = action.resp;

  switch (action.type) {
    case 'SET_SESSION_VALUE':
      return _extends({}, state, resp);

    case 'SET_FETCH_CONFIG_STATUS':
      return _extends({}, state, {
        hasFetchedConfig: true
      });

    default:
      return state;
  }
};

var rootReducer = function rootReducer() {
  return combineReducers({
    config: config,
    strings: stringsReducer,
    routing: routing,
    ui: ui,
    onboarding: onboarding,
    teams: teams,
    games: games,
    picks: picks,
    players: players,
    howTo: howTo,
    prizeList: prizeList,
    heatStreak: heatStreak,
    reminders: reminders,
    offers: offers,
    leaderboard: leaderboard
  });
};

var configureStore = (function (initialState) {
  if (initialState === void 0) {
    initialState = {};
  }

  var middleware = [thunkMiddleware];
  var enhancers = [];
  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  var store = createStore(rootReducer(), initialState, composeEnhancers.apply(void 0, [applyMiddleware.apply(void 0, middleware)].concat(enhancers)));
  return store;
});

var ANALYTICS_SUFFIX = process.env.APP_NODE_ENV === 'development' ? 'STAGING' : 'PROD';

var map = curry(function (iteratee, arr) {
  return arr.map(iteratee);
});
var mapValues = curry(function (iteratee, obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[key] = iteratee(obj[key]), _extends2));
  }, {});
});

var flexCenter = function flexCenter() {
  return "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n";
};
var flexStack = function flexStack() {
  return "\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  flex-direction: column;\n";
};
var flexEqualColumn = function flexEqualColumn() {
  return "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-flow: row;\n";
};
var fixTop = function fixTop() {
  return "\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n";
};
var fixAll = function fixAll() {
  return "\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n";
};

var createTypeHelper = function createTypeHelper(type, name) {
  return function (_ref) {
    var theme = _ref.theme;
    var _theme$typography$typ = theme.typography[type][name],
        fontSize = _theme$typography$typ.fontSize,
        lineHeight = _theme$typography$typ.lineHeight,
        letterSpacing = _theme$typography$typ.letterSpacing;
    return "\n    font-size: " + fontSize + ";\n    line-height: " + lineHeight + ";\n    letter-spacing: " + (letterSpacing || 'normal') + ";\n  ";
  };
};
var textByte = createTypeHelper('text', 'byte');
var textKilo = createTypeHelper('text', 'kilo');
var textMega = createTypeHelper('text', 'mega');
var textGiga = createTypeHelper('text', 'giga');
var textTera = createTypeHelper('text', 'tera');
var textPeta = createTypeHelper('text', 'peta');
var resetList = function resetList() {
  return "\n  list-style: none;\n  margin: 0;\n  padding: 0;\n ";
};
var disableVisually = function disableVisually() {
  return "\n  pointer-events: none;\n  box-shadow: none;\n";
};
var hideVisually = function hideVisually() {
  return "\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  whiteSpace: nowrap;\n  width: 1px;\n";
};
var createMediaQueries = mapValues(function (mediaExpression) {
  var _ref2 = typeof mediaExpression === 'string' ? {} : {
    prefix: '(min-width: ',
    suffix: 'px)'
  },
      _ref2$prefix = _ref2.prefix,
      prefix = _ref2$prefix === void 0 ? '' : _ref2$prefix,
      _ref2$suffix = _ref2.suffix,
      suffix = _ref2$suffix === void 0 ? '' : _ref2$suffix;

  var enhancedExpression = prefix + mediaExpression + suffix;
  return "@media " + enhancedExpression;
});

var white = '#FFFFFF';
var black = '#131112';
var gradientLight = 'rgba(255, 255, 255, 0)';
var gradientDark = 'rgba(255, 255, 255, 1)';
var neutrals = {
  n100: '#E0DBDB',
  n300: '#F7F7F7',
  n400: '#E8E8E8',
  n500: '#D8D8D8',
  n550: '#DCDCDC',
  n600: '#797979',
  n650: '#666666',
  n700: '#A4A4A4',
  n800: '#ABABAB',
  n850: '#595959',
  n900: '#606060'
};
var greens = {
  g100: '#EBFFE4',
  g200: '#EFF5F2',
  g300: '#F4FCF1',
  g500: '#44be74',
  g600: '#008A15',
  g700: '#30AB46',
  g800: '#67BE41',
  g900: '#008A15',
  g950: '#5CBD31'
};
var blues = {
  bl100: '#0C1945',
  bl300: '569BDD',
  bl500: '#40b5de',
  bl900: '#09345C'
};
var oranges = {
  o300: '#fcb602',
  o400: '#FF8119',
  o500: '#E68835',
  o700: '#FF8219',
  o900: '#B52F01'
};
var yellows = {
  y500: '#ffde3c'
};
var reds = {
  r300: '#F13753',
  r500: '#C8102E',
  r700: '#880A1E',
  r600: '#BE3F36'
};
var browns = {
  b100: '#654D4D',
  b200: '#D1C9CA',
  b300: '#8D7171',
  b400: '#3F2021',
  b500: '#432726',
  b900: '#572D2D'
};
var primary = {
  red: reds.r500
};
var misc = {
  white50: 'rgba(255, 255, 255, 0.50)',
  shadow: 'rgba(0,0,0,0.75)',
  textShadow: 'rgba(84, 84, 84, 1)',
  bodyColor: black,
  headerBg: '#131112',
  headerBg90: 'rgba(17, 15, 16, 0.9)',
  sectionBg: '#F2F2F2',
  darkBg: '#0D1824',
  danger: reds.r500,
  success: greens.g700,
  warning: oranges.o500
};
var teams$1 = {
  anaheim: '#FC4C02',
  arizona: '#AE3142',
  boston: '#FFB81C',
  buffalo: '#041E42',
  calgary: '#C8102E',
  carolina: '#C00000',
  chicago: '#CE1126',
  colorado: '#8A2432',
  columbus: '#041E42',
  dallas: '#006341',
  detroit: '#CE1126',
  edmonton: '#091F40',
  florida: '#C8102E',
  losAngeles: '#A2AAAD',
  lasVegas: '#85714D',
  minnesota: '#154734',
  montreal: '#AF1E2D',
  nashville: '#041E42',
  newJersey: '#C00000',
  newYorkIslanders: '#00529B',
  newYorkRangers: '#00428D',
  ottawa: '#E21A32',
  philadelphia: '#FA4616',
  phoenix: '#AE3142',
  pittsburgh: '#FFB81C',
  sanJose: '#006272',
  stLouis: '#002F87',
  tampaBay: '#00205B',
  toronto: '#003D7D',
  vancouver: '#002D55',
  washington: '#041E42',
  winnipeg: '#002D61'
};
var heatStreak$1 = {
  image: {
    start: '#8E8D92',
    end: '#8E8D92'
  },
  cold: {
    start: '#60a1df',
    end: '#60a1df'
  },
  hot: {
    start: '#FF8119',
    end: '#FF8119'
  },
  h0: {
    start: '#818181',
    end: '#4c4c4c'
  },
  h1: {
    start: '#C3AC5F',
    end: '#FFBE00'
  },
  h2: {
    start: '#FFBE00',
    end: ' #C1660E'
  },
  h3: {
    start: '#FFBE00',
    end: '#FF7300'
  },
  h4: {
    start: '#FF8119',
    end: '#D14D09'
  },
  h5: {
    start: '#FF0201',
    end: '#850100'
  },
  h6: {
    start: '#FF0201',
    end: '#D70600'
  },
  h7: {
    start: '#FF0000',
    end: '#FF0000'
  }
};
var colors = _extends({
  white: white,
  black: black,
  gradientLight: gradientLight,
  gradientDark: gradientDark
}, neutrals, greens, reds, blues, yellows, oranges, browns, primary, misc, teams$1, {
  heatStreak: heatStreak$1
});

var buildGradient = function buildGradient(start, end) {
  return "linear-gradient(\n    360deg,\n    " + start + " 2%,\n    " + end + " 47%\n  )";
};

var orangeLinear = buildGradient('rgba(181, 46, 0, 1)', 'rgba(255, 129, 25, 1)');
var greyLinear = buildGradient('rgba(76,76,76,1) ', 'rgba(129,129,129,1)');
var gradients = {
  orangeLinear: orangeLinear,
  greyLinear: greyLinear
};

var spacings = {
  atom: '2px',
  bit: '4px',
  "byte": '8px',
  kilo: '12px',
  mega: '16px',
  giga: '20px',
  tera: '28px',
  peta: '40px',
  exa: '48px',
  zetta: '60px',
  yotta: '87px'
};

var fontStack = {
  "default": {
    name: 'Brewed-Regular',
    weight: 400
  },
  bold: {
    name: 'Brewed-Bold',
    weight: 700
  },
  black: {
    name: 'Brewed-Black',
    weight: 900
  },
  light: {
    name: 'Brewed-Light',
    weight: 500
  },
  condensedLight: {
    name: 'Brewed-Light-Condensed',
    weight: 300
  },
  designer: {
    name: 'grease_pencil',
    weight: 500
  }
};

var calculateLineHeight = function calculateLineHeight(ratio, fontSize) {
  var lineHeight = Math.floor(fontSize * ratio);
  return lineHeight;
};

var getLineHeight = function getLineHeight(ratio) {
  return function (fontSize) {
    return calculateLineHeight(ratio, fontSize);
  };
};

var lineHeightRatio = 1.3;
var lineHeight = getLineHeight(lineHeightRatio);
var typography = {
  headings: {
    deca: {
      fontSize: '14px',
      lineHeight: lineHeight(16) + "px"
    },
    kilo: {
      fontSize: '17px',
      lineHeight: lineHeight(17) + "px"
    },
    mega: {
      fontSize: '18px',
      lineHeight: lineHeight(19) + "px"
    },
    giga: {
      fontSize: '21px',
      lineHeight: lineHeight(21) + "px"
    },
    tera: {
      fontSize: '24px',
      lineHeight: lineHeight(24) + "px"
    },
    peta: {
      fontSize: '28px',
      lineHeight: lineHeight(28) + "px"
    },
    exa: {
      fontSize: '40px',
      lineHeight: lineHeight(40) + "px"
    },
    zetta: {
      fontSize: '70px',
      lineHeight: lineHeight(70) + "px"
    },
    yotta: {
      fontSize: '105px',
      lineHeight: lineHeight(105) + "px",
      letterSpacing: '4px'
    }
  },
  subHeadings: {
    "byte": {
      fontSize: '11px',
      lineHeight: lineHeight(11) + "px"
    },
    kilo: {
      fontSize: '12px',
      lineHeight: lineHeight(12) + "px"
    },
    mega: {
      fontSize: '14px',
      lineHeight: lineHeight(14) + "px",
      letterSpacing: '-0.22px'
    },
    tera: {
      fontSize: '32px',
      lineHeight: lineHeight(24) + "px",
      letterSpacing: '2px'
    },
    peta: {
      fontSize: '36px',
      lineHeight: lineHeight(36) + "px",
      letterSpacing: '2px'
    },
    exa: {
      fontSize: '40px',
      lineHeight: lineHeight(40) + "px",
      letterSpacing: '-2.17px'
    }
  },
  text: {
    atom: {
      fontSize: '9px',
      lineHeight: lineHeight(9) + "px"
    },
    bit: {
      fontSize: '10px',
      lineHeight: lineHeight(10) + "px"
    },
    "byte": {
      fontSize: '11px',
      lineHeight: lineHeight(11) + "px"
    },
    kilo: {
      fontSize: '12px',
      lineHeight: lineHeight(12) + "px"
    },
    mega: {
      fontSize: '13px',
      lineHeight: lineHeight(13) + "px"
    },
    giga: {
      fontSize: '14px',
      lineHeight: lineHeight(14) + "px",
      letterSpacing: '-0.22px'
    },
    tera: {
      fontSize: '16px',
      lineHeight: lineHeight(16) + "px",
      letterSpacing: '-0.06px'
    },
    peta: {
      fontSize: '18px',
      lineHeight: lineHeight(18) + "px",
      letterSpacing: '-0.28px'
    },
    exa: {
      fontSize: '20px',
      lineHeight: lineHeight(20) + "px"
    },
    zetta: {
      fontSize: '22px',
      lineHeight: lineHeight(22) + "px"
    },
    yotta: {
      fontSize: '26px',
      lineHeight: lineHeight(26) + " px"
    }
  }
};

var fontWeight = {
  regular: '400',
  medium: '600',
  bold: '800'
};

var borderWidth = {
  kilo: '1px',
  mega: '2px',
  giga: '3px'
};

var borderRadius = {
  kilo: '1px',
  mega: '4px',
  giga: '7px',
  tera: '9px',
  peta: '12px',
  exa: '50px',
  circle: '50%'
};

var transitions = {
  "default": "200ms ease-in-out",
  slow: "300ms ease-in-out"
};

var zIndex = {
  "default": 0,
  absolute: 1,
  drawer: 10,
  textbox: 20,
  popover: 30,
  tooltip: 300,
  header: 600,
  backdrop: 700,
  sidebar: 800,
  dimmar: 900,
  modal: 950,
  modalbox: 1000,
  footer: 500
};

var elementSize = {
  header: '51px',
  content: '100%',
  sidebar: '440px',
  toolbar: '60px'
};

var grid = {
  "default": {
    priority: 0,
    breakpoint: 'default',
    cols: 12,
    maxWidth: '880px',
    gutter: spacings.mega
  },
  untilKilo: {
    priority: 1,
    breakpoint: 'untilKilo',
    cols: 12,
    maxWidth: '400px',
    gutter: spacings["byte"]
  },
  kilo: {
    priority: 2,
    breakpoint: 'kilo',
    cols: 12,
    maxWidth: '600px',
    gutter: spacings.mega
  },
  mega: {
    priority: 3,
    breakpoint: 'mega',
    cols: 12,
    maxWidth: '760px',
    gutter: spacings.giga
  },
  giga: {
    priority: 4,
    breakpoint: 'giga',
    cols: 12,
    maxWidth: '880px',
    gutter: spacings.giga
  },
  afterTera: {
    priority: 5,
    breakpoint: 'tera',
    cols: 12,
    maxWidth: '1200px',
    gutter: spacings.giga
  }
};

var breakpoints = {
  untilKilo: '(max-width: 479px)',
  kilo: 480,
  kiloToMega: '(min-width: 480px) and (max-width: 767px)',
  mega: 768,
  untilMega: '(max-width: 767px)',
  megaToGiga: '(min-width: 768px) and (max-width: 959px)',
  giga: 960,
  gigaToTera: '(min-width: 960px) and (max-width: 1279px)',
  tera: 1280,
  afterTera: '(min-width: 1280px)'
};

var mq = createMediaQueries(breakpoints);

var iconSizes = {
  "byte": '14px',
  kilo: '16px',
  mega: '24px',
  giga: '32px'
};



var baseTheme = {
  __proto__: null,
  colors: colors,
  gradients: gradients,
  spacings: spacings,
  fontStack: fontStack,
  typography: typography,
  fontWeight: fontWeight,
  borderWidth: borderWidth,
  borderRadius: borderRadius,
  transitions: transitions,
  zIndex: zIndex,
  elementSize: elementSize,
  grid: grid,
  breakpoints: breakpoints,
  mq: mq,
  iconSizes: iconSizes
};

var component = {
  titleBgColor: colors.n500,
  howToBgColor: colors.r500,
  howToTitleColor: colors.r500,
  footerBgColor: colors.n500
};

var standard = _extends({}, baseTheme, {
  component: component
});

var component$1 = {
  titleBgColor: colors.bl900,
  howToBgColor: colors.bl900,
  howToTitleColor: colors.black,
  footerBgColor: colors.white
};

var blue = _extends({}, baseTheme, {
  component: component$1
});

var Theme = {
  base: standard,
  challenge20: blue
};

var allIcons = [faChevronDown, faChevronUp, faExclamationCircle, faTimesCircle, faCheck, faCheckCircle, faLock, faFire, faBurn, faSnowflake, faThumbsUp, faFrown, faCaretUp, faCaretDown, faExclamationTriangle];
var addIconsToLibrary = function addIconsToLibrary() {
  return allIcons.forEach(function (icon) {
    return library.add(icon);
  });
};

var _templateObject;

var createBaseStyles = function createBaseStyles(theme) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  @font-face {\n    font-family: 'Brewed-Regular';\n    src: url('https://s3.us-east-1.amazonaws.com/menu.images.production.us-east-1/hockey/Brewed-Regular.otf')\n      format('opentype');\n    font-weight: normal;\n    font-style: normal;\n  }\n\n  @font-face {\n    font-family: 'Brewed-Light';\n    src: url('https://s3.us-east-1.amazonaws.com/menu.images.production.us-east-1/hockey/Brewed-Light.otf')\n      format('opentype');\n    font-weight: normal;\n    font-style: normal;\n  }\n\n  @font-face {\n    font-family: 'Brewed-Bold';\n    src: url('https://s3.us-east-1.amazonaws.com/menu.images.production.us-east-1/hockey/Brewed-Bold.otf')\n      format('opentype');\n    font-weight: normal;\n    font-style: normal;\n  }\n\n  @font-face {\n    font-family: 'grease_pencil';\n    src: url('https://timhortons.sfo2.digitaloceanspaces.com/crm/GreasePencil.otf') format('opentype');\n    font-weight: normal;\n    font-style: normal;\n  }\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: inherit;\n  }\n\n  html {\n    box-sizing: border-box;\n    scroll-behavior: smooth;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  body {\n    background-color: ", ";\n    color: ", ";\n    font-family: ", ";\n    font-weight: ", ";\n    letter-spacing: 0.3px;\n    font-size: 14px;\n    font-weight: 300;\n    line-height: 1.4;\n    margin: 0;\n    padding: 0;\n    -webkit-text-size-adjust: 100%;\n  }\n\n  sup {\n    font-size: 7px;\n    top: -1em;\n  }\n"])), theme.colors.white, theme.colors.black, theme.fontStack["default"].name, theme.fontStack["default"].weight);
};

var BaseStyles = function BaseStyles() {
  return /*#__PURE__*/React.createElement(Global, {
    styles: function styles(theme) {
      return createBaseStyles(theme);
    }
  });
};

BaseStyles.propTypes = {};
BaseStyles.defaultProps = {
  custom: ''
};

var _templateObject$1;

var colorStyles = function colorStyles(_ref) {
  var theme = _ref.theme,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'black' : _ref$variant,
      _ref$cssProp = _ref.cssProp,
      cssProp = _ref$cssProp === void 0 ? 'color' : _ref$cssProp,
      paddingTop = _ref.paddingTop;

  var colorMap = _extends({}, theme.colors, {
    red: theme.colors.r500,
    blue: theme.colors.bl500,
    darkBlue: theme.colors.bl900,
    green: theme.colors.g500,
    lightGrey: theme.colors.n400,
    grey: theme.colors.n700,
    darkGrey: theme.colors.n900,
    brown: theme.colors.b900,
    lightBrown: theme.colors.b300,
    white: theme.colors.white,
    black: theme.colors.black,
    orange: theme.colors.o700,
    grey97: '#979797'
  });

  var color = colorMap[variant];
  return css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n    padding-top: ", ";\n    ", ": ", ";\n    ", "\n  "])), paddingTop, cssProp, color, cssProp === 'color' && "\n      a {\n        " + cssProp + ": " + color + ";\n      }\n    ");
};

var ColorProvider = styled('div')(colorStyles);
ColorProvider.propTypes = {
  cssProp: propTypes.oneOf(['color', 'background']),
  variant: propTypes.string
};

var _excluded = ["children", "as", "subHeading"];

var _templateObject$2, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

var baseStyles = function baseStyles(_ref) {
  var theme = _ref.theme,
      weight = _ref.weight;
  return css(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-weight: ", ";\n  margin-bottom: ", ";\n"])), theme.fontStack[weight].name, theme.fontStack[weight].weight, theme.spacings.tera);
};

var sizeStyles = function sizeStyles(_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant,
      size = _ref2.size;
  return size && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    font-size: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n  "])), theme.typography[variant][size].fontSize, theme.typography[variant][size].lineHeight, theme.typography[variant][size].letterSpacing);
};

var centeredStyles = function centeredStyles(_ref3) {
  var centered = _ref3.centered;
  return centered && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    text-align: center;\n  "])));
};

var noMarginTopStyles = function noMarginTopStyles(_ref4) {
  var noMarginTop = _ref4.noMarginTop;
  return noMarginTop && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n    margin-top: 0;\n  "])));
};

var noMarginBottomStyles = function noMarginBottomStyles(_ref5) {
  var noMarginBottom = _ref5.noMarginBottom;
  return noMarginBottom && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n    margin-bottom: 0;\n  "])));
};

var noMarginBothStyles = function noMarginBothStyles(_ref6) {
  var noMarginBoth = _ref6.noMarginBoth;
  return noMarginBoth && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n    margin-top: 0;\n    margin-bottom: 0;\n  "])));
};

var subHeadingStyles = function subHeadingStyles(_ref7) {
  var theme = _ref7.theme,
      subHeading = _ref7.subHeading;
  return subHeading && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n  "])), theme.colors.n300);
};

var upperStyles = function upperStyles(_ref8) {
  var upper = _ref8.upper;
  return upper && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n    text-transform: uppercase;\n  "])));
};

var italicStyles = function italicStyles(_ref9) {
  var italic = _ref9.italic;
  return italic && css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n    font-style: italic;\n  "])));
};

var designerStyles = function designerStyles(_ref10) {
  var theme = _ref10.theme,
      designer = _ref10.designer;
  return designer && css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-weight: ", ";\n  "])), theme.fontStack.designer.name, theme.fontStack.designer.weight);
};

var shadowStyles = function shadowStyles(_ref11) {
  var theme = _ref11.theme,
      shadow = _ref11.shadow;
  return shadow && css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n    text-shadow: -1px 0px 1px ", ";\n  "])), theme.colors.textShadow);
};

var HeadingElement = styled('h2', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop) && prop !== 'size';
  }
})(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), baseStyles, sizeStyles, noMarginTopStyles, noMarginBottomStyles, noMarginBothStyles, subHeadingStyles, upperStyles, italicStyles, designerStyles, shadowStyles, centeredStyles);

var Heading = function Heading(_ref12) {
  var children = _ref12.children,
      as = _ref12.as,
      subHeading = _ref12.subHeading,
      restProps = _objectWithoutPropertiesLoose(_ref12, _excluded);

  return /*#__PURE__*/React.createElement(HeadingElement, _extends({}, restProps, {
    subHeading: subHeading,
    as: as,
    dangerouslySetInnerHTML: {
      __html: children
    }
  }));
};

Heading.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  variant: propTypes.oneOf(['headings', 'subHeadings']),
  size: propTypes.oneOf(['kilo', 'mega', 'giga', 'tera', 'peta', 'exa', 'zetta', 'yotta', 'deca']),
  weight: propTypes.string,
  className: propTypes.string,
  subHeading: propTypes.string,
  noMarginTop: propTypes.bool,
  noMarginBottom: propTypes.bool,
  noMarginBoth: propTypes.bool,
  centered: propTypes.bool,
  as: propTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6'])
};
Heading.defaultProps = {
  variant: 'headings',
  as: 'h2',
  weight: 'bold',
  className: '',
  subHeading: '',
  children: null
};

var _excluded$1 = ["as", "children"];

var _templateObject$3, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1;

var baseStyles$1 = function baseStyles(_ref) {
  var theme = _ref.theme,
      as = _ref.as;
  return css(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-weight: ", ";\n  display: block;\n  margin-top: 0;\n  margin-bottom: ", ";\n  letter-spacing: -0.18px;\n"])), theme.fontStack["default"].name, theme.fontStack["default"].weight, as === 'p' ? theme.spacings.bit : 0);
};

var sizeStyles$1 = function sizeStyles(_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size,
      heading = _ref2.heading,
      lineHeight = _ref2.lineHeight;

  if (!size) {
    return null;
  }

  if (heading) {
    return css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n      font-size: ", ";\n      line-height: ", ";\n    "])), theme.typography.headings[size].fontSize, lineHeight || theme.typography.headings[size].lineHeight);
  }

  return css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), theme.typography.text[size].fontSize, lineHeight || theme.typography.text[size].lineHeight);
};

var boldStyles = function boldStyles(_ref3) {
  var theme = _ref3.theme,
      bold = _ref3.bold;
  return bold && css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n    font-family: ", ";\n    font-weight: ", ";\n  "])), theme.fontStack.bold.name, theme.fontStack.bold.weight);
};

var lightStyles = function lightStyles(_ref4) {
  var theme = _ref4.theme,
      light = _ref4.light;
  return light && css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n    font-family: ", ";\n  "])), theme.fontStack.light);
};

var italicStyles$1 = function italicStyles(_ref5) {
  var italic = _ref5.italic;
  return italic && css(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteralLoose(["\n    font-style: italic;\n  "])));
};

var designerStyles$1 = function designerStyles(_ref6) {
  var theme = _ref6.theme,
      designer = _ref6.designer;
  return designer && css(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteralLoose(["\n    font-family: ", ";\n  "])), theme.fontStack.designer);
};

var strikeThroughStyles = function strikeThroughStyles(_ref7) {
  var theme = _ref7.theme,
      strike = _ref7.strike;
  return strike && css(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteralLoose(["\n    text-decoration: line-through;\n    text-decoration-color: ", ";\n  "])), theme.colors.r700);
};

var marginStyles = function marginStyles(_ref8) {
  var noMargin = _ref8.noMargin;
  return noMargin && css(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteralLoose(["\n    margin-bottom: 0;\n  "])));
};

var upperStyles$1 = function upperStyles(_ref9) {
  var upper = _ref9.upper;
  return upper && css(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteralLoose(["\n    text-transform: uppercase;\n  "])));
};

var centeredStyles$1 = function centeredStyles(_ref10) {
  var centered = _ref10.centered;
  return centered && css(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteralLoose(["\n    text-align: center;\n  "])));
};

var StyledText = styled('p', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop) && prop !== 'size';
  }
})(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), baseStyles$1, marginStyles, boldStyles, lightStyles, italicStyles$1, designerStyles$1, strikeThroughStyles, upperStyles$1, sizeStyles$1, centeredStyles$1);

var Text = function Text(_ref11) {
  var as = _ref11.as,
      children = _ref11.children,
      restProps = _objectWithoutPropertiesLoose(_ref11, _excluded$1);

  return /*#__PURE__*/React.createElement(StyledText, _extends({}, restProps, {
    as: as,
    dangerouslySetInnerHTML: {
      __html: children
    }
  }));
};

Text.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  size: propTypes.oneOf(['atom', 'bit', 'byte', 'kilo', 'mega', 'giga', 'tera', 'peta', 'exa', 'zetta', 'yotta']),
  className: propTypes.string,
  noMargin: propTypes.bool,
  bold: propTypes.bool,
  italic: propTypes.bool,
  designer: propTypes.bool,
  strike: propTypes.bool,
  centered: propTypes.bool,
  lineHeight: propTypes.string,
  as: propTypes.string
};
Text.defaultProps = {
  as: 'p',
  size: 'kilo',
  className: '',
  children: null
};

var _excluded$2 = ["text", "size", "textColor"];

var _templateObject$4, _templateObject2$2;

var baseStyles$2 = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-width: 200px;\n  min-height: 25px;\n  padding: 0 ", ";\n"])), theme.spacings.kilo);
};

var TextWrapper = styled('div')(baseStyles$2);

var containerBaseStyles = function containerBaseStyles() {
  return css(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"])));
};

var Container = styled(ColorProvider)(containerBaseStyles);

var TextBar = function TextBar(_ref2) {
  var text = _ref2.text,
      size = _ref2.size,
      textColor = _ref2.textColor,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded$2);

  return /*#__PURE__*/React.createElement(Container, props, /*#__PURE__*/React.createElement(TextWrapper, null, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: textColor
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    size: size || 'mega',
    noMargin: true
  }, text))));
};

TextBar.propTypes = {
  variant: propTypes.string,
  text: propTypes.string,
  textColor: propTypes.string,
  size: propTypes.string
};
TextBar.defaultProps = {
  variant: 'r500',
  cssProp: 'background',
  textColor: 'white'
};

var _excluded$3 = ["text", "size", "align", "styles"];

var _templateObject$5, _templateObject2$3, _templateObject3$2, _templateObject4$2;

var baseStyles$3 = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  display: flex;\n  width: 100%;\n  a {\n    color: ", ";\n    text-decoration: underline;\n  }\n"])), theme.colors.n900, theme.colors.n900);
};

var Container$1 = styled('div')(baseStyles$3);

var textWrapperBaseStyles = function textWrapperBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteralLoose(["\n  margin: 0 ", ";\n  width: 100%;\n  max-width: 1200px;\n"])), theme.spacings.kilo);
};

var textWrapperAlignStyles = function textWrapperAlignStyles(_ref3) {
  var theme = _ref3.theme,
      align = _ref3.align;
  return align && css(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n    text-align: ", ";\n    padding: 0 ", ";\n  "])), align, theme.spacings.mega);
};

var customStylesFooter = function customStylesFooter(_ref4) {
  var theme = _ref4.theme,
      styles = _ref4.styles;
  return styles && css(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteralLoose(["\n    ", "\n  "])), styles(theme));
};

var TextWrapper$1 = styled('div')(textWrapperBaseStyles, textWrapperAlignStyles, customStylesFooter);

var TextBlock = function TextBlock(_ref5) {
  var text = _ref5.text,
      size = _ref5.size,
      align = _ref5.align,
      styles = _ref5.styles,
      props = _objectWithoutPropertiesLoose(_ref5, _excluded$3);

  return /*#__PURE__*/React.createElement(Container$1, null, /*#__PURE__*/React.createElement(TextWrapper$1, {
    align: align,
    styles: styles
  }, /*#__PURE__*/React.createElement(Text, _extends({
    as: 'p',
    size: size || 'byte'
  }, props), text)));
};

TextBlock.propTypes = {
  text: propTypes.string,
  size: propTypes.string,
  align: propTypes.string,
  noMargin: propTypes.bool
};
TextBlock.defaultProps = {
  text: 'This is a text block.',
  noMargin: false
};

var idCounter = 0;
var uniqueId = function uniqueId(prefix) {
  if (prefix === void 0) {
    prefix = '';
  }

  idCounter += 1;
  return "" + prefix + idCounter;
};

var _templateObject$6, _templateObject2$4, _templateObject3$3, _templateObject4$3;
var textMega$1 = textMega,
    hideVisually$1 = hideVisually,
    disableVisually$1 = disableVisually;

var baseStyles$4 = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: block;\n"])), textMega$1({
    theme: theme
  }));
};

var visuallyHiddenStyles = function visuallyHiddenStyles(_ref2) {
  var visuallyHidden = _ref2.visuallyHidden;
  return visuallyHidden && css(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteralLoose(["\n    ", ";\n  "])), hideVisually$1());
};

var inlineStyles = function inlineStyles(_ref3) {
  var theme = _ref3.theme,
      inline = _ref3.inline;
  return inline && css(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteralLoose(["\n    display: inline-block;\n    margin-right: ", ";\n  "])), theme.spacings.mega);
};

var disabledStyles = function disabledStyles(_ref4) {
  var disabled = _ref4.disabled;
  return disabled && css(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteralLoose(["\n    ", ";\n  "])), disableVisually$1());
};

var Label = styled('label')(baseStyles$4, visuallyHiddenStyles, inlineStyles, disabledStyles);
Label.propTypes = {
  htmlFor: propTypes.string,
  visuallyHidden: propTypes.bool,
  inline: propTypes.bool,
  disabled: propTypes.bool
};

var _excluded$4 = ["prefix", "icon"];

var Icon = function Icon(_ref) {
  var prefix = _ref.prefix,
      icon = _ref.icon,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$4);

  return /*#__PURE__*/React.createElement(FontAwesomeIcon, _extends({
    icon: [prefix, icon]
  }, props));
};

Icon.propTypes = {
  prefix: propTypes.string,
  icon: propTypes.string
};
Icon.defaultProps = {};

var _excluded$5 = ["validationHint"];

var _templateObject$7, _templateObject2$5, _templateObject3$4;
var textMega$2 = textMega;

var baseStyles$5 = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: flex;\n  align-items: flex-start;\n  margin-top: ", ";\n  color: ", ";\n  transition: color ", ";\n"])), textMega$2({
    theme: theme
  }), theme.spacings["byte"], theme.colors.n900, theme.transitions["default"]);
};

var invalidStyles = function invalidStyles(_ref2) {
  var theme = _ref2.theme,
      invalid = _ref2.invalid;
  return invalid && css(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n  "])), theme.colors.danger);
};

var alignStyles = function alignStyles(_ref3) {
  var textAlign = _ref3.textAlign;
  return textAlign === 'right' && css(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteralLoose(["\n    justify-content: flex-end;\n  "])));
};

var Container$2 = styled('span')(baseStyles$5, invalidStyles, alignStyles);

var ValidationHint = function ValidationHint(_ref4) {
  var validationHint = _ref4.validationHint,
      props = _objectWithoutPropertiesLoose(_ref4, _excluded$5);

  if (!validationHint) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Container$2, {
    role: "alert",
    id: props.id,
    invalid: props.invalid,
    textAlign: props.textAlign
  }, validationHint);
};

ValidationHint.propTypes = {
  validationHint: propTypes.string,
  invalid: propTypes.bool,
  textAlign: propTypes.string,
  id: propTypes.string
};

var _excluded$6 = ["value", "renderPrefix", "renderSuffix", "validationHint", "invalid", "hasWarning", "showValid", "noMargin", "inline", "disabled", "labelStyles", "inputStyles", "label", "hideLabel", "validationTextAlign", "id", "maxLength", "type", "minWidth"];

var _templateObject$8, _templateObject2$6, _templateObject3$5, _templateObject4$4, _templateObject5$2, _templateObject6$2, _templateObject7$2, _templateObject8$2, _templateObject9$2, _templateObject10$2, _templateObject11$2, _templateObject12$2, _templateObject13;
var textMega$3 = textMega;

var containerStyles = function containerStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  label &,\n  label + & {\n    margin-top: ", ";\n  }\n"])), theme.spacings.bit);
};

var InputContainer = styled('div')(containerStyles);

var labelCustomStyles = function labelCustomStyles(_ref2) {
  var theme = _ref2.theme,
      noMargin = _ref2.noMargin;
  return !noMargin && css(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteralLoose(["\n    margin-bottom: ", ";\n  "])), theme.spacings.mega);
};

var InputLabel = styled(Label)(labelCustomStyles);

var inputBaseStyles = function inputBaseStyles(_ref3) {
  var theme = _ref3.theme,
      minWidth = _ref3.minWidth;
  return css(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteralLoose(["\n  -webkit-appearance: none;\n  font-family: ", ";\n  background-color: ", ";\n  border: none;\n  outline: 0;\n  border-radius: ", ";\n  padding: calc(", " + 1px) ", ";\n  transition: box-shadow ", ", padding ", ";\n  width: 100%;\n  min-width: ", ";\n  margin: 0;\n  box-shadow: 0 0 0 1px ", ";\n  ", ";\n  &::placeholder {\n    color: ", ";\n    transition: color ", ";\n  }\n"])), theme.fontStack["default"], theme.colors.white, theme.borderRadius.mega, theme.spacings.kilo, theme.spacings.kilo, theme.transitions["default"], theme.transitions["default"], minWidth ? minWidth + "px" : '250px', theme.colors.n400, textMega$3({
    theme: theme
  }), theme.colors.n900, theme.transitions["default"]);
};

var inputWarningStyles = function inputWarningStyles(_ref4) {
  var theme = _ref4.theme,
      hasWarning = _ref4.hasWarning,
      disabled = _ref4.disabled;
  return !disabled && hasWarning && css(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteralLoose(["\n    &:not(:focus)::placeholder {\n      color: ", ";\n    }\n  "])), theme.colors.y500);
};

var inputInvalidStyles = function inputInvalidStyles(_ref5) {
  var theme = _ref5.theme,
      invalid = _ref5.invalid,
      disabled = _ref5.disabled;
  return !disabled && invalid && css(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteralLoose(["\n    box-shadow: 0 0 0 1px ", ";\n    &:not(:focus)::placeholder {\n      color: ", ";\n    }\n  "])), theme.colors.r500, theme.colors.r500);
};

var inputReadonlyStyles = function inputReadonlyStyles(_ref6) {
  var theme = _ref6.theme,
      readOnly = _ref6.readOnly;
  return readOnly && css(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n  "])), theme.colors.n200);
};

var inputDisabledStyles = function inputDisabledStyles(_ref7) {
  var theme = _ref7.theme,
      disabled = _ref7.disabled;
  return disabled && css(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n  "])), theme.colors.n300);
};

var inputTextAlignRightStyles = function inputTextAlignRightStyles(_ref8) {
  var textAlign = _ref8.textAlign;
  return textAlign === 'right' && css(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteralLoose(["\n    text-align: right;\n  "])));
};

var inputPrefixStyles = function inputPrefixStyles(_ref9) {
  var hasPrefix = _ref9.hasPrefix;
  return hasPrefix && css(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteralLoose(["\n    padding-left: 40px;\n  "])));
};

var inputSuffixStyles = function inputSuffixStyles(_ref10) {
  var hasSuffix = _ref10.hasSuffix;
  return hasSuffix && css(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteralLoose(["\n    padding-right: 40px;\n  "])));
};

var InputElement = styled('input')(inputBaseStyles, inputWarningStyles, inputInvalidStyles, inputTextAlignRightStyles, inputReadonlyStyles, inputDisabledStyles, inputPrefixStyles, inputSuffixStyles);

var prefixStyles = function prefixStyles(_ref11) {
  var theme = _ref11.theme;
  return css(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 1px;\n  left: 1px;\n  pointer-events: none;\n  color: ", ";\n  padding: ", ";\n  height: ", ";\n  width: ", ";\n"])), theme.colors.n700, theme.spacings.kilo, theme.spacings.peta, theme.spacings.peta);
};

var suffixStyles = function suffixStyles(_ref12) {
  var theme = _ref12.theme,
      hasValidationIcon = _ref12.hasValidationIcon;
  return css(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 1px;\n  right: ", ";\n  pointer-events: none;\n  color: ", ";\n  padding: ", ";\n  height: ", ";\n  width: ", ";\n  transition: right ", ";\n"])), hasValidationIcon ? '29px' : '1px', theme.colors.n700, theme.spacings.kilo, theme.spacings.peta, theme.spacings.peta, theme.transitions["default"]);
};

var iconBaseStyles = function iconBaseStyles(_ref13) {
  var theme = _ref13.theme,
      color = _ref13.color;
  return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  right: 0;\n  margin-top: 0.3em;\n  margin-right: 0.3em;\n  color: ", ";\n  font-size: 2em;\n"])), theme.colors[color]);
};

var StyledIcon = styled(Icon)(iconBaseStyles);

var getIcon = function getIcon(state) {
  switch (true) {
    case state.disabled:
      {
        return null;
      }

    case state.invalid:
      {
        return /*#__PURE__*/React.createElement(StyledIcon, {
          role: "presentation",
          icon: "exclamation-circle",
          color: "danger"
        });
      }

    case state.hasWarning:
      {
        return /*#__PURE__*/React.createElement(StyledIcon, {
          role: "presentation",
          icon: "exclamation-circle",
          color: "warning"
        });
      }

    case state.showValid:
      {
        return /*#__PURE__*/React.createElement(StyledIcon, {
          role: "presentation",
          prefix: "far",
          icon: "check-circle",
          color: "success"
        });
      }

    default:
      {
        return null;
      }
  }
};

var Input = /*#__PURE__*/React.forwardRef(function (state, ref) {
  var value = state.value,
      RenderPrefix = state.renderPrefix,
      RenderSuffix = state.renderSuffix,
      validationHint = state.validationHint,
      invalid = state.invalid,
      hasWarning = state.hasWarning,
      showValid = state.showValid,
      noMargin = state.noMargin,
      inline = state.inline,
      disabled = state.disabled,
      labelStyles = state.labelStyles,
      inputStyles = state.inputStyles,
      validationTextAlign = state.validationTextAlign,
      customId = state.id,
      maxLength = state.maxLength,
      type = state.type,
      minWidth = state.minWidth,
      props = _objectWithoutPropertiesLoose(state, _excluded$6);

  var id = customId || uniqueId('input_');
  var hintId = 'hint_' + id;
  var prefix = RenderPrefix && /*#__PURE__*/React.createElement(RenderPrefix, {
    css: prefixStyles
  });
  var suffix = RenderSuffix && /*#__PURE__*/React.createElement(RenderSuffix, {
    css: suffixStyles
  });
  var hasPrefix = Boolean(prefix);
  var hasSuffix = Boolean(suffix);
  var icon = getIcon(state);
  return /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: id,
    inline: inline,
    disabled: disabled,
    noMargin: noMargin
  }, /*#__PURE__*/React.createElement(InputContainer, {
    css: labelStyles
  }, prefix, /*#__PURE__*/React.createElement(InputElement, _extends({
    minWidth: minWidth,
    type: type,
    id: id,
    value: value,
    invalid: invalid,
    "aria-invalid": invalid,
    "aria-describedby": hintId,
    disabled: disabled,
    hasWarning: hasWarning,
    hasPrefix: hasPrefix,
    hasSuffix: hasSuffix,
    css: inputStyles,
    maxLength: maxLength,
    ref: ref
  }, props)), icon, suffix), /*#__PURE__*/React.createElement(ValidationHint, {
    id: hintId,
    disabled: disabled,
    invalid: invalid,
    hasWarning: hasWarning,
    showValid: showValid,
    validationHint: validationHint,
    textAlign: validationTextAlign
  }));
});
Input.propTypes = {
  label: propTypes.string,
  id: propTypes.string,
  value: propTypes.string,
  disabled: propTypes.bool,
  renderPrefix: propTypes.node,
  renderSuffix: propTypes.node,
  validationHint: propTypes.string,
  invalid: propTypes.bool,
  hasWarning: propTypes.bool,
  showValid: propTypes.bool,
  readOnly: propTypes.bool,
  inline: propTypes.bool,
  noMargin: propTypes.bool,
  textAlign: propTypes.oneOf(['left', 'right']),
  hideLabel: propTypes.bool,
  inputStyles: propTypes.object,
  labelStyles: propTypes.object,
  validationTextAlign: propTypes.oneOf(['left', 'right']),
  maxLength: propTypes.string,
  type: propTypes.oneOf(['text', 'textarea'])
};

var _templateObject$9, _templateObject2$7, _templateObject3$6;

var switchBaseStyles = function switchBaseStyles(_ref) {
  var theme = _ref.theme,
      isActive = _ref.isActive;
  return css(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  cursor: pointer;\n  position: relative;\n  width: 48px;\n  height: 24px;\n  transition: 0.4s;\n  border-radius: 22px;\n"])), isActive ? theme.colors.r500 : theme.colors.b100, theme.colors.b100);
};

var Switch = styled('div')(switchBaseStyles);

var sliderBaseStyles = function sliderBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteralLoose(["\n  border: 1px solid ", ";\n  // box-shadow: 0 0 3px 1px ", ";\n  position: absolute;\n  height: 18px;\n  width: 18px;\n  left: 2px;\n  bottom: 2px;\n  background-color: ", ";\n  transition: 0.4s;\n  border-radius: 22px;\n"])), theme.colors.n700, theme.colors.n700, theme.colors.white);
};

var sliderActiveStyles = function sliderActiveStyles(_ref3) {
  var isActive = _ref3.isActive;
  return isActive && css(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteralLoose(["\n    transform: translateX(24px);\n  "])));
};

var Slider = styled('span')(sliderBaseStyles, sliderActiveStyles);

var ToggleSwitch = function ToggleSwitch(_ref4) {
  var isActive = _ref4.isActive;
  return /*#__PURE__*/React.createElement(Switch, {
    isActive: isActive
  }, /*#__PURE__*/React.createElement(Slider, {
    isActive: isActive
  }));
};

ToggleSwitch.propTypes = {
  isActive: propTypes.bool
};

var TOP$1 = 'top';
var BOTTOM$1 = 'bottom';
var LEFT$1 = 'left';
var RIGHT$1 = 'right';
var START$1 = 'start';
var END$1 = 'end';
var CENTER$1 = 'center';
var MIN_COL_SPAN = 1;
var MAX_COL_WIDTH = 100;
var DEFAULT_BREAKPOINT = 'default';

var childrenPropType = propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]);
var componentsPropType = propTypes.oneOfType([propTypes.element, propTypes.func]);
var positionPropType = propTypes.oneOf([TOP$1, BOTTOM$1, LEFT$1, RIGHT$1]);
var alignPropType = propTypes.oneOf([START$1, END$1, CENTER$1]);

var _excluded$7 = ["type"],
    _excluded2 = ["children", "icon", "onSelect"];

var _templateObject$a, _templateObject2$8, _templateObject3$7, _templateObject4$5, _templateObject5$3, _templateObject6$3, _templateObject7$3, _templateObject8$3, _templateObject9$3;
var textByte$1 = textByte,
    textMega$4 = textMega,
    textGiga$1 = textGiga,
    textTera$1 = textTera,
    flexCenter$1 = flexCenter,
    disableVisually$2 = disableVisually;
var BORDER_WIDTH = '1px';

var baseStyles$6 = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$a || (_templateObject$a = _taggedTemplateLiteralLoose(["\n  font-family: ", ";\n  font-weight: ", ";\n  color: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  cursor: pointer;\n  padding: 6px ", " ", ";\n  position: relative;\n\n  ", "\n  ", "  \n\n  &:focus,\n  &:active {\n    outline: none;\n  }\n\n  &:disabled,\n  &[disabled] {\n    ", ";\n    background: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n"])), theme.fontStack.bold.name, theme.fontStack.bold.weight, theme.colors.white, theme.colors.red, theme.colors.red, theme.borderRadius.peta, theme.spacings.mega, theme.spacings.giga, textMega$4({
    theme: theme
  }), flexCenter$1(), disableVisually$2(), theme.colors.n700, theme.colors.n700, theme.colors.white);
};

var primaryStyles = function primaryStyles(_ref2) {
  var theme = _ref2.theme,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'secondary' : _ref2$variant;
  return variant === 'primary' && css(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  "])), theme.colors.p500, theme.colors.p500, theme.colors.white);
};

var secondaryStyles = function secondaryStyles(_ref3) {
  var theme = _ref3.theme,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'secondary' : _ref3$variant;
  return variant === 'secondary' && css(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    background: linear-gradient(180deg, ", " 0%, ", " 50%);\n    border-color: ", ";\n    color: ", ";\n\n    &:disabled,\n    &[disabled] {\n      ", ";\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n      opacity: 0.6;\n    }\n  "])), theme.colors.y500, theme.colors.y500, theme.colors.o300, theme.colors.o300, theme.colors.black, disableVisually$2(), theme.colors.y500, theme.colors.o300, theme.colors.black);
};

var tertiaryStyles = function tertiaryStyles(_ref4) {
  var theme = _ref4.theme,
      _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? 'secondary' : _ref4$variant;
  return variant === 'tertiary' && css(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  "])), theme.colors.white, theme.colors.red, theme.colors.red);
};

var alternateStyles = function alternateStyles(_ref5) {
  var theme = _ref5.theme,
      _ref5$variant = _ref5.variant,
      variant = _ref5$variant === void 0 ? 'secondary' : _ref5$variant;
  return variant === 'alternate' && css(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  "])), theme.colors.white, theme.colors.white, theme.colors.red);
};

var contrastStyles = function contrastStyles(_ref6) {
  var theme = _ref6.theme,
      _ref6$variant = _ref6.variant,
      variant = _ref6$variant === void 0 ? 'secondary' : _ref6$variant;
  return variant === 'contrast' && css(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  "])), theme.colors.red, theme.colors.red, theme.colors.white);
};

var sizeStyles$2 = function sizeStyles(_ref7) {
  var theme = _ref7.theme,
      hasIcon = _ref7.hasIcon,
      _ref7$size = _ref7.size,
      size = _ref7$size === void 0 ? 'tera' : _ref7$size;
  var sizeMap = {
    "byte": {
      padding: theme.spacings.bit + " " + theme.spacings["byte"],
      borderRadius: theme.borderRadius.peta,
      type: textByte$1({
        theme: theme
      })
    },
    kilo: {
      padding: theme.spacings["byte"] + " calc(" + theme.spacings.giga + " - " + BORDER_WIDTH + ")",
      borderRadius: theme.borderRadius.peta,
      type: textMega$4({
        theme: theme
      })
    },
    giga: {
      padding: theme.spacings.bit + " calc(" + theme.spacings.giga + " - " + BORDER_WIDTH + ")",
      borderRadius: theme.borderRadius.peta,
      type: textGiga$1({
        theme: theme
      })
    },
    peta: {
      padding: "" + theme.spacings.mega,
      borderRadius: theme.borderRadius.peta,
      type: textTera$1({
        theme: theme
      })
    },
    tera: {
      padding: theme.spacings[hasIcon ? 'byte' : 'kilo'] + " " + theme.spacings.giga,
      paddingLeft: theme.spacings[hasIcon ? 'byte' : 'giga'],
      borderRadius: theme.borderRadius.peta,
      type: textTera$1({
        theme: theme
      }),
      minWidth: '230px'
    }
  };

  var _ref8 = sizeMap[size] || 'byte',
      type = _ref8.type,
      rest = _objectWithoutPropertiesLoose(_ref8, _excluded$7);

  return css(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n  "])), type, rest);
};

var stretchStyles = function stretchStyles(_ref9) {
  var stretch = _ref9.stretch;
  return stretch && css(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n  "])));
};

var BaseButton = styled('button', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop) && prop !== 'size';
  }
})(baseStyles$6, primaryStyles, secondaryStyles, tertiaryStyles, alternateStyles, contrastStyles, sizeStyles$2, stretchStyles);

var iconContainerBaseStyles = function iconContainerBaseStyles(_ref10) {
  var theme = _ref10.theme;
  return css(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    margin-right: ", ";\n  "])), theme.colors.black, theme.spacings.mega);
};

var IconContainer = styled('div')(iconContainerBaseStyles);

var Button = function Button(_ref11) {
  var children = _ref11.children,
      icon = _ref11.icon,
      onSelect = _ref11.onSelect,
      props = _objectWithoutPropertiesLoose(_ref11, _excluded2);

  return /*#__PURE__*/React.createElement(BaseButton, _extends({}, props, {
    onClick: onSelect
  }), icon && /*#__PURE__*/React.createElement(IconContainer, null, icon), children);
};

Button.propTypes = {
  children: childrenPropType,
  icon: componentsPropType,
  onSelect: propTypes.func
};

var _templateObject$b, _templateObject2$9, _templateObject3$8, _templateObject4$6, _templateObject5$4, _templateObject6$4;

var styledHeadingBaseStyles = function styledHeadingBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$b || (_templateObject$b = _taggedTemplateLiteralLoose(["\n  line-height: 20px;\n  margin-bottom: ", ";\n"])), theme.spacings["byte"]);
};

var StyledHeading = styled(Heading)(styledHeadingBaseStyles);

var baseStyles$7 = function baseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  display: flex;\n  overflow-x: scroll;\n  list-style: none;\n  padding: 0;\n  margin-bottom: 0;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"])), theme.colors.white);
};

var CarouselContainer = styled('ol')(baseStyles$7);

var panelContainerBaseStyles = function panelContainerBaseStyles(_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteralLoose(["\n  background: #2c2c2c;\n  border-radius: 11px;\n  padding: ", ";\n  margin-bottom: ", ";\n  display: flex;\n  flex-direction: column;\n  min-width: 100%;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n"])), theme.spacings.giga, theme.spacings.mega);
};

var PanelContainer = styled('li')(panelContainerBaseStyles);
var IndicatorContainer = styled('div')(css(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n"]))));

var bulletStyles = function bulletStyles(_ref4) {
  var theme = _ref4.theme;
  return css(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border-radius: 50%;\n  padding: ", ";\n  margin: ", " ", ";\n  border: none;\n"])), theme.colors.o300, theme.spacings["byte"], theme.spacings["byte"], theme.spacings.giga);
};

var ButtelLabel = styled.div(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteralLoose(["\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"])));
var BulletBtn = styled('button')(bulletStyles);

var Carousel = function Carousel(_ref5) {
  var data = _ref5.data;

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      strings = _useSelector.strings;

  var _useState = useState(0),
      scrollProgress = _useState[0],
      setScrollProgress = _useState[1];

  var theme = useTheme();
  var displayableStats = data.filter(function (d) {
    if (Object.keys(d).length > 0) {
      return d;
    }
  });
  var carouselContainerRef = useRef();
  var carouselWidth;
  var pickAccuracyTitle = strings['heatstreak/statistic/pickAccuracy/title'];
  var daysPlayedTitle = strings['heatstreak/statistic/daysPlayed/title'];
  var correctPicksTitle = strings['heatstreak/statistic/correctPicks/title'];
  var carouselBulletText1 = strings['button/heatstreak/panel1'];
  var carouselBulletText2 = strings['button/heatstreak/panel2'];
  var carouselBulletText3 = strings['button/heatstreak/panel3'];
  var bulletTextArray = [carouselBulletText1, carouselBulletText2, carouselBulletText3];

  var handleClick = function handleClick(i) {
    var moveAmount;

    if (scrollProgress < i) {
      if (i < displayableStats.length - 1) {
        moveAmount = (carouselWidth + 4 * (displayableStats.length - 1)) * Math.abs(scrollProgress - i);
      } else {
        moveAmount = (carouselWidth + 4 * (displayableStats.length - 1)) * Math.abs(scrollProgress - i);
      }
    } else {
      if (i > 0) {
        moveAmount = -Math.abs((carouselWidth + 4 * (displayableStats.length - 1)) * (scrollProgress - i));
      } else {
        moveAmount = -Math.abs(carouselWidth + 4 * (displayableStats.length - 1)) * (scrollProgress - i);
      }
    }

    if (carouselContainerRef.current) {
      carouselContainerRef.current.scrollLeft += moveAmount;
    }

    setScrollProgress(i);
  };

  var scrollListener = function scrollListener() {
    if (carouselContainerRef.current) {
      var elm = carouselContainerRef.current;
      var windowScroll = elm.scrollLeft;
      var totalWidth = elm.scrollWidth - carouselWidth;
      var tileSize = totalWidth / data.length;
      var scrolledStep = Math.floor(windowScroll / tileSize);
      if (scrolledStep <= data.length - 1) setScrollProgress(scrolledStep);
    }
  };

  useEffect(function () {
    if (carouselContainerRef.current) {
      carouselWidth = carouselContainerRef.current.clientWidth;
      carouselContainerRef.current.addEventListener('touchmove', scrollListener);
    }

    return function () {
      if (carouselContainerRef.current) {
        carouselContainerRef.current.removeEventListener('touchmove', scrollListener);
      }
    };
  });

  var renderPillIndicators = function renderPillIndicators(pillCount, i) {
    var selectedPillValue = scrollProgress;
    var isActive = selectedPillValue === i;
    return /*#__PURE__*/React.createElement(Fragment$1, {
      key: i
    }, /*#__PURE__*/React.createElement(ButtelLabel, {
      id: "buttonLabel" + i
    }, bulletTextArray[i]), /*#__PURE__*/React.createElement(BulletBtn, {
      style: {
        backgroundColor: isActive ? theme.colors.white : theme.colors.white50
      },
      onClick: function onClick() {
        handleClick(i);
      },
      "aria-labelledby": "buttonLabel" + i
    }));
  };

  var renderPanel = function renderPanel(data, index) {
    var styleMod;

    if (index === 0) {
      styleMod = {
        marginRight: theme.spacings.bit
      };
    } else if (index === displayableStats.length - 1) {
      styleMod = {
        marginLeft: theme.spacings.bit
      };
    } else {
      styleMod = {
        marginLeft: theme.spacings.bit,
        marginRight: theme.spacings.bit
      };
    }

    return /*#__PURE__*/React.createElement(PanelContainer, {
      key: data.title + "_" + index,
      style: _extends({}, styleMod)
    }, /*#__PURE__*/React.createElement(Spacing, {
      sizeBottom: "mega"
    }, /*#__PURE__*/React.createElement(ColorProvider, {
      variant: "white"
    }, /*#__PURE__*/React.createElement(StyledHeading, {
      as: "h3",
      size: "mega",
      noMarginBoth: true
    }, data.title))), /*#__PURE__*/React.createElement(Grid, {
      style: {
        alignItems: 'start'
      }
    }, /*#__PURE__*/React.createElement(Col, {
      columns: "4"
    }, /*#__PURE__*/React.createElement(Spacing, null, /*#__PURE__*/React.createElement(Statistic, {
      titleColor: "n800",
      suffixTextSize: "tera",
      title: pickAccuracyTitle,
      value: data.pickAccuracy ? "" + data.pickAccuracy : '0'
    }))), /*#__PURE__*/React.createElement(Col, {
      columns: "4"
    }, /*#__PURE__*/React.createElement(Spacing, {
      sizeLeft: "mega"
    }, /*#__PURE__*/React.createElement(Statistic, {
      titleColor: "n800",
      suffixTextSize: "tera",
      title: daysPlayedTitle,
      value: data.daysPlayed ? "" + data.daysPlayed : '0',
      suffix: ""
    }))), /*#__PURE__*/React.createElement(Col, {
      columns: "4"
    }, /*#__PURE__*/React.createElement(Spacing, {
      sizeLeft: "mega"
    }, /*#__PURE__*/React.createElement(Statistic, {
      titleColor: "n800",
      suffixTextSize: "tera",
      title: correctPicksTitle,
      value: data.correctPicks ? "" + data.correctPicks : '0',
      suffix: ""
    })))));
  };

  return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(CarouselContainer, {
    ref: carouselContainerRef,
    className: "carouselContainer"
  }, displayableStats.map(function (d, index) {
    return renderPanel(d, index);
  })), displayableStats.length > 1 && /*#__PURE__*/React.createElement(IndicatorContainer, {
    target: carouselContainerRef
  }, displayableStats.map(function (d, index) {
    return renderPillIndicators(displayableStats.length, index);
  })));
};

Carousel.propTypes = {};

var _templateObject$c, _templateObject2$a;

var iconContainerBaseStyles$1 = function iconContainerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$c || (_templateObject$c = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  background-color: ", ";\n  color: ", ";\n  width: 20px;\n  height: 20px;\n\n  svg {\n    width: 100% !important;\n    height: 100% !important;\n    padding: ", ";\n  }\n"])), theme.borderRadius.circle, theme.colors.red, theme.colors.white, theme.spacings.bit);
};

var iconContainerLiteStyles = function iconContainerLiteStyles(_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant;
  return variant === 'lite' && css(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    border: 1px solid ", ";\n    color: ", ";\n  "])), theme.colors.white, theme.colors.g700, theme.colors.g700);
};

var IconContainer$1 = styled('div')(iconContainerBaseStyles$1, iconContainerLiteStyles);

var CheckCircle = function CheckCircle(_ref3) {
  var variant = _ref3.variant;
  return /*#__PURE__*/React.createElement(IconContainer$1, {
    variant: variant
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "check"
  }));
};

CheckCircle.propTypes = {
  variant: propTypes.string
};

var _templateObject$d, _templateObject2$b;

var baseStyles$8 = function baseStyles(_ref) {
  var color = _ref.color;
  return css(_templateObject$d || (_templateObject$d = _taggedTemplateLiteralLoose(["\n  border-radius: 50%;\n  border: 0 solid #666;\n  background: ", ";\n  text-align: center;\n  box-sizing: content-box;\n  display: inline-block;\n"])), color);
};

var sizeStyles$3 = function sizeStyles(_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size,
      width = _ref2.width;
  return css(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  line-height: ", ";\n"])), width || theme.typography.text[size].lineHeight, width || theme.typography.text[size].lineHeight);
};

var CircleText = styled(Text)(baseStyles$8, sizeStyles$3);
CircleText.propTypes = {
  color: propTypes.string,
  width: propTypes.string
};

var _templateObject$e, _templateObject2$c;

var iconContainerBaseStyles$2 = function iconContainerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$e || (_templateObject$e = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: relative;\n  cursor: pointer;\n  width: 25px;\n  height: 25px;\n  border: none;\n  background: none;\n\n  &:before,\n  &:after {\n    position: absolute;\n    top: 0;\n    left: 12px;\n    content: ' ';\n    height: 25px;\n    width: 2px;\n    background-color: ", ";\n  }\n\n  &:before {\n    transform: rotate(45deg);\n  }\n\n  &:after {\n    transform: rotate(-45deg);\n  }\n"])), theme.colors.white);
};

var IconContainer$2 = styled('button')(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteralLoose(["\n  ", ";\n"])), iconContainerBaseStyles$2);

var Close = function Close(props) {
  return /*#__PURE__*/React.createElement(IconContainer$2, props);
};

var _templateObject$f;

var baseStyles$9 = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$f || (_templateObject$f = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  width: 100%;\n  height: 1px;\n"])), theme.colors.n500);
};

var Divider = styled('div')(baseStyles$9);

var _templateObject$g, _templateObject2$d, _templateObject3$9, _templateObject4$7;
var flexCenter$2 = flexCenter;

var baseStyles$a = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$g || (_templateObject$g = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  background-color: ", ";\n  width: 20px;\n  height: 20px;\n  ", "\n"])), theme.borderRadius.circle, theme.colors.n500, flexCenter$2());
};

var activeStyles = function activeStyles(_ref2) {
  var theme = _ref2.theme,
      isActive = _ref2.isActive;
  return isActive && css(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n  "])), theme.colors.red);
};

var largeStyles = function largeStyles(_ref3) {
  var isLarge = _ref3.isLarge;
  return isLarge && css(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteralLoose(["\n    width: 28px;\n    height: 28px;\n  "])));
};

var darkStyles = function darkStyles(_ref4) {
  var theme = _ref4.theme,
      isDark = _ref4.isDark;
  return isDark && css(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    color: ", ";\n  "])), theme.colors.n900, theme.colors.white);
};

var Dot = styled('div')(baseStyles$a, activeStyles, largeStyles, darkStyles);
Dot.propTypes = {
  isActive: propTypes.bool,
  isLarge: propTypes.bool,
  isDark: propTypes.bool
};

var _excluded$8 = ["children", "hasPadding"];

var _templateObject$h, _templateObject2$e, _templateObject3$a, _templateObject4$8, _templateObject5$5, _templateObject6$5, _templateObject7$4, _templateObject8$4;
var flexCenter$3 = flexCenter;

var baseStyles$b = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$h || (_templateObject$h = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  overflow: hidden;\n  padding: 2px;\n  position: relative;\n\n  ", ";\n\n  &:before {\n    content: '';\n    border-radius: ", ";\n    width: 100%;\n    height: 100%;\n  }\n"])), theme.borderRadius.circle, flexCenter$3(), theme.borderRadius.circle);
};

var variantStyles = function variantStyles(_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant;
  var variantMap = {
    "default": {
      bgColor: theme.colors.n700,
      bgColorBefore: theme.colors.white
    },
    solid: {
      bgColor: theme.colors.n500,
      bgColorBefore: theme.colors.n500
    },
    whiteTransparent: {
      borderBefore: "2px solid " + theme.colors.white,
      bgColor: 'none',
      bgColorBefore: 'none'
    },
    grey: {
      bgColor: theme.colors.n700,
      bgColorBefore: '#f2f2f2'
    }
  };

  var _ref3 = variantMap[variant] || variantMap["default"],
      borderBefore = _ref3.borderBefore,
      bgColor = _ref3.bgColor,
      bgColorBefore = _ref3.bgColorBefore;

  return css(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteralLoose(["\n    background: ", ";\n\n    &:before {\n      border: ", ";\n      background: ", ";\n    }\n  "])), bgColor, borderBefore || 'none', bgColorBefore);
};

var sizeStyles$4 = function sizeStyles(_ref4) {
  var size = _ref4.size;
  var sizeMap = {
    bit: {
      width: '20px',
      height: '20px'
    },
    "byte": {
      width: '28px',
      height: '28px'
    },
    giga: {
      width: '33px',
      height: '33px'
    },
    tera: {
      width: '37px',
      height: '37px'
    },
    peta: {
      width: '40px',
      height: '40px'
    },
    zetta: {
      width: '103px',
      height: '103px',
      padding: '4px'
    }
  };
  var sizeProps = sizeMap[size] || sizeMap.giga;
  return css(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteralLoose(["\n    ", ";\n  "])), sizeProps);
};

var borderColorStyles = function borderColorStyles(_ref5) {
  var theme = _ref5.theme,
      borderColor = _ref5.borderColor;
  return borderColor && css(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteralLoose(["\n    background: ", ";\n  "])), theme.colors[borderColor]);
};

var thinStyles = function thinStyles(_ref6) {
  var thin = _ref6.thin;
  return thin && css(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteralLoose(["\n    padding: 1px;\n  "])));
};

var dashedStyles = function dashedStyles(_ref7) {
  var theme = _ref7.theme,
      dashed = _ref7.dashed;
  return dashed && css(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteralLoose(["\n    border: 1px dashed ", ";\n    background: none;\n\n    &:before {\n      background: none;\n    }\n  "])), theme.colors.n700);
};

var Container$3 = styled('div')(baseStyles$b, variantStyles, sizeStyles$4, borderColorStyles, thinStyles, dashedStyles);

var wrapperBaseStyles = function wrapperBaseStyles(_ref8) {
  var theme = _ref8.theme;
  return css(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  text-align: center;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n"])), theme.colors.white);
};

var wrapperPaddingStyles = function wrapperPaddingStyles(_ref9) {
  var theme = _ref9.theme,
      hasPadding = _ref9.hasPadding;
  return hasPadding && css(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteralLoose(["\n    padding: ", ";\n  "])), theme.spacings["byte"]);
};

var Wrapper = styled('div')(wrapperBaseStyles, wrapperPaddingStyles);

var Frame = function Frame(_ref10) {
  var children = _ref10.children,
      hasPadding = _ref10.hasPadding,
      props = _objectWithoutPropertiesLoose(_ref10, _excluded$8);

  return /*#__PURE__*/React.createElement(Container$3, props, /*#__PURE__*/React.createElement(Wrapper, {
    hasPadding: hasPadding
  }, children));
};

Frame.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  hasPadding: propTypes.bool
};

var _excluded$9 = ["isSvg"];

var _templateObject$i, _templateObject2$f;

var baseStyles$c = function baseStyles() {
  return css(_templateObject$i || (_templateObject$i = _taggedTemplateLiteralLoose(["\n  display: block;\n  width: 100%;\n  max-width: 500px;\n  height: auto;\n  margin: auto;\n"])));
};

var naturalStyles = function naturalStyles(_ref) {
  var naturalSize = _ref.naturalSize;
  return naturalSize && css(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteralLoose(["\n    width: auto;\n    max-width: none;\n  "])));
};

var StyledImage = styled('img')(baseStyles$c, naturalStyles);

var Image = function Image(_ref2) {
  var isSvg = _ref2.isSvg,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded$9);

  if (isSvg) {
    return /*#__PURE__*/React.createElement(ReactSVG, {
      src: props.src
    });
  }

  return /*#__PURE__*/React.createElement(StyledImage, props);
};

Image.propTypes = {
  src: propTypes.string.isRequired,
  alt: propTypes.string.isRequired,
  naturalSize: propTypes.bool,
  isSvg: propTypes.bool
};
Image.defaultProps = {
  src: 'https://cdn.rbi.digital/hockey/sticks.svg',
  alt: '',
  isSvg: false
};

var _templateObject$j, _templateObject2$g, _templateObject3$b, _templateObject4$9, _templateObject5$6, _templateObject6$6;
var textMega$5 = textMega,
    textKilo$1 = textKilo,
    textGiga$2 = textGiga,
    resetList$1 = resetList;

var baseStyles$d = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$j || (_templateObject$j = _taggedTemplateLiteralLoose(["\n  font-weight: ", ";\n  margin-bottom: ", ";\n"])), theme.fontWeight.regular, theme.spacings.mega);
};

var sizeStyles$5 = function sizeStyles(_ref2) {
  var theme = _ref2.theme,
      inline = _ref2.inline,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'mega' : _ref2$size;
  var sizeMap = {
    kilo: {
      marginBottom: theme.spacings.kilo,
      paddingLeft: theme.spacings.kilo,
      marginLeft: theme.spacings.bit,
      type: textKilo$1({
        theme: theme
      })
    },
    mega: {
      marginBottom: theme.spacings["byte"],
      paddingLeft: theme.spacings.kilo,
      marginLeft: theme.spacings.kilo,
      type: textMega$5({
        theme: theme
      })
    },
    giga: {
      marginBottom: theme.spacings.kilo,
      paddingLeft: theme.spacings.mega,
      marginLeft: theme.spacings.kilo,
      type: textGiga$2({
        theme: theme
      })
    }
  };
  var _sizeMap$size = sizeMap[size],
      marginBottom = _sizeMap$size.marginBottom,
      paddingLeft = _sizeMap$size.paddingLeft,
      marginLeft = _sizeMap$size.marginLeft,
      type = _sizeMap$size.type;
  return !inline && css(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteralLoose(["\n      padding-left: ", ";\n      ", ";\n\n      li {\n        margin-bottom: ", ";\n        margin-left: ", ";\n      }\n\n      ul,\n      ol {\n        margin-left: ", ";\n      }\n    "])), paddingLeft, type, marginBottom, marginLeft, marginLeft);
};

var marginStyles$1 = function marginStyles(_ref3) {
  var noMargin = _ref3.noMargin;
  return noMargin && css(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteralLoose(["\n    margin-bottom: 0;\n  "])));
};

var bulletStyles$1 = function bulletStyles(_ref4) {
  var noBullets = _ref4.noBullets;
  return noBullets && css(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteralLoose(["\n    ", "\n  "])), resetList$1());
};

var inlineStyles$1 = function inlineStyles(_ref5) {
  var inline = _ref5.inline;
  return inline && css(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-wrap: wrap;\n  "])));
};

var BaseElement = styled('ol', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop) && prop !== 'size';
  }
})(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n  ", ";\n  ", "\n  ", "\n"])), baseStyles$d, sizeStyles$5, marginStyles$1, bulletStyles$1, inlineStyles$1);

var _templateObject$k, _templateObject2$h, _templateObject3$c, _templateObject4$a, _templateObject5$7;
var flexCenter$4 = flexCenter;

var baseStyles$e = function baseStyles(_ref) {
  var variant = _ref.variant;
  return variant !== 'secondary' && css(_templateObject$k || (_templateObject$k = _taggedTemplateLiteralLoose(["\n    width: 100%;\n\n    ", ";\n  "])), flexCenter$4());
};

var variantStyles$1 = function variantStyles(_ref2) {
  var variant = _ref2.variant;
  return variant === 'secondary' && css(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteralLoose([""])));
};

var Container$4 = styled('div')(baseStyles$e, variantStyles$1);

var blink = function blink(_ref3) {
  var theme = _ref3.theme;
  return keyframes(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteralLoose(["\n    50% {\n      background-color: ", ";\n    }\n  "])), theme.colors.red);
};

var iconBaseStyles$1 = function iconBaseStyles(_ref4) {
  var theme = _ref4.theme,
      isLite = _ref4.isLite;
  return css(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteralLoose(["\n  display: block;\n  background-color: ", ";\n  border-radius: ", ";\n  width: 12px;\n  height: 12px;\n  margin: 0 ", ";\n  animation: ", " 1s infinite;\n\n  &:nth-of-type(1) {\n    animation-delay: 0ms;\n  }\n\n  &:nth-of-type(2) {\n    animation-delay: 250ms;\n  }\n\n  &:nth-of-type(3) {\n    animation-delay: 500ms;\n  }\n"])), theme.colors.n500, theme.borderRadius.circle, theme.spacings.bit, blink({
    theme: theme,
    isLite: isLite
  }));
};

var iconLargeStyles = function iconLargeStyles(_ref5) {
  var variant = _ref5.variant;
  return variant === 'secondary' && css(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteralLoose(["\n    width: 20px;\n    height: 20px;\n    margin: 0;\n  "])));
};

var Icon$1 = styled('span')(iconBaseStyles$1, iconLargeStyles);

var LoadingIcon = function LoadingIcon(_ref6) {
  var size = _ref6.size,
      variant = _ref6.variant;
  return /*#__PURE__*/React.createElement(Container$4, {
    variant: variant
  }, new Array(size).fill(null).map(function (item, index) {
    return /*#__PURE__*/React.createElement(Icon$1, {
      key: "loading-icon-" + index,
      variant: variant
    });
  }));
};

LoadingIcon.propTypes = {
  size: propTypes.number,
  variant: propTypes.string
};
LoadingIcon.defaultProps = {
  size: 3
};

var _templateObject$l, _templateObject2$i, _templateObject3$d, _templateObject4$b;
var fixAll$1 = fixAll,
    flexCenter$5 = flexCenter;

var baseStyles$f = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$l || (_templateObject$l = _taggedTemplateLiteralLoose(["\n  ", "\n  z-index: ", ";\n  padding-right: 24px;\n  padding-left: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #3f2021;\n  opacity: 0.66;\n"])), fixAll$1(), theme.zIndex.modal);
};

var Container$5 = styled('div')(baseStyles$f);

var wrapperBaseStyles$1 = function wrapperBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  opacity: 1;\n  overflow: auto;\n  height: 272px;\n  border-radius: 12px;\n  width: 100%;\n"])), theme.colors.n300);
};

var Wrapper$1 = styled('div')(wrapperBaseStyles$1);

var modalPrimaryBaseStyles = function modalPrimaryBaseStyles() {
  return css(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteralLoose(["\n  ", "\n"])), flexCenter$5());
};

var ModalPrimary = styled('div')(modalPrimaryBaseStyles);

var modalSecondaryBaseStyles = function modalSecondaryBaseStyles() {
  return css(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteralLoose([""])));
};

var ModalSecondary = styled('div')(modalSecondaryBaseStyles);

var Modal = function Modal(_ref3) {
  var primaryContent = _ref3.primaryContent,
      secondaryContent = _ref3.secondaryContent;
  return /*#__PURE__*/React.createElement(Container$5, null, /*#__PURE__*/React.createElement(Wrapper$1, null, primaryContent && /*#__PURE__*/React.createElement(ModalPrimary, null, primaryContent), secondaryContent && /*#__PURE__*/React.createElement(ModalSecondary, null, secondaryContent)));
};

Modal.propTypes = {
  primaryContent: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  secondaryContent: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

var _templateObject$m;

var baseStyles$g = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$m || (_templateObject$m = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  width: 1px;\n  height: 100px;\n"])), theme.colors.n700);
};

var Pipe = styled('div')(baseStyles$g);

var _templateObject$n, _templateObject2$j, _templateObject3$e, _templateObject4$c, _templateObject5$8;

var containerBaseStyles$1 = function containerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$n || (_templateObject$n = _taggedTemplateLiteralLoose(["\n  border: 2px solid ", ";\n  border-radius: ", ";\n  width: 20px;\n  height: 20px;\n"])), theme.colors.n700, theme.borderRadius.circle);
};

var containerActiveStyles = function containerActiveStyles(_ref2) {
  var theme = _ref2.theme,
      isActive = _ref2.isActive;
  return isActive && css(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteralLoose(["\n    border-color: ", ";\n  "])), theme.colors.red);
};

var Container$6 = styled('div')(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n"])), containerBaseStyles$1, containerActiveStyles);

var innerCircleBaseStyles = function innerCircleBaseStyles(_ref3) {
  var theme = _ref3.theme,
      isActive = _ref3.isActive;
  return isActive && css(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteralLoose(["\n    border: 3px solid ", ";\n    background-color: ", ";\n    border-radius: ", ";\n    width: 16px;\n    height: 16px;\n  "])), theme.colors.white, theme.colors.red, theme.borderRadius.circle);
};

var InnerCircle = styled('div')(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteralLoose(["\n  ", ";\n"])), innerCircleBaseStyles);

var Radio = function Radio(_ref4) {
  var isActive = _ref4.isActive;
  return /*#__PURE__*/React.createElement(Container$6, {
    isActive: isActive
  }, /*#__PURE__*/React.createElement(InnerCircle, {
    isActive: isActive
  }));
};

Radio.propTypes = {
  isActive: propTypes.bool
};
Radio.defaultProps = {
  isActive: false
};

var _templateObject$o, _templateObject2$k, _templateObject3$f, _templateObject4$d;

var containerBaseStyles$2 = function containerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$o || (_templateObject$o = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border: ", " solid ", ";\n  width: 100%;\n  min-height: 100px;\n  min-width: 200px;\n  padding: ", " 0;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])), theme.colors.white, theme.borderWidth.mega, theme.colors.n500, theme.spacings["byte"]);
};

var Container$7 = styled('div')(containerBaseStyles$2);

var rinkGoalBaseStyles = function rinkGoalBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border-radius: ", ";\n  border: ", " solid ", ";\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  top: 50%;\n  left: -20px;\n  transform: translateY(-50%);\n"])), theme.colors.white, theme.borderRadius.circle, theme.borderWidth.mega, theme.colors.n500);
};

var rinkGoalAlignStyles = function rinkGoalAlignStyles(_ref3) {
  var alignRight = _ref3.alignRight;
  return alignRight && css(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteralLoose(["\n    left: auto;\n    right: -20px;\n  "])));
};

var RinkGoal = styled('div')(rinkGoalBaseStyles, rinkGoalAlignStyles);

var rinkCenterBaseStyles = function rinkCenterBaseStyles(_ref4) {
  var theme = _ref4.theme;
  return css(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  padding: 0 ", ";\n"])), theme.spacings.exa);
};

var RinkCenter = styled('div')(rinkCenterBaseStyles);

var Rink = function Rink(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/React.createElement(Container$7, null, /*#__PURE__*/React.createElement(RinkGoal, null), /*#__PURE__*/React.createElement(RinkCenter, null, children), /*#__PURE__*/React.createElement(RinkGoal, {
    alignRight: true
  }));
};

Rink.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node])
};

var _templateObject$p, _templateObject2$l, _templateObject3$g, _templateObject4$e, _templateObject5$9, _templateObject6$7, _templateObject7$5, _templateObject8$5, _templateObject9$4;

var flash = function flash() {
  return keyframes(_templateObject$p || (_templateObject$p = _taggedTemplateLiteralLoose(["\n    from {\n      opacity: 1;\n      box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.5);\n    }\n    to {\n      opacity: 1;\n      box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);\n    }\n  "])));
};

var baseStyles$h = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  width: 100%;\n  min-height: 30px;\n  min-width: 200px;\n  position: relative;\n"])), theme.colors.white);
};

var animateStyles = function animateStyles(_ref2) {
  var animate = _ref2.animate;
  return animate ? css(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteralLoose(["\n        &:after {\n          content: '';\n          position: absolute;\n          top: 0;\n          left: 0;\n          z-index: -1;\n          width: 100%;\n          height: 100%;\n          opacity: 0;\n          border-radius: 5px;\n          animation: ", " 2s ease-in 0s 1 normal forwards;\n        }\n      "])), flash()) : css(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteralLoose(["\n        box-shadow: 0 2px 4px 0 rgba(172, 172, 172, 0.5);\n      "])));
};

var centeredStyles$2 = function centeredStyles(_ref3) {
  var centered = _ref3.centered;
  return centered && css(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  "])));
};

var roundedStyles = function roundedStyles(_ref4) {
  var theme = _ref4.theme,
      rounded = _ref4.rounded;
  return rounded && css(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteralLoose(["\n    border-radius: ", ";\n  "])), theme.borderRadius.giga);
};

var arrowStyles = function arrowStyles(_ref5) {
  var theme = _ref5.theme,
      arrow = _ref5.arrow;
  return arrow && css(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteralLoose(["\n    &:after {\n      content: ' ';\n      width: 0;\n      height: 0;\n      border-top: 10px solid transparent;\n      border-bottom: 10px solid transparent;\n      border-right: 10px solid ", ";\n      position: absolute;\n      top: 5px;\n      left: -10px;\n    }\n  "])), theme.colors.white);
};

var arrowActiveStyles = function arrowActiveStyles(_ref6) {
  var theme = _ref6.theme,
      arrow = _ref6.arrow,
      active = _ref6.active;
  return arrow && active && css(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteralLoose(["\n    &:after {\n      border-right-color: ", ";\n    }\n  "])), theme.colors.g300);
};

var backgroundStyles = function backgroundStyles(_ref7) {
  var background = _ref7.background;
  return background && css(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteralLoose(["\n    background: ", ";\n  "])), background);
};

var ShadowBox = styled('div')(baseStyles$h, animateStyles, centeredStyles$2, roundedStyles, arrowStyles, arrowActiveStyles, backgroundStyles);

var _excluded$a = ["isLoading", "isSubmitted", "text", "onSelect"];

var _templateObject$q, _templateObject2$m, _templateObject3$h, _templateObject4$f;

var styledButtonBaseStyles = function styledButtonBaseStyles() {
  return css(_templateObject$q || (_templateObject$q = _taggedTemplateLiteralLoose(["\n    position: relative;\n  "])));
};

var styledButtonLoadingStyles = function styledButtonLoadingStyles(_ref) {
  var isLoading = _ref.isLoading;
  return isLoading && css(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteralLoose(["\n    pointer-events: none;\n  "])));
};

var StyledButton = styled(Button)(styledButtonBaseStyles, styledButtonLoadingStyles);

var loadingContainerBaseStyles = function loadingContainerBaseStyles() {
  return css(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
};

var LoadingContainer = styled('span')(loadingContainerBaseStyles);

var buttonTextLoadingStyles = function buttonTextLoadingStyles(_ref2) {
  var isLoading = _ref2.isLoading;
  return isLoading && css(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteralLoose(["\n    opacity: 0;\n  "])));
};

var ButtonText = styled('span')(buttonTextLoadingStyles);

var SubmitButton = function SubmitButton(_ref3) {
  var isLoading = _ref3.isLoading,
      text = _ref3.text,
      onSelect = _ref3.onSelect,
      btnProps = _objectWithoutPropertiesLoose(_ref3, _excluded$a);

  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    isLoading: isLoading,
    onSelect: onSelect
  }, btnProps), isLoading && /*#__PURE__*/React.createElement(LoadingContainer, null, /*#__PURE__*/React.createElement(LoadingIcon, null)), /*#__PURE__*/React.createElement(ButtonText, {
    isLoading: isLoading
  }, text));
};

SubmitButton.propTypes = {
  isLoading: propTypes.bool,
  isSubmitted: propTypes.bool,
  text: propTypes.string,
  onSelect: propTypes.func
};

var _templateObject$r, _templateObject2$n, _templateObject3$i;
var CardContainer = styled.div(_templateObject$r || (_templateObject$r = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  text-align: center;\n  background-color: ", ";\n  color: ", ";\n  padding: 10px 4px 4px 4px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.r600;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
});
var CardHeader = styled.h1(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteralLoose(["\n  font-size: 18px;\n  font-weight: 900;\n  line-height: 18px;\n  margin: 0;\n"])));
var CardText = styled.div(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteralLoose(["\n  margin: 0;\n  padding: 5px;\n"])));

var NotificationCard = function NotificationCard(_ref3) {
  var titleText = _ref3.titleText,
      bodyText = _ref3.bodyText;
  return /*#__PURE__*/React.createElement(CardContainer, null, /*#__PURE__*/React.createElement(CardHeader, {
    dangerouslySetInnerHTML: {
      __html: titleText
    }
  }), /*#__PURE__*/React.createElement(CardText, {
    dangerouslySetInnerHTML: {
      __html: bodyText
    }
  }));
};

NotificationCard.propTypes = {
  titleText: propTypes.string,
  bodyText: propTypes.string
};

var sensitiveKeys = ['currentSession'];

var sanitizeData = function sanitizeData(data) {
  var sanitized = _extends({}, data);

  sensitiveKeys.forEach(function (key) {
    if (sanitized[key]) {
      sanitized[key] = '**REDACTED**';
    }
  });
  return sanitized;
};

var fireMessageEvent = function fireMessageEvent(_ref) {
  var type = _ref.type,
      platform = _ref.platform,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data;
  var msgType = type || MPARTICLE_LOG_MESSAGE_TYPE;
  var sanitizedData = sanitizeData(data);
  var sentData = {
    type: msgType,
    evtSource: title,
    mParticleEvtType: 8,
    evtMessage: sanitizedData
  };

  switch (platform) {
    case 'mobile':
      if (type !== 'LOG' && type !== 'ERROR') {
        var sentDataForDataDog = {
          type: 'LOG',
          evtSource: 'hockey-challenge: ' + title,
          evtMessage: sanitizedData
        };
        window.ReactNativeWebView.postMessage(JSON.stringify(sentDataForDataDog));
      }

      window.ReactNativeWebView.postMessage(JSON.stringify(sentData));
      break;

    default:
      window.parent.postMessage(JSON.stringify(sentData), '*');
      break;
  }
};

var api = function api(action) {
  var actionName = action.toUpperCase();
  return {
    sendStart: function sendStart() {
      return {
        type: "SEND_" + actionName + "_START"
      };
    },
    sendSuccess: function sendSuccess(resp) {
      return {
        type: "SEND_" + actionName + "_SUCCESS",
        resp: resp
      };
    },
    sendFailure: function sendFailure(err) {
      return {
        type: "SEND_" + actionName + "_FAILURE",
        err: err
      };
    },
    fetchStart: function fetchStart() {
      return {
        type: "FETCH_" + actionName + "_START"
      };
    },
    fetchSuccess: function fetchSuccess(resp) {
      return {
        type: "FETCH_" + actionName + "_SUCCESS",
        resp: resp
      };
    },
    fetchFailure: function fetchFailure(err) {
      return {
        type: "FETCH_" + actionName + "_FAILURE",
        err: err
      };
    }
  };
};

var common = function common(action) {
  var actionName = action.toUpperCase();
  return {
    setValue: function setValue(resp) {
      return {
        type: "SET_" + actionName,
        resp: resp
      };
    }
  };
};

var createRoute = function createRoute(baseUrl) {
  return function (proxy, route) {
    return baseUrl + "/" + proxy + "/" + route;
  };
};

var getEndpoint = function getEndpoint(baseUrl) {
  var setEndpoint = createRoute(baseUrl);
  return {
    quiz: setEndpoint('user', 'stq'),
    notification: setEndpoint('user', 'preferences'),
    pickHistory: setEndpoint('hockey', 'picks/history'),
    players: setEndpoint('hockey', 'picks'),
    playerPicks: setEndpoint('hockey', 'picks'),
    user: setEndpoint('hockey', 'user'),
    userStats: setEndpoint('hockey', 'user/stats'),
    leaderboard: setEndpoint('hockey', 'contest/challenge/leaderboard'),
    postSeasonLeaderboard: setEndpoint('hockey', 'contest/postseason/leaderboard'),
    seasonLeaderboard: setEndpoint('hockey', 'contest/season/leaderboard'),
    leaderboardLocal: setEndpoint('hockey', 'contest/challenge/leaderboard/local'),
    postSeasonLeaderboardLocal: setEndpoint('hockey', 'contest/postseason/leaderboard/local'),
    seasonLeaderboardLocal: setEndpoint('hockey', 'contest/season/leaderboard/local')
  };
};

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.message === 'Network Error') {
    return {
      response: {
        status: 401
      }
    };
  }

  return Promise.reject(error);
});
var makeRequest = function makeRequest(_ref) {
  var _ref$method = _ref.method,
      method = _ref$method === void 0 ? 'POST' : _ref$method,
      apiUrl = _ref.apiUrl,
      userId = _ref.userId,
      currentSession = _ref.currentSession,
      route = _ref.route,
      data = _ref.data,
      _ref$params = _ref.params,
      params = _ref$params === void 0 ? {} : _ref$params,
      _ref$headers = _ref.headers,
      headers = _ref$headers === void 0 ? {} : _ref$headers;

  try {
    var url = getEndpoint(apiUrl)[route];
    var jwt = currentSession;
    return Promise.resolve(axios({
      method: method,
      url: url,
      headers: _extends({
        'Content-Type': 'application/json',
        Authorization: "Bearer " + jwt,
        'x-cognito-id': userId
      }, headers),
      data: data,
      params: params
    }).then(function (success) {
      var _success$response;

      if ((success === null || success === void 0 ? void 0 : (_success$response = success.response) === null || _success$response === void 0 ? void 0 : _success$response.status) === 401) {
        throw success.response;
      }

      return camelizeKeys(success.data);
    })["catch"](function (error) {
      var _error$response;

      if (error.status === 401) {
        throw error;
      }

      if (Math.floor((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) / 100) === 5) {
        var err = {
          code: 500
        };
        throw err;
      }

      var data = error.response.data;
      if ((data === null || data === void 0 ? void 0 : data.code) === 'noContest') return data;
      throw data;
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var setIsFetching = function setIsFetching() {
  return function (dispatch) {
    var _commonActions = common('ui_is_fetching'),
        setValue = _commonActions.setValue;

    dispatch(setValue());
  };
};
var setIsNotFetching = function setIsNotFetching() {
  return function (dispatch) {
    var _commonActions2 = common('ui_is_not_fetching'),
        setValue = _commonActions2.setValue;

    dispatch(setValue());
  };
};
var setNotificationBarToOpen = function setNotificationBarToOpen() {
  return function (dispatch) {
    var _commonActions5 = common('notification_bar_open'),
        setValue = _commonActions5.setValue;

    dispatch(setValue());
  };
};
var setNotificationBarToClosed = function setNotificationBarToClosed() {
  return function (dispatch) {
    var _commonActions6 = common('notification_bar_closed'),
        setValue = _commonActions6.setValue;

    dispatch(setValue());
  };
};
var setHeatStreakPanelToOpen = function setHeatStreakPanelToOpen() {
  return function (dispatch) {
    var _commonActions7 = common('heatstreak_panel_open'),
        setValue = _commonActions7.setValue;

    dispatch(setValue());
  };
};
var setHeatStreakPanelToClosed = function setHeatStreakPanelToClosed() {
  return function (dispatch) {
    var _commonActions8 = common('heatstreak_panel_closed'),
        setValue = _commonActions8.setValue;

    dispatch(setValue());
  };
};
var setElementHeight = function setElementHeight(height) {
  return function (dispatch) {
    var _commonActions9 = common('element_height'),
        setValue = _commonActions9.setValue;

    dispatch(setValue(height));
  };
};
var setElementFocused = function setElementFocused(element) {
  return function (dispatch) {
    var _commonActions10 = common('element_in_view'),
        setValue = _commonActions10.setValue;

    dispatch(setValue(element));
  };
};
var incrementFetchErrorCount = function incrementFetchErrorCount(value) {
  return function (dispatch) {
    var _commonActions11 = common('INCREMENT_FETCH_ERROR_COUNT'),
        setValue = _commonActions11.setValue;

    dispatch(setValue({
      fetchErrorCount: value
    }));
  };
};
var browserIsActive$1 = function browserIsActive(isActive) {
  return function (dispatch) {
    var _commonActions12 = common('APP_FOCUS_STATE'),
        setValue = _commonActions12.setValue;

    dispatch(setValue({
      focusState: isActive
    }));
  };
};
var hasFetchError$1 = function hasFetchError() {
  return function (dispatch) {
    dispatch({
      type: "FETCH_RESET"
    });
  };
};

var allImages = {
  hockeyChallengeLogo: '2025_hockey-challenge-logo.png',
  hockeyChallengeLogoFr: '2025_hockey-challenge-logo-fr.png',
  bannerBgDefault: 'banner-bg.png',
  bannerBgBlack: 'banner-bg-black.png',
  redTexture: 'red-texture.jpg',
  iceTexture: 'ice-texture.jpg',
  bannerPlayerGraphic: 'play-banner-graphic.png',
  bannerPlayerGraphicFr: 'play-banner-graphic-fr.png',
  bannerTicketRed: 'prize-ballot-entry.png',
  bannerTicketRedFr: 'prize-ballot-entry.png',
  bannerTicketYellow: 'ballot-entry-self-directed.png',
  bannerTicketYellowFr: 'ballot-entry-self-directed.png',
  prizeInstantCoffee: 'instant-prize-coffee.png',
  prizeInstantCoffeeFr: 'instant-prize-coffee-fr.png',
  bannerAutoPicks: 'scout-picks-background.png',
  iconTicket: 'ticket-empty.svg',
  iconTicketWhite: 'ticket.svg',
  iconTicketRed: 'ticket-red.svg',
  iconTicketYellow: 'ticket-yellow.svg',
  iconCoffeeWithRedTicket: 'instant-prize-coffee-red.svg',
  iconCoffeeWithYellowTicket: 'instant-prize-coffee-yellow.svg',
  iconLock: 'lock.svg',
  iconLockNew: 'lock_new.svg',
  iconNewLock: 'new_lock.svg',
  iconFlame: 'icon_flame.svg',
  sticks: 'sticks.svg',
  errorTriangle: 'error-triangle.svg',
  chevronUp: 'chevron_up.svg',
  chevronDown: 'chevron_down.svg',
  loadingSticks: 'loading-sticks.png',
  hockeySticks: '2025_sticks.png',
  hockeySticksSmall: '2025_small_sticks.svg',
  collectToWinLogo: 'collect-to-win-logo.png',
  collectToWinLogoFr: 'collect-to-win-logo-fr.png',
  collectToWinLogoSmall: 'collect-to-win-logo-small.png',
  collectToWinLogoSmallFr: 'collect-to-win-logo-small-fr.png',
  collectToWinLogoWithTicket: 'collect-to-win-logo-ticket.png',
  collectToWinLogoWithTicketFr: 'collect-to-win-logo-ticket-fr.png',
  howToPick: 'Step1.png',
  howToSubmit: 'Step2.png',
  howToWin: 'howto-step3.png',
  howToScan: 'howto-scan.png',
  howToScanFr: 'howto-scan-fr.png',
  howToEarn: 'howto-earn.png',
  howToEarnFr: 'howto-earn-fr.png',
  howToUnwrap: 'howto-unwrap.png',
  howToUnwrapFr: 'howto-unwrap-fr.png',
  freeCoffeeInstant: 'free-coffee-instant.png',
  freeCoffeeInstantFr: 'free-coffee-instant.png',
  freeCoffeeYear: 'free-coffee-year.png',
  freeCoffeeYearFr: 'free-coffee-year-fr.png',
  timcard50: 'timcard-50.png',
  timcard50Fr: 'timcard-50-fr.png',
  nhlSubscription: 'nhl-subscription.png',
  nhlSubscriptionFr: 'nhl-subscription.png',
  stanleyCupFinal: 'stanley-cup-final.png',
  stanleyCupFinalFr: 'stanley-cup-final.png',
  meetSydney: 'meet-sydney.png',
  meetSydneyFr: 'meet-sydney.png',
  challengeCardHeader: 'challenge-card-header.png',
  challengeCardBackground: 'challenge-card-header-background.png',
  playoffLogo: '2024_Stanley_Cup.png',
  playoffLogoEn: '2024_Stanley_Cup_Playoff_Logo_en.png',
  playoffLogoFr: '2024_Stanley_Cup_Playoff_Logo_fr.png',
  leaderboardResultsDivider: 'leaderboard-results-divider.png',
  seasonEnd: 'TH_TimBits_Trophy.png',
  challengeEnd: 'TH_TimBits_Foam_Hand.png',
  historyUnscored: 'static-loading-icon.svg',
  heatStreakBannerImg1Src: 'playoff_streak_large.png',
  heatStreakBannerImg2Src: 'playoff_streak_small.png',
  miniBannerBackground: 'heat_streak_playoff_background.png',
  heatstreakBannerBackground: '2025_streak_banner_bg.png'
};

var imageList = function imageList(version) {
  return Object.keys(allImages).reduce(function (acc, id) {
    var _extends2;

    var image = allImages[id];
    return _extends({}, acc, (_extends2 = {}, _extends2[id] = image + "?v=" + version, _extends2));
  }, {});
};

var childrenPropType$1 = propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]);
var typePropType = propTypes.shape({
  fontSize: propTypes.string,
  lineHeight: propTypes.string
}).isRequired;
var themePropType = propTypes.shape({
  colors: propTypes.shape({
    white: propTypes.string.isRequired,
    black: propTypes.string.isRequired,
    n100: propTypes.string.isRequired,
    n300: propTypes.string.isRequired,
    n700: propTypes.string.isRequired,
    b100: propTypes.string.isRequired,
    b300: propTypes.string.isRequired,
    b500: propTypes.string.isRequired,
    b700: propTypes.string.isRequired,
    b900: propTypes.string.isRequired,
    g100: propTypes.string.isRequired,
    g300: propTypes.string.isRequired,
    g500: propTypes.string.isRequired,
    g700: propTypes.string.isRequired,
    g900: propTypes.string.isRequired,
    y100: propTypes.string.isRequired,
    y300: propTypes.string.isRequired,
    y500: propTypes.string.isRequired,
    y700: propTypes.string.isRequired,
    y900: propTypes.string.isRequired,
    r100: propTypes.string.isRequired,
    r300: propTypes.string.isRequired,
    r500: propTypes.string.isRequired,
    r700: propTypes.string.isRequired,
    r900: propTypes.string.isRequired,
    p100: propTypes.string.isRequired,
    p300: propTypes.string.isRequired,
    p500: propTypes.string.isRequired,
    p700: propTypes.string.isRequired,
    p900: propTypes.string.isRequired,
    shadow: propTypes.string.isRequired,
    bodyBg: propTypes.string.isRequired,
    bodyColor: propTypes.string.isRequired
  }).isRequired,
  spacings: propTypes.shape({
    bit: propTypes.string.isRequired,
    "byte": propTypes.string.isRequired,
    kilo: propTypes.string.isRequired,
    mega: propTypes.string.isRequired,
    giga: propTypes.string.isRequired,
    tera: propTypes.string.isRequired,
    peta: propTypes.string.isRequired,
    exa: propTypes.string.isRequired,
    zetta: propTypes.string.isRequired
  }).isRequired,
  iconSizes: propTypes.shape({
    kilo: propTypes.string.isRequired,
    mega: propTypes.string.isRequired
  }),
  borderRadius: propTypes.shape({
    kilo: propTypes.string,
    mega: propTypes.string,
    giga: propTypes.string
  }).isRequired,
  typography: propTypes.shape({
    headings: propTypes.shape({
      kilo: typePropType,
      mega: typePropType,
      giga: typePropType,
      tera: typePropType,
      peta: typePropType,
      exa: typePropType,
      zetta: typePropType
    }).isRequired,
    subHeadings: propTypes.shape({
      kilo: typePropType,
      mega: typePropType
    }).isRequired,
    text: propTypes.shape({
      kilo: typePropType,
      mega: typePropType,
      giga: typePropType
    }).isRequired
  }),
  fontStack: propTypes.shape({
    "default": propTypes.string,
    mono: propTypes.string
  }),
  fontWeight: propTypes.shape({
    regular: propTypes.string.isRequired,
    bold: propTypes.string.isRequired
  }).isRequired
});
var componentsPropType$1 = propTypes.oneOfType([propTypes.element, propTypes.func]);
var positionPropType$1 = propTypes.oneOf([TOP, BOTTOM, LEFT, RIGHT]);
var alignPropType$1 = propTypes.oneOf([START, END, CENTER]);

var prefixCdnUrl = function prefixCdnUrl(cdnUrl, ids, images) {
  return ids.reduce(function (acc, id) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[id] = "" + cdnUrl + images[id], _extends2));
  }, {});
};
var getAssetSet = function getAssetSet(cb, filename) {
  var assets = cb(filename);

  if (Array.isArray(filename) && filename.length === 1) {
    return assets[filename[0]];
  }

  if (Array.isArray(filename)) {
    return assets;
  }

  return assets[filename];
};

var CDN_URL = 'https://cdn.rbi.digital/hockey/';
var ConfigContext = createContext();

var ConfigProvider = function ConfigProvider(_ref) {
  var config = _ref.config,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(ConfigContext.Provider, {
    value: config
  }, children);
};

ConfigProvider.propTypes = {
  config: propTypes.object,
  children: childrenPropType$1
};

var useCdnUrl = function useCdnUrl() {
  return CDN_URL;
};

var useCdnImage = function useCdnImage(ids) {
  var version = process.env.APP_VERSION;
  return prefixCdnUrl(CDN_URL, Array.isArray(ids) ? ids : [ids], imageList(version));
};

var _templateObject$s, _templateObject2$o, _templateObject3$j, _templateObject4$g, _templateObject5$a, _templateObject6$8, _templateObject7$6, _templateObject8$6;
var fixAll$2 = fixAll,
    flexStack$1 = flexStack,
    flexCenter$6 = flexCenter;

var assetSet = function assetSet(filename) {
  return getAssetSet(useCdnImage, filename);
};

var Container$8 = styled.div(_templateObject$s || (_templateObject$s = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  z-index: ", ";\n  padding: 0 24px;\n"])), fixAll$2(), flexCenter$6(), function (_ref) {
  var theme = _ref.theme;
  return theme.zIndex.modal;
});
var Backdrop = styled.div(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteralLoose(["\n  ", "\n  padding: 0 24px;\n  background-color: #3f2021;\n  opacity: 0.66;\n"])), fixAll$2());
var Wrapper$2 = styled.div(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteralLoose(["\n  ", "\n  background: ", ";\n  z-index: ", ";\n  opacity: 1;\n  overflow: auto;\n  height: auto;\n  border-radius: 12px;\n  width: 100%;\n  padding: 30px 20px 20px;\n"])), flexStack$1(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.n300;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.zIndex.modalbox;
});
var ModalPrimary$1 = styled.div(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteralLoose(["\n  ", "\n"])), flexStack$1());
var Circle = styled.div(_templateObject5$a || (_templateObject5$a = _taggedTemplateLiteralLoose(["\n  ", "\n  background-color: #eaddc8;\n  border-radius: 100px;\n  height: 56px;\n  width: 56px;\n\n  img {\n    width: 24px;\n    height: 24px;\n  }\n"])), flexCenter$6());
var MainHeading = styled(Heading)(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin: 16px 0 18px;\n"])));
var Cta = styled(Button)(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteralLoose(["\n  margin-top: 20px;\n"])));
var ModalText = styled(Text)(_templateObject8$6 || (_templateObject8$6 = _taggedTemplateLiteralLoose(["\n  font-size: 15px;\n  line-height: 18px;\n"])));

var Modal$1 = function Modal(_ref4) {
  var title = _ref4.title,
      message = _ref4.message,
      buttonText = _ref4.buttonText,
      onClose = _ref4.onClose,
      imageSrc = _ref4.imageSrc,
      _ref4$imageAlt = _ref4.imageAlt,
      imageAlt = _ref4$imageAlt === void 0 ? 'error' : _ref4$imageAlt;
  var defaultImageSrc = assetSet(['errorTriangle']);
  var dispatch = useDispatch();

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      config = _useSelector.config,
      strings = _useSelector.strings,
      ui = _useSelector.ui;

  var platform = config.platform,
      env = config.env;
  var heatStreakPanelOpen = ui.heatStreakPanelOpen;
  var ariaLabel = strings['roles/button/close/aria'];
  var headerText = title || strings['notifications/errormodal/header'];
  var bodyText = message || strings['notifications/errormodal/text'];
  var buttonLabel = buttonText || strings['notifications/errormodal/button'];

  var handleClose = function handleClose(e) {
    if (onClose) {
      onClose(e);
    } else if (heatStreakPanelOpen) {
      dispatch(setHeatStreakPanelToClosed());
      e.preventDefault();
    } else {
      fireMessageEvent({
        type: 'CLOSE_WINDOW',
        platform: platform,
        env: env
      });
    }
  };

  return /*#__PURE__*/React.createElement(Container$8, null, /*#__PURE__*/React.createElement(Backdrop, null), /*#__PURE__*/React.createElement(Wrapper$2, null, /*#__PURE__*/React.createElement(Circle, null, /*#__PURE__*/React.createElement(Image, {
    src: imageSrc || defaultImageSrc,
    alt: imageAlt
  })), /*#__PURE__*/React.createElement(ModalPrimary$1, null, /*#__PURE__*/React.createElement(MainHeading, {
    noMarginBottom: true
  }, headerText), /*#__PURE__*/React.createElement(ModalText, {
    centered: true
  }, bodyText), /*#__PURE__*/React.createElement(Cta, {
    variant: "primary",
    stretch: true,
    "aria-label": ariaLabel,
    onSelect: handleClose
  }, buttonLabel))));
};

Modal$1.propTypes = {
  title: propTypes.string,
  message: propTypes.string,
  buttonText: propTypes.string,
  onClose: propTypes.func,
  imageSrc: propTypes.string,
  imageAlt: propTypes.string
};

var _excluded$b = ["grid"];
var isDefault = isEqual(DEFAULT_BREAKPOINT);
var wrapStyles = function wrapStyles(styles, breakpoint, theme) {
  return isDefault(breakpoint) ? css(styles) : theme.mq[breakpoint] + " { " + styles + " }";
};
var createSpanStyles = function createSpanStyles(grid, theme, span) {
  if (!grid) {
    return null;
  }

  var cols = grid.cols,
      breakpoint = grid.breakpoint;
  var safeSpan = clamp(MIN_COL_SPAN, cols, span);
  var styles = "\n    width: " + MAX_COL_WIDTH / cols * safeSpan + "%;\n  ";
  return wrapStyles(styles, breakpoint, theme);
};
var createBreakpointStyles = curry(function (theme, current) {
  var config = theme.grid[current.breakpoint];

  if (!config) {
    return null;
  }

  var styles = "\n    padding-left: 0;\n    padding-right: 0;\n  ";
  return wrapStyles(styles, current.breakpoint, theme);
});
var getBreakPointStyles = function getBreakPointStyles(theme) {
  return compose$1(values, mapValues(createBreakpointStyles(theme)))(theme.grid);
};
var sortByPriority = curry(function (grid, iteratee) {
  return iteratee.sort(function (a, b) {
    return grid[head(a)].priority - grid[head(b)].priority;
  });
});
var mapBreakpoint = curry(function (fn, grid, theme, _ref) {
  var key = _ref[0],
      value = _ref[1];
  return fn(grid[key], theme, value);
});
var composeBreakpoints = curry(function (fn, grid, theme, breakpoints) {
  return compose$1(map(mapBreakpoint(fn, grid, theme)), sortByPriority(grid), toPairs)(breakpoints);
});
var getSpanStyles = function getSpanStyles(_ref2, span) {
  var grid = _ref2.grid,
      theme = _objectWithoutPropertiesLoose(_ref2, _excluded$b);

  return isString(span) ? createSpanStyles(grid["default"], theme, span) : composeBreakpoints(createSpanStyles, grid, theme, span);
};

var _templateObject$t;

var baseStyles$i = function baseStyles(_ref) {
  var theme = _ref.theme,
      columns = _ref.columns;
  return css(_templateObject$t || (_templateObject$t = _taggedTemplateLiteralLoose(["\n  flex: 0 0 auto;\n  position: relative;\n\n  ", ";\n  ", ";\n"])), getBreakPointStyles(theme), getSpanStyles(theme, columns));
};

var Col = styled('div')(baseStyles$i);
var sizingProp = propTypes.oneOfType([propTypes.object, propTypes.number, propTypes.string]);
Col.propTypes = {
  columns: sizingProp
};
Col.defaultProps = {
  columns: '0'
};

var _templateObject$u;

var baseStyles$j = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$u || (_templateObject$u = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  flex-direction: row;\n  display: flex;\n  justify-content: space-between;\n  width: 90%;\n  color: #3f2021;\n  background-color: #ffe7e7;\n  margin: ", " auto;\n  padding: ", " 23px;\n  border-radius: 10px;\n"])), theme.spacings.mega, theme.spacings.kilo);
};

var ErrorDiv = styled('div')(baseStyles$j);

var _templateObject$v;

var baseStyles$k = function baseStyles(_ref) {
  var theme = _ref.theme,
      top = _ref.top;
  return css(_templateObject$v || (_templateObject$v = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: ", ";\n  left: 0;\n  width: 100%;\n  z-index: ", ";\n"])), top, theme.zIndex.drawer);
};

var FixedContainer = styled('div')(baseStyles$k);
FixedContainer.propTypes = {
  top: propTypes.string
};
FixedContainer.defaultProps = {
  top: '52px'
};

var _templateObject$w;
var flexEqualColumn$1 = flexEqualColumn;

var baseStyles$l = function baseStyles() {
  return css(_templateObject$w || (_templateObject$w = _taggedTemplateLiteralLoose(["\n  ", "\n"])), flexEqualColumn$1());
};

var Grid = styled('div')(baseStyles$l);

var _templateObject$x, _templateObject2$p, _templateObject3$k, _templateObject4$h, _templateObject5$b, _templateObject6$9, _templateObject7$7, _templateObject8$7, _templateObject9$5, _templateObject10$3;

var baseStyles$m = function baseStyles(_ref) {
  var width = _ref.width;
  return css(_templateObject$x || (_templateObject$x = _taggedTemplateLiteralLoose(["\n    width: ", ";\n  "])), width || '100%');
};

var sizeStyles$6 = function sizeStyles(_ref2) {
  var theme = _ref2.theme,
      sizeTop = _ref2.sizeTop,
      sizeBottom = _ref2.sizeBottom,
      sizeLeft = _ref2.sizeLeft,
      sizeRight = _ref2.sizeRight,
      paddingBottom = _ref2.paddingBottom,
      paddingTop = _ref2.paddingTop;
  var spacings = theme.spacings;

  var sizeMap = _extends({}, sizeTop && {
    marginTop: spacings[sizeTop]
  }, sizeBottom && {
    marginBottom: spacings[sizeBottom]
  }, sizeLeft && {
    paddingLeft: spacings[sizeLeft]
  }, sizeRight && {
    paddingRight: spacings[sizeRight]
  }, paddingBottom && {
    paddingBottom: spacings[paddingBottom]
  }, paddingTop && {
    paddingTop: spacings[paddingTop]
  });

  return css(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteralLoose(["\n    ", ";\n  "])), sizeMap);
};

var marginBottomStyles = function marginBottomStyles(_ref3) {
  var theme = _ref3.theme,
      bottom = _ref3.bottom;
  return bottom && css(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteralLoose(["\n    margin-bottom: ", ";\n  "])), theme.spacings.giga);
};

var marginTopStyles = function marginTopStyles(_ref4) {
  var theme = _ref4.theme,
      top = _ref4.top;
  return top && css(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteralLoose(["\n    margin-top: ", ";\n  "])), theme.spacings.giga);
};

var singleBottomStyles = function singleBottomStyles(_ref5) {
  var theme = _ref5.theme,
      bottom = _ref5.bottom,
      single = _ref5.single;
  return bottom && single && css(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteralLoose(["\n    margin-bottom: ", ";\n  "])), theme.spacings.kilo);
};

var doubleBottomStyles = function doubleBottomStyles(_ref6) {
  var theme = _ref6.theme,
      bottom = _ref6.bottom,
      _double = _ref6["double"];
  return bottom && _double && css(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteralLoose(["\n    margin-bottom: ", ";\n  "])), theme.spacings.peta);
};

var tripleBottomStyles = function tripleBottomStyles(_ref7) {
  var theme = _ref7.theme,
      bottom = _ref7.bottom,
      triple = _ref7.triple;
  return bottom && triple && css(_templateObject7$7 || (_templateObject7$7 = _taggedTemplateLiteralLoose(["\n    margin-bottom: ", ";\n  "])), theme.spacings.zetta);
};

var sideStyles = function sideStyles(_ref8) {
  var theme = _ref8.theme,
      sides = _ref8.sides;
  return sides && css(_templateObject8$7 || (_templateObject8$7 = _taggedTemplateLiteralLoose(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), theme.spacings.mega, theme.spacings.mega);
};

var doubleSideStyles = function doubleSideStyles(_ref9) {
  var theme = _ref9.theme,
      sides = _ref9.sides,
      _double2 = _ref9["double"];
  return sides && _double2 && css(_templateObject9$5 || (_templateObject9$5 = _taggedTemplateLiteralLoose(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), theme.spacings.tera, theme.spacings.tera);
};

var tripleSideStyles = function tripleSideStyles(_ref10) {
  var theme = _ref10.theme,
      sides = _ref10.sides,
      triple = _ref10.triple;
  return sides && triple && css(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteralLoose(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), theme.spacings.peta, theme.spacings.peta);
};

var Spacing = styled('div')(baseStyles$m, marginBottomStyles, marginTopStyles, singleBottomStyles, doubleBottomStyles, tripleBottomStyles, sideStyles, doubleSideStyles, tripleSideStyles, sizeStyles$6);

var _excluded$c = ["onSelect"];

var _templateObject$y;

var baseButtonStyles = function baseButtonStyles() {
  return css(_templateObject$y || (_templateObject$y = _taggedTemplateLiteralLoose(["\n  border: none;\n  padding: 0;\n  width: 100%;\n  max-width: 350px;\n"])));
};

var StyledButton$1 = styled('button')(baseButtonStyles);

var AdvertisingTile = function AdvertisingTile(_ref) {
  var onSelect = _ref.onSelect,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$c);

  return /*#__PURE__*/React.createElement(StyledButton$1, {
    onClick: function onClick() {
      onSelect();
    }
  }, /*#__PURE__*/React.createElement(Image, rest));
};

AdvertisingTile.propTypes = {
  src: propTypes.string.isRequired,
  alt: propTypes.string.isRequired,
  naturalSize: propTypes.bool,
  isSvg: propTypes.bool,
  onSelect: propTypes.func.isRequired
};
AdvertisingTile.defaultProps = {
  src: 'https://via.placeholder.com/350x200',
  alt: 'For Placement Only',
  naturalSize: true,
  isSvg: false,
  onSelect: function onSelect() {
    console.log('should run the function passed in onSelect');
  }
};

var _templateObject$z, _templateObject2$q, _templateObject3$l, _templateObject4$i, _templateObject5$c, _templateObject6$a;

var containerBaseStyles$3 = function containerBaseStyles() {
  return css(_templateObject$z || (_templateObject$z = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: stretch;\n  height: 100%;\n"])));
};

var Container$9 = styled('div')(containerBaseStyles$3);

var imageWrapperBaseStyles = function imageWrapperBaseStyles() {
  return css(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 12px;\n"])));
};

var ImageWrapper = styled('div')(imageWrapperBaseStyles);

var textContainerBaseStyles = function textContainerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteralLoose(["\n  color: #3f2021;\n  display: flex;\n  align-items: center;\n  min-height: 46px;\n  margin-left: ", ";\n"])), theme.spacings["byte"]);
};

var textContainerErrorStyles = function textContainerErrorStyles(_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant;
  return variant === 'error' && css(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteralLoose(["\n    color: ", ";\n  "])), theme.colors.r500);
};

var StyledImage$1 = styled(Image)(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  height: ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacings.mega;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacings.mega;
});
var ShadowBoxWrapper = styled(ShadowBox)(_templateObject6$a || (_templateObject6$a = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  box-shadow: none;\n  padding: ", " ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.g200;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacings.kilo;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacings.giga;
});
var TextContainer = styled('div')(textContainerBaseStyles, textContainerErrorStyles);

var AlertBanner = function AlertBanner(_ref8) {
  var text = _ref8.text,
      variant = _ref8.variant;

  var getAssetSetUrl = function getAssetSetUrl(filename) {
    return getAssetSet(useCdnImage, filename);
  };

  return /*#__PURE__*/React.createElement(ShadowBoxWrapper, {
    rounded: true
  }, /*#__PURE__*/React.createElement(Container$9, {
    "data-testid": "alert-banner"
  }, /*#__PURE__*/React.createElement(ImageWrapper, null, /*#__PURE__*/React.createElement(StyledImage$1, {
    src: getAssetSetUrl('iconNewLock')
  })), /*#__PURE__*/React.createElement(TextContainer, {
    variant: variant
  }, /*#__PURE__*/React.createElement(Text, {
    size: "mega",
    noMargin: true
  }, text))));
};

AlertBanner.propTypes = {
  text: propTypes.string,
  variant: propTypes.string
};
AlertBanner.defaultProps = {
  variant: 'success'
};

var _templateObject$A, _templateObject2$r, _templateObject3$m, _templateObject4$j;
var flexCenter$7 = flexCenter;

var iconContainerBaseStyles$3 = function iconContainerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$A || (_templateObject$A = _taggedTemplateLiteralLoose(["\n    border-radius: ", ";\n    background-color: #367d61;\n    width: 23px;\n    height: 23px;\n    ", "\n  "])), theme.borderRadius.circle, flexCenter$7());
};

var iconContainerErrorStyles = function iconContainerErrorStyles(_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant;
  return variant === 'error' && css(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteralLoose(["\n    border-color: ", ";\n    color: ", ";\n  "])), theme.colors.r500, theme.colors.r500);
};

var iconContainerSuccessStyles = function iconContainerSuccessStyles(_ref3) {
  var theme = _ref3.theme,
      variant = _ref3.variant;
  return variant === 'success' && css(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteralLoose(["\n    border-color: ", ";\n    color: ", ";\n    padding: 0 0 1px 0;\n  "])), theme.colors.white, theme.colors.white);
};

var iconContainerSizeStyles = function iconContainerSizeStyles(_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 'giga' : _ref4$size;
  var sizeMap = {
    "byte": {
      width: '16px',
      height: '16px'
    },
    giga: {
      width: '23px',
      height: '23px'
    },
    tera: {
      width: '25px',
      height: '25px'
    }
  };
  var iconContainerSize = sizeMap[size] || 'byte';
  return css(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteralLoose(["\n    ", ";\n  "])), iconContainerSize);
};

var IconContainer$3 = styled('div')(iconContainerBaseStyles$3, iconContainerErrorStyles, iconContainerSuccessStyles, iconContainerSizeStyles);

var _templateObject$B;

var baseStyles$n = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$B || (_templateObject$B = _taggedTemplateLiteralLoose(["\n  margin-top: ", ";\n"])), theme.spacings.atom);
};

var StyledText$1 = styled(Text)(baseStyles$n);

var setSlotToOpen = function setSlotToOpen(id) {
  return function (dispatch) {
    var _commonActions = common('slot_to_open'),
        setValue = _commonActions.setValue;

    dispatch(setValue(id));
  };
};
var setSlotToClosed = function setSlotToClosed(id) {
  return function (dispatch) {
    var _commonActions2 = common('slot_to_closed'),
        setValue = _commonActions2.setValue;

    dispatch(setValue(id));
  };
};
var setPlaceholderState = function setPlaceholderState(resp) {
  return function (dispatch) {
    var _commonActions3 = common('placeholder_state'),
        setValue = _commonActions3.setValue;

    dispatch(setValue(resp));
  };
};
var setPlayerToPicked = function setPlayerToPicked(props) {
  return function (dispatch) {
    var _commonActions4 = common('player_to_picked'),
        setValue = _commonActions4.setValue;

    dispatch(setValue(props));
  };
};
var setRandomPlayerPicks = function setRandomPlayerPicks(props) {
  return function (dispatch) {
    var _commonActions5 = common('random_player_picks'),
        setValue = _commonActions5.setValue;

    dispatch(setValue(props));
  };
};
var setIncompletePicksModalToOpen = function setIncompletePicksModalToOpen() {
  return {
    type: 'SET_INCOMPLETE_PICKS_MODAL_OPEN'
  };
};
var setIncompletePicksModalToClosed = function setIncompletePicksModalToClosed() {
  return {
    type: 'SET_INCOMPLETE_PICKS_MODAL_CLOSED'
  };
};
var setPendingNavigation = function setPendingNavigation(routeId) {
  return {
    type: 'SET_PENDING_NAVIGATION',
    payload: routeId
  };
};
var clearPendingNavigation = function clearPendingNavigation() {
  return {
    type: 'CLEAR_PENDING_NAVIGATION'
  };
};
var resetNavigationModalState = function resetNavigationModalState() {
  return {
    type: 'RESET_NAVIGATION_MODAL_STATE'
  };
};
var clearAllPicks = function clearAllPicks() {
  return {
    type: 'CLEAR_ALL_PICKS'
  };
};
var handleModalLeave = function handleModalLeave() {
  return function (dispatch, getState) {
    var state = getState();

    if (state.picks.pendingNavigation) {
      var _routeById$targetRout;

      var targetRoute = state.picks.pendingNavigation;

      if (targetRoute === 'close') {
        dispatch(clearPendingNavigation());
        dispatch(setIncompletePicksModalToClosed());
        dispatch(clearAllPicks());
        var config = state.config;
        var platform = config.platform,
            env = config.env;
        fireMessageEvent({
          type: 'CLOSE_WINDOW',
          platform: platform,
          env: env
        });
        return;
      }

      if (targetRoute === 'heatstreak') {
        dispatch(clearPendingNavigation());
        dispatch(setIncompletePicksModalToClosed());
        dispatch(clearAllPicks());

        var _commonActions6 = common('heatstreak_panel_open'),
            setValue = _commonActions6.setValue;

        dispatch(setValue());
        return;
      }

      var routeById = state.routing.routeById;
      var targetPath = (_routeById$targetRout = routeById[targetRoute]) === null || _routeById$targetRout === void 0 ? void 0 : _routeById$targetRout.path;

      if (targetPath) {
        dispatch(clearPendingNavigation());
        dispatch(setIncompletePicksModalToClosed());
        dispatch(clearAllPicks());
        window.history.pushState({}, '', targetPath);
        window.dispatchEvent(new PopStateEvent('popstate'));
      } else {
        dispatch(clearPendingNavigation());
        dispatch(setIncompletePicksModalToClosed());
      }
    } else {
      dispatch(setIncompletePicksModalToClosed());
    }
  };
};
var sendPlayerPicks = function sendPlayerPicks() {
  return function (dispatch, getState) {
    var _getState = getState(),
        config = _getState.config,
        picks = _getState.picks;

    var apiUrl = config.apiUrl,
        env = config.env,
        userId = config.userId,
        currentSession = config.currentSession,
        platform = config.platform;
    var picked = picks.picked;

    var _apiActions = api('player_picks'),
        sendStart = _apiActions.sendStart,
        sendSuccess = _apiActions.sendSuccess,
        sendFailure = _apiActions.sendFailure;

    dispatch(setIsFetching());
    dispatch(sendStart());
    var playerPicks = [{
      setId: '1',
      playerId: picked[1]
    }, {
      setId: '2',
      playerId: picked[2]
    }, {
      setId: '3',
      playerId: picked[3]
    }];
    return makeRequest({
      route: 'playerPicks',
      data: {
        picks: playerPicks
      },
      apiUrl: apiUrl,
      env: env,
      userId: userId,
      currentSession: currentSession
    }).then(function (resp) {
      if (resp.code && resp.code.includes('hc.') || resp.code && resp.code === 'serverError') {
        dispatch(sendFailure(resp.code));
        return dispatch(setIsNotFetching());
      }

      var messageData = {
        route: 'playerPicks',
        picks: picks,
        apiUrl: apiUrl,
        userId: userId,
        currentSession: currentSession
      };
      fireMessageEvent({
        type: 'LOG',
        platform: platform,
        title: 'hockey-challenge-picks-endpoint-success',
        data: messageData
      });
      dispatch(sendSuccess());
      return dispatch(setIsNotFetching());
    }, function (err) {
      var messageData = {
        err: err,
        route: 'playerPicks',
        picks: picks,
        apiUrl: apiUrl,
        userId: userId,
        currentSession: currentSession
      };
      fireMessageEvent({
        type: 'ERROR',
        platform: platform,
        title: 'hockey-challenge-error',
        data: messageData
      });

      if ((err === null || err === void 0 ? void 0 : err.status) !== 401) {
        dispatch(sendFailure(err));
      }

      if (err.code === 500) {
        dispatch(api('data_500').fetchFailure(err));
      }

      return dispatch(setIsNotFetching());
    });
  };
};
var clearSubmissionError = function clearSubmissionError() {
  return function (dispatch) {
    dispatch({
      type: 'CLEAR_SUBMISSION_ERROR'
    });
  };
};

var CloseApp = function CloseApp() {
  var dispatch = useDispatch();

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      config = _useSelector.config,
      strings = _useSelector.strings,
      ui = _useSelector.ui,
      picks = _useSelector.picks;

  var platform = config.platform,
      env = config.env;
  var heatStreakPanelOpen = ui.heatStreakPanelOpen;
  var picked = picks.picked,
      picksSubmitted = picks.picksSubmitted,
      picksLocked = picks.picksLocked;
  var ariaLabel = strings['roles/button/close/aria'];
  var slotsPicked = Object.keys(picked).map(function (id) {
    return picked[id];
  }).filter(function (id) {
    return id;
  });
  var hasUnsubmittedPicks = slotsPicked.length > 0 && !picksSubmitted && !picksLocked;

  var handleClose = function handleClose(e) {
    if (hasUnsubmittedPicks) {
      dispatch(setPendingNavigation('close'));
      dispatch(setIncompletePicksModalToOpen());
    } else if (heatStreakPanelOpen) {
      dispatch(setHeatStreakPanelToClosed());
      e.preventDefault();
    } else {
      fireMessageEvent({
        type: 'CLOSE_WINDOW',
        platform: platform,
        env: env
      });
    }
  };

  return /*#__PURE__*/React.createElement(Close, {
    "aria-label": ariaLabel,
    onClick: handleClose
  });
};

var _templateObject$C, _templateObject2$s;
var flexStack$2 = flexStack;

var baseStyles$o = function baseStyles() {
  return css(_templateObject$C || (_templateObject$C = _taggedTemplateLiteralLoose(["\n  ", "\n  align-items: center;\n"])), flexStack$2());
};

var Container$a = styled('div')(baseStyles$o);

var subTextBaseStyles = function subTextBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteralLoose(["\n  margin-top: -", ";\n"])), theme.spacings["byte"]);
};

var SubText = styled('div')(subTextBaseStyles);

var _excluded$d = ["assetUrl", "assetAlt", "text"];

var _templateObject$D, _templateObject2$t, _templateObject3$n, _templateObject4$k;
var flexCenter$8 = flexCenter;

var containerBaseStyles$4 = function containerBaseStyles() {
  return css(_templateObject$D || (_templateObject$D = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
};

var containerPlaceholderStyles = function containerPlaceholderStyles(_ref) {
  var theme = _ref.theme,
      isPlaceholder = _ref.isPlaceholder;
  return isPlaceholder && css(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n  "])), theme.colors.n500);
};

var Container$b = styled('div')(containerBaseStyles$4, containerPlaceholderStyles);

var imageWrapperBaseStyles$1 = function imageWrapperBaseStyles() {
  return css(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  ", ";\n\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n"])), flexCenter$8());
};

var ImageWrapper$1 = styled('div')(imageWrapperBaseStyles$1);

var textWrapperBaseStyles$1 = function textWrapperBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject4$k || (_templateObject4$k = _taggedTemplateLiteralLoose(["\n  margin-left: ", ";\n"])), theme.spacings["byte"]);
};

var TextWrapper$2 = styled('div')(textWrapperBaseStyles$1);

var ImageWithFrame = function ImageWithFrame(_ref3) {
  var assetUrl = _ref3.assetUrl,
      assetAlt = _ref3.assetAlt,
      text = _ref3.text,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded$d);

  return /*#__PURE__*/React.createElement(Container$b, null, /*#__PURE__*/React.createElement(Frame, props, assetUrl && /*#__PURE__*/React.createElement(ImageWrapper$1, null, /*#__PURE__*/React.createElement(Image, {
    src: assetUrl,
    assetAlt: assetAlt
  }))), text && /*#__PURE__*/React.createElement(TextWrapper$2, null, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    size: "mega",
    noMargin: true
  }, text)));
};

ImageWithFrame.propTypes = {
  assetUrl: propTypes.string,
  assetAlt: propTypes.string,
  text: propTypes.string
};

var _templateObject$E, _templateObject2$u, _templateObject3$o, _templateObject4$l, _templateObject5$d, _templateObject6$b, _templateObject7$8, _templateObject8$8, _templateObject9$6;
var fixTop$1 = fixTop,
    flexCenter$9 = flexCenter;
var containerBaseStyles$5 = css(_templateObject$E || (_templateObject$E = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  ", ";\n"])), flexCenter$9());

var containerFixedStyles = function containerFixedStyles(_ref) {
  var isFixed = _ref.isFixed;
  return isFixed && css(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteralLoose(["\n    ", "\n  "])), fixTop$1());
};

var Container$c = styled('div')(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n"])), containerBaseStyles$5, containerFixedStyles);
var wrapperBaseStyles$2 = css(_templateObject4$l || (_templateObject4$l = _taggedTemplateLiteralLoose(["\n  ", ";\n  flex-wrap: wrap;\n"])), flexCenter$9());
var Wrapper$3 = styled('div')(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteralLoose(["\n  ", ";\n"])), wrapperBaseStyles$2);

var loadingImageContainerBaseStyles = function loadingImageContainerBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject6$b || (_templateObject6$b = _taggedTemplateLiteralLoose(["\n  fill: ", ";\n  margin-bottom: ", ";\n  max-width: 52px;\n  min-height: 39px;\n  ", "\n"])), theme.colors.n700, theme.spacings.giga, flexCenter$9());
};

var LoadingImageContainer = styled('div')(_templateObject7$8 || (_templateObject7$8 = _taggedTemplateLiteralLoose(["\n  ", ";\n"])), loadingImageContainerBaseStyles);

var loadingTextBaseStyles = function loadingTextBaseStyles(_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject8$8 || (_templateObject8$8 = _taggedTemplateLiteralLoose(["\n  margin-top: ", ";\n"])), theme.spacings.giga);
};

var LoadingText = styled('div')(_templateObject9$6 || (_templateObject9$6 = _taggedTemplateLiteralLoose(["\n  ", ";\n"])), loadingTextBaseStyles);

var Loader = function Loader(_ref4) {
  var assetUrl = _ref4.assetUrl,
      assetAlt = _ref4.assetAlt,
      isSvg = _ref4.isSvg,
      text = _ref4.text,
      isFixed = _ref4.isFixed;
  return /*#__PURE__*/React.createElement(Container$c, {
    isFixed: isFixed
  }, /*#__PURE__*/React.createElement(Wrapper$3, null, /*#__PURE__*/React.createElement(LoadingImageContainer, null, /*#__PURE__*/React.createElement(Image, {
    src: assetUrl,
    alt: assetAlt,
    isSvg: isSvg
  })), /*#__PURE__*/React.createElement(LoadingIcon, null), /*#__PURE__*/React.createElement(LoadingText, null, /*#__PURE__*/React.createElement(Text, {
    size: "tera",
    bold: true
  }, text))));
};

Loader.defaultProps = {
  isFixed: true
};
Loader.propTypes = {
  assetUrl: propTypes.string,
  assetAlt: propTypes.string,
  text: propTypes.string,
  isSvg: propTypes.bool,
  isFixed: propTypes.bool
};

var _templateObject$F, _templateObject2$v, _templateObject3$p, _templateObject4$m, _templateObject5$e, _templateObject6$c, _templateObject7$9, _templateObject8$9;

var baseStyles$p = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$F || (_templateObject$F = _taggedTemplateLiteralLoose(["\n  background-color: ", "; \n  color: ", ";\n  width: 100%;\n  padding ", " ", ";\n  display: flex;\n"])), theme.colors.red, theme.colors.white, theme.spacings.kilo, theme.spacings.mega);
};

var centeredStyles$3 = function centeredStyles(_ref2) {
  var centered = _ref2.centered;
  return centered && css(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteralLoose(["\n    text-align: center;\n  "])));
};

var secondaryStyles$1 = function secondaryStyles(_ref3) {
  var theme = _ref3.theme,
      variant = _ref3.variant;
  return variant === 'secondary' && css(_templateObject3$p || (_templateObject3$p = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n  "])), theme.colors.bl900);
};

var tertiaryStyles$1 = function tertiaryStyles(_ref4) {
  var theme = _ref4.theme,
      variant = _ref4.variant;
  return variant === 'tertiary' && css(_templateObject4$m || (_templateObject4$m = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    color: ", ";\n  "])), theme.colors.o300, theme.colors.black);
};

var Container$d = styled('div')(baseStyles$p, centeredStyles$3, secondaryStyles$1, tertiaryStyles$1);

var closeIconBaseStyles = function closeIconBaseStyles() {
  return css(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteralLoose(["\n  margin-left: auto;\n"])));
};

var CloseIcon = styled('div')(closeIconBaseStyles);

var textWrapperBaseStyles$2 = function textWrapperBaseStyles(_ref5) {
  var theme = _ref5.theme;
  return css(_templateObject6$c || (_templateObject6$c = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n\n  span {\n    border-bottom: 1px solid ", ";\n  }\n"])), theme.colors.white);
};

var TextWrapper$3 = styled('div')(textWrapperBaseStyles$2);

var iconWrapperBaseStyles = function iconWrapperBaseStyles(_ref6) {
  var theme = _ref6.theme;
  return css(_templateObject7$9 || (_templateObject7$9 = _taggedTemplateLiteralLoose(["\n  padding-left: ", ";\n"])), theme.spacings.kilo);
};

var IconWrapper = styled('div')(iconWrapperBaseStyles);

var spacerBaseStyles = function spacerBaseStyles() {
  return css(_templateObject8$9 || (_templateObject8$9 = _taggedTemplateLiteralLoose(["\n  visibility: hidden;\n"])));
};

var Spacer = styled('div')(spacerBaseStyles);

var NotificationBar = function NotificationBar(_ref7) {
  var centered = _ref7.centered,
      variant = _ref7.variant,
      title = _ref7.title,
      text = _ref7.text,
      size = _ref7.size,
      icon = _ref7.icon,
      iconPrefix = _ref7.iconPrefix,
      hideIcon = _ref7.hideIcon,
      onSelect = _ref7.onSelect;
  var showSpacer = !hideIcon && centered;
  return /*#__PURE__*/React.createElement(Container$d, {
    centered: centered,
    variant: variant
  }, showSpacer && /*#__PURE__*/React.createElement(Spacer, null, "Spacer"), /*#__PURE__*/React.createElement(TextWrapper$3, null, title && /*#__PURE__*/React.createElement(Text, {
    as: "h3",
    size: size || 'giga',
    bold: true,
    noMargin: true
  }, title), text && /*#__PURE__*/React.createElement(Text, {
    as: "p",
    size: size || 'giga',
    noMargin: true
  }, text)), !hideIcon && /*#__PURE__*/React.createElement(IconWrapper, null, icon ? /*#__PURE__*/React.createElement(Frame, {
    variant: "whiteTransparent"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    prefix: iconPrefix
  })) : /*#__PURE__*/React.createElement(CloseIcon, {
    onClick: onSelect
  }, /*#__PURE__*/React.createElement(Close, null))));
};

NotificationBar.propTypes = {
  centered: propTypes.bool,
  variant: propTypes.string,
  title: propTypes.string,
  text: propTypes.string,
  textLong: propTypes.string,
  icon: propTypes.string,
  iconPrefix: propTypes.string,
  hideIcon: propTypes.bool,
  size: propTypes.string,
  onSelect: propTypes.func
};
NotificationBar.defaultProps = {
  centered: true,
  hideIcon: true
};

var _excluded$e = ["assetUrl", "text", "size", "variant"];

var _templateObject$G, _templateObject2$w, _templateObject3$q;
var flexCenter$a = flexCenter;

var baseStyles$q = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$G || (_templateObject$G = _taggedTemplateLiteralLoose(["\n  background: ", " no-repeat 0 0;\n  background-size: cover;\n  color: ", ";\n  width: 100%;\n  min-height: 40px;\n  margin: 0;\n  padding ", " ", ";\n  ", ";\n"])), theme.component.titleBgColor, theme.colors.white, theme.spacings.bit, theme.spacings["byte"], flexCenter$a());
};

var sizeStyles$7 = function sizeStyles(_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'mega' : _ref2$size;
  var sizeMap = {
    kilo: {
      minHeight: 'none'
    },
    mega: {
      minHeight: '40px'
    }
  };
  return css(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteralLoose(["\n    ", ";\n  "])), sizeMap[size]);
};

var imageStyles = function imageStyles(_ref3) {
  var assetUrl = _ref3.assetUrl;
  return assetUrl && css(_templateObject3$q || (_templateObject3$q = _taggedTemplateLiteralLoose(["\n    background-image: url(", ");\n  "])), assetUrl);
};

var Container$e = styled('div')(baseStyles$q, sizeStyles$7, imageStyles);

var SectionTitle = function SectionTitle(_ref4) {
  var assetUrl = _ref4.assetUrl,
      text = _ref4.text,
      size = _ref4.size,
      variant = _ref4.variant,
      headingProps = _objectWithoutPropertiesLoose(_ref4, _excluded$e);

  return /*#__PURE__*/React.createElement(Container$e, {
    assetUrl: assetUrl,
    size: size
  }, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: variant
  }, /*#__PURE__*/React.createElement(Heading, _extends({
    as: "h3",
    size: size,
    upper: true,
    bold: true,
    noMarginBoth: true
  }, headingProps), text)));
};

SectionTitle.propTypes = {
  assetUrl: propTypes.string,
  size: propTypes.string,
  variant: propTypes.string,
  text: propTypes.string
};
SectionTitle.defaultProps = {
  text: 'This is a Section Title',
  size: 'kilo',
  variant: 'white'
};

var _templateObject$H, _templateObject2$x, _templateObject3$r, _templateObject4$n;

var valueContainerBaseStyles = function valueContainerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$H || (_templateObject$H = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-bottom: ", ";\n"])), theme.spacings.bit);
};

var ValueContainer = styled('div')(valueContainerBaseStyles);

var styledHeadingStyles = function styledHeadingStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteralLoose(["\n  margin-top: ", ";\n  margin-right: ", ";\n  line-height: 35px;\n"])), theme.spacings.bit, theme.spacings.bit);
};

var StyledHeading$1 = styled(Heading)(styledHeadingStyles);

var styledSuffixStyles = function styledSuffixStyles() {
  return css(_templateObject3$r || (_templateObject3$r = _taggedTemplateLiteralLoose(["\n  line-height: 24px;\n  margin-top: 6px;\n"])));
};

var StyledSuffix = styled(Heading)(styledSuffixStyles);

var styledTextStyles = function styledTextStyles() {
  return css(_templateObject4$n || (_templateObject4$n = _taggedTemplateLiteralLoose(["\n  line-height: 14px;\n"])));
};

var StyledText$2 = styled(Text)(styledTextStyles);

var Statistic = function Statistic(_ref3) {
  var valueColor = _ref3.valueColor,
      valueTextSize = _ref3.valueTextSize,
      value = _ref3.value,
      suffixTextSize = _ref3.suffixTextSize,
      suffix = _ref3.suffix,
      titleColor = _ref3.titleColor,
      titleTextSize = _ref3.titleTextSize,
      title = _ref3.title;
  return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(ValueContainer, null, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: valueColor
  }, /*#__PURE__*/React.createElement(StyledHeading$1, {
    variant: "subHeadings",
    as: "h3",
    weight: "default",
    size: valueTextSize,
    noMarginBoth: true
  }, value)), suffix && /*#__PURE__*/React.createElement(ColorProvider, {
    variant: valueColor
  }, /*#__PURE__*/React.createElement(StyledSuffix, {
    as: "h4",
    size: suffixTextSize,
    noMarginBoth: true
  }, suffix))), title && /*#__PURE__*/React.createElement(ColorProvider, {
    variant: titleColor
  }, /*#__PURE__*/React.createElement(StyledText$2, {
    as: "span",
    size: titleTextSize,
    noMargin: true
  }, title)));
};

Statistic.propTypes = {
  valueColor: propTypes.string,
  value: propTypes.string,
  valueTextSize: propTypes.string,
  suffix: propTypes.string,
  suffixTextSize: propTypes.string,
  titleColor: propTypes.string,
  title: propTypes.string,
  titleTextSize: propTypes.string
};
Statistic.defaultProps = {
  valueTextSize: 'exa',
  value: '96',
  valueColor: 'white',
  suffix: '%',
  suffixTextSize: 'tera',
  title: 'pick <br />accuracy',
  titleColor: 'lightGrey',
  titleTextSize: 'giga'
};

var _excluded$f = ["text", "introTitle", "introText", "introSubTitle"];

var _templateObject$I, _templateObject2$y, _templateObject3$s, _templateObject4$o, _templateObject5$f;
var TeaserWrapper = styled.div(_templateObject$I || (_templateObject$I = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  padding: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacings.tera;
});
var TeaserRow = styled.div(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.n700;
});
var TeaserImage = styled.div(_templateObject3$s || (_templateObject3$s = _taggedTemplateLiteralLoose(["\n  margin-bottom: ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacings.giga;
});
var TeaserText = styled.div(_templateObject4$o || (_templateObject4$o = _taggedTemplateLiteralLoose(["\n  margin-bottom: ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacings["byte"];
});
var IntroTitleContainer = styled(Text)(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteralLoose(["\n  line-height: 22px;\n  margin-bottom: ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacings["byte"];
});

var Teaser = function Teaser(_ref6) {
  var text = _ref6.text,
      introTitle = _ref6.introTitle,
      introText = _ref6.introText,
      introSubTitle = _ref6.introSubTitle,
      props = _objectWithoutPropertiesLoose(_ref6, _excluded$f);

  return /*#__PURE__*/React.createElement(TeaserWrapper, null, (introTitle || introText) && /*#__PURE__*/React.createElement(TeaserRow, null, /*#__PURE__*/React.createElement(TeaserText, null, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: "black"
  }, introTitle && /*#__PURE__*/React.createElement(IntroTitleContainer, {
    size: "zetta",
    bold: true
  }, introTitle), introSubTitle && /*#__PURE__*/React.createElement(IntroTitleContainer, {
    size: "tera"
  }, introSubTitle), introText && /*#__PURE__*/React.createElement(Text, {
    size: "giga",
    bold: true
  }, introText)))), /*#__PURE__*/React.createElement(TeaserRow, null, /*#__PURE__*/React.createElement(TeaserImage, null, /*#__PURE__*/React.createElement(Image, props))), text && /*#__PURE__*/React.createElement(TeaserRow, null, /*#__PURE__*/React.createElement(TeaserText, null, /*#__PURE__*/React.createElement(Text, {
    size: "tera",
    bold: true,
    upper: true,
    noMargin: true
  }, text))));
};

Teaser.propTypes = {
  introTitle: propTypes.string,
  introSubTitle: propTypes.string,
  introText: propTypes.string,
  text: propTypes.string
};

var _excluded$g = ["variant", "text"];

var TermsText = function TermsText(_ref) {
  var variant = _ref.variant,
      text = _ref.text,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$g);

  return /*#__PURE__*/React.createElement(ColorProvider, {
    variant: variant
  }, /*#__PURE__*/React.createElement(Text, _extends({
    size: "kilo",
    centered: true
  }, props), text));
};

TermsText.propTypes = {
  variant: propTypes.string,
  text: propTypes.string
};
TermsText.defaultProps = {
  variant: 'darkGrey'
};

var _templateObject$J, _templateObject2$z, _templateObject3$t, _templateObject4$p, _templateObject5$g, _templateObject6$d, _templateObject7$a, _templateObject8$a, _templateObject9$7, _templateObject10$4, _templateObject11$3;

var containerBaseStyles$6 = function containerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$J || (_templateObject$J = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: ", ";\n"])), theme.spacings.kilo);
};

var containerPaddingStyles = function containerPaddingStyles(_ref2) {
  var theme = _ref2.theme,
      reducePadding = _ref2.reducePadding;
  return reducePadding && css(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteralLoose(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), theme.spacings.bit, theme.spacings.bit);
};

var containerClickableStyles = function containerClickableStyles(_ref3) {
  var isClickable = _ref3.isClickable;
  return isClickable && css(_templateObject3$t || (_templateObject3$t = _taggedTemplateLiteralLoose(["\n    cursor: pointer;\n  "])));
};

var containerActiveStyles$1 = function containerActiveStyles(_ref4) {
  var theme = _ref4.theme,
      isActive = _ref4.isActive;
  return isActive && css(_templateObject4$p || (_templateObject4$p = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n  "])), theme.colors.g300);
};

var Container$f = styled('div')(containerBaseStyles$6, containerPaddingStyles, containerClickableStyles, containerActiveStyles$1);

var imageContainerBaseStyles = function imageContainerBaseStyles() {
  return css(_templateObject5$g || (_templateObject5$g = _taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
};

var ImageContainer = styled('div')(imageContainerBaseStyles);

var secondaryImageContainerBaseStyles = function secondaryImageContainerBaseStyles() {
  return css(_templateObject6$d || (_templateObject6$d = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  bottom: 0;\n  right: -10px;\n"])));
};

var SecondaryImageContainer = styled('div')(secondaryImageContainerBaseStyles);

var rowBaseStyles = function rowBaseStyles() {
  return css(_templateObject7$a || (_templateObject7$a = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n"])));
};

var rowVariantStyles = function rowVariantStyles(_ref5) {
  var variant = _ref5.variant;
  return variant === 'centered' && css(_templateObject8$a || (_templateObject8$a = _taggedTemplateLiteralLoose(["\n    justify-content: center;\n  "])));
};

var Row = styled('div')(rowBaseStyles, rowVariantStyles);

var textPlaceholderBaseStyles = function textPlaceholderBaseStyles(_ref6) {
  var theme = _ref6.theme,
      length = _ref6.length,
      height = _ref6.height;
  return css(_templateObject9$7 || (_templateObject9$7 = _taggedTemplateLiteralLoose(["\n    background-color: ", ";\n    width: ", "px;\n    height: ", "px;\n    margin-bottom: ", ";\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n  "])), theme.colors.n500, length, height, theme.spacings.bit);
};

var TextPlaceholder = styled('div')(textPlaceholderBaseStyles);

var iconContainerBaseStyles$4 = function iconContainerBaseStyles() {
  return css(_templateObject10$4 || (_templateObject10$4 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 40px;\n    height: 20px;\n  "])));
};

var iconContainerLeftStyles = function iconContainerLeftStyles(_ref7) {
  var variant = _ref7.variant;
  return variant === 'left' && css(_templateObject11$3 || (_templateObject11$3 = _taggedTemplateLiteralLoose(["\n    margin-left: auto;\n  "])));
};

var IconContainer$4 = styled('div')(iconContainerBaseStyles$4, iconContainerLeftStyles);
var subTextProps = {
  centered: {
    size: 'kilo',
    bold: true,
    upper: false,
    noMargin: true
  },
  left: {
    size: 'tera',
    bold: false,
    upper: false,
    noMargin: true
  },
  leftSelected: {
    size: 'tera',
    bold: true,
    upper: false,
    noMargin: true
  },
  placeholder: {
    size: 'tera',
    bold: false,
    upper: false,
    noMargin: true
  }
};
var subTextColor = {
  centered: 'grey',
  left: 'black',
  leftSelected: 'black',
  placeholder: 'darkGrey'
};
var textProps = {
  centered: {
    size: 'tera',
    bold: false,
    upper: false,
    noMargin: true
  },
  left: {
    size: 'kilo',
    bold: false,
    upper: false,
    noMargin: true
  },
  leftSelected: {
    size: 'kilo',
    bold: true,
    upper: false,
    noMargin: true
  }
};
var textColor = {
  centered: 'black',
  left: 'grey',
  leftSelected: 'grey'
};

var StyledIcon$1 = function StyledIcon(_ref8) {
  var _ref8$variant = _ref8.variant,
      variant = _ref8$variant === void 0 ? 'chevron-down' : _ref8$variant;
  var cdnImages = useCdnImage(['chevronUp', 'chevronDown', 'iconLockNew', 'iconFlame']);
  var icons = [variant === 'success' && /*#__PURE__*/React.createElement(CheckCircle, null), variant === 'success-lite' && /*#__PURE__*/React.createElement(CheckCircle, {
    variant: "lite"
  }), variant === 'chevron-down' && /*#__PURE__*/React.createElement(Image, {
    src: cdnImages.chevronDown,
    alt: "chev_down",
    isSvg: true
  }), variant === 'chevron-up' && /*#__PURE__*/React.createElement(Image, {
    src: cdnImages.chevronUp,
    alt: "chev_up",
    isSvg: true
  }), variant === 'lock' && /*#__PURE__*/React.createElement(Image, {
    src: cdnImages.iconLockNew,
    alt: "lock",
    isSvg: true
  }), variant === 'radio' && /*#__PURE__*/React.createElement(Radio, null), variant === 'radioActive' && /*#__PURE__*/React.createElement(Radio, {
    isActive: true
  })];
  return find(identity, icons) || /*#__PURE__*/React.createElement(Image, {
    src: cdnImages.chevronDown,
    alt: "chev_down",
    isSvg: true
  });
};

var TextLine = function TextLine(_ref9) {
  var rowVariant = _ref9.rowVariant,
      colorVariant = _ref9.colorVariant,
      textOptions = _ref9.textOptions,
      text = _ref9.text;
  return /*#__PURE__*/React.createElement(Row, {
    variant: rowVariant
  }, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: colorVariant
  }, /*#__PURE__*/React.createElement(Text, _extends({
    as: "span"
  }, textOptions), text)));
};

var getIcon$1 = function getIcon(_ref10) {
  var hasIcon = _ref10.hasIcon,
      variant = _ref10.variant,
      icon = _ref10.icon;
  return hasIcon ? /*#__PURE__*/React.createElement(IconContainer$4, {
    variant: variant
  }, /*#__PURE__*/React.createElement(StyledIcon$1, {
    variant: icon || 'chevron-down'
  })) : null;
};

var PickItem = function PickItem(_ref11) {
  var isPlaceholder = _ref11.isPlaceholder,
      variant = _ref11.variant,
      isClickable = _ref11.isClickable,
      assetUrl = _ref11.assetUrl,
      assetSize = _ref11.assetSize,
      secondaryAssetUrl = _ref11.secondaryAssetUrl,
      secondaryAssetSize = _ref11.secondaryAssetSize,
      assetNoBorder = _ref11.assetNoBorder,
      borderColor = _ref11.borderColor,
      subText = _ref11.subText,
      text = _ref11.text,
      icon = _ref11.icon,
      isActive = _ref11.isActive,
      hasIcon = _ref11.hasIcon,
      onSelect = _ref11.onSelect,
      reducePadding = _ref11.reducePadding;
  var showPrimaryAsset = assetUrl || isPlaceholder;
  return /*#__PURE__*/React.createElement(Container$f, {
    onClick: onSelect,
    isClickable: isClickable,
    isActive: isActive,
    reducePadding: reducePadding
  }, /*#__PURE__*/React.createElement(ImageContainer, null, showPrimaryAsset && /*#__PURE__*/React.createElement(ImageWithFrame, {
    assetUrl: assetUrl,
    noBorder: assetNoBorder,
    hasPadding: false,
    borderColor: borderColor,
    size: assetSize,
    variant: isPlaceholder && 'solid'
  }), secondaryAssetUrl && /*#__PURE__*/React.createElement(SecondaryImageContainer, null, /*#__PURE__*/React.createElement(ImageWithFrame, {
    assetUrl: secondaryAssetUrl,
    noBorder: assetNoBorder,
    borderColor: borderColor,
    size: secondaryAssetSize,
    variant: isPlaceholder && 'solid'
  }))), /*#__PURE__*/React.createElement(Spacing, {
    sides: true,
    "double": true
  }, isPlaceholder ? /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(TextPlaceholder, {
    length: 150,
    height: 20
  }), /*#__PURE__*/React.createElement(TextPlaceholder, {
    length: 100,
    height: 18
  })) : /*#__PURE__*/React.createElement(Fragment$1, null, subText && /*#__PURE__*/React.createElement(TextLine, {
    rowVariant: variant,
    colorVariant: subTextColor[variant],
    textOptions: subTextProps[variant],
    text: subText
  }), text && /*#__PURE__*/React.createElement(TextLine, {
    rowVariant: variant,
    colorVariant: textColor[variant],
    textOptions: textProps[variant],
    text: text
  }))), isPlaceholder ? /*#__PURE__*/React.createElement(LoadingIcon, {
    size: 1,
    variant: "secondary"
  }) : getIcon$1({
    hasIcon: hasIcon,
    variant: variant,
    icon: icon
  }));
};

PickItem.propTypes = {
  variant: propTypes.string,
  isPlaceholder: propTypes.bool,
  isClickable: propTypes.bool,
  rowVariant: propTypes.string,
  colorVariant: propTypes.string,
  borderColor: propTypes.string,
  assetUrl: propTypes.string,
  assetSize: propTypes.string,
  secondaryAssetUrl: propTypes.string,
  secondaryAssetSize: propTypes.string,
  assetNoBorder: propTypes.bool,
  subText: propTypes.string,
  hasIcon: propTypes.bool,
  text: propTypes.string,
  icon: propTypes.string,
  isActive: propTypes.bool,
  onSelect: propTypes.func
};
TextLine.propTypes = {
  text: propTypes.string,
  size: propTypes.string,
  rowVariant: propTypes.string,
  colorVariant: propTypes.string,
  textOptions: propTypes.object
};
PickItem.defaultProps = {
  variant: 'centered',
  assetSize: 'peta',
  secondaryAssetSize: 'bit',
  hasIcon: true
};

var Drawer = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Drawer, _PureComponent);

  function Drawer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;
    _this.state = {
      height: _this.props["default"] === 'closed' ? 0 : 'auto'
    };

    _this.setHeight = function (height) {
      return _this.setState({
        height: height
      });
    };

    _this.componentDidUpdate = function (prevProps) {
      var toggle = _this.props.toggle;
      var height = _this.state.height;
      var isToggled = prevProps.toggle !== toggle;

      if (isToggled && height) {
        _this.setHeight(0);
      } else if (isToggled && !height) {
        _this.setHeight('auto');
      }
    };

    _this.render = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          duration = _this$props.duration,
          handleAnimationEnd = _this$props.handleAnimationEnd,
          delay = _this$props.delay;
      var height = _this.state.height;
      return /*#__PURE__*/React.createElement(AnimateHeight, {
        duration: duration,
        delay: delay,
        height: height,
        onAnimationEnd: handleAnimationEnd,
        style: {
          width: '100%'
        }
      }, children);
    };

    return _this;
  }

  return Drawer;
}(PureComponent);

Drawer.propTypes = {
  children: propTypes.node,
  duration: propTypes.number,
  delay: propTypes.number,
  toggle: propTypes.bool,
  "default": propTypes.string,
  handleAnimationEnd: propTypes.func
};
Drawer.defaultProps = {
  duration: 300
};

var _templateObject$K, _templateObject2$A, _templateObject3$u;

var containerBaseStyles$7 = function containerBaseStyles() {
  return css(_templateObject$K || (_templateObject$K = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n"])));
};

var Container$g = styled('div')(containerBaseStyles$7);

var drawerHeaderBaseStyles = function drawerHeaderBaseStyles(_ref) {
  var isSubmitted = _ref.isSubmitted,
      theme = _ref.theme;
  return css(_templateObject2$A || (_templateObject2$A = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  background: ", ";\n  border-radius: 8px;\n"])), isSubmitted ? theme.colors.g200 : theme.colors.white);
};

var DrawerHeader = styled('div')(drawerHeaderBaseStyles);
var DrawerItem = styled('div')();
var ShadowBoxWrapper$1 = styled(ShadowBox)(_templateObject3$u || (_templateObject3$u = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  box-shadow: none;\n  border: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius.giga;
}, function (_ref3) {
  var isSubmitted = _ref3.isSubmitted,
      theme = _ref3.theme;
  return isSubmitted ? 'none' : "1px solid " + theme.colors.n100;
});

var CardWithDrawer = function CardWithDrawer(_ref4) {
  var id = _ref4.id,
      isPlaceholder = _ref4.isPlaceholder,
      assetUrl = _ref4.assetUrl,
      secondaryAssetUrl = _ref4.secondaryAssetUrl,
      headerAssetHasPadding = _ref4.headerAssetHasPadding,
      subText = _ref4.subText,
      text = _ref4.text,
      items = _ref4.items,
      drawerDefault = _ref4.drawerDefault,
      drawerOpen = _ref4.drawerOpen,
      closeDelay = _ref4.closeDelay,
      isSubmitted = _ref4.isSubmitted,
      selectedItem = _ref4.selectedItem,
      handleDrawerToggle = _ref4.handleDrawerToggle,
      handleItemClick = _ref4.handleItemClick;
  var drawerHeaderRef = useRef(null);
  var selectedClosed = selectedItem && !drawerOpen;
  var selectedSubmitted = !drawerOpen && isSubmitted;
  var closedSelectedSubmitted = selectedClosed || selectedSubmitted;
  var headerVariant = closedSelectedSubmitted ? 'leftSelected' : 'centered';
  var closedNotSelected = drawerOpen ? 'chevron-up' : 'chevron-down';
  var headerIcon = isSubmitted ? 'lock' : closedNotSelected;

  var onItemClick = function onItemClick(id) {
    return function () {
      if (drawerHeaderRef && drawerHeaderRef.current) {
        drawerHeaderRef.current.scrollIntoView({
          block: 'center'
        });
      }

      handleItemClick(id);
    };
  };

  return /*#__PURE__*/React.createElement(ShadowBoxWrapper$1, {
    isSubmitted: isSubmitted
  }, /*#__PURE__*/React.createElement(Container$g, null, /*#__PURE__*/React.createElement(Spacing, null, /*#__PURE__*/React.createElement(DrawerHeader, _extends({
    ref: drawerHeaderRef,
    isSubmitted: isSubmitted
  }, !isSubmitted && {
    onClick: function onClick() {
      return handleDrawerToggle(id);
    }
  }), /*#__PURE__*/React.createElement(PickItem, {
    isPlaceholder: isPlaceholder,
    variant: headerVariant,
    assetUrl: assetUrl,
    secondaryAssetUrl: secondaryAssetUrl,
    subText: subText,
    text: text,
    icon: headerIcon,
    isClickable: !isSubmitted,
    assetHasPadding: headerAssetHasPadding
  }))), !isSubmitted && /*#__PURE__*/React.createElement(Drawer, {
    "default": drawerDefault,
    toggle: drawerOpen,
    delay: closeDelay
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(DrawerItem, {
      key: index,
      onClick: onItemClick(item.id)
    }, /*#__PURE__*/React.createElement(Spacing, {
      sizeLeft: "kilo",
      sizeRight: "kilo"
    }, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(PickItem, _extends({
      variant: "left",
      icon: selectedItem === item.id ? 'radioActive' : 'radio',
      isClickable: true,
      reducePadding: true
    }, item))));
  }))));
};

CardWithDrawer.propTypes = {
  id: propTypes.number,
  isPlaceholder: propTypes.bool,
  assetUrl: propTypes.string,
  secondaryAssetUrl: propTypes.string,
  headerAssetHasPadding: propTypes.bool,
  subText: propTypes.string,
  isSubmitted: propTypes.bool,
  text: propTypes.string,
  items: propTypes.array,
  selectedItem: propTypes.oneOfType([propTypes.number, propTypes.string]),
  drawerDefault: propTypes.string,
  drawerOpen: propTypes.bool,
  closeDelay: propTypes.func,
  handleDrawerToggle: propTypes.func,
  handleItemClick: propTypes.func
};

var _templateObject$L, _templateObject2$B, _templateObject3$v, _templateObject4$q, _templateObject5$h, _templateObject6$e, _templateObject7$b;

var colBaseStyles = function colBaseStyles() {
  return css(_templateObject$L || (_templateObject$L = _taggedTemplateLiteralLoose([""])));
};

var Col$1 = styled('div')(colBaseStyles);

var baseStyles$r = function baseStyles() {
  return css(_templateObject2$B || (_templateObject2$B = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n"])));
};

var Container$h = styled('div')(baseStyles$r);

var styledTitleBaseStyles = function styledTitleBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject3$v || (_templateObject3$v = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  line-height: 20px;\n"])), theme.component.howToTitleColor);
};

var StyledTitle = styled(Text)(styledTitleBaseStyles);

var imageContainerBaseStyles$1 = function imageContainerBaseStyles() {
  return css(_templateObject4$q || (_templateObject4$q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  max-width: 250px;\n"])));
};

var imageContainerPositionStyles = function imageContainerPositionStyles(_ref2) {
  var theme = _ref2.theme,
      position = _ref2.position;
  return position === 'left' ? css(_templateObject5$h || (_templateObject5$h = _taggedTemplateLiteralLoose(["\n        margin-right: ", ";\n        margin-left: ", ";\n      "])), theme.spacings.giga, theme.spacings.giga) : css(_templateObject6$e || (_templateObject6$e = _taggedTemplateLiteralLoose(["\n        margin-left: ", ";\n        margin-right: ", ";\n      "])), theme.spacings.giga, theme.spacings.giga);
};

var imageContainerSizeStyles = function imageContainerSizeStyles(_ref3) {
  var assetSize = _ref3.assetSize;
  return assetSize && css(_templateObject7$b || (_templateObject7$b = _taggedTemplateLiteralLoose(["\n    max-width: ", "px;\n  "])), assetSize);
};

var ImageContainer$1 = styled('div')(imageContainerBaseStyles$1, imageContainerPositionStyles, imageContainerSizeStyles);

var _templateObject$M, _templateObject2$C, _templateObject3$w, _templateObject4$r;

var containerBaseStyles$8 = function containerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$M || (_templateObject$M = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  position: relative;\n"])), theme.colors.white);
};

var containerSizeStyles = function containerSizeStyles(_ref2) {
  var size = _ref2.size;
  var sizeMap = {
    bit: {
      width: '36px',
      height: '36px'
    },
    "byte": {
      width: '50px',
      height: '50px'
    },
    kilo: {
      width: '65px',
      height: '65px'
    },
    mega: {
      width: '103px',
      height: '103px'
    }
  };
  var sizeProps = sizeMap[size] || sizeMap.kilo;
  return css(_templateObject2$C || (_templateObject2$C = _taggedTemplateLiteralLoose(["\n    ", ";\n  "])), sizeProps);
};

var Container$i = styled('div')(containerBaseStyles$8, containerSizeStyles);

var chartBaseStyles = function chartBaseStyles() {
  return css(_templateObject3$w || (_templateObject3$w = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n"])));
};

var Chart = styled('div')(chartBaseStyles);

var chartContentBaseStyles = function chartContentBaseStyles(_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject4$r || (_templateObject4$r = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n  overflow: hidden;\n"])), theme.borderRadius.circle);
};

var ChartContent = styled('div')(chartContentBaseStyles);

var CirclePercentage = function CirclePercentage(_ref4) {
  var children = _ref4.children,
      size = _ref4.size,
      percentage = _ref4.percentage,
      strokeWidth = _ref4.strokeWidth,
      startColor = _ref4.startColor,
      endColor = _ref4.endColor,
      trailStrokeColor = _ref4.trailStrokeColor,
      gradientId = _ref4.gradientId;
  var gradientTransform = "rotate(90)";
  return /*#__PURE__*/React.createElement(Container$i, {
    size: size
  }, /*#__PURE__*/React.createElement("svg", {
    style: {
      height: 0,
      width: 0
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientId,
    gradientTransform: gradientTransform
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "2%",
    stopColor: startColor
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47%",
    stopColor: endColor
  })))), /*#__PURE__*/React.createElement(Chart, null, /*#__PURE__*/React.createElement(CircularProgressbar, {
    value: percentage,
    strokeWidth: strokeWidth,
    styles: {
      path: {
        stroke: "url(#" + gradientId + ")",
        height: '100%',
        strokeLinecap: 'round'
      },
      trail: {
        strokeLinecap: 'round',
        stroke: trailStrokeColor
      }
    }
  })), /*#__PURE__*/React.createElement(ChartContent, null, children));
};

CirclePercentage.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  size: propTypes.string,
  percentage: propTypes.oneOfType([propTypes.string, propTypes.number]),
  strokeWidth: propTypes.number,
  startColor: propTypes.string,
  endColor: propTypes.string,
  trailStrokeColor: propTypes.string,
  gradientId: propTypes.string,
  chartTheme: propTypes.object
};
CirclePercentage.defaultProps = {
  gradientId: 'circleChart',
  strokeWidth: 6,
  trailStrokeColor: '#454545',
  startColor: '#FF8119',
  endColor: '#D14D09'
};

var _templateObject$N, _templateObject2$D, _templateObject3$x, _templateObject4$s, _templateObject5$i, _templateObject6$f;
var flexCenter$b = flexCenter;

var containerBaseStyles$9 = function containerBaseStyles() {
  return css(_templateObject$N || (_templateObject$N = _taggedTemplateLiteralLoose(["\n  ", ";\n  line-height: 0.8;\n"])), flexCenter$b());
};

var Container$j = styled('div')(containerBaseStyles$9);

var textWrapperBaseStyles$3 = function textWrapperBaseStyles() {
  return css(_templateObject2$D || (_templateObject2$D = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  text-align: center;\n"])));
};

var TextWrapper$4 = styled('div')(textWrapperBaseStyles$3);

var textRowBaseStyles = function textRowBaseStyles(_ref) {
  var textOrder = _ref.textOrder;
  return textOrder && css(_templateObject3$x || (_templateObject3$x = _taggedTemplateLiteralLoose(["\n    order: ", ";\n  "])), textOrder);
};

var TextRow = styled(Spacing)(textRowBaseStyles);

var iconContainerColorStyles = function iconContainerColorStyles(_ref2) {
  var _theme$colors$heatStr;

  var theme = _ref2.theme,
      variant = _ref2.variant;
  return css(_templateObject4$s || (_templateObject4$s = _taggedTemplateLiteralLoose(["\n  color: ", ";\n"])), ((_theme$colors$heatStr = theme.colors.heatStreak[variant]) === null || _theme$colors$heatStr === void 0 ? void 0 : _theme$colors$heatStr.start) || theme.colors.heatStreak.image.start);
};

var IconContainer$5 = styled('div')(iconContainerColorStyles);

var primaryTextBaseStyles = function primaryTextBaseStyles(_ref3) {
  var _theme$colors$heatStr2;

  var theme = _ref3.theme,
      variant = _ref3.variant,
      size = _ref3.size,
      textOrder = _ref3.textOrder;
  var styleMap = {
    bit: {
      marginTop: textOrder === 1 ? '3px' : 0,
      lineHeight: '10px'
    },
    kilo: {
      marginTop: 0,
      lineHeight: textOrder === 1 ? '10px' : '13px'
    },
    peta: {
      marginTop: 0,
      lineHeight: '18px'
    },
    zetta: {
      marginTop: 0,
      lineHeight: '22px'
    }
  };
  var textStyles = styleMap[size] || styleMap.bit;
  return css(_templateObject5$i || (_templateObject5$i = _taggedTemplateLiteralLoose(["\n    ", "\n    color: ", ";\n  "])), textStyles, ((_theme$colors$heatStr2 = theme.colors.heatStreak[variant]) === null || _theme$colors$heatStr2 === void 0 ? void 0 : _theme$colors$heatStr2.start) || theme.colors.white);
};

var PrimaryText = styled(Text)(primaryTextBaseStyles);

var secondaryTextBaseStyles = function secondaryTextBaseStyles(_ref4) {
  var size = _ref4.size,
      textOrder = _ref4.textOrder;
  var styleMap = {
    bit: {
      marginTop: '-1px',
      lineHeight: '11px'
    },
    "byte": {},
    kilo: {
      marginTop: '-3px',
      lineHeight: '11px'
    },
    mega: {},
    giga: {
      marginTop: textOrder === 2 ? 0 : '1px',
      lineHeight: '11px'
    },
    tera: {},
    peta: {
      marginTop: 0,
      lineHeight: '15px'
    },
    yotta: {
      marginTop: 0,
      lineHeight: '20px'
    },
    zetta: {
      marginTop: 0,
      lineHeight: textOrder === 2 ? '17px' : '22px'
    }
  };
  var textStyles = styleMap[size] || styleMap.kilo;
  return css(_templateObject6$f || (_templateObject6$f = _taggedTemplateLiteralLoose(["\n    ", "\n  "])), textStyles);
};

var SecondaryText = styled(Text)(secondaryTextBaseStyles);

var getIconSize = function getIconSize(_ref5) {
  var size = _ref5.size;
  var sizeMap = {
    bit: 'sm',
    "byte": 'lg',
    kilo: '2x',
    mega: '3x'
  };
  return sizeMap[size] || sizeMap.kilo;
};

var getTextSpacing = function getTextSpacing(_ref6) {
  var size = _ref6.size;
  var marginMap = {
    kilo: 'atom',
    mega: 'bit'
  };
  return marginMap[size] || marginMap.kilo;
};

var getTextSize = function getTextSize(_ref7) {
  var size = _ref7.size,
      hasSecondaryText = _ref7.hasSecondaryText;
  var sizeMap = {
    bit: hasSecondaryText ? 'bit' : 'mega',
    giga: hasSecondaryText ? 'giga' : 'tera',
    "byte": hasSecondaryText ? 'kilo' : 'zetta',
    kilo: hasSecondaryText ? 'peta' : 'yotta',
    mega: hasSecondaryText ? 'zetta' : 'yotta'
  };
  return sizeMap[size];
};

var getSecondaryTextSize = function getSecondaryTextSize(_ref8) {
  var size = _ref8.size;
  var sizeMap = {
    bit: 'giga',
    "byte": 'peta',
    kilo: 'zetta',
    mega: 'yotta'
  };
  return sizeMap[size] || sizeMap.kilo;
};

var stringNotEmpty = function stringNotEmpty(text) {
  return !!text && text !== undefined;
};

var StyledIcon$2 = function StyledIcon(_ref9) {
  var variant = _ref9.variant,
      assetSrc = _ref9.assetSrc,
      size = _ref9.size;

  if (variant === 'image') {
    return /*#__PURE__*/React.createElement(Image, {
      src: assetSrc
    });
  }

  var icons = [variant === 'cold' && /*#__PURE__*/React.createElement(Icon, {
    icon: "snowflake"
  }), variant === 'locked' && /*#__PURE__*/React.createElement(Icon, {
    icon: "lock"
  }), variant === 'hot' && /*#__PURE__*/React.createElement(Image, {
    src: "https://cdn.rbi.digital/hockey/icon_flame.svg"
  })];
  return find(identity, icons) || /*#__PURE__*/React.createElement(Icon, {
    icon: "burn",
    size: getIconSize({
      size: size
    })
  });
};

var HeatStreakText = function HeatStreakText(_ref10) {
  var primaryTextOrder = _ref10.primaryTextOrder,
      secondaryTextOrder = _ref10.secondaryTextOrder,
      showIcon = _ref10.showIcon,
      text = _ref10.text,
      secondaryText = _ref10.secondaryText,
      variant = _ref10.variant,
      assetSrc = _ref10.assetSrc,
      size = _ref10.size,
      isFrench = _ref10.isFrench;
  var hasText = stringNotEmpty(text);
  var hasSecondaryText = stringNotEmpty(secondaryText);
  var showTextWrapper = hasText || hasSecondaryText;
  var iconVisible = !hasSecondaryText && showIcon || !hasSecondaryText && showIcon;
  return /*#__PURE__*/React.createElement(Container$j, null, iconVisible && /*#__PURE__*/React.createElement(IconContainer$5, {
    variant: variant
  }, /*#__PURE__*/React.createElement(StyledIcon$2, {
    variant: variant,
    assetSrc: assetSrc,
    size: size
  })), showTextWrapper && /*#__PURE__*/React.createElement(TextWrapper$4, {
    style: {
      flexDirection: isFrench ? 'column-reverse' : 'column'
    }
  }, hasText && /*#__PURE__*/React.createElement(TextRow, {
    textOrder: primaryTextOrder,
    sizeLeft: iconVisible && getTextSpacing({
      size: size
    })
  }, /*#__PURE__*/React.createElement(PrimaryText, {
    style: {
      color: 'white',
      fontWeight: 'bold'
    },
    as: "span",
    size: variant === 'hot' ? 'tera' : getTextSize({
      size: size,
      hasSecondaryText: hasSecondaryText
    }),
    textOrder: primaryTextOrder,
    variant: variant,
    noMargin: true
  }, text)), hasSecondaryText && /*#__PURE__*/React.createElement(TextRow, {
    textOrder: secondaryTextOrder,
    sizeLeft: iconVisible && getTextSpacing({
      size: size
    })
  }, /*#__PURE__*/React.createElement(SecondaryText, {
    as: "span",
    size: getSecondaryTextSize({
      size: size
    }),
    textOrder: secondaryTextOrder,
    bold: true,
    noMargin: true
  }, secondaryText))));
};

HeatStreakText.propTypes = {
  primaryTextOrder: propTypes.number,
  secondaryTextOrder: propTypes.number,
  showIcon: propTypes.bool,
  text: propTypes.oneOfType([propTypes.string, propTypes.number]),
  secondaryText: propTypes.oneOfType([propTypes.string, propTypes.number]),
  variant: propTypes.string,
  assetSrc: propTypes.string,
  size: propTypes.string,
  isFrench: propTypes.bool
};
StyledIcon$2.propTypes = HeatStreakText.propTypes;
HeatStreakText.defaultProps = {
  primaryTextOrder: 1,
  secondaryTextOrder: 2,
  showIcon: true
};

var _excluded$h = ["text", "size", "secondaryText", "variant", "graphVariant", "showIcon", "primaryTextOrder", "secondaryTextOrder", "assetSrc", "isFrench"];

var getGraphColor = function getGraphColor(_ref) {
  var colors = _ref.colors,
      graphVariant = _ref.graphVariant;
  return function (position) {
    return colors.heatStreak[graphVariant][position];
  };
};

var HeatStreakGraph = function HeatStreakGraph(_ref2) {
  var text = _ref2.text,
      size = _ref2.size,
      secondaryText = _ref2.secondaryText,
      variant = _ref2.variant,
      graphVariant = _ref2.graphVariant,
      showIcon = _ref2.showIcon,
      primaryTextOrder = _ref2.primaryTextOrder,
      secondaryTextOrder = _ref2.secondaryTextOrder,
      assetSrc = _ref2.assetSrc,
      isFrench = _ref2.isFrench,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded$h);

  var _useTheme = useTheme(),
      colors = _useTheme.colors;

  var getColor = getGraphColor({
    colors: colors,
    graphVariant: graphVariant
  });
  return /*#__PURE__*/React.createElement(CirclePercentage, _extends({
    startColor: getColor('start'),
    endColor: getColor('end'),
    size: size
  }, props), /*#__PURE__*/React.createElement(HeatStreakText, {
    size: size,
    primaryTextOrder: primaryTextOrder,
    secondaryTextOrder: secondaryTextOrder,
    iconColor: getColor('start'),
    text: text,
    secondaryText: secondaryText,
    showIcon: showIcon,
    variant: variant,
    assetSrc: assetSrc,
    isFrench: isFrench
  }));
};

HeatStreakGraph.propTypes = {
  primaryTextOrder: propTypes.number,
  secondaryTextOrder: propTypes.number,
  text: propTypes.oneOfType([propTypes.string, propTypes.number]),
  size: propTypes.string,
  secondaryText: propTypes.oneOfType([propTypes.string, propTypes.number]),
  graphVariant: propTypes.string,
  variant: propTypes.string,
  assetSrc: propTypes.string,
  showIcon: propTypes.bool,
  isFrench: propTypes.bool
};

var _templateObject$O, _templateObject2$E, _templateObject3$y, _templateObject4$t, _templateObject5$j;
var flexCenter$c = flexCenter;

var baseStyles$s = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$O || (_templateObject$O = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  overflow: hidden;\n  padding: 2px;\n  position: relative;\n\n  ", ";\n\n  &:before {\n    content: '';\n    border-radius: ", ";\n    background-color: ", ";\n    width: 100%;\n    height: 100%;\n  }\n\n  svg {\n    width: 0.7em;\n  }\n"])), theme.borderRadius.circle, flexCenter$c(), theme.borderRadius.circle, theme.colors.white);
};

var sizeStyles$8 = function sizeStyles(_ref2) {
  var size = _ref2.size;
  var sizeMap = {
    bit: {
      width: '32px',
      height: '32px'
    },
    "byte": {},
    kilo: {
      width: '67px',
      height: '67px'
    },
    mega: {}
  };
  var sizeProps = sizeMap[size] || sizeMap.bit;
  return css(_templateObject2$E || (_templateObject2$E = _taggedTemplateLiteralLoose(["\n    ", ";\n  "])), sizeProps);
};

var variantStyles$2 = function variantStyles(_ref3) {
  var theme = _ref3.theme,
      variant = _ref3.variant;
  return css(_templateObject3$y || (_templateObject3$y = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  color: ", ";\n"])), variant && theme.colors.heatStreak[variant].start || theme.colors.n700, variant && theme.colors.heatStreak[variant].start || theme.colors.n700);
};

var gradientStyles = function gradientStyles(_ref4) {
  var theme = _ref4.theme,
      variant = _ref4.variant,
      isGradient = _ref4.isGradient;
  return isGradient && css(_templateObject4$t || (_templateObject4$t = _taggedTemplateLiteralLoose(["\n    background: linear-gradient(\n      360deg,\n      ", " 2%,\n      ", " 47%\n    );\n    color: ", ";\n  "])), theme.colors.heatStreak[variant].start, theme.colors.heatStreak[variant].end, theme.colors.heatStreak[variant].start);
};

var Container$k = styled('div')(baseStyles$s, sizeStyles$8, variantStyles$2, gradientStyles);

var wrapperBaseStyles$3 = function wrapperBaseStyles() {
  return css(_templateObject5$j || (_templateObject5$j = _taggedTemplateLiteralLoose(["\n  ", ";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  text-align: center;\n\n  img {\n    max-width: 16px;\n    max-height: 14px;\n  }\n"])), flexCenter$c());
};

var Wrapper$4 = styled('div')(wrapperBaseStyles$3);

var HeatStreakIcon = function HeatStreakIcon(_ref5) {
  var props = _extends({}, _ref5);

  return /*#__PURE__*/React.createElement(Container$k, _extends({}, props, {
    variant: props.variant !== 'locked' && props.variant !== 'image' && props.variant
  }), /*#__PURE__*/React.createElement(Wrapper$4, null, /*#__PURE__*/React.createElement(HeatStreakText, props)));
};

var _templateObject$P, _templateObject2$F, _templateObject3$z;
var flexStack$3 = flexStack;

var baseStyles$t = function baseStyles() {
  return css(_templateObject$P || (_templateObject$P = _taggedTemplateLiteralLoose(["\n  ", ";\n  text-align: center;\n"])), flexStack$3());
};

var Container$l = styled('div')(baseStyles$t);

var imageContainerBaseStyles$2 = function imageContainerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$F || (_templateObject2$F = _taggedTemplateLiteralLoose(["\n  margin-bottom: ", ";\n"])), theme.spacings["byte"]);
};

var ImageContainer$2 = styled('div')(imageContainerBaseStyles$2);

var styledHeadingBaseStyles$1 = function styledHeadingBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject3$z || (_templateObject3$z = _taggedTemplateLiteralLoose(["\n  margin-bottom: ", ";\n  line-height: 24px;\n"])), theme.spacings.bit);
};

var StyledHeading$2 = styled(Heading)(styledHeadingBaseStyles$1);

var _templateObject$Q, _templateObject2$G;

var assetSet$1 = function assetSet(filename) {
  return getAssetSet(useCdnImage, filename);
};

var imageContainerBaseStyles$3 = function imageContainerBaseStyles() {
  return css(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  max-width: 250px;\n"])));
};

var imageContainerStyles = function imageContainerStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$G || (_templateObject2$G = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-width: 100%;\n    background-color: ", ";\n    flex-direction: column;\n  "])), theme.colors.white);
};

var ImageContainer$3 = styled('div')(imageContainerBaseStyles$3, imageContainerStyles);

var LeaderboardResultsDivider = function LeaderboardResultsDivider(_ref2) {
  var playerCount = _ref2.playerCount;

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      strings = _useSelector.strings;

  var resultDividerImg = assetSet$1(['leaderboardResultsDivider']);
  var position = 'center';
  return /*#__PURE__*/React.createElement(ImageContainer$3, {
    position: position
  }, /*#__PURE__*/React.createElement(Image, {
    src: resultDividerImg,
    alt: ""
  }), /*#__PURE__*/React.createElement(Text, {
    as: "p",
    size: "tera",
    centered: true,
    bold: true
  }, strings['leaderboard/table/localPos']("" + playerCount)), /*#__PURE__*/React.createElement(Text, {
    as: "p",
    size: "giga",
    centered: true
  }, strings['leaderboard/table/localPosPep']));
};

LeaderboardResultsDivider.propTypes = {
  playerCount: propTypes.number
};

var _templateObject$R, _templateObject2$H, _templateObject3$A;

var imageContainerBaseStyles$4 = function imageContainerBaseStyles() {
  return css(_templateObject$R || (_templateObject$R = _taggedTemplateLiteralLoose(["\n  max-width: 100px;\n"])));
};

var ImageContainer$4 = styled('div')(imageContainerBaseStyles$4);

var prizeDotGroupBaseStyles = function prizeDotGroupBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$H || (_templateObject2$H = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-bottom: ", ";\n"])), theme.spacings.kilo);
};

var PrizeDotGroup = styled('div')(prizeDotGroupBaseStyles);

var prizeDotBaseStyles = function prizeDotBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject3$A || (_templateObject3$A = _taggedTemplateLiteralLoose(["\n  margin-right: ", ";\n  max-width: 30px;\n"])), theme.spacings.giga);
};

var PrizeDot = styled('div')(prizeDotBaseStyles);
var TextGroup = styled('div')();

var _templateObject$S, _templateObject2$I, _templateObject3$B, _templateObject4$u, _templateObject5$k, _templateObject6$g, _templateObject7$c;
var flexCenter$d = flexCenter;

var containerBaseStyles$a = function containerBaseStyles() {
  return css(_templateObject$S || (_templateObject$S = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n"])));
};

var Container$m = styled('div')(containerBaseStyles$a);

var imageWrapperBaseStyles$2 = function imageWrapperBaseStyles() {
  return css(_templateObject2$I || (_templateObject2$I = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  max-width: 20px;\n  height: 20px;\n  overflow: hidden;\n"])));
};

var ImageWrapper$2 = styled('div')(imageWrapperBaseStyles$2);

var tierHeaderBaseStyles = function tierHeaderBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject3$B || (_templateObject3$B = _taggedTemplateLiteralLoose(["\n  padding: ", " ", ";\n  width: 100%;\n"])), theme.spacings.mega, theme.spacings.giga);
};

var TierHeader = styled('div')(tierHeaderBaseStyles);

var tierBodyBaseStyles = function tierBodyBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject4$u || (_templateObject4$u = _taggedTemplateLiteralLoose(["\n  padding: 0 ", " ", " ", ";\n  width: 100%;\n"])), theme.spacings.bit, theme.spacings["byte"], theme.spacings.giga);
};

var TierBody = styled('div')(tierBodyBaseStyles);

var entryItemBaseStyles = function entryItemBaseStyles(_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject5$k || (_templateObject5$k = _taggedTemplateLiteralLoose(["\n  margin-bottom: ", ";\n  margin-right: ", ";\n  width: calc(100% / 10 - ", ");\n"])), theme.spacings.kilo, theme.spacings.kilo, theme.spacings.kilo);
};

var EntryItem = styled('li')(entryItemBaseStyles);

var tierFooterBaseStyles = function tierFooterBaseStyles(_ref4) {
  var theme = _ref4.theme;
  return css(_templateObject6$g || (_templateObject6$g = _taggedTemplateLiteralLoose(["\n  border-top: ", " solid ", ";\n  padding: ", " ", ";\n  width: 100%;\n\n  span {\n    color: ", ";\n    font-weight: ", ";\n  }\n"])), theme.borderWidth.kilo, theme.colors.n500, theme.spacings["byte"], theme.spacings.giga, theme.colors.r500, theme.fontWeight.bold);
};

var TierFooter = styled('div')(tierFooterBaseStyles);

var tierFooterWrapperBaseStyles = function tierFooterWrapperBaseStyles() {
  return css(_templateObject7$c || (_templateObject7$c = _taggedTemplateLiteralLoose(["\n  ", "\n"])), flexCenter$d());
};

var TierFooterWrappr = styled('div')(tierFooterWrapperBaseStyles);

var _templateObject$T;

var baseContainerStyles = function baseContainerStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$T || (_templateObject$T = _taggedTemplateLiteralLoose(["\n  border-top-left-radius: ", ";\n  border-top-right-radius: ", ";\n  background-color: ", ";\n  color: ", ";\n  padding: ", " ", ";\n  text-align: center;\n"])), theme.borderRadius.giga, theme.borderRadius.giga, theme.colors.red, theme.colors.white, theme.spacings["byte"], theme.spacings.kilo);
};

var Container$n = styled('div')(baseContainerStyles);

var ListHeader = function ListHeader(_ref2) {
  var text = _ref2.text;
  return /*#__PURE__*/React.createElement(Container$n, null, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    size: "mega",
    upper: true,
    bold: true,
    noMargin: true
  }, text));
};

ListHeader.propTypes = {
  text: propTypes.string
};
ListHeader.defaultProps = {
  text: 'This is a list header text'
};

var _templateObject$U, _templateObject2$J, _templateObject3$C, _templateObject4$v, _templateObject5$l, _templateObject6$h;

var baseStyles$u = function baseStyles() {
  return css(_templateObject$U || (_templateObject$U = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  min-width: 200px;\n  display: flex;\n  align-items: center;\n"])));
};

var Container$o = styled('div')(baseStyles$u);

var radioImageBaseStyles = function radioImageBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$J || (_templateObject2$J = _taggedTemplateLiteralLoose(["\n    margin-right: ", ";\n  "])), theme.spacings.kilo);
};

var RadioImage = styled('div')(radioImageBaseStyles);

var radioDetailsBaseStyles = function radioDetailsBaseStyles(_ref2) {
  var theme = _ref2.theme,
      centered = _ref2.centered;
  return !centered && css(_templateObject3$C || (_templateObject3$C = _taggedTemplateLiteralLoose(["\n    margin-right: ", ";\n  "])), theme.spacings.exa);
};

var radioDetailsCenteredStyles = function radioDetailsCenteredStyles(_ref3) {
  var centered = _ref3.centered;
  return centered && css(_templateObject4$v || (_templateObject4$v = _taggedTemplateLiteralLoose(["\n    text-align: center;\n    margin: 0 auto;\n    width: 100%;\n  "])));
};

var RadioDetails = styled('div')(radioDetailsBaseStyles, radioDetailsCenteredStyles);

var headingContainerBaseStyles = function headingContainerBaseStyles() {
  return css(_templateObject5$l || (_templateObject5$l = _taggedTemplateLiteralLoose(["\n  margin-left: 20px;\n"])));
};

var HeadingContainer = styled('div')(headingContainerBaseStyles);

var radioSelectorBaseStyles = function radioSelectorBaseStyles() {
  return css(_templateObject6$h || (_templateObject6$h = _taggedTemplateLiteralLoose(["\n  margin-left: auto;\n"])));
};

var RadioSelector = styled('div')(radioSelectorBaseStyles);

var RadioCard = function RadioCard(_ref4) {
  var itemId = _ref4.itemId,
      assetUrl = _ref4.assetUrl,
      title = _ref4.title,
      text = _ref4.text,
      centered = _ref4.centered,
      selected = _ref4.selected,
      titleProps = _ref4.titleProps,
      onSelect = _ref4.onSelect;
  return /*#__PURE__*/React.createElement(Container$o, {
    onClick: function onClick() {
      return onSelect(itemId);
    }
  }, assetUrl && /*#__PURE__*/React.createElement(RadioImage, null, /*#__PURE__*/React.createElement(ImageWithFrame, {
    assetUrl: assetUrl,
    size: "tera",
    noBorder: true
  })), /*#__PURE__*/React.createElement(RadioDetails, {
    centered: centered
  }, title && (centered ? /*#__PURE__*/React.createElement(HeadingContainer, null, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: "brown"
  }, /*#__PURE__*/React.createElement(Text, _extends({
    size: "tera",
    noMargin: true
  }, titleProps), title))) : /*#__PURE__*/React.createElement(ColorProvider, {
    variant: "brown"
  }, /*#__PURE__*/React.createElement(Text, _extends({
    size: "tera",
    noMargin: true
  }, titleProps), title))), text && /*#__PURE__*/React.createElement(ColorProvider, {
    variant: "grey"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "kilo",
    noMargin: true
  }, text))), /*#__PURE__*/React.createElement(RadioSelector, {
    centered: centered
  }, /*#__PURE__*/React.createElement(Radio, {
    isActive: selected === itemId
  })));
};

RadioCard.propTypes = {
  itemId: propTypes.number,
  assetUrl: propTypes.string,
  title: propTypes.oneOfType([propTypes.number, propTypes.string]),
  text: propTypes.string,
  centered: propTypes.bool,
  titleProps: propTypes.object,
  selected: propTypes.oneOfType([propTypes.number, propTypes.string]),
  onSelect: propTypes.func
};

var _excluded$i = ["sideIndent"];

var _templateObject$V, _templateObject2$K;

var baseStyles$v = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$V || (_templateObject$V = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  border-bottom: 1px solid ", ";\n  width: 100%;\n  padding: ", " 0 ", ";\n  transition: background-color ", ";\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  &:last-of-type {\n    border-bottom: 0;\n  }\n"])), theme.colors.white, theme.colors.n500, theme.spacings.mega, theme.spacings.mega, theme.transitions["default"]);
};

var indentStyles = function indentStyles(_ref2) {
  var theme = _ref2.theme,
      sideIndent = _ref2.sideIndent;
  return sideIndent && css(_templateObject2$K || (_templateObject2$K = _taggedTemplateLiteralLoose(["\n    padding-left: ", ";\n    padding-right: ", ";\n  "])), theme.spacings.kilo, theme.spacings.kilo);
};

var Container$p = styled('li')(baseStyles$v, indentStyles);

var RadioItem = function RadioItem(_ref3) {
  var sideIndent = _ref3.sideIndent,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded$i);

  return /*#__PURE__*/React.createElement(Container$p, {
    sideIndent: sideIndent
  }, /*#__PURE__*/React.createElement(RadioCard, props));
};

RadioItem.propTypes = {
  itemId: propTypes.number,
  title: propTypes.oneOfType([propTypes.number, propTypes.string]),
  text: propTypes.string,
  isActive: propTypes.bool,
  sideIndent: propTypes.bool,
  centered: propTypes.bool
};
RadioItem.defaultProps = {};

var _excluded$j = ["items"],
    _excluded2$1 = ["id"];

var _templateObject$W;
var flexStack$4 = flexStack,
    resetList$2 = resetList;

var baseStyles$w = function baseStyles() {
  return css(_templateObject$W || (_templateObject$W = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n"])), flexStack$4(), resetList$2());
};

var Container$q = styled('ul')(baseStyles$w);

var RadioList = function RadioList(_ref) {
  var items = _ref.items,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$j);

  return /*#__PURE__*/React.createElement(Container$q, null, items.map(function (_ref2) {
    var id = _ref2.id,
        props = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);

    return /*#__PURE__*/React.createElement(RadioItem, _extends({
      key: id,
      itemId: id
    }, props, rest));
  }));
};

RadioList.propTypes = {
  items: propTypes.arrayOf(propTypes.shape({
    id: propTypes.number,
    title: propTypes.oneOfType([propTypes.number, propTypes.string]),
    text: propTypes.string
  }))
};
RadioList.defaultProps = {
  items: [{
    id: 1,
    title: 'This is a title text.',
    text: 'This is a body text.'
  }, {
    id: 2,
    title: 'This is a title text.',
    text: 'This is a body text.'
  }]
};

addIconsToLibrary();

var setCurrentRoute = function setCurrentRoute(id) {
  return function (dispatch) {
    var _commonActions = common('current_route'),
        setValue = _commonActions.setValue;

    dispatch(setValue(id));
  };
};
var setMenuLinkClicked = function setMenuLinkClicked(id) {
  return function (dispatch) {
    var _commonActions2 = common('menu_link_click'),
        setValue = _commonActions2.setValue;

    dispatch(setValue(id));
  };
};

var paths = {
  '': 'playNow',
  '/game-info': 'gameInfo',
  '/history': 'history',
  '/leaderboard': 'leaderboard',
  '/onboarding': 'onboarding'
};

var pathMap = function pathMap(routeBase) {
  var pathsWithBase = {};

  for (var _i = 0, _Object$keys = Object.keys(paths); _i < _Object$keys.length; _i++) {
    var path = _Object$keys[_i];
    pathsWithBase[routeBase + path] = paths[path];
  }

  return pathsWithBase;
};

var setLanguage = function setLanguage(language) {
  return function (dispatch) {
    var _commonActions = common('language'),
        setValue = _commonActions.setValue;

    return dispatch(setValue(language));
  };
};

var sessionIsCurrent = function sessionIsCurrent(jwt) {
  return function (dispatch) {
    var _commonActions = common('SESSION_VALUE'),
        setValue = _commonActions.setValue;

    dispatch(setValue({
      currentSession: jwt
    }));
  };
};
var fetchedConfig = function fetchedConfig() {
  return function (dispatch) {
    var _commonActions2 = common('FETCH_CONFIG_STATUS'),
        setValue = _commonActions2.setValue;

    dispatch(setValue());
  };
};

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

var analyticActionMap = {
  quizOpen: SKILL_TEST_OPEN,
  quizOptionSelected: SKILL_TEST_OPTION_SELECTED,
  quizAnswered: SKILL_TEST_ANSWERED,
  playNowOpen: PLAY_NOW_OPEN,
  gameInfoOpen: GAME_INFO_OPEN,
  historyOpen: HISTORY_OPEN,
  leaderboardOpen: LEADERBOARD_OPEN,
  playNowClick: PLAY_NOW_CLICK,
  gameInfoClick: GAME_INFO_CLICK,
  historyClick: HISTORY_CLICK,
  leaderboardClick: LEADERBOARD_CLICK,
  picksSubmitted: PICKS_SUBMITTED,
  picksAutoSelected: PICKS_AUTO_SELECTED,
  heatStreakPanelSelected: HEAT_STREAK_PANEL_SELECTED,
  leaderboardSeasonTabSelected: LEADERBOARD_SEASON_TAB_SELECTED,
  leaderboardMonthlyTabSelected: LEADERBOARD_MONTHLY_TAB_SELECTED,
  leaderboardPlayoffsTabSelected: LEADERBOARD_PLAYOFFS_TAB_SELECTED,
  clickedType: CLICKED_TYPE,
  viewedType: VIEWED_TYPE,
  modalOpenedType: MODAL_OPENED_TYPE,
  skillTestAnswered: SKILL_TEST_ANSWERED,
  skillTestQuestion: SKILL_TESTING_QUESTION,
  notifications: NOTIFICATIONS,
  onboarding: ONBOARDING,
  submitElement: SUBMIT_ELEMENT,
  answerElement: ANSWER_ELEMENT,
  playNow: PLAY_NOW_ELEMENT,
  submitPicks: SUBMIT_PICKS_ELEMENT,
  randomlySelectPlayers: RANDOMLY_SELECT_PLAYERS_ELEMENT,
  history: HISTORY_ELEMENT,
  leaderboard: LEADERBOARD_ELEMENT,
  leaderboardSeason: LEADERBOARD_SEASON_ELEMENT,
  leaderboardMonthly: LEADERBOARD_MONTHLY_ELEMENT,
  leaderboardPlayoffs: LEADERBOARD_PLAYOFFS_ELEMENT,
  gameInfo: GAME_INFO_ELEMENT,
  userStats: USER_STATS_ELEMENT,
  makeYourPicks: MAKE_YOUR_PICKS_ELEMENT,
  seeYourPosition: SEE_YOUR_POSITION,
  scrollToTop: SCROLL_TO_TOP,
  buttonType: BUTTON_TYPE,
  toggleType: TOGGLE_TYPE,
  tabType: TAB_TYPE,
  popupType: POPUP_TYPE,
  onValue: ON_VALUE,
  offValue: OFF_VALUE,
  correctValue: CORRECT_VALUE,
  incorrectValue: INCORRECT_VALUE,
  path: PATH
};

var skillTestAnswered = analyticActionMap.skillTestAnswered,
    path = analyticActionMap.path,
    answerElement = analyticActionMap.answerElement,
    correctValue = analyticActionMap.correctValue,
    incorrectValue = analyticActionMap.incorrectValue;

var checkIfPlayoffs = function checkIfPlayoffs(config) {
  try {
    var apiUrl = config.apiUrl,
        userId = config.userId,
        env = config.env,
        currentSession = config.currentSession;
    return Promise.resolve(makeRequest({
      method: 'GET',
      apiUrl: apiUrl,
      userId: userId,
      env: env,
      currentSession: currentSession,
      route: 'postSeasonLeaderboard'
    })).then(function (response) {
      return response.status === 'current';
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var setCompletedOnboarding = function setCompletedOnboarding(config) {
  return function (dispatch) {
    var platform = config.platform,
        env = config.env;

    var _commonActions = common('completed_onboarding'),
        setValue = _commonActions.setValue;

    dispatch(setValue());
    fireMessageEvent({
      platform: platform,
      env: env,
      title: skillTestAnswered,
      data: {
        path: path,
        element_name: answerElement + "_" + correctValue,
        element_action: correctValue
      }
    });
  };
};
var setSelectedAnswer = function setSelectedAnswer(answer) {
  return function (dispatch) {
    var _commonActions2 = common('selected_answer'),
        setValue = _commonActions2.setValue;

    dispatch(setValue(answer));
  };
};
var setCorrectAnswer = function setCorrectAnswer() {
  return function (dispatch) {
    var _commonActions3 = common('correct_answer'),
        setValue = _commonActions3.setValue;

    dispatch(setValue());
  };
};
var setIncorrectAnswer = function setIncorrectAnswer() {
  return function (dispatch) {
    var _commonActions4 = common('incorrect_answer'),
        setValue = _commonActions4.setValue;

    dispatch(setValue());
  };
};
var setLockout = function setLockout() {
  return function (dispatch) {
    var _commonActions5 = common('lockout'),
        setValue = _commonActions5.setValue;

    dispatch(setValue());
  };
};
var fetchQuizData = function fetchQuizData() {
  return function (dispatch, getState) {
    try {
      var _getState = getState(),
          config = _getState.config;

      var apiUrl = config.apiUrl,
          env = config.env,
          userId = config.userId,
          currentSession = config.currentSession;

      var _apiActions = api('quiz_data'),
          fetchStart = _apiActions.fetchStart,
          fetchSuccess = _apiActions.fetchSuccess,
          fetchFailure = _apiActions.fetchFailure;

      dispatch(fetchStart());
      return Promise.resolve(_catch(function () {
        return Promise.resolve(checkIfPlayoffs(config)).then(function (isPlayoffs) {
          dispatch({
            type: 'SET_IS_PLAYOFFS',
            payload: isPlayoffs
          });
          var eventId = isPlayoffs ? '2024-25-playoffs' : '2025-26';
          return Promise.resolve(makeRequest({
            method: 'GET',
            route: 'quiz',
            params: {
              eventId: eventId
            },
            apiUrl: apiUrl,
            env: env,
            userId: userId,
            currentSession: currentSession
          })).then(function (result) {
            return result === 'error' ? dispatch(fetchFailure('error')) : dispatch(fetchSuccess(result));
          });
        });
      }, function (error) {
        return error.code === 'NotAllowed' ? dispatch(setLockout()) : dispatch(fetchFailure(error));
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
};
var sendQuizAnswer = function sendQuizAnswer() {
  return function (dispatch, getState) {
    try {
      var _getState2 = getState(),
          config = _getState2.config,
          onboarding = _getState2.onboarding;

      var selectedAnswer = onboarding.selectedAnswer,
          attempts = onboarding.attempts,
          answers = onboarding.answers;
      var apiUrl = config.apiUrl,
          env = config.env,
          userId = config.userId,
          currentSession = config.currentSession,
          platform = config.platform;

      var _apiActions2 = api('quiz_answer'),
          sendStart = _apiActions2.sendStart,
          sendSuccess = _apiActions2.sendSuccess,
          sendFailure = _apiActions2.sendFailure;

      dispatch(sendStart());
      return Promise.resolve(_catch(function () {
        return Promise.resolve(checkIfPlayoffs(config)).then(function (isPlayoffs) {
          var eventId = isPlayoffs ? '2024-25-playoffs' : '2025-26';
          var isIncorrect = selectedAnswer !== answers[attempts];
          return Promise.resolve(makeRequest({
            route: 'quiz',
            data: {
              eventId: eventId,
              failed: isIncorrect
            },
            apiUrl: apiUrl,
            env: env,
            userId: userId,
            currentSession: currentSession
          })).then(function (result) {
            if (!result) {
              fireMessageEvent({
                platform: platform,
                env: env,
                title: skillTestAnswered,
                data: {
                  path: path,
                  element_name: answerElement + "_" + incorrectValue,
                  element_action: incorrectValue
                }
              });
              dispatch(setNotificationBarToOpen());
              return dispatch(setIncorrectAnswer());
            }

            fireMessageEvent({
              platform: platform,
              env: env,
              title: skillTestAnswered,
              data: {
                path: path,
                element_name: answerElement + "_" + correctValue,
                element_action: correctValue
              }
            });
            dispatch(setCorrectAnswer());
            return dispatch(sendSuccess(result));
          });
        });
      }, function (error) {
        return error.code === 'NotAllowed' ? dispatch(setLockout()) : dispatch(sendFailure(error));
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
};
var resetUserNameStatus = function resetUserNameStatus() {
  return {
    type: 'RESET_USERNAME_STATUS'
  };
};
var resetErrorCodeStatus = function resetErrorCodeStatus() {
  return {
    type: 'SEND_ERROR_CODE_RESET'
  };
};
var resetUsernameAttemptFailure = function resetUsernameAttemptFailure() {
  return {
    type: 'SET_USERNAME_ATTEMPT_FAILURE'
  };
};
var resetUsernameAttemptSuccess = function resetUsernameAttemptSuccess() {
  return {
    type: 'SET_USERNAME_ATTEMPT_SUCCESS'
  };
};
var submitUsername = function submitUsername(username) {
  return function (dispatch, getState) {
    try {
      dispatch(setUsernameValidationErr(false));

      var _getState3 = getState(),
          config = _getState3.config;

      var apiUrl = config.apiUrl,
          env = config.env,
          userId = config.userId,
          currentSession = config.currentSession;
      var trimmedUsername = username.trim();
      var regex = new RegExp(/^\w{3,15}$/i);

      if (!regex.test(trimmedUsername)) {
        return Promise.resolve(dispatch(setUsernameValidationErr(true)));
      }

      var _apiActions3 = api('username'),
          sendStart = _apiActions3.sendStart,
          sendSuccess = _apiActions3.sendSuccess,
          sendFailure = _apiActions3.sendFailure;

      var _apiActions4 = api('auth'),
          fetchFailure = _apiActions4.fetchFailure;

      dispatch(sendStart());
      return Promise.resolve(_catch(function () {
        return Promise.resolve(makeRequest({
          method: 'PATCH',
          route: 'user',
          data: {
            username: trimmedUsername
          },
          apiUrl: apiUrl,
          env: env,
          userId: userId,
          currentSession: currentSession
        })).then(function (result) {
          dispatch(fetchUserData());
          setTimeout(function () {
            dispatch(resetUserNameStatus());
          }, 10000);
          return batch(function () {
            dispatch(sendSuccess(result));
            dispatch(resetUsernameAttemptSuccess());
          });
        });
      }, function (error) {
        if (error.code && error.code.includes('hc.')) {
          return dispatch(sendFailure(error.code));
        }

        return error.status === 401 ? batch(function () {
          dispatch(fetchFailure());
          dispatch(resetUsernameAttemptFailure());
        }) : dispatch(sendFailure(error));
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
};
var fetchUserData = function fetchUserData() {
  return function (dispatch, getState) {
    try {
      var _getState4 = getState(),
          config = _getState4.config;

      var apiUrl = config.apiUrl,
          env = config.env,
          userId = config.userId,
          currentSession = config.currentSession;

      var _apiActions5 = api('user'),
          fetchStart = _apiActions5.fetchStart,
          fetchSuccess = _apiActions5.fetchSuccess,
          fetchFailure = _apiActions5.fetchFailure;

      dispatch(fetchStart());
      return Promise.resolve(_catch(function () {
        return Promise.resolve(makeRequest({
          method: 'GET',
          route: 'user',
          apiUrl: apiUrl,
          env: env,
          userId: userId,
          currentSession: currentSession
        })).then(function (result) {
          return dispatch(fetchSuccess(result));
        });
      }, function (error) {
        return dispatch(fetchFailure(error));
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
};
var setUsernameValidationErr = function setUsernameValidationErr(isErr) {
  return function (dispatch) {
    var _commonActions9 = common('username_validation_err'),
        setValue = _commonActions9.setValue;

    dispatch(setValue(isErr));
  };
};
var fetchNotificationStatus = function fetchNotificationStatus() {
  return function (dispatch, getState) {
    try {
      var _getState5 = getState(),
          config = _getState5.config;

      var apiUrl = config.apiUrl,
          env = config.env,
          userId = config.userId,
          currentSession = config.currentSession;

      var _apiActions6 = api('notifications'),
          fetchStart = _apiActions6.fetchStart,
          fetchSuccess = _apiActions6.fetchSuccess,
          fetchFailure = _apiActions6.fetchFailure;

      dispatch(fetchStart());
      return Promise.resolve(_catch(function () {
        return Promise.resolve(makeRequest({
          route: 'notification',
          apiUrl: apiUrl,
          env: env,
          userId: userId,
          currentSession: currentSession
        })).then(function (result) {
          return dispatch(fetchSuccess(result));
        });
      }, function (error) {
        return dispatch(fetchFailure(error));
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
};
var sendNotificationStatus = function sendNotificationStatus(status) {
  return function (dispatch, getState) {
    try {
      var _getState6 = getState(),
          config = _getState6.config;

      var apiUrl = config.apiUrl,
          env = config.env,
          userId = config.userId,
          currentSession = config.currentSession;

      var _apiActions7 = api('notifications'),
          sendStart = _apiActions7.sendStart,
          sendSuccess = _apiActions7.sendSuccess,
          sendFailure = _apiActions7.sendFailure;

      dispatch(sendStart());
      return Promise.resolve(_catch(function () {
        return Promise.resolve(makeRequest({
          route: 'notification',
          data: {
            attributes: {
              tnhc_user_reminders: status
            }
          },
          apiUrl: apiUrl,
          env: env,
          userId: userId,
          currentSession: currentSession
        })).then(function () {
          return dispatch(sendSuccess(status));
        });
      }, function (error) {
        return dispatch(sendFailure(error));
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
};

var fetchHistoryData = function fetchHistoryData() {
  return function (dispatch, getState) {
    var _getState = getState(),
        config = _getState.config;

    var apiUrl = config.apiUrl,
        env = config.env,
        userId = config.userId,
        currentSession = config.currentSession,
        platform = config.platform;

    var _apiActions = api('history_data'),
        fetchStart = _apiActions.fetchStart,
        fetchSuccess = _apiActions.fetchSuccess,
        fetchFailure = _apiActions.fetchFailure;

    dispatch(fetchStart());
    return makeRequest({
      method: 'GET',
      route: 'pickHistory',
      apiUrl: apiUrl,
      env: env,
      userId: userId,
      currentSession: currentSession
    }).then(function (resp) {
      if (resp.code === 'serverError') {
        return dispatch(fetchFailure(resp));
      }

      return dispatch(fetchSuccess(resp));
    }, function (err) {
      var messageData = {
        err: err,
        route: 'pickHistory',
        apiUrl: apiUrl,
        userId: userId,
        currentSession: currentSession
      };
      fireMessageEvent({
        type: 'ERROR',
        platform: platform,
        title: 'hockey-challenge-error',
        data: messageData
      });

      if (err.code === 500) {
        return dispatch(api('data_500').fetchFailure(err));
      }

      dispatch(fetchFailure(err));
    });
  };
};
var fetchUserStats = function fetchUserStats() {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        config = _getState2.config;

    var apiUrl = config.apiUrl,
        env = config.env,
        userId = config.userId,
        currentSession = config.currentSession,
        platform = config.platform;

    var _apiActions2 = api('user_stats'),
        fetchStart = _apiActions2.fetchStart,
        fetchSuccess = _apiActions2.fetchSuccess,
        fetchFailure = _apiActions2.fetchFailure;

    var _apiActions3 = api('auth'),
        authFailure = _apiActions3.fetchFailure;

    dispatch(fetchStart());
    return makeRequest({
      method: 'GET',
      apiUrl: apiUrl,
      userId: userId,
      route: 'userStats',
      env: env,
      currentSession: currentSession
    }).then(function (resp) {
      if (resp.code === 'serverError') {
        return dispatch(fetchFailure(resp));
      }

      if (resp.code === 'noContest') {
        return dispatch(fetchFailure(resp));
      }

      return dispatch(fetchSuccess(resp));
    }, function (err) {
      var messageData = {
        err: err,
        route: 'userStats',
        apiUrl: apiUrl,
        userId: userId,
        currentSession: currentSession
      };
      fireMessageEvent({
        type: 'ERROR',
        platform: platform,
        title: 'hockey-challenge-error',
        data: messageData
      });

      if (err.status === 401) {
        dispatch(authFailure());
      } else if (err.code === 500) {
        return dispatch(api('data_500').fetchFailure(err));
      } else {
        dispatch(fetchFailure(err));
      }
    });
  };
};

var noContestToday = function noContestToday() {
  return function (dispatch) {
    var _commonActions2 = common('no_contest_today'),
        setValue = _commonActions2.setValue;

    dispatch(setValue());
  };
};
var playerPicksSubmitted = function playerPicksSubmitted(picks) {
  return function (dispatch) {
    var _commonActions3 = common('player_picks_submitted'),
        setValue = _commonActions3.setValue;

    dispatch(setValue(picks));
  };
};
var fetchPlayerData = function fetchPlayerData() {
  return function (dispatch, getState) {
    var _getState = getState(),
        config = _getState.config;

    var apiUrl = config.apiUrl,
        env = config.env,
        userId = config.userId,
        currentSession = config.currentSession,
        platform = config.platform;

    var _apiActions = api('player_data'),
        fetchStart = _apiActions.fetchStart,
        fetchSuccess = _apiActions.fetchSuccess,
        fetchFailure = _apiActions.fetchFailure;

    dispatch(fetchStart());
    return makeRequest({
      method: 'GET',
      route: 'players',
      apiUrl: apiUrl,
      env: env,
      userId: userId,
      currentSession: currentSession
    }).then(function (resp) {
      if (resp.code === 'serverError') {
        return dispatch(fetchFailure(resp));
      }

      if (resp.code === 'noContest') {
        return dispatch(noContestToday());
      }

      if (resp.picks) {
        return dispatch(playerPicksSubmitted(resp));
      }

      return dispatch(fetchSuccess(resp));
    }, function (err) {
      var messageData = {
        err: err,
        route: 'players',
        apiUrl: apiUrl,
        userId: userId,
        currentSession: currentSession
      };
      fireMessageEvent({
        type: 'ERROR',
        platform: platform,
        title: 'hockey-challenge-error',
        data: messageData
      });

      if ((err === null || err === void 0 ? void 0 : err.status) !== 401) {
        dispatch(fetchFailure(err));
      }

      return dispatch(api('data_500').fetchFailure(err));
    });
  };
};

var getLeaderBoardRoute = {
  season: 'seasonLeaderboard',
  monthly: 'leaderboard',
  playoffs: 'postSeasonLeaderboard'
};

var fetchContestRank = function fetchContestRank(_ref) {
  var dispatch = _ref.dispatch,
      apiUrl = _ref.apiUrl,
      userId = _ref.userId,
      env = _ref.env,
      currentSession = _ref.currentSession,
      _ref$board = _ref.board,
      board = _ref$board === void 0 ? null : _ref$board,
      _ref$isLocal = _ref.isLocal,
      isLocal = _ref$isLocal === void 0 ? false : _ref$isLocal,
      challengeNumber = _ref.challengeNumber,
      season = _ref.season,
      platform = _ref.platform;
  var actionType = isLocal ? 'local_leaderboard' : 'leaderboard';

  var _apiActions = api(actionType),
      fetchSuccess = _apiActions.fetchSuccess,
      fetchFailure = _apiActions.fetchFailure;

  var suffix = isLocal ? 'Local' : '';
  return makeRequest(_extends({
    method: 'GET',
    apiUrl: apiUrl,
    userId: userId,
    env: env,
    currentSession: currentSession,
    route: "" + getLeaderBoardRoute[board] + suffix
  }, challengeNumber && {
    params: {
      challengeNumber: challengeNumber,
      season: season
    }
  })).then(function (resp) {
    return dispatch(fetchSuccess(_extends({}, resp, {
      board: board
    })));
  }, function (err) {
    var messageData = {
      err: err,
      apiUrl: apiUrl,
      route: "" + getLeaderBoardRoute[board] + suffix,
      userId: userId,
      currentSession: currentSession
    };
    fireMessageEvent({
      type: 'ERROR',
      platform: platform,
      title: 'hockey-challenge-error',
      data: messageData
    });

    if (err.code === 500) {
      return dispatch(api('data_500').fetchFailure(err));
    }

    return dispatch(fetchFailure(err));
  });
};

var fetchLeaderboardData = function fetchLeaderboardData(board, challengeNumber, season) {
  return function (dispatch, getState) {
    try {
      var _getState = getState(),
          config = _getState.config;

      var apiUrl = config.apiUrl,
          userId = config.userId,
          env = config.env,
          currentSession = config.currentSession,
          platform = config.platform;

      var _apiActions2 = api('leaderboard'),
          fetchStart = _apiActions2.fetchStart;

      dispatch(fetchStart());
      return Promise.resolve(fetchContestRank({
        dispatch: dispatch,
        apiUrl: apiUrl,
        userId: userId,
        env: env,
        currentSession: currentSession,
        board: board,
        challengeNumber: challengeNumber,
        season: season,
        platform: platform
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
};
var fetchLocalLeaderboardData = function fetchLocalLeaderboardData(board, isLocal, challengeNumber, season) {
  return function (dispatch, getState) {
    var _getState2 = getState(),
        config = _getState2.config;

    var apiUrl = config.apiUrl,
        userId = config.userId,
        env = config.env,
        currentSession = config.currentSession,
        platform = config.platform;

    var _apiActions3 = api('local_leaderboard'),
        fetchStart = _apiActions3.fetchStart;

    dispatch(fetchStart());
    return fetchContestRank({
      dispatch: dispatch,
      apiUrl: apiUrl,
      userId: userId,
      env: env,
      currentSession: currentSession,
      board: board,
      isLocal: isLocal,
      challengeNumber: challengeNumber,
      season: season,
      platform: platform
    });
  };
};
var fetchIsCurrentlySeason = function fetchIsCurrentlySeason() {
  return function (dispatch, getState) {
    var _getState3 = getState(),
        config = _getState3.config;

    var apiUrl = config.apiUrl,
        userId = config.userId,
        env = config.env,
        currentSession = config.currentSession,
        platform = config.platform;

    var _apiActions4 = api('season_status'),
        fetchStart = _apiActions4.fetchStart;

    var _apiActions5 = api('season_status'),
        fetchSuccess = _apiActions5.fetchSuccess,
        fetchFailure = _apiActions5.fetchFailure;

    dispatch(fetchStart());
    return makeRequest({
      method: 'GET',
      apiUrl: apiUrl,
      userId: userId,
      env: env,
      currentSession: currentSession,
      route: 'seasonLeaderboard'
    }).then(function (resp) {
      var status = resp.status === 'current';
      return dispatch(fetchSuccess(status));
    }, function (err) {
      var messageData = {
        err: err,
        route: 'seasonLeaderboard',
        apiUrl: apiUrl,
        userId: userId,
        currentSession: currentSession
      };
      fireMessageEvent({
        type: 'ERROR',
        platform: platform,
        title: 'hockey-challenge-error',
        data: messageData
      });

      if (err.code === 500) {
        return dispatch(api('data_500').fetchFailure(err));
      }

      return dispatch(fetchFailure(err));
    });
  };
};
var fetchIsCurrentlyPlayoffs = function fetchIsCurrentlyPlayoffs() {
  return function (dispatch, getState) {
    var _getState4 = getState(),
        config = _getState4.config;

    var apiUrl = config.apiUrl,
        userId = config.userId,
        env = config.env,
        currentSession = config.currentSession,
        platform = config.platform;

    var _apiActions6 = api('playoffs_status'),
        fetchStart = _apiActions6.fetchStart;

    var _apiActions7 = api('playoffs_status'),
        fetchSuccess = _apiActions7.fetchSuccess,
        fetchFailure = _apiActions7.fetchFailure;

    dispatch(fetchStart());
    return makeRequest({
      method: 'GET',
      apiUrl: apiUrl,
      userId: userId,
      env: env,
      currentSession: currentSession,
      route: 'postSeasonLeaderboard'
    }).then(function (resp) {
      var status = resp.status === 'current';
      return dispatch(fetchSuccess(status));
    }, function (err) {
      var messageData = {
        err: err,
        route: 'postSeasonLeaderboard',
        apiUrl: apiUrl,
        userId: userId,
        currentSession: currentSession
      };
      fireMessageEvent({
        type: 'ERROR',
        platform: platform,
        title: 'hockey-challenge-error',
        data: messageData
      });

      if (err.code === 500) {
        return dispatch(api('data_500').fetchFailure(err));
      }

      return dispatch(fetchFailure(err));
    });
  };
};
var setChallengeNumber = function setChallengeNumber(challengeNumber) {
  return function (dispatch) {
    var _commonActions = common('challenge_number'),
        setValue = _commonActions.setValue;

    dispatch(setValue(challengeNumber));
  };
};
var setBoardView = function setBoardView(board) {
  return function (dispatch) {
    var _commonActions2 = common('board_view'),
        setValue = _commonActions2.setValue;

    dispatch(setValue(board));
  };
};

var _templateObject$X;
var StepContainer = styled.div(_templateObject$X || (_templateObject$X = _taggedTemplateLiteralLoose(["\n  display: ", ";\n"])), function (_ref) {
  var active = _ref.active;
  return active ? 'block' : 'none';
});
var Step = function Step(_ref2) {
  var bannerText = _ref2.bannerText,
      children = _ref2.children,
      _ref2$isCurrent = _ref2.isCurrent,
      isCurrent = _ref2$isCurrent === void 0 ? false : _ref2$isCurrent;
  return /*#__PURE__*/React.createElement(StepContainer, {
    active: isCurrent
  }, /*#__PURE__*/React.createElement(SectionTitle, {
    text: bannerText
  }), children);
};
Step.propTypes = {
  children: propTypes.node,
  isCurrent: propTypes.bool,
  bannerText: propTypes.string
};

var _templateObject$Y, _templateObject2$L;
var ProgressContainer = styled.ol(_templateObject$Y || (_templateObject$Y = _taggedTemplateLiteralLoose(["\n  margin: 1em 0;\n  padding: 0;\n  text-align: center;\n"])));
var ProgressDot = styled.li(_templateObject2$L || (_templateObject2$L = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  margin: 2px;\n  background: ", ";\n"])), function (_ref) {
  var active = _ref.active,
      theme = _ref.theme;
  return active ? theme.colors.red : theme.colors.n700;
});

var Stepper = function Stepper(_ref2) {
  var children = _ref2.children,
      _ref2$initialStep = _ref2.initialStep,
      initialStep = _ref2$initialStep === void 0 ? 0 : _ref2$initialStep;
  return /*#__PURE__*/React.createElement("div", null, React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      index: index,
      isCurrent: initialStep === index
    });
  }), /*#__PURE__*/React.createElement(ProgressContainer, null, React.Children.map(children, function (_, index) {
    return /*#__PURE__*/React.createElement(ProgressDot, {
      active: initialStep === index
    });
  })));
};

Stepper.propTypes = {
  children: propTypes.node,
  initialStep: propTypes.number
};

var _templateObject$Z, _templateObject2$M, _templateObject3$D, _templateObject4$w, _templateObject5$m;

var containerBaseStyles$b = function containerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$Z || (_templateObject$Z = _taggedTemplateLiteralLoose(["\n  padding: 0 ", ";\n"])), theme.spacings.exa);
};

var Container$r = styled('div')(containerBaseStyles$b);

var textContainerBaseStyles$1 = function textContainerBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject2$M || (_templateObject2$M = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  text-align: center;\n"])), theme.colors.b500);
};

var textContainerMarginStyles = function textContainerMarginStyles(_ref3) {
  var margin = _ref3.margin;
  return margin && css(_templateObject3$D || (_templateObject3$D = _taggedTemplateLiteralLoose(["\n    margin-top: 0;\n    margin-bottom: 0;\n  "])));
};

var TextContainer$1 = styled('div')(textContainerBaseStyles$1, textContainerMarginStyles);

var titleOverrideBaseStyles = function titleOverrideBaseStyles() {
  return css(_templateObject4$w || (_templateObject4$w = _taggedTemplateLiteralLoose(["\n  p {\n    line-height: 22px !important;\n  }\n"])));
};

var TitleOverride = styled('div')(titleOverrideBaseStyles);

var textOverrideBaseStyles = function textOverrideBaseStyles() {
  return css(_templateObject5$m || (_templateObject5$m = _taggedTemplateLiteralLoose(["\n  p {\n    line-height: 19px !important;\n  }\n"])));
};

var TextOverride = styled('div')(textOverrideBaseStyles);

var QuizHeader = function QuizHeader(_ref4) {
  var title = _ref4.title,
      text = _ref4.text;
  return /*#__PURE__*/React.createElement(Container$r, null, /*#__PURE__*/React.createElement(TextContainer$1, null, /*#__PURE__*/React.createElement(TitleOverride, null, /*#__PURE__*/React.createElement(Text, {
    size: "zetta",
    bold: true
  }, title)), text && /*#__PURE__*/React.createElement(TextContainer$1, {
    margin: true
  }, /*#__PURE__*/React.createElement(TextOverride, null, /*#__PURE__*/React.createElement(Text, {
    size: "giga"
  }, text)))));
};

QuizHeader.propTypes = {
  title: propTypes.string,
  text: propTypes.string
};
QuizHeader.defaultProps = {
  title: 'Please solve the math problem below to continue'
};

var _templateObject$_;

var containerBaseStyles$c = function containerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$_ || (_templateObject$_ = _taggedTemplateLiteralLoose(["\n  padding: 0 ", ";\n"])), theme.spacings.zetta);
};

var Container$s = styled('div')(containerBaseStyles$c);

var QuizImage = function QuizImage(_ref2) {
  var cdnUrl = _ref2.cdnUrl,
      filename = _ref2.filename;
  return /*#__PURE__*/React.createElement(Container$s, null, /*#__PURE__*/React.createElement(Image, {
    src: "" + cdnUrl + filename,
    isSmall: true
  }));
};

QuizImage.propTypes = {
  cdnUrl: propTypes.string,
  filename: propTypes.string
};
QuizImage.defaultProps = {
  cdnUrl: 'https://hockeygame.s3.amazonaws.com/'
};

var _templateObject$$, _templateObject2$N, _templateObject3$E, _templateObject4$x;

var containerBaseStyles$d = function containerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$$ || (_templateObject$$ = _taggedTemplateLiteralLoose(["\n  padding: 0 ", ";\n"])), theme.spacings.peta);
};

var Container$t = styled('div')(containerBaseStyles$d);

var questionRowBaseStyles = function questionRowBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject2$N || (_templateObject2$N = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  display: flex;\n  margin: ", " 0;\n"])), theme.colors.b500, theme.spacings.bit);
};

var QuestionRow = styled('div')(questionRowBaseStyles);

var questionOperatorBaseStyles = function questionOperatorBaseStyles(_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject3$E || (_templateObject3$E = _taggedTemplateLiteralLoose(["\n  margin-left: ", ";\n  text-align: left;\n  width: 70%;\n"])), theme.spacings.mega);
};

var QuestionOperator = styled('div')(questionOperatorBaseStyles);

var questionOperationBaseStyles = function questionOperationBaseStyles(_ref4) {
  var theme = _ref4.theme;
  return css(_templateObject4$x || (_templateObject4$x = _taggedTemplateLiteralLoose(["\n  margin: 0 ", ";\n  text-align: left;\n  width: 30%;\n"])), theme.spacings.bit);
};

var QuestionOperation = styled('div')(questionOperationBaseStyles);

var QuizQuestion = function QuizQuestion(_ref5) {
  var question = _ref5.question;
  return /*#__PURE__*/React.createElement(Container$t, null, /*#__PURE__*/React.createElement(Rink, null, question.map(function (_ref6) {
    var id = _ref6.id,
        operator = _ref6.operator,
        operation = _ref6.operation;
    return /*#__PURE__*/React.createElement(QuestionRow, {
      key: id
    }, /*#__PURE__*/React.createElement(QuestionOperator, null, /*#__PURE__*/React.createElement(Text, {
      as: "h3",
      size: "mega",
      bold: true,
      heading: true,
      noMargin: true
    }, operator)), /*#__PURE__*/React.createElement(QuestionOperation, null, /*#__PURE__*/React.createElement(Text, {
      as: "h3",
      size: "mega",
      bold: true,
      heading: true,
      noMargin: true
    }, operation)));
  })));
};

QuizQuestion.propTypes = {
  question: propTypes.array
};
QuizQuestion.defaultProps = {
  question: [{
    id: "multiply",
    operator: 'Multiply',
    operation: '6x2'
  }, {
    id: "divide",
    operator: 'Divide By',
    operation: 3
  }, {
    id: "add",
    operator: 'Add',
    operation: 1
  }, {
    id: "subtract",
    operator: 'Subtract',
    operation: 4
  }]
};

var _templateObject$10;

var listWrapperBaseStyles = function listWrapperBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$10 || (_templateObject$10 = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  padding: 0 ", ";\n"])), theme.colors.white, theme.spacings["byte"]);
};

var ListWrapper = styled('div')(listWrapperBaseStyles);

var QuizAnswer = function QuizAnswer(_ref2) {
  var title = _ref2.title,
      items = _ref2.items,
      selected = _ref2.selected,
      onSelect = _ref2.onSelect;
  return /*#__PURE__*/React.createElement(ShadowBox, null, /*#__PURE__*/React.createElement(ListHeader, {
    text: title
  }), /*#__PURE__*/React.createElement(ListWrapper, null, /*#__PURE__*/React.createElement(RadioList, {
    items: items,
    selected: selected,
    onSelect: onSelect,
    titleProps: {
      bold: true
    },
    centered: true,
    sideIndent: true
  })));
};

QuizAnswer.propTypes = {
  title: propTypes.string,
  items: propTypes.array,
  selected: propTypes.bool,
  onSelect: propTypes.func
};
QuizAnswer.defaultProps = {
  items: [{
    id: 'stq-1',
    title: 1
  }, {
    id: 'stq-2',
    title: 3
  }, {
    id: 'stq-3',
    title: 2
  }, {
    id: 'stq-4',
    title: 5
  }]
};

var _excluded$k = ["text", "isSubmitting", "selected", "onSubmit", "disabled"];

var _templateObject$11, _templateObject2$O, _templateObject3$F;

var baseStyles$x = function baseStyles() {
  return css(_templateObject$11 || (_templateObject$11 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  width: 100%;\n  text-align: right;\n"])));
};

var submittedStyles = function submittedStyles(_ref) {
  var theme = _ref.theme,
      isSubmitted = _ref.isSubmitted;
  return isSubmitted && css(_templateObject2$O || (_templateObject2$O = _taggedTemplateLiteralLoose(["\n    margin-bottom: 0;\n    padding: 0 ", ";\n  "])), theme.spacings.mega);
};

var Container$u = styled('div')(baseStyles$x, submittedStyles);

var buttonContainerBaseStyles = function buttonContainerBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject3$F || (_templateObject3$F = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    padding: 0 ", ";\n  "])), theme.spacings.zetta);
};

var ButtonContainer = styled('div')(buttonContainerBaseStyles);

var SubmitQuiz = function SubmitQuiz(_ref3) {
  var text = _ref3.text,
      isSubmitting = _ref3.isSubmitting,
      selected = _ref3.selected,
      onSubmit = _ref3.onSubmit,
      disabled = _ref3.disabled,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded$k);

  return /*#__PURE__*/React.createElement(Container$u, null, /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(Button, _extends({
    type: "submit",
    variant: "primary",
    isSubmitting: isSubmitting,
    onSelect: function onSelect() {
      return onSubmit(selected);
    },
    disabled: disabled,
    stretch: true
  }, props), text)));
};

SubmitQuiz.propTypes = {
  text: propTypes.string,
  isSubmitting: propTypes.bool,
  selected: propTypes.string,
  onSubmit: propTypes.func,
  disabled: propTypes.bool
};
SubmitQuiz.defaultProps = {
  text: 'Submit Answer',
  disabled: true
};

var _templateObject$12, _templateObject2$P;

var baseStyles$y = function baseStyles() {
  return css$1(_templateObject$12 || (_templateObject$12 = _taggedTemplateLiteralLoose([""])));
};

var Container$v = styled('div')(baseStyles$y);

var termsWrapperBaseStyles = function termsWrapperBaseStyles(_ref) {
  var theme = _ref.theme;
  return css$1(_templateObject2$P || (_templateObject2$P = _taggedTemplateLiteralLoose(["\n  padding: 0 ", ";\n"])), theme.spacings.tera);
};

var TermsWrapper = styled('div')(termsWrapperBaseStyles);

var TimsSkillTest = function TimsSkillTest(_ref2) {
  var gameLocked = _ref2.gameLocked,
      lockedText = _ref2.lockedText,
      lockedImageFilename = _ref2.lockedImageFilename,
      title = _ref2.title,
      text = _ref2.text,
      cdnUrl = _ref2.cdnUrl,
      quizImageFilename = _ref2.quizImageFilename,
      question = _ref2.question,
      answerTitle = _ref2.answerTitle,
      items = _ref2.items,
      selected = _ref2.selected,
      onSelect = _ref2.onSelect,
      isSubmitting = _ref2.isSubmitting,
      btnText = _ref2.btnText,
      btnVarient = _ref2.btnVarient,
      btnDisabled = _ref2.btnDisabled,
      termsText = _ref2.termsText,
      onSubmit = _ref2.onSubmit;
  return /*#__PURE__*/React.createElement(Container$v, null, /*#__PURE__*/React.createElement(Spacing, {
    bottom: true
  }, /*#__PURE__*/React.createElement(QuizHeader, {
    title: title,
    text: text
  })), gameLocked && /*#__PURE__*/React.createElement(Spacing, {
    bottom: true,
    triple: true
  }, /*#__PURE__*/React.createElement(Teaser, {
    text: lockedText,
    cdnUrl: cdnUrl,
    filename: lockedImageFilename
  })), !gameLocked && /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(Spacing, {
    bottom: true
  }, /*#__PURE__*/React.createElement(QuizImage, {
    cdnUrl: cdnUrl,
    filename: quizImageFilename
  })), /*#__PURE__*/React.createElement(Spacing, {
    bottom: true
  }, /*#__PURE__*/React.createElement(QuizQuestion, {
    question: question
  })), /*#__PURE__*/React.createElement(Spacing, {
    bottom: true
  }, /*#__PURE__*/React.createElement(Spacing, {
    sides: true
  }, /*#__PURE__*/React.createElement(QuizAnswer, {
    title: answerTitle,
    items: items,
    selected: selected,
    onSelect: onSelect
  }))), /*#__PURE__*/React.createElement(Spacing, {
    bottom: true
  }, /*#__PURE__*/React.createElement(TermsWrapper, null, /*#__PURE__*/React.createElement(TermsText, {
    text: termsText
  }))), /*#__PURE__*/React.createElement(SubmitQuiz, {
    isSubmitting: isSubmitting,
    disabled: btnDisabled,
    text: btnText,
    variant: btnVarient,
    selected: selected,
    onSubmit: onSubmit
  })));
};

TimsSkillTest.propTypes = {
  gameLocked: propTypes.bool,
  lockedText: propTypes.string,
  lockedImageFilename: propTypes.string,
  title: propTypes.string,
  text: propTypes.string,
  cdnUrl: propTypes.string,
  quizImageFilename: propTypes.string,
  question: propTypes.array,
  answerTitle: propTypes.string,
  items: propTypes.array,
  selected: propTypes.bool,
  onSelect: propTypes.func,
  isSubmitting: propTypes.bool,
  termsText: propTypes.string,
  btnDisabled: propTypes.bool,
  btnText: propTypes.string,
  btnVarient: propTypes.string,
  onSubmit: propTypes.func
};
TimsSkillTest.defaultProps = {
  gameLocked: false,
  lockedImageFilename: 'sticks.svg',
  quizImageFilename: 'hockey-divider.svg',
  btnVarient: 'primary'
};

var assetSet$2 = function assetSet(filename) {
  return getAssetSet(useCdnImage, filename);
};

var QuizApp = function QuizApp(_ref) {
  var hasError = _ref.hasError,
      errorText = _ref.errorText,
      gameLocked = _ref.gameLocked,
      lockedText = _ref.lockedText,
      title = _ref.title,
      text = _ref.text,
      termsText = _ref.termsText,
      question = _ref.question,
      answerTitle = _ref.answerTitle,
      answerOptions = _ref.answerOptions,
      selectedAnswer = _ref.selectedAnswer,
      btnText = _ref.btnText,
      btnVarient = _ref.btnVarient,
      btnDisabled = _ref.btnDisabled,
      handleQuizAnswerClick = _ref.handleQuizAnswerClick,
      handleQuizSubmission = _ref.handleQuizSubmission;
  var cdnUrl = useCdnUrl();
  return /*#__PURE__*/React.createElement(Fragment$1, null, !hasError ? /*#__PURE__*/React.createElement(Spacing, {
    top: true,
    bottom: true
  }, /*#__PURE__*/React.createElement(TimsSkillTest, {
    gameLocked: gameLocked,
    lockedText: lockedText,
    assetUrl: cdnUrl,
    title: title,
    text: text,
    question: question,
    answerTitle: answerTitle,
    items: answerOptions,
    onSelect: handleQuizAnswerClick,
    selected: selectedAnswer,
    btnText: btnText,
    btnVarient: btnVarient,
    btnDisabled: btnDisabled,
    onSubmit: handleQuizSubmission,
    termsText: termsText
  })) : /*#__PURE__*/React.createElement(Spacing, {
    sides: true,
    top: true,
    bottom: true
  }, /*#__PURE__*/React.createElement(Teaser, {
    src: assetSet$2(['sticks']),
    text: errorText
  })));
};

QuizApp.propTypes = {
  hasError: propTypes.bool,
  errorText: propTypes.string,
  showNotificationBar: propTypes.bool,
  notificationBarTitle: propTypes.string,
  notificationBarText: propTypes.string,
  gameLocked: propTypes.bool,
  lockedText: propTypes.string,
  title: propTypes.string,
  text: propTypes.string,
  question: propTypes.array,
  answerTitle: propTypes.string,
  answerOptions: propTypes.array,
  selectedAnswer: propTypes.number,
  termsText: propTypes.string,
  btnText: propTypes.string,
  btnVarient: propTypes.string,
  btnDisabled: propTypes.bool,
  handleQuizAnswerClick: propTypes.func,
  handleQuizSubmission: propTypes.func,
  handleNotificationBarCloseClick: propTypes.func
};

var mapStateToProps = function mapStateToProps(state) {
  var config = state.config,
      strings = state.strings,
      onboarding = state.onboarding,
      ui = state.ui;
  var notificationBarOpen = ui.notificationBarOpen;
  var questions = onboarding.questions,
      attempts = onboarding.attempts,
      selectedAnswer = onboarding.selectedAnswer,
      correctAnswer = onboarding.correctAnswer,
      options = onboarding.options,
      lockout = onboarding.lockout;
  var hasError = false;
  var showNotificationBar = attempts > 0 && !correctAnswer && notificationBarOpen;
  var notificationBarTitle = strings['notifications/quiz/wrongAnswer/title'];
  var notificationBarText = strings['notifications/quiz/wrongAnswer/text'];
  var operationText = {
    multiplyText: strings['quiz/question/multiply/text'],
    divideByText: strings['quiz/question/divideBy/text'],
    addText: strings['quiz/question/add/text'],
    subtractText: strings['quiz/question/subtract/text']
  };
  var question = [{
    id: "question-" + attempts + "-multiply",
    operator: operationText.multiplyText,
    operation: questions[attempts][0]
  }, {
    id: "question-" + attempts + "-divide",
    operator: operationText.divideByText,
    operation: questions[attempts][1]
  }, {
    id: "question-" + attempts + "-add",
    operator: operationText.addText,
    operation: questions[attempts][2]
  }, {
    id: "question-" + attempts + "-subtract",
    operator: operationText.subtractText,
    operation: questions[attempts][3]
  }];
  var answerOptions = options[attempts].map(function (option) {
    return {
      id: option,
      title: option
    };
  });
  var defaultProps = {
    config: config,
    gameLocked: false,
    title: strings['quiz/helpInfo/text'],
    answerTitle: strings['quiz/answerTitle/text'],
    termsText: strings['modals/tierSelection/terms/text'],
    question: question,
    answerOptions: answerOptions,
    selectedAnswer: selectedAnswer,
    btnText: strings['button/submitAnswer/text'],
    btnVarient: 'primary',
    btnDisabled: !selectedAnswer
  };

  if (lockout) {
    return _extends({}, defaultProps, {
      gameLocked: true,
      title: strings['notifications/quiz/gameLocked/checkBack/text'],
      text: strings['notifications/quiz/gameLocked/text'],
      lockedText: strings['notifications/quiz/gameLocked/checkBack/text']
    });
  }

  return _extends({}, defaultProps, {
    showNotificationBar: showNotificationBar,
    notificationBarTitle: notificationBarTitle,
    notificationBarText: notificationBarText,
    hasError: hasError
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    handleQuizAnswerClick: function handleQuizAnswerClick(id) {
      return dispatch(setSelectedAnswer(id));
    },
    handleQuizSubmission: function handleQuizSubmission(answer) {
      return dispatch(sendQuizAnswer());
    }
  };
};

var QuizApp$1 = connect(mapStateToProps, mapDispatchToProps)(QuizApp);

var _templateObject$13;

var nameEntryStyles = function nameEntryStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$13 || (_templateObject$13 = _taggedTemplateLiteralLoose(["\n  padding-top: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n"])), theme.spacings.tera, theme.spacings.peta, theme.spacings.peta);
};

var NameEntryContainer = styled('div')(nameEntryStyles);

var scrollToRef = function scrollToRef(ref) {
  document.getElementById('thLayout').scrollTo(0, ref.current.getBoundingClientRect().bottom);
};

var NameEntry = function NameEntry() {
  var _useSelector = useSelector(function (state) {
    return state;
  }),
      strings = _useSelector.strings,
      onboarding = _useSelector.onboarding,
      ui = _useSelector.ui;

  var dispatch = useDispatch();
  var usernameValidationErr = onboarding.usernameValidationErr,
      isFetching = onboarding.isFetching,
      resetUserNameAttemptStatus = onboarding.resetUserNameAttemptStatus;
  var hasFetchError = ui.hasFetchError;

  var _useState = useState(''),
      username = _useState[0],
      setUsername = _useState[1];

  var inputRef = useRef();

  var executeScroll = function executeScroll() {
    scrollToRef(inputRef);
  };

  useEffect(function () {
    inputRef.current.focus();
  });
  useEffect(function () {
    if (!hasFetchError && resetUserNameAttemptStatus) {
      dispatch(submitUsername(username));
    }
  }, [hasFetchError, resetUserNameAttemptStatus]);
  var cdnUrl = useCdnUrl();

  var handleUsernameSubmit = function handleUsernameSubmit() {
    dispatch(submitUsername(username));
  };

  var errorText = usernameValidationErr ? strings['username/usernameLengthError/text'] : onboarding.errorCode ? strings['username/boomError/text'](onboarding.errorCode) : '';
  var headerText = strings['username/header/text'];
  var blurbText = strings['username/blurb/text'];
  var buttonText = strings['username/saveButton/text'];
  return /*#__PURE__*/React.createElement(NameEntryContainer, null, /*#__PURE__*/React.createElement(Text, {
    lineHeight: "22px",
    size: "zetta",
    bold: true,
    centered: true
  }, headerText), /*#__PURE__*/React.createElement(Spacing, {
    paddingTop: "giga"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    size: "giga",
    noMargin: true,
    centered: true
  }, blurbText)), /*#__PURE__*/React.createElement(Spacing, {
    paddingBottom: "giga",
    paddingTop: "giga"
  }, /*#__PURE__*/React.createElement(Image, {
    src: cdnUrl + "user-profile.png",
    naturalSize: true
  })), /*#__PURE__*/React.createElement(Spacing, {
    paddingBottom: "yotta"
  }, /*#__PURE__*/React.createElement(Input, {
    type: "text",
    value: username,
    submitUsername: true,
    onChange: function onChange(e) {
      setUsername(e.target.value.trim());
    },
    onFocus: function onFocus() {
      return executeScroll();
    },
    validationHint: errorText,
    invalid: errorText.length > 0,
    maxLength: "15",
    ref: inputRef
  })), /*#__PURE__*/React.createElement(SubmitButton, {
    isLoading: isFetching,
    variant: "primary",
    text: buttonText,
    stretch: true,
    onSelect: handleUsernameSubmit
  }));
};

var _templateObject$14;

var SuccessStyles = function SuccessStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$14 || (_templateObject$14 = _taggedTemplateLiteralLoose(["\n  padding-top: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n"])), theme.spacings.tera, theme.spacings.peta, theme.spacings.peta);
};

var SuccessContainer = styled('div')(SuccessStyles);
var clickedType = analyticActionMap.clickedType,
    path$1 = analyticActionMap.path,
    buttonType = analyticActionMap.buttonType,
    makeYourPicks = analyticActionMap.makeYourPicks,
    onboarding$1 = analyticActionMap.onboarding;

var Success = function Success(_ref2) {
  var headerText = _ref2.headerText,
      blurbText = _ref2.blurbText,
      buttonText = _ref2.buttonText,
      logoUrl = _ref2.logoUrl,
      handleOnboardingComplete = _ref2.handleOnboardingComplete,
      config = _ref2.config;
  var platform = config.platform,
      env = config.env;
  var cdnUrl = useCdnUrl();
  return /*#__PURE__*/React.createElement(SuccessContainer, null, /*#__PURE__*/React.createElement(Text, {
    lineHeight: "22px",
    size: "zetta",
    bold: true,
    centered: true
  }, headerText), /*#__PURE__*/React.createElement(Spacing, {
    paddingTop: "giga"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    size: "giga",
    noMargin: true,
    centered: true
  }, blurbText)), /*#__PURE__*/React.createElement(Spacing, {
    paddingBottom: "giga",
    paddingTop: "giga"
  }, /*#__PURE__*/React.createElement(Image, {
    src: "" + cdnUrl + logoUrl
  })), /*#__PURE__*/React.createElement(Spacing, {
    paddingTop: "yotta"
  }, /*#__PURE__*/React.createElement(SubmitButton, {
    variant: "primary",
    text: buttonText,
    stretch: true,
    onSelect: function onSelect() {
      fireMessageEvent({
        platform: platform,
        env: env,
        title: clickedType,
        data: {
          path: path$1,
          modal: onboarding$1,
          element: buttonType,
          element_name: makeYourPicks
        }
      });
      handleOnboardingComplete(config);
    }
  })));
};

Success.propTypes = {
  hasError: propTypes.bool,
  errorText: propTypes.string,
  headerText: propTypes.string,
  blurbText: propTypes.string,
  buttonText: propTypes.string,
  isFetching: propTypes.bool
};

var mapStateToProps$1 = function mapStateToProps(state) {
  var strings = state.strings,
      config = state.config;
  return {
    headerText: strings['success/header/text'],
    blurbText: strings['success/blurb/text'],
    buttonText: strings['success/button/text'],
    logoUrl: strings['success/logo/src'],
    config: config
  };
};

var mapDispatchToProps$1 = function mapDispatchToProps(dispatch) {
  return {
    handleOnboardingComplete: function handleOnboardingComplete(config) {
      return dispatch(setCompletedOnboarding(config));
    }
  };
};

var Success$1 = connect(mapStateToProps$1, mapDispatchToProps$1)(Success);

var _excluded$l = ["header", "body", "text", "buttonText", "handleToggleSubmission"];

var _templateObject$15, _templateObject2$Q, _templateObject3$G;

var containerBaseStyles$e = function containerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$15 || (_templateObject$15 = _taggedTemplateLiteralLoose(["\n  padding-top: ", ";\n  margin-left: ", ";\n  margin-right: ", ";\n"])), theme.spacings.tera, theme.spacings.peta, theme.spacings.peta);
};

var Container$w = styled('div')(containerBaseStyles$e);

var switchWrapperBaseStyles = function switchWrapperBaseStyles(_ref2) {
  return css(_templateObject2$Q || (_templateObject2$Q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
};

var Wrapper$5 = styled('div')(switchWrapperBaseStyles);

var reminderSwitchBaseStyles = function reminderSwitchBaseStyles(_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject3$G || (_templateObject3$G = _taggedTemplateLiteralLoose(["\n  margin-right: ", ";\n"])), theme.spacings.kilo);
};

var ReminderSwitch = styled('div')(reminderSwitchBaseStyles);

var Notification = function Notification(_ref4) {
  var header = _ref4.header,
      body = _ref4.body,
      text = _ref4.text,
      buttonText = _ref4.buttonText,
      handleToggleSubmission = _ref4.handleToggleSubmission,
      props = _objectWithoutPropertiesLoose(_ref4, _excluded$l);

  var _useState = useState(false),
      isActive = _useState[0],
      setActive = _useState[1];

  var _useState2 = useState(false),
      reminderHasUpdated = _useState2[0],
      setReminderHasUpdated = _useState2[1];

  var cdnUrl = useCdnUrl();
  var config = props.config,
      currentRoute = props.currentRoute;
  var platform = config.platform,
      env = config.env;
  var clickedType = analyticActionMap.clickedType,
      path = analyticActionMap.path,
      toggleType = analyticActionMap.toggleType,
      onValue = analyticActionMap.onValue,
      offValue = analyticActionMap.offValue,
      notifications = analyticActionMap.notifications;

  var submitNotificationStatus = function submitNotificationStatus() {
    handleToggleSubmission(isActive, reminderHasUpdated);
  };

  if (reminderHasUpdated) {
    fireMessageEvent({
      title: clickedType,
      data: {
        platform: platform,
        env: env,
        path: path,
        modal: notifications,
        element: toggleType,
        element_name: analyticActionMap[currentRoute] + "_" + notifications + "_" + (isActive ? onValue : offValue),
        element_action: isActive ? onValue : offValue
      }
    });
  }

  return /*#__PURE__*/React.createElement(Container$w, null, /*#__PURE__*/React.createElement(Text, {
    lineHeight: "22px",
    size: "zetta",
    bold: true,
    centered: true
  }, header), /*#__PURE__*/React.createElement(Spacing, {
    paddingTop: "giga"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    size: "giga",
    noMargin: true,
    centered: true
  }, body)), /*#__PURE__*/React.createElement(Spacing, {
    paddingBottom: "giga",
    paddingTop: "giga"
  }, /*#__PURE__*/React.createElement(Image, {
    src: cdnUrl + "notification.png",
    naturalSize: true
  })), /*#__PURE__*/React.createElement(Spacing, {
    paddingBottom: "yotta",
    paddingTop: "giga"
  }, /*#__PURE__*/React.createElement(Wrapper$5, null, /*#__PURE__*/React.createElement(ReminderSwitch, {
    onClick: function onClick() {
      setReminderHasUpdated(true);
      setActive(!isActive);
    }
  }, /*#__PURE__*/React.createElement(ToggleSwitch, {
    isActive: isActive
  })), /*#__PURE__*/React.createElement(Text, {
    size: "mega",
    noMargin: true
  }, text))), /*#__PURE__*/React.createElement(SubmitButton, {
    variant: "primary",
    text: buttonText,
    stretch: true,
    onSelect: submitNotificationStatus
  }));
};

var mapStateToProps$2 = function mapStateToProps(state) {
  var strings = state.strings;
  var allStrings = {
    header: strings['notifications/reminders/header'],
    body: strings['notifications/reminders/body'],
    text: strings['notifications/reminders/text'],
    buttonText: strings['notifications/reminders/button']
  };
  return _extends({}, allStrings);
};

var mapDispatchToProps$2 = function mapDispatchToProps(dispatch) {
  return {
    handleToggleSubmission: function handleToggleSubmission(status) {
      return dispatch(sendNotificationStatus(status));
    }
  };
};

var Notifications = connect(mapStateToProps$2, mapDispatchToProps$2)(Notification);

var _excluded$m = ["quizText", "usernameText", "notificationsText", "doneText", "initialStep", "handleOnboardingComplete"];

var Onboarding = function Onboarding(_ref) {
  var quizText = _ref.quizText,
      usernameText = _ref.usernameText,
      notificationsText = _ref.notificationsText,
      doneText = _ref.doneText,
      initialStep = _ref.initialStep,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$m);

  return /*#__PURE__*/React.createElement(Stepper, {
    initialStep: initialStep
  }, /*#__PURE__*/React.createElement(Step, {
    bannerText: quizText
  }, /*#__PURE__*/React.createElement(QuizApp$1, null)), /*#__PURE__*/React.createElement(Step, {
    bannerText: usernameText
  }, /*#__PURE__*/React.createElement(NameEntry, null)), /*#__PURE__*/React.createElement(Step, {
    bannerText: notificationsText
  }, /*#__PURE__*/React.createElement(Notifications, props)), /*#__PURE__*/React.createElement(Step, {
    bannerText: doneText
  }, /*#__PURE__*/React.createElement(Success$1, null)));
};

var mapStateToProps$3 = function mapStateToProps(state) {
  var strings = state.strings,
      onboarding = state.onboarding,
      config = state.config;
  var hasAnswered = onboarding.hasAnswered,
      hasUsername = onboarding.hasUsername,
      hasNotificationPref = onboarding.hasNotificationPref;
  var step;

  if (!hasAnswered) {
    step = 0;
  } else if (!hasUsername) {
    step = 1;
  } else if (!hasNotificationPref) {
    step = 2;
  } else {
    step = 3;
  }

  return {
    initialStep: step,
    quizText: strings['titles/onboarding/quiz/text'],
    usernameText: strings['titles/onboarding/username/text'],
    notificationsText: strings['titles/onboarding/notifications/text'],
    doneText: strings['titles/onboarding/done/text'],
    config: config
  };
};

var mapDispatchToProps$3 = function mapDispatchToProps(dispatch) {
  return {
    handleOnboardingComplete: function handleOnboardingComplete(config) {
      return dispatch(setCompletedOnboarding(config));
    }
  };
};

var Onboarding$1 = connect(mapStateToProps$3, mapDispatchToProps$3)(Onboarding);

var _templateObject$16, _templateObject2$R, _templateObject3$H, _templateObject4$y, _templateObject5$n, _templateObject6$i, _templateObject7$d;
var HeatStreakBanner = styled.div(_templateObject$16 || (_templateObject$16 = _taggedTemplateLiteralLoose(["\n  margin-top: 24px;\n  padding-right: ", ";\n  padding-left: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacings["byte"];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacings["byte"];
});
var HeatStreakBannerTop = styled.div(_templateObject2$R || (_templateObject2$R = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n"])));
var HeatStreakBannerImage1 = styled(Image)(_templateObject3$H || (_templateObject3$H = _taggedTemplateLiteralLoose(["\n  max-width: 75px;\n  flex: 1;\n"])));
var HeatStreakBannerImage2 = styled(Image)(_templateObject4$y || (_templateObject4$y = _taggedTemplateLiteralLoose(["\n  margin-top: ", ";\n  padding-right: 14px;\n  padding-left: 14px;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacings.mega;
});
var HeatStreakBannerTextContainer = styled.div(_templateObject5$n || (_templateObject5$n = _taggedTemplateLiteralLoose(["\n  margin-left: ", ";\n  flex: 3;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacings.mega;
});
var HeatStreakBannerTitle = styled(Text)(_templateObject6$i || (_templateObject6$i = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  font-weight: 700;\n  letter-spacing: ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.text.tera.fontSize;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.text.peta.letterSpacing;
});
var HeatStreakBannerText = styled(Text)(_templateObject7$d || (_templateObject7$d = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  letter-spacing: ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.text.giga.fontSize;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.text.giga.letterSpacing;
});
var PlayoffHeatStreakBanner = function PlayoffHeatStreakBanner(_ref9) {
  var heatStreakBannerImg1Src = _ref9.heatStreakBannerImg1Src,
      heatStreakBannerImg2Src = _ref9.heatStreakBannerImg2Src,
      playoffHeatStreakBannerTitle = _ref9.playoffHeatStreakBannerTitle,
      playoffHeatStreakBannerText = _ref9.playoffHeatStreakBannerText;
  return /*#__PURE__*/React.createElement(HeatStreakBanner, null, /*#__PURE__*/React.createElement(HeatStreakBannerTop, null, /*#__PURE__*/React.createElement(HeatStreakBannerImage1, {
    src: heatStreakBannerImg1Src
  }), /*#__PURE__*/React.createElement(HeatStreakBannerTextContainer, null, /*#__PURE__*/React.createElement(HeatStreakBannerTitle, null, playoffHeatStreakBannerTitle), /*#__PURE__*/React.createElement(HeatStreakBannerText, null, playoffHeatStreakBannerText))), /*#__PURE__*/React.createElement(HeatStreakBannerImage2, {
    src: heatStreakBannerImg2Src
  }));
};
PlayoffHeatStreakBanner.propTypes = {
  heatStreakBannerImg1Src: propTypes.string,
  heatStreakBannerImg2Src: propTypes.string,
  playoffHeatStreakBannerTitle: propTypes.string,
  playoffHeatStreakBannerText: propTypes.string
};

var _templateObject$17, _templateObject2$S, _templateObject3$I, _templateObject4$z, _templateObject5$o, _templateObject6$j, _templateObject7$e, _templateObject8$b;
var Container$x = styled(ShadowBox)(_templateObject$17 || (_templateObject$17 = _taggedTemplateLiteralLoose(["\n  padding: ", ";\n  margin: 0 auto;\n\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacings.giga;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
});
var CardHeader$1 = styled.div(_templateObject2$S || (_templateObject2$S = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  line-height: ", ";\n  letter-spacing: ", ";\n  align-items: center;\n  margin-top: ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.subHeadings.mega.lineHeight;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.subHeadings.mega.letterSpacing;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacings.bit;
});
var Badge = styled.span(_templateObject3$I || (_templateObject3$I = _taggedTemplateLiteralLoose(["\n  font-family: 'Brewed-Bold';\n  background-color: ", ";\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 800;\n  padding: ", ";\n"])), function (props) {
  return props.theme.colors[props.color];
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacings.bit + " " + theme.spacings.kilo;
});
var Title = styled(Heading)(_templateObject4$z || (_templateObject4$z = _taggedTemplateLiteralLoose(["\n  flex-grow: 1;\n  font-size: 18px;\n  font-weight: 800;\n  width: 50%;\n"])));
var SponsorSection = styled.div(_templateObject5$o || (_templateObject5$o = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  border-bottom: ", ";\n  margin-top: ", ";\n"])), function (props) {
  return props.hasDivider ? '1px solid rgba(255,255,255,0.3)' : '';
}, function (props) {
  return props.spacingTop ? '28px' : props.spacingTopSmall ? '10px' : '';
});
var LogoContainer = styled.div(_templateObject6$j || (_templateObject6$j = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  padding: ", ";\n"])), function (props) {
  return "" + props.width;
}, function (props) {
  return props.noPadding ? "0px 0px " + props.theme.spacings.giga : props.theme.spacings.giga + " " + props.theme.spacings.giga;
});
var SponsorLogo = styled(Image)(_templateObject7$e || (_templateObject7$e = _taggedTemplateLiteralLoose([""])));
var SponsorDesc = styled(Text)(_templateObject8$b || (_templateObject8$b = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  span {\n    font-family: 'Brewed-Bold';\n    display: block;\n    margin: ", " ", ";\n    font-weight: 900;\n    font-size: ", ";\n    line-height: ", ";\n    letter-spacing: -1.5px;\n    padding-bottom: ", ";\n    sup {\n      font-size: ", ";\n    }\n  }\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacings.atom;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.spacings.kilo;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.typography.subHeadings.tera.fontSize;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.subHeadings.tera.lineHeight;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.spacings.giga;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.typography.headings.deca.fontSize;
});

var ChallengeCard = function ChallengeCard(_ref13) {
  var title = _ref13.title,
      logosSrc = _ref13.logosSrc,
      sponsorText = _ref13.sponsorText,
      children = _ref13.children,
      background = _ref13.background,
      hasDivider = _ref13.hasDivider,
      spacingTop = _ref13.spacingTop,
      spacingTopSmall = _ref13.spacingTopSmall,
      noPadding = _ref13.noPadding,
      active = _ref13.active,
      noBadge = _ref13.noBadge;
  var cdnUrl = useCdnUrl();

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      strings = _useSelector.strings;

  var inProgressText = strings['challenges/inProgress/text'];
  var completedText = strings['challenges/completed/text'];
  return /*#__PURE__*/React.createElement(Container$x, {
    background: background
  }, /*#__PURE__*/React.createElement(CardHeader$1, null, /*#__PURE__*/React.createElement(Title, {
    as: "h4",
    noMarginTop: true,
    noMarginBottom: true
  }, title), !noBadge && (active ? /*#__PURE__*/React.createElement(Badge, {
    color: "g600"
  }, inProgressText) : /*#__PURE__*/React.createElement(Badge, {
    color: "n900"
  }, completedText)), ' '), /*#__PURE__*/React.createElement(SponsorSection, {
    hasDivider: hasDivider,
    spacingTop: spacingTop,
    spacingTopSmall: spacingTopSmall
  }, (logosSrc === null || logosSrc === void 0 ? void 0 : logosSrc.length) > 0 && logosSrc.map(function (logo, i) {
    return /*#__PURE__*/React.createElement(LogoContainer, {
      key: "sponsor-" + i,
      width: logo.width,
      noPadding: noPadding
    }, /*#__PURE__*/React.createElement(SponsorLogo, {
      src: "" + cdnUrl + logo.src
    }));
  }), /*#__PURE__*/React.createElement(SponsorDesc, {
    size: "tera",
    noMargin: true
  }, sponsorText)), children);
};

ChallengeCard.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  background: propTypes.string,
  title: propTypes.string,
  dates: propTypes.string,
  logosSrc: propTypes.array,
  sponsorText: propTypes.string,
  active: propTypes.bool,
  noBadge: propTypes.bool
};

var _excluded$n = ["text", "prizes", "analyticsTitle", "heatStreak"];

var _templateObject$18, _templateObject2$T, _templateObject3$J, _templateObject4$A, _templateObject5$p;
var PrizeList = styled.ol(_templateObject$18 || (_templateObject$18 = _taggedTemplateLiteralLoose(["\n  list-style: none;\n  margin: ", " 0 0;\n  padding: 0;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacings.mega;
});
var PrizeItem = styled.li(_templateObject2$T || (_templateObject2$T = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  margin-top: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacings.giga;
});
var PrizeDesc = styled(Text)(_templateObject3$J || (_templateObject3$J = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  margin-bottom: 0px;\n  text-shadow: 0px 4.128px 20.638px rgba(0, 0, 0, 0.49);\n"])));
var Disclaimer = styled.div(_templateObject4$A || (_templateObject4$A = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  a {\n    color: ", ";\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
});
var Rank = styled.span(_templateObject5$p || (_templateObject5$p = _taggedTemplateLiteralLoose(["\n  width: 1.8em;\n  height: 1.8em;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-image: url('https://cdn.rbi.digital/hockey/icon_badge_gold.svg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  padding-top: 2px;\n  font-weight: 800;\n  color: ", ";\n  margin-right: ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.black;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacings.kilo;
});

var CurrentCard = function CurrentCard(_ref6) {
  var prizes = _ref6.prizes,
      analyticsTitle = _ref6.analyticsTitle,
      heatStreak = _ref6.heatStreak,
      props = _objectWithoutPropertiesLoose(_ref6, _excluded$n);

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      config = _useSelector.config;

  var env = config.env,
      platform = config.platform;

  var handleDisclaimerClickAnalytics = function handleDisclaimerClickAnalytics() {
    fireMessageEvent({
      platform: platform,
      env: env,
      title: analyticsTitle
    });
  };

  var challengeDisclaimer = props.challengeDisclaimer;
  return /*#__PURE__*/React.createElement(ChallengeCard, props, prizes && /*#__PURE__*/React.createElement(PrizeList, null, prizes.map(function (prize, i) {
    return /*#__PURE__*/React.createElement(PrizeItem, {
      key: i
    }, /*#__PURE__*/React.createElement(Rank, null, i + 1), /*#__PURE__*/React.createElement(PrizeDesc, {
      size: "giga"
    }, prize));
  })), heatStreak, analyticsTitle ? /*#__PURE__*/React.createElement(Disclaimer, {
    onClick: handleDisclaimerClickAnalytics
  }, challengeDisclaimer) : /*#__PURE__*/React.createElement(Disclaimer, null, challengeDisclaimer));
};

CurrentCard.propTypes = {
  title: propTypes.string,
  dates: propTypes.string,
  logosSrc: propTypes.arrayOf(propTypes.shape({
    src: propTypes.string,
    width: propTypes.string
  })),
  sponsorText: propTypes.string,
  prizes: propTypes.arrayOf(propTypes.string),
  analyticsTitle: propTypes.string,
  heatStreak: propTypes.elementType
};

var _templateObject$19, _templateObject2$U;

var assetSet$3 = function assetSet(filename) {
  return getAssetSet(useCdnImage, filename);
};

var ChallengesContainer = styled.div(_templateObject$19 || (_templateObject$19 = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.sectionBg;
});
var ChallengeDisclaimer = styled(Text)(_templateObject2$U || (_templateObject2$U = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  color: ", ";\n  margin-top: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacings.giga;
});

var Challenges = function Challenges(_ref4) {
  var title = _ref4.title,
      blurb = _ref4.blurb,
      blurb2 = _ref4.blurb2,
      language = _ref4.language,
      disclaimer = _ref4.disclaimer,
      playOffTitle = _ref4.playOffTitle,
      playOffText = _ref4.playOffText,
      playoffPrizes = _ref4.playoffPrizes,
      playOffComingSoonTitle = _ref4.playOffComingSoonTitle,
      playOffComingSoonText = _ref4.playOffComingSoonText,
      seasonPrizes = _ref4.seasonPrizes,
      seasonText = _ref4.seasonText,
      seasonTitle = _ref4.seasonTitle,
      monthlyChallengeTitle = _ref4.monthlyChallengeTitle,
      monthlyPrizes = _ref4.monthlyPrizes,
      monthlyText = _ref4.monthlyText;
  var theme = useTheme();

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      leaderboard = _useSelector.leaderboard;

  var isCurrentlyPlayoffs = leaderboard.isCurrentlyPlayoffs,
      isCurrentlySeason = leaderboard.isCurrentlySeason;
  var seasonCardProps = {
    title: seasonTitle,
    logosSrc: [{
      src: "2025-2026_Season_Prize.png",
      width: '100%'
    }],
    challengeDisclaimer: /*#__PURE__*/React.createElement(ChallengeDisclaimer, null, disclaimer),
    background: theme.colors.darkBg + " no-repeat top / 100% 266px url(" + assetSet$3('challengeCardBackground') + ")",
    sponsorText: seasonText,
    prizes: seasonPrizes,
    noPadding: true
  };
  var monthlyCardProps = {
    title: monthlyChallengeTitle,
    logosSrc: [{
      src: "2026_monthly_prizes_" + language + ".png",
      width: '100%'
    }],
    background: theme.colors.darkBg + " no-repeat top / 100% 163px url( " + assetSet$3('challengeCardHeader') + ")",
    challengeDisclaimer: /*#__PURE__*/React.createElement(ChallengeDisclaimer, null, disclaimer),
    prizes: monthlyPrizes,
    spacingTop: true,
    hasDivider: true
  };
  var playOffsComingSoonCardProps = {
    title: playOffComingSoonTitle,
    logosSrc: [{
      src: "2024_Stanley_Cup.png",
      width: '35%'
    }],
    background: theme.colors.darkBg + " no-repeat top / 100% 366px url( " + assetSet$3('challengeCardBackground') + ")",
    sponsorText: playOffComingSoonText,
    analyticsTitle: GAME_INFO_TERMS_AND_CONDITIONS_CLICKED,
    spacingTopSmall: true
  };
  var playOffsCurrentCardProps = {
    title: playOffTitle,
    logosSrc: [{
      src: "2025_Playoffs_Prize_" + language + ".png",
      width: '100%'
    }],
    challengeDisclaimer: /*#__PURE__*/React.createElement(ChallengeDisclaimer, null, disclaimer),
    background: theme.colors.darkBg + " no-repeat top / 100% 266px url( " + assetSet$3('challengeCardBackground') + ")",
    sponsorText: playOffText,
    prizes: playoffPrizes,
    analyticsTitle: GAME_INFO_TERMS_AND_CONDITIONS_CLICKED
  };
  return /*#__PURE__*/React.createElement(ChallengesContainer, null, /*#__PURE__*/React.createElement(Spacing, null, /*#__PURE__*/React.createElement(SectionTitle, {
    text: title,
    size: "deca",
    shadow: true
  })), /*#__PURE__*/React.createElement(Spacing, {
    sizeLeft: "peta",
    sizeRight: "peta",
    sizeTop: "giga"
  }, /*#__PURE__*/React.createElement(Text, {
    centered: true,
    size: "tera",
    noMargin: true
  }, blurb), /*#__PURE__*/React.createElement(Spacing, {
    sizeTop: "giga"
  }), /*#__PURE__*/React.createElement(Text, {
    centered: true,
    size: "tera",
    noMargin: true
  }, blurb2)), isCurrentlySeason ? /*#__PURE__*/React.createElement(Spacing, {
    sizeLeft: "mega",
    sizeRight: "mega"
  }, /*#__PURE__*/React.createElement(Spacing, {
    sizeTop: "mega",
    paddingBottom: "giga"
  }, /*#__PURE__*/React.createElement(CurrentCard, _extends({}, seasonCardProps, {
    active: isCurrentlySeason
  }))), /*#__PURE__*/React.createElement(Spacing, {
    sizeTop: "mega",
    paddingBottom: "giga"
  }, /*#__PURE__*/React.createElement(CurrentCard, _extends({}, monthlyCardProps, {
    sponsorText: monthlyText,
    active: isCurrentlySeason
  }))), /*#__PURE__*/React.createElement(Spacing, {
    sizeTop: "mega",
    paddingBottom: "giga"
  }, /*#__PURE__*/React.createElement(CurrentCard, _extends({}, playOffsComingSoonCardProps, {
    noBadge: true
  })))) : /*#__PURE__*/React.createElement(Spacing, {
    sizeLeft: "mega",
    sizeRight: "mega",
    paddingBottom: "giga",
    paddingTop: "giga"
  }, /*#__PURE__*/React.createElement(CurrentCard, _extends({}, playOffsCurrentCardProps, {
    active: isCurrentlyPlayoffs
  }))));
};

Challenges.propTypes = {
  title: propTypes.string,
  blurb: propTypes.string,
  blurb2: propTypes.string,
  challenge1Src: propTypes.string
};

var mapStateToProps$4 = function mapStateToProps(state) {
  var strings = state.strings,
      config = state.config;
  var language = config.language;
  var allStrings = {
    title: strings['titles/section/challenges/text'],
    blurb: strings['challenges/blurb/text/line/1'],
    blurb2: strings['challenges/blurb/text/line/2'],
    dates: strings['challenges/dates'],
    pasts: strings['challenges/pasts'],
    disclaimer: strings['challenges/footer/disclaimer'],
    playOffTitle: strings['challenges/playoff/title'],
    playOffText: strings['challenges/playoff/text'],
    playoffPrizes: strings['challenges/playoffs/prizes'],
    playOffComingSoonTitle: strings['challenges/playoffcomingsoon/title'],
    playOffComingSoonText: strings['challenges/playoffcomingsoon/text'],
    playoffComingSoonPrizes: strings['challenges/playoffscomingsoon/prizes'],
    monthlyChallengeTitle: strings['challenges/monthly/title'],
    monthlyPrizes: strings['challenges/prizes'],
    seasonTitle: strings['challenges/season/title'],
    seasonText: strings['challenges/season/text'],
    seasonPrizes: strings['challenges/season/prizes'],
    monthlyText: strings['challenges/text']
  };
  return _extends({}, allStrings, {
    language: language
  });
};

var Challenges$1 = connect(mapStateToProps$4)(Challenges);

var _templateObject$1a, _templateObject2$V;

var baseStyles$z = function baseStyles() {
  return css(_templateObject$1a || (_templateObject$1a = _taggedTemplateLiteralLoose(["\n  margin: 0 auto;\n"])));
};

var inactiveStyles = function inactiveStyles(_ref) {
  var inactive = _ref.inactive;
  return inactive && css(_templateObject2$V || (_templateObject2$V = _taggedTemplateLiteralLoose(["\n    opacity: 0.4;\n  "])));
};

var Container$y = styled('div')(baseStyles$z, inactiveStyles);

var GameItem = function GameItem(_ref2) {
  var children = _ref2.children,
      inactive = _ref2.inactive;
  return /*#__PURE__*/React.createElement(Container$y, {
    inactive: inactive
  }, children);
};

GameItem.propTypes = {
  children: propTypes.node,
  inactive: propTypes.bool
};

var _templateObject$1b, _templateObject2$W;

var containerBaseStyles$f = function containerBaseStyles() {
  return css(_templateObject$1b || (_templateObject$1b = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n\n  p {\n    margin: 0;\n  }\n"])));
};

var Container$z = styled('div')(containerBaseStyles$f);

var imageWrapperBaseStyles$3 = function imageWrapperBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$W || (_templateObject2$W = _taggedTemplateLiteralLoose(["\n  max-width: 25px;\n  margin-right: ", ";\n"])), theme.spacings["byte"]);
};

var ImageWrapper$3 = styled('div')(imageWrapperBaseStyles$3);

var GameBuilder = function GameBuilder(_ref2) {
  var title = _ref2.title,
      gameList = _ref2.gameList,
      lastGameItemIndex = _ref2.lastGameItemIndex;
  return /*#__PURE__*/React.createElement(Container$z, null, /*#__PURE__*/React.createElement(Spacing, null, /*#__PURE__*/React.createElement(SectionTitle, {
    text: title
  })), /*#__PURE__*/React.createElement(Spacing, {
    sizeTop: "byte",
    sizeBottom: "byte",
    sizeLeft: "kilo",
    sizeRight: "kilo"
  }, gameList.map(function (_ref3, index) {
    var gameTime = _ref3.gameTime,
        gameStarted = _ref3.gameStarted,
        homeTeam = _ref3.homeTeam,
        awayTeam = _ref3.awayTeam;
    return /*#__PURE__*/React.createElement(GameItem, {
      key: index,
      inactive: gameStarted
    }, /*#__PURE__*/React.createElement(Spacing, {
      sizeTop: "bit",
      sizeBottom: "bit"
    }, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Col, {
      columns: "2"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "bit",
      bold: true
    }, gameTime)), /*#__PURE__*/React.createElement(Col, {
      columns: "1"
    }, /*#__PURE__*/React.createElement(ImageWrapper$3, null, /*#__PURE__*/React.createElement(Image, {
      src: awayTeam.teamLogo,
      alt: awayTeam.teamName
    }))), /*#__PURE__*/React.createElement(Col, {
      columns: "3"
    }, /*#__PURE__*/React.createElement(Text, null, awayTeam.teamName)), /*#__PURE__*/React.createElement(Col, {
      columns: "1"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "kilo"
    }, "@")), /*#__PURE__*/React.createElement(Col, {
      columns: "1"
    }, /*#__PURE__*/React.createElement(ImageWrapper$3, null, /*#__PURE__*/React.createElement(Image, {
      src: homeTeam.teamLogo,
      alt: homeTeam.teamName
    }))), /*#__PURE__*/React.createElement(Col, {
      columns: "3"
    }, /*#__PURE__*/React.createElement(Text, null, homeTeam.teamName)))), lastGameItemIndex !== index && /*#__PURE__*/React.createElement(Divider, null));
  })));
};

GameBuilder.propTypes = {
  title: propTypes.string,
  lastGameItemIndex: propTypes.number,
  gameList: propTypes.array
};

var mapStateToProps$5 = function mapStateToProps(state) {
  var config = state.config,
      strings = state.strings,
      games = state.games;
  var language = config.language;
  var allStrings = {
    title: strings['titles/section/games/text']
  };

  var getTeamDetails = function getTeamDetails(team) {
    return {
      teamName: (team === null || team === void 0 ? void 0 : team.name) || 'team 1',
      teamCity: (team === null || team === void 0 ? void 0 : team.city) || 'city 1',
      teamLogo: (team === null || team === void 0 ? void 0 : team.logo) || ''
    };
  };

  var gameList = games.all.map(function (_ref4) {
    var startTime = _ref4.startTime,
        started = _ref4.started,
        teams = _ref4.teams,
        venue = _ref4.venue;
    var gameTime = getFormattedTimestamp(startTime, language);
    var gameStarted = started;
    var homeTeam = getTeamDetails(teams.home);
    var awayTeam = getTeamDetails(teams.away);
    return {
      gameTime: gameStarted ? strings['global/games/status/started/text'] : gameTime,
      gameStarted: gameStarted,
      homeTeam: homeTeam,
      awayTeam: awayTeam,
      venue: venue
    };
  });
  return _extends({}, allStrings, {
    gameList: gameList,
    lastGameItemIndex: gameList.length - 1
  });
};

var Games = connect(mapStateToProps$5)(GameBuilder);

var slotItemBuilder = function slotItemBuilder(_ref) {
  var playerData = _ref.playerData,
      teamData = _ref.teamData,
      defaultAssetUrl = _ref.defaultAssetUrl;
  return function (id, isPlaceholder) {
    var _playerData$id = playerData[id],
        subText = _playerData$id.fullName,
        image = _playerData$id.image,
        teamId = _playerData$id.teamId,
        number = _playerData$id.number,
        position = _playerData$id.position;

    if (!teamData[teamId]) {
      return {
        id: null,
        subText: null,
        text: null
      };
    }

    var _teamData$teamId = teamData[teamId],
        abbr = _teamData$teamId.abbr,
        logo = _teamData$teamId.logo;
    var teamAbbr = abbr && abbr + " -";
    var text = teamAbbr + " #" + number + " - " + position;
    var assetUrl = image && image || defaultAssetUrl;
    var secondaryAssetUrl = logo && logo || defaultAssetUrl;
    return {
      id: id,
      subText: subText,
      text: text,
      assetUrl: !isPlaceholder && assetUrl,
      secondaryAssetUrl: !isPlaceholder && secondaryAssetUrl
    };
  };
};
var PLAYER_UNAVAILABLE_ERROR_CODES = ['hc.30', 'hc.8'];
var isPlayerUnavailableError = function isPlayerUnavailableError(error) {
  if (!(error !== null && error !== void 0 && error.code) || typeof error.code !== 'string') {
    return false;
  }

  return PLAYER_UNAVAILABLE_ERROR_CODES.includes(error.code);
};

var Slot = function Slot(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(Spacing, {
    sizeBottom: "byte"
  }, /*#__PURE__*/React.createElement(CardWithDrawer, props));
};

var mapStateToProps$6 = function mapStateToProps(state, ownProps) {
  var slotId = ownProps.slotId,
      drawerOpen = ownProps.drawerOpen,
      defaultAssetUrl = ownProps.defaultAssetUrl,
      isPlaceholder = ownProps.isPlaceholder;
  var picks = state.picks,
      players = state.players,
      teams = state.teams;
  var byTeamId = teams.byTeamId;
  var byPlayerId = players.byPlayerId,
      bySlotId = players.bySlotId,
      playersPicked = players.playersPicked;
  var picked = picks.picked;
  var playerId = picked[slotId];
  var playersBySlot = bySlotId[slotId];
  var slotBuilder = slotItemBuilder({
    playerData: byPlayerId,
    teamData: byTeamId,
    defaultAssetUrl: defaultAssetUrl
  });

  if (playersPicked) {
    return _extends({}, slotBuilder(playerId, isPlaceholder), {
      id: slotId,
      items: []
    });
  }

  var items = playersBySlot ? playersBySlot.map(function (_ref2) {
    var id = _ref2.id;
    return slotBuilder(id);
  }) : [];

  if (!drawerOpen && playerId) {
    return _extends({}, slotBuilder(playerId, isPlaceholder), {
      id: slotId,
      items: items
    });
  }

  return {
    items: items
  };
};

var Slot$1 = connect(mapStateToProps$6)(Slot);

var _templateObject$1c, _templateObject2$X, _templateObject3$K, _templateObject4$B, _templateObject5$q, _templateObject6$k, _templateObject7$f, _templateObject8$c, _templateObject9$8;
var fixAll$3 = fixAll,
    flexStack$5 = flexStack,
    flexCenter$e = flexCenter;
var Container$A = styled.div(_templateObject$1c || (_templateObject$1c = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  z-index: ", ";\n  padding: 0 24px;\n  touch-action: none;\n  -webkit-overflow-scrolling: touch;\n"])), fixAll$3(), flexCenter$e(), function (_ref) {
  var theme = _ref.theme;
  return theme.zIndex.modal;
});
var Backdrop$1 = styled.div(_templateObject2$X || (_templateObject2$X = _taggedTemplateLiteralLoose(["\n  ", "\n  padding: 0 24px;\n  background-color: ", ";\n  opacity: 0.66;\n"])), fixAll$3(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.b400;
});
var Wrapper$6 = styled.div(_templateObject3$K || (_templateObject3$K = _taggedTemplateLiteralLoose(["\n  ", "\n  background: ", ";\n  z-index: ", ";\n  border-radius: ", ";\n  width: 100%;\n  max-width: 375px;\n  padding: ", ";\n"])), flexStack$5(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.n300;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.zIndex.modalbox;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadius.peta;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacings.giga;
});
var ModalPrimary$2 = styled.div(_templateObject4$B || (_templateObject4$B = _taggedTemplateLiteralLoose(["\n  ", "\n  width: 100%;\n"])), flexStack$5());
var MainHeading$1 = styled(Heading)(_templateObject5$q || (_templateObject5$q = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-size: ", ";\n  font-weight: bold;\n  margin: 0 0 ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.text.zetta.fontSize;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.spacings.mega;
});
var BodyText = styled(Text)(_templateObject6$k || (_templateObject6$k = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-size: 15px;\n  color: ", ";\n  line-height: 18px;\n  margin-bottom: ", ";\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.b100;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.spacings.giga;
});
var ButtonContainer$1 = styled.div(_templateObject7$f || (_templateObject7$f = _taggedTemplateLiteralLoose(["\n  ", "\n  width: 100%;\n  gap: 12px;\n"])), flexStack$5());
var LeaveButton = styled(Button)(_templateObject8$c || (_templateObject8$c = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  background: ", ";\n  border: none;\n  color: ", ";\n  border-radius: ", ";\n  padding: ", " ", ";\n  font-weight: ", ";\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.r500;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.n300;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.borderRadius.giga;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.spacings.kilo;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.spacings.mega;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontStack.bold.weight;
});
var CancelButton = styled(Button)(_templateObject9$8 || (_templateObject9$8 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  background: transparent;\n  border: 2px solid ", ";\n  color: ", ";\n  border-radius: ", ";\n  padding: ", " ", ";\n  font-weight: ", ";\n"])), function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.b200;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.b400;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.borderRadius.giga;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.spacings.kilo;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.spacings.mega;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.fontStack.bold.weight;
});

var IncompletePicksModal = function IncompletePicksModal(_ref23) {
  var title = _ref23.title,
      text = _ref23.text,
      leaveButtonText = _ref23.leaveButtonText,
      cancelButtonText = _ref23.cancelButtonText,
      onLeave = _ref23.onLeave,
      onCancel = _ref23.onCancel,
      leaveAriaLabel = _ref23.leaveAriaLabel,
      cancelAriaLabel = _ref23.cancelAriaLabel;
  return /*#__PURE__*/React.createElement(Container$A, {
    onClick: onCancel
  }, /*#__PURE__*/React.createElement(Backdrop$1, null), /*#__PURE__*/React.createElement(Wrapper$6, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/React.createElement(ModalPrimary$2, null, /*#__PURE__*/React.createElement(MainHeading$1, {
    noMarginBottom: true
  }, title), /*#__PURE__*/React.createElement(BodyText, {
    noMargin: true
  }, text), /*#__PURE__*/React.createElement(ButtonContainer$1, null, /*#__PURE__*/React.createElement(LeaveButton, {
    variant: "primary",
    "aria-label": leaveAriaLabel,
    onSelect: onLeave
  }, leaveButtonText), /*#__PURE__*/React.createElement(CancelButton, {
    variant: "secondary",
    "aria-label": cancelAriaLabel,
    onSelect: onCancel
  }, cancelButtonText)))));
};

IncompletePicksModal.propTypes = {
  title: propTypes.string,
  text: propTypes.string,
  leaveButtonText: propTypes.string,
  cancelButtonText: propTypes.string,
  onLeave: propTypes.func,
  onCancel: propTypes.func,
  leaveAriaLabel: propTypes.string,
  cancelAriaLabel: propTypes.string
};

var _templateObject$1d, _templateObject2$Y, _templateObject3$L, _templateObject4$C;
var disableVisually$3 = disableVisually;

var baseStyles$A = function baseStyles() {
  return css(_templateObject$1d || (_templateObject$1d = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  width: 100%;\n  text-align: right;\n"])));
};

var submittedStyles$1 = function submittedStyles(_ref) {
  var theme = _ref.theme,
      isSubmitted = _ref.isSubmitted;
  return isSubmitted && css(_templateObject2$Y || (_templateObject2$Y = _taggedTemplateLiteralLoose(["\n    margin-bottom: 0;\n    padding: 0 ", ";\n  "])), theme.spacings.mega);
};

var Container$B = styled('div')(baseStyles$A, submittedStyles$1);

var confirmRowBaseStyles = function confirmRowBaseStyles(_ref2) {
  var theme = _ref2.theme,
      adRendered = _ref2.adRendered,
      btnEnabled = _ref2.btnEnabled;
  return css(_templateObject3$L || (_templateObject3$L = _taggedTemplateLiteralLoose(["\n    color: ", ";\n    margin-bottom: ", ";\n    width: 100%;\n  "])), theme.colors.b900, adRendered && !btnEnabled ? 0 : theme.spacings.mega);
};

var ConfirmRow = styled('div')(confirmRowBaseStyles);

var submitButtonStyles = function submitButtonStyles(_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject4$C || (_templateObject4$C = _taggedTemplateLiteralLoose(["\n  font-size: 18px;\n  &:disabled,\n  &[disabled] {\n    ", ";\n    background: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n"])), disableVisually$3(), theme.colors.n400, theme.colors.n400, theme.colors.b300);
};

var StyledSubmitButton = styled(SubmitButton)(submitButtonStyles);

var ConfirmPicks = function ConfirmPicks(_ref4) {
  var buttonText = _ref4.buttonText,
      isSubmitted = _ref4.isSubmitted,
      btnEnabled = _ref4.btnEnabled,
      handlePickSubmission = _ref4.handlePickSubmission,
      adRendered = _ref4.adRendered,
      platform = _ref4.platform,
      picks = _ref4.picks,
      incompletePicksModalOpen = _ref4.incompletePicksModalOpen,
      handleIncompletePicksModalClose = _ref4.handleIncompletePicksModalClose,
      incompletePicksTitle = _ref4.incompletePicksTitle,
      incompletePicksText = _ref4.incompletePicksText,
      incompletePicksLeaveButtonText = _ref4.incompletePicksLeaveButtonText,
      incompletePicksCancelButtonText = _ref4.incompletePicksCancelButtonText,
      incompletePicksLeaveAriaLabel = _ref4.incompletePicksLeaveAriaLabel,
      incompletePicksCancelAriaLabel = _ref4.incompletePicksCancelAriaLabel,
      pendingNavigation = _ref4.pendingNavigation,
      handleModalLeave = _ref4.handleModalLeave,
      handleModalCancel = _ref4.handleModalCancel;
  return /*#__PURE__*/React.createElement(Container$B, {
    isSubmitted: isSubmitted
  }, /*#__PURE__*/React.createElement(ConfirmRow, {
    adRendered: adRendered,
    btnEnabled: btnEnabled
  }, /*#__PURE__*/React.createElement(Spacing, {
    sizeLeft: "zetta",
    sizeRight: "zetta"
  }, /*#__PURE__*/React.createElement(StyledSubmitButton, {
    variant: "primary",
    text: buttonText,
    disabled: !btnEnabled,
    onSelect: function onSelect() {
      fireMessageEvent({
        type: 'LOG',
        platform: platform,
        title: 'Submit Picks Button Clicked',
        data: {
          element: 'button',
          element_name: "Submit Picks",
          picks: picks
        }
      });
      handlePickSubmission();
    },
    stretch: true
  }))), incompletePicksModalOpen && /*#__PURE__*/React.createElement(IncompletePicksModal, {
    title: incompletePicksTitle,
    text: incompletePicksText,
    leaveButtonText: incompletePicksLeaveButtonText,
    cancelButtonText: incompletePicksCancelButtonText,
    onLeave: pendingNavigation ? handleModalLeave : handleIncompletePicksModalClose,
    onCancel: pendingNavigation ? handleModalCancel : handleIncompletePicksModalClose,
    leaveAriaLabel: incompletePicksLeaveAriaLabel,
    cancelAriaLabel: incompletePicksCancelAriaLabel
  }));
};

ConfirmPicks.propTypes = {
  buttonText: propTypes.string,
  confirmText: propTypes.string,
  btnEnabled: propTypes.bool,
  isSubmitting: propTypes.bool,
  isSubmitted: propTypes.bool,
  isLarge: propTypes.bool,
  isActive: propTypes.bool,
  handlePickSubmission: propTypes.func,
  adRendered: propTypes.bool,
  platform: propTypes.string,
  picks: propTypes.object,
  incompletePicksModalOpen: propTypes.bool,
  handleIncompletePicksModalClose: propTypes.func,
  incompletePicksTitle: propTypes.string,
  incompletePicksText: propTypes.string,
  incompletePicksLeaveButtonText: propTypes.string,
  incompletePicksCancelButtonText: propTypes.string,
  incompletePicksLeaveAriaLabel: propTypes.string,
  incompletePicksCancelAriaLabel: propTypes.string,
  pendingNavigation: propTypes.string,
  handleModalLeave: propTypes.func,
  handleModalCancel: propTypes.func
};
ConfirmPicks.defaultProps = {
  btnEnabled: true,
  isSubmitted: false,
  isLarge: true,
  isActive: false,
  adRendered: false
};

var mapStateToProps$7 = function mapStateToProps(state) {
  var strings = state.strings,
      picks = state.picks,
      config = state.config;
  var platform = config.platform;
  var picked = picks.picked,
      slotCount = picks.slotCount,
      incompletePicksModalOpen = picks.incompletePicksModalOpen,
      pendingNavigation = picks.pendingNavigation;
  var slotsPicked = Object.keys(picked).map(function (id) {
    return picked[id];
  }).filter(function (id) {
    return id;
  });
  var allSlotsPicked = slotsPicked.length === slotCount;
  var allStrings = {
    buttonText: strings['button/confirmPlayers/text'],
    confirmText: strings['notifications/confirmPicks/text'],
    incompletePicksTitle: strings['notifications/incompletePicks/title'],
    incompletePicksText: strings['notifications/incompletePicks/text'],
    incompletePicksLeaveButtonText: strings['notifications/incompletePicks/leaveButton'],
    incompletePicksCancelButtonText: strings['notifications/incompletePicks/cancelButton'],
    incompletePicksLeaveAriaLabel: strings['roles/button/close/aria'],
    incompletePicksCancelAriaLabel: strings['roles/button/close/aria']
  };
  return _extends({}, allStrings, {
    btnEnabled: allSlotsPicked,
    platform: platform,
    picks: picks,
    incompletePicksModalOpen: incompletePicksModalOpen,
    pendingNavigation: pendingNavigation
  });
};

var mapDispatchToProps$4 = function mapDispatchToProps(dispatch) {
  return {
    handlePickSubmission: function handlePickSubmission(picks) {
      return dispatch(sendPlayerPicks());
    },
    handleIncompletePicksModalClose: function handleIncompletePicksModalClose() {
      return dispatch(setIncompletePicksModalToClosed());
    },
    handleModalLeave: function handleModalLeave$1() {
      return dispatch(handleModalLeave());
    },
    handleModalCancel: function handleModalCancel() {
      dispatch(clearPendingNavigation());
      dispatch(setIncompletePicksModalToClosed());
    }
  };
};

var ConfirmPicks$1 = connect(mapStateToProps$7, mapDispatchToProps$4)(ConfirmPicks);

var _templateObject$1e, _templateObject2$Z, _templateObject3$M, _templateObject4$D, _templateObject5$r, _templateObject6$l;

var containerBaseStyles$g = function containerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$1e || (_templateObject$1e = _taggedTemplateLiteralLoose(["\n  padding: ", " 0 ", " ", ";\n  background-color: ", ";\n  display: flex;\n  border-radius: 8px;\n  align-items: center;\n  margin: 1px ", " 32px ", ";\n"])), theme.spacings.mega, theme.spacings.mega, theme.spacings.kilo, theme.colors.bl100, theme.spacings.kilo, theme.spacings.kilo);
};

var Container$C = styled('div')(containerBaseStyles$g);

var styledHeadingBaseStyles$2 = function styledHeadingBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject2$Z || (_templateObject2$Z = _taggedTemplateLiteralLoose(["\n  font-size: 22px;\n  line-height: ", ";\n  letter-spacing: -1px;\n  padding-bottom: ", ";\n"])), theme.spacings.mega, theme.spacings.kilo);
};

var StyledHeading$3 = styled(Heading)(styledHeadingBaseStyles$2);

var bannerBaseStyles = function bannerBaseStyles() {
  return css(_templateObject3$M || (_templateObject3$M = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 2;\n  flex-direction: column;\n"])));
};

var Banner = styled('div')(bannerBaseStyles);

var graphicContainerBaseStyles = function graphicContainerBaseStyles() {
  return css(_templateObject4$D || (_templateObject4$D = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  margin-left: auto;\n"])));
};

var GraphicContainer = styled('div')(graphicContainerBaseStyles);

var assetSet$4 = function assetSet(filename) {
  return getAssetSet(useCdnImage, filename);
};

var styledDescriptionTextBaseStyles = function styledDescriptionTextBaseStyles(_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject5$r || (_templateObject5$r = _taggedTemplateLiteralLoose(["\n  line-height: 1;\n  margin-right: 50px;\n  padding-bottom: ", ";\n"])), theme.spacings.bit);
};

var StyledDescriptionText = styled(Text)(styledDescriptionTextBaseStyles);

var styledButtonBaseStyles$1 = function styledButtonBaseStyles(_ref4) {
  var theme = _ref4.theme;
  return css(_templateObject6$l || (_templateObject6$l = _taggedTemplateLiteralLoose(["\n  padding: ", " ", ";\n  border-radius: ", ";\n  border: none;\n  color: ", ";\n  margin-right: ", ";\n  text-align: left;\n  line-height: 1.2;\n"])), theme.spacings["byte"], theme.spacings.kilo, theme.spacings["byte"], theme.colors.bl100, theme.spacings.peta);
};

var StyledButton$2 = styled(Button)(styledButtonBaseStyles$1);

var AutoPicks = function AutoPicks(_ref5) {
  var handleAutoPickClick = _ref5.handleAutoPickClick,
      handleSetElementFocused = _ref5.handleSetElementFocused,
      playerCounts = _ref5.playerCounts,
      playerIds = _ref5.playerIds,
      playersBySlot = _ref5.playersBySlot,
      title = _ref5.title,
      text = _ref5.text,
      btnText = _ref5.btnText;
  return /*#__PURE__*/React.createElement(Container$C, null, /*#__PURE__*/React.createElement(Banner, null, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: "white"
  }, /*#__PURE__*/React.createElement(StyledHeading$3, {
    as: "h3",
    size: "giga",
    noMarginBoth: true,
    bold: true
  }, title)), /*#__PURE__*/React.createElement(Spacing, {
    sizeBottom: "bit"
  }, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: "white"
  }, /*#__PURE__*/React.createElement(StyledDescriptionText, {
    size: "giga",
    noMargin: true
  }, text))), /*#__PURE__*/React.createElement(StyledButton$2, {
    size: "giga",
    variant: "tertiary",
    onSelect: function onSelect() {
      handleSetElementFocused({
        picks: true
      });
      handleAutoPickClick({
        playerCounts: playerCounts,
        playerIds: playerIds,
        playersBySlot: playersBySlot
      });
    }
  }, btnText)), /*#__PURE__*/React.createElement(GraphicContainer, null, /*#__PURE__*/React.createElement(Image, {
    src: assetSet$4('bannerAutoPicks')
  })));
};

AutoPicks.propTypes = {
  playerIds: propTypes.array,
  playersBySlot: propTypes.object,
  handleAutoPickClick: propTypes.func,
  handleSetElementFocused: propTypes.func,
  playerCounts: propTypes.object,
  title: propTypes.string,
  text: propTypes.string,
  btnText: propTypes.string
};

var mapStateToProps$8 = function mapStateToProps(state) {
  var strings = state.strings,
      reminders = state.reminders,
      players = state.players;
  var isActive = reminders.isActive;
  var playerCounts = players.bySlotPlayerCount,
      byPlayerId = players.byPlayerId,
      bySlotId = players.bySlotId;
  var allStrings = {
    title: strings['banners/gameInfo/autoPicks/title'],
    text: strings['banners/gameInfo/autoPicks/text'],
    btnText: strings['button/autoPicks/text']
  };
  return _extends({}, allStrings, {
    isActive: isActive,
    playerCounts: playerCounts,
    playerIds: Object.keys(byPlayerId),
    playersBySlot: bySlotId
  });
};

var mapDispatchToProps$5 = function mapDispatchToProps(dispatch) {
  return {
    handleAutoPickClick: function handleAutoPickClick(props) {
      return dispatch(setRandomPlayerPicks(props));
    },
    handleSetElementFocused: function handleSetElementFocused(element) {
      return dispatch(setElementFocused(element));
    }
  };
};

var AutoPicks$1 = connect(mapStateToProps$8, mapDispatchToProps$5)(AutoPicks);

var _templateObject$1f, _templateObject2$_;

var containerBaseStyles$h = function containerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$1f || (_templateObject$1f = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 ", ";\n"])), theme.spacings.zetta);
};

var Container$D = styled('div')(containerBaseStyles$h);

var reminderSwitchBaseStyles$1 = function reminderSwitchBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject2$_ || (_templateObject2$_ = _taggedTemplateLiteralLoose(["\n  margin-right: ", ";\n"])), theme.spacings.kilo);
};

var ReminderSwitch$1 = styled('div')(reminderSwitchBaseStyles$1);

var Reminders = function Reminders(_ref3) {
  var isActive = _ref3.isActive,
      text = _ref3.text,
      handleReminderStatus = _ref3.handleReminderStatus,
      reminderHasUpdated = _ref3.reminderHasUpdated;
  return /*#__PURE__*/React.createElement(Spacing, {
    sizeTop: "giga",
    sizeBottom: "giga"
  }, /*#__PURE__*/React.createElement(Container$D, null, /*#__PURE__*/React.createElement(ReminderSwitch$1, {
    onClick: function onClick() {
      return handleReminderStatus(!isActive, !reminderHasUpdated);
    }
  }, /*#__PURE__*/React.createElement(ToggleSwitch, {
    isActive: isActive
  })), /*#__PURE__*/React.createElement(Text, {
    size: "mega",
    noMargin: true
  }, text)));
};

Reminders.propTypes = {
  handleReminderStatus: propTypes.func,
  isActive: propTypes.bool,
  text: propTypes.string,
  reminderHasUpdated: propTypes.bool
};

var mapStateToProps$9 = function mapStateToProps(state) {
  var strings = state.strings,
      reminders = state.reminders;
  var isActive = reminders.isActive,
      reminderHasUpdated = reminders.reminderHasUpdated;
  var allStrings = {
    text: strings['notifications/reminders/text']
  };
  return _extends({}, allStrings, {
    isActive: isActive,
    reminderHasUpdated: reminderHasUpdated
  });
};

var mapDispatchToProps$6 = function mapDispatchToProps(dispatch) {
  return {
    handleReminderStatus: function handleReminderStatus(status) {
      return dispatch(sendNotificationStatus(status));
    }
  };
};

var Reminders$1 = connect(mapStateToProps$9, mapDispatchToProps$6)(Reminders);

var _excluded$o = ["id"];

var _templateObject$1g, _templateObject2$$;
var containerBaseStyles$i = function containerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$1g || (_templateObject$1g = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid ", ";\n"])), theme.colors.n500);
};
var Container$E = styled('div')(containerBaseStyles$i);

var styledTextBlockBaseStyles = function styledTextBlockBaseStyles() {
  return css(_templateObject2$$ || (_templateObject2$$ = _taggedTemplateLiteralLoose(["\n  padding: 0 20px;\n  font-size: 12px;\n"])));
};

var StyledTextBlock = styled(TextBlock)(styledTextBlockBaseStyles);

var assetSet$5 = function assetSet(filename) {
  return getAssetSet(useCdnImage, filename);
};

var Picks = function Picks(_ref2) {
  var isPlaceholder = _ref2.isPlaceholder,
      isPicksFocused = _ref2.isPicksFocused,
      randomPicksSelected = _ref2.randomPicksSelected,
      pickClicked = _ref2.pickClicked,
      title = _ref2.title,
      slots = _ref2.slots,
      slotOpenId = _ref2.slotOpenId,
      picked = _ref2.picked,
      isSubmitted = _ref2.isSubmitted,
      termsText = _ref2.termsText,
      successText = _ref2.successText,
      handleSlotClick = _ref2.handleSlotClick,
      handlePlayerPickClick = _ref2.handlePlayerPickClick,
      handlePlaceholderState = _ref2.handlePlaceholderState,
      handleSlotClose = _ref2.handleSlotClose,
      showScoutPicks = _ref2.showScoutPicks,
      showReminders = _ref2.showReminders,
      submissionError = _ref2.submissionError,
      strings = _ref2.strings,
      handleClearSubmissionError = _ref2.handleClearSubmissionError,
      confirmText = _ref2.confirmText,
      allSlotsPicked = _ref2.allSlotsPicked;
  var defaultAssetUrl = assetSet$5(['hockeySticksSmall']);
  useEffect(function () {
    if (!isPicksFocused || !isPlaceholder[1] || !isPlaceholder[2] || !isPlaceholder[3]) {
      return;
    }

    if (slotOpenId) {
      handleSlotClose(slotOpenId);
    }

    setTimeout(function () {
      return handlePlaceholderState(1);
    }, 400);
    setTimeout(function () {
      return handlePlaceholderState(2);
    }, 1100);
    setTimeout(function () {
      return handlePlaceholderState(3);
    }, 1700);
  }, [isPicksFocused, randomPicksSelected, isPlaceholder]);
  useEffect(function () {
    if (!isPicksFocused || !slotOpenId || !pickClicked) {
      return;
    }

    handleSlotClose(slotOpenId);
  }, [slotOpenId, isPicksFocused, pickClicked]);
  var isPlayerUnavailable = isPlayerUnavailableError(submissionError);
  var errorTitle = isPlayerUnavailable ? strings['notifications/submission/badPlayerData/title'] : strings['notifications/picks/submission/error/title'];
  var errorMessage = isPlayerUnavailable ? strings['notifications/submission/badPlayerData/text'] : strings['notifications/picks/submission/error/text'];
  var errorButtonText = strings['notifications/errormodal/button'];
  return /*#__PURE__*/React.createElement(Container$E, null, /*#__PURE__*/React.createElement(Spacing, {
    sizeBottom: "mega"
  }, /*#__PURE__*/React.createElement(SectionTitle, {
    text: title
  })), isSubmitted && /*#__PURE__*/React.createElement(Spacing, {
    sizeBottom: "mega",
    sizeLeft: "kilo",
    sizeRight: "kilo"
  }, /*#__PURE__*/React.createElement(AlertBanner, {
    text: successText
  })), /*#__PURE__*/React.createElement(Spacing, {
    sizeLeft: "kilo",
    sizeRight: "kilo",
    sizeBottom: "mega"
  }, slots.map(function (_ref3) {
    var id = _ref3.id,
        props = _objectWithoutPropertiesLoose(_ref3, _excluded$o);

    return /*#__PURE__*/React.createElement(Slot$1, _extends({
      key: "slot-" + id,
      id: id,
      slotId: id,
      isPlaceholder: isPlaceholder[id],
      assetUrl: defaultAssetUrl,
      handleDrawerToggle: handleSlotClick,
      selectedItem: picked[id],
      drawerDefault: "closed",
      drawerOpen: id === slotOpenId,
      isSubmitted: isSubmitted,
      headerAssetHasPadding: !picked[id],
      handleItemClick: function handleItemClick(playerId) {
        handleSlotClose(id);
        return handlePlayerPickClick({
          id: id,
          playerId: playerId
        });
      }
    }, props));
  })), showScoutPicks && /*#__PURE__*/React.createElement(AutoPicks$1, null), showReminders && /*#__PURE__*/React.createElement(Reminders$1, null), !isSubmitted && /*#__PURE__*/React.createElement(Fragment$1, null, allSlotsPicked && !isSubmitted && /*#__PURE__*/React.createElement(Spacing, {
    sizeLeft: "bit",
    sizeRight: "bit"
  }, /*#__PURE__*/React.createElement(TextBlock, {
    noMargin: true,
    text: confirmText,
    align: "center",
    size: "kilo",
    bold: true
  })), /*#__PURE__*/React.createElement(Spacing, {
    sizeBottom: "mega"
  }, /*#__PURE__*/React.createElement(StyledTextBlock, {
    text: termsText,
    align: "center"
  })), /*#__PURE__*/React.createElement(Spacing, {
    sizeBottom: "giga"
  }, /*#__PURE__*/React.createElement(ConfirmPicks$1, null))), submissionError && /*#__PURE__*/React.createElement(Modal$1, {
    title: errorTitle,
    message: errorMessage,
    buttonText: errorButtonText,
    onClose: handleClearSubmissionError
  }));
};

Picks.propTypes = {
  isPlaceholder: propTypes.object,
  adConfig: propTypes.object,
  isPicksFocused: propTypes.bool,
  randomPicksSelected: propTypes.bool,
  pickClicked: propTypes.bool,
  scrollPosition: propTypes.number,
  successText: propTypes.string,
  title: propTypes.string,
  termsText: propTypes.string,
  slots: propTypes.array,
  slotOpenId: propTypes.number,
  picked: propTypes.object,
  isSubmitted: propTypes.bool,
  handleSlotClick: propTypes.func,
  handlePlayerPickClick: propTypes.func,
  handlePlaceholderState: propTypes.func,
  handleSlotClose: propTypes.func,
  platform: propTypes.string,
  language: propTypes.string,
  submissionError: propTypes.object,
  strings: propTypes.object,
  handleClearSubmissionError: propTypes.func
};

var mapStateToProps$a = function mapStateToProps(state) {
  var strings = state.strings,
      picks = state.picks,
      players = state.players,
      ui = state.ui;
  var isPlaceholder = picks.isPlaceholder,
      picked = picks.picked,
      slotOpenId = picks.slotOpenId,
      picksLocked = picks.picksLocked,
      randomPickCount = picks.randomPickCount,
      randomPicksSelected = picks.randomPicksSelected,
      pickClicked = picks.pickClicked,
      submissionError = picks.submissionError;
  var playersPicked = players.playersPicked;
  var isFocused = ui.isFocused,
      componentSize = ui.componentSize,
      notificationBarOpen = ui.notificationBarOpen,
      isScrolling = ui.isScrolling;
  var picksScrollPosition = componentSize.picksScrollPosition;
  var withNotification = picksScrollPosition.withNotification,
      withoutNotification = picksScrollPosition.withoutNotification;
  var slotCount = picks.slotCount;
  var slotsPicked = Object.keys(picked).map(function (id) {
    return picked[id];
  }).filter(function (id) {
    return id;
  });
  var allSlotsPicked = slotsPicked.length === slotCount;
  var allStrings = {
    title: strings['titles/section/picks/text'],
    termsText: strings['global/termsAndPrivacy/text']('timhortons://terms-of-use', 'timhortons://privacy-policy'),
    submitBtnText: strings['button/confirmPlayers/text'],
    successText: strings['button/submitted/text'],
    confirmText: strings['notifications/confirmPicks/text']
  };
  var slots = [{
    id: 1,
    subText: strings['global/slots/playerSelect/text'],
    text: strings['global/slots/number/text'](1),
    showToggleIcon: true
  }, {
    id: 2,
    subText: strings['global/slots/playerSelect/text'],
    text: strings['global/slots/number/text'](2),
    showToggleIcon: true
  }, {
    id: 3,
    subText: strings['global/slots/playerSelect/text'],
    text: strings['global/slots/number/text'](3),
    showToggleIcon: true
  }];
  var scrollPosition = notificationBarOpen ? withNotification : withoutNotification;
  return _extends({}, allStrings, {
    isPlaceholder: isPlaceholder,
    scrollPosition: scrollPosition,
    isScrolling: isScrolling,
    slots: slots,
    slotOpenId: slotOpenId,
    picked: picked,
    randomPickCount: randomPickCount,
    randomPicksSelected: randomPicksSelected,
    pickClicked: pickClicked,
    isPicksFocused: isFocused.picks,
    isSubmitted: picksLocked || playersPicked,
    submissionError: submissionError,
    strings: strings,
    allSlotsPicked: allSlotsPicked
  });
};

var mapDispatchToProps$7 = function mapDispatchToProps(dispatch) {
  return {
    handleSlotClick: function handleSlotClick(id) {
      return dispatch(setSlotToOpen(id));
    },
    handleSlotClose: function handleSlotClose(id) {
      return dispatch(setSlotToClosed(id));
    },
    handlePlayerPickClick: function handlePlayerPickClick(props) {
      return dispatch(setPlayerToPicked(props));
    },
    handlePlaceholderState: function handlePlaceholderState(slotId) {
      return dispatch(setPlaceholderState(slotId));
    },
    handleClearSubmissionError: function handleClearSubmissionError() {
      return dispatch(clearSubmissionError());
    }
  };
};

var Picks$1 = connect(mapStateToProps$a, mapDispatchToProps$7)(Picks);

var setOfferClicked = function setOfferClicked() {
  return function (dispatch) {
    var _commonActions = common('offer_clicked'),
        setValue = _commonActions.setValue;

    dispatch(setValue());
  };
};

var _excluded$p = ["handleOfferClick"];

var _templateObject$1h;

var offerContentBaseStyles = function offerContentBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$1h || (_templateObject$1h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  color: ", ";\n  margin-top: ", ";\n"])), theme.colors.g500, theme.spacings["byte"]);
};

var OfferContent = styled('div')(offerContentBaseStyles);

var Offers = function Offers(_ref2) {
  var handleOfferClick = _ref2.handleOfferClick,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded$p);

  var isClicked = props.isClicked,
      promotions = props.promotions;

  var _useState = useState(''),
      redirected = _useState[0],
      setRedirected = _useState[1];

  useEffect(function () {
    if (isClicked) {
      window.location.href = redirected;
    }
  }, [isClicked, redirected]);

  var renderAdvertisingTiles = function renderAdvertisingTiles() {
    if (Object.values(promotions[0]).length > 1) {
      return promotions.map(function (promotion, index) {
        return /*#__PURE__*/React.createElement(AdvertisingTile, {
          key: index,
          onSelect: function onSelect() {
            handleOfferClick();
            setRedirected(promotion.goTo);
          },
          src: promotion.imgSrc,
          alt: promotion.altText
        });
      });
    }
  };

  return !(promotions !== null && promotions !== void 0 && promotions.length) ? null : /*#__PURE__*/React.createElement(Spacing, {
    sizeTop: "giga",
    sizeBottom: "giga",
    sizeLeft: "giga",
    sizeRight: "giga"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Heading, {
    as: "h3",
    noMarginBoth: true
  }, "Offers and Products"), /*#__PURE__*/React.createElement(OfferContent, null, renderAdvertisingTiles())));
};

Offers.propTypes = {
  handleOfferClick: propTypes.func
};

var mapStateToProps$b = function mapStateToProps(state) {
  var strings = state.strings,
      offers = state.offers;
  var allStrings = {
    text: strings['notifications/reminders/toggle/text']
  };
  return _extends({}, allStrings, offers);
};

var mapDispatchToProps$8 = function mapDispatchToProps(dispatch) {
  return {
    handleOfferClick: function handleOfferClick() {
      return dispatch(setOfferClicked());
    }
  };
};

var Offers$1 = connect(mapStateToProps$b, mapDispatchToProps$8)(Offers);

var useElementHeight = function useElementHeight(elementRef) {
  var el = elementRef.current;
  if (!el) return 0;
  var prevValue = Math.floor(el.getBoundingClientRect().height);
  var handle = setInterval(function () {
    var nextValue = Math.floor(el.getBoundingClientRect().height);

    if (nextValue === prevValue) {
      clearInterval(handle);
    } else {
      prevValue = nextValue;
    }
  }, 500);
  return prevValue;
};

var getNotificationText = function getNotificationText(strings, type, entity) {
  if (entity === void 0) {
    entity = 'games';
  }

  return {
    notificationBarTitle: strings["notifications/" + entity + "/" + type + "/title"],
    notificationBarText: strings["notifications/" + entity + "/" + type + "/text"]
  };
};

var _templateObject$1i, _templateObject2$10, _templateObject3$N, _templateObject4$E, _templateObject5$s, _templateObject6$m;
var Container$F = styled(ShadowBox)(_templateObject$1i || (_templateObject$1i = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: ", ";\n  height: 565px;\n  color: ", ";\n  text-align: center;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacings.giga;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
});
var CardHeader$2 = styled.div(_templateObject2$10 || (_templateObject2$10 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-top: ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacings.bit;
});
var NoChallengeTitle = styled(Heading)(_templateObject3$N || (_templateObject3$N = _taggedTemplateLiteralLoose(["\n  flex-grow: 1;\n  font-size: 28px;\n  width: 360px;\n  line-height: 1;\n"])));
var NoChallengeDescription = styled(Text)(_templateObject4$E || (_templateObject4$E = _taggedTemplateLiteralLoose(["\n  line-height: 25px;\n  text-align: center;\n  padding: 6px 24px 12px 24px;\n  span {\n    display: block;\n    margin-bottom: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    padding-bottom: ", ";\n    sup {\n      font-size: ", ";\n    }\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacings.atom;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.subHeadings.tera.fontSize;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.subHeadings.tera.fontSize;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacings.giga;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.headings.deca.fontSize;
});
var NoChallengeButton = styled(Button)(_templateObject5$s || (_templateObject5$s = _taggedTemplateLiteralLoose(["\n  min-width: 0;\n"])));
var NoChallengeImage = styled(Image)(_templateObject6$m || (_templateObject6$m = _taggedTemplateLiteralLoose(["\n  width: 200px;\n  margin: 16px 0 0 0;\n"])));

var NoChallengeCard = function NoChallengeCard(_ref9) {
  var handleHeatStreakPanelClick = _ref9.handleHeatStreakPanelClick;

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      strings = _useSelector.strings;

  var noChallengeTitle = strings['challenges/nochallenge/title'];
  var noChallengeDescription = strings['challenges/nochallenge/description'];
  var noChallengeButtonText = strings['challenges/nochallenge/buttonText'];
  var noChallengeImage = '2024_HockeySticks.svg';
  var theme = useTheme();
  var cdnUrl = useCdnUrl();
  return /*#__PURE__*/React.createElement(Container$F, {
    background: "" + theme.colors.headerBg
  }, /*#__PURE__*/React.createElement(CardHeader$2, null, /*#__PURE__*/React.createElement(NoChallengeTitle, {
    as: "h4",
    noMarginTop: true,
    noMarginBottom: true
  }, noChallengeTitle)), /*#__PURE__*/React.createElement(NoChallengeDescription, {
    size: "tera"
  }, noChallengeDescription), /*#__PURE__*/React.createElement(NoChallengeButton, {
    variant: "primary",
    onSelect: handleHeatStreakPanelClick,
    noMargin: true
  }, /*#__PURE__*/React.createElement(Text, {
    as: "h4",
    size: "peta",
    bold: true
  }, noChallengeButtonText)), /*#__PURE__*/React.createElement(NoChallengeImage, {
    src: "" + cdnUrl + noChallengeImage
  }));
};

NoChallengeCard.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]),
  background: propTypes.string,
  title: propTypes.string,
  dates: propTypes.string,
  logosSrc: propTypes.array,
  sponsorText: propTypes.string,
  active: propTypes.bool,
  noBadge: propTypes.bool
};

var mapDispatchToProps$9 = function mapDispatchToProps(dispatch) {
  return {
    handleHeatStreakPanelClick: function handleHeatStreakPanelClick() {
      return dispatch(setHeatStreakPanelToOpen());
    }
  };
};

var NoChallengeCard$1 = connect(null, mapDispatchToProps$9)(NoChallengeCard);

var _templateObject$1j, _templateObject2$11, _templateObject3$O, _templateObject4$F, _templateObject5$t, _templateObject6$n, _templateObject7$g;
var HeatStreakBannerWrapper = styled.div(_templateObject$1j || (_templateObject$1j = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-top: ", ";\n  padding: ", " ", " 0;\n  overflow: hidden;\n  background-image: url(", ");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacings.mega;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacings.mega;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacings.mega;
}, function (_ref4) {
  var backgroundImage = _ref4.backgroundImage;
  return backgroundImage;
});
var TextWrapper$5 = styled.div(_templateObject2$11 || (_templateObject2$11 = _taggedTemplateLiteralLoose(["\n  margin-left: ", ";\n  padding-bottom: ", ";\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacings.giga;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacings.mega;
});
var BannerImage = styled(Image)(_templateObject3$O || (_templateObject3$O = _taggedTemplateLiteralLoose(["\n  max-width: 100px;\n  box-shadow: 0 0 40px 0 #ff2020;\n  margin-bottom: -5px;\n"])));
var Title$1 = styled.div(_templateObject4$F || (_templateObject4$F = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.text.tera.fontSize;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeight.bold;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.white;
});
var MainText = styled.div(_templateObject5$t || (_templateObject5$t = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  color: ", ";\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.text.giga.fontSize;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.white;
});
var Terms = styled(Text)(_templateObject6$n || (_templateObject6$n = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  color: ", ";\n  a {\n    color: ", ";\n  }\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.typography.text.giga.fontSize;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.colors.white;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.white;
});
var MainTextWrapper = styled.div(_templateObject7$g || (_templateObject7$g = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  justify-content: space-between;\n"])));
var HeatStreakInfoBanner = function HeatStreakInfoBanner(_ref15) {
  var imageSrc = _ref15.imageSrc,
      title = _ref15.title,
      text = _ref15.text,
      disclaimerTerms = _ref15.disclaimerTerms;
  var cdnUrl = useCdnUrl();
  var backgroundImageUrl = getAssetSet(useCdnImage, 'heatstreakBannerBackground');
  return /*#__PURE__*/React.createElement(HeatStreakBannerWrapper, {
    backgroundImage: backgroundImageUrl
  }, /*#__PURE__*/React.createElement(BannerImage, {
    src: "" + cdnUrl + imageSrc
  }), /*#__PURE__*/React.createElement(TextWrapper$5, null, /*#__PURE__*/React.createElement(Title$1, null, title), /*#__PURE__*/React.createElement(MainTextWrapper, null, /*#__PURE__*/React.createElement(MainText, null, text), /*#__PURE__*/React.createElement(Terms, null, disclaimerTerms))));
};
HeatStreakInfoBanner.propTypes = {
  imageSrc: propTypes.string,
  title: propTypes.string,
  text: propTypes.string,
  disclaimerTerms: propTypes.string
};

var assetSet$6 = function assetSet(filename) {
  return getAssetSet(useCdnImage, filename);
};

var PlayNow = function PlayNow(_ref) {
  var showNotificationBar = _ref.showNotificationBar,
      slotOpenId = _ref.slotOpenId,
      notificationBarTitle = _ref.notificationBarTitle,
      notificationBarText = _ref.notificationBarText,
      gameListEnabled = _ref.gameListEnabled,
      randomPickCount = _ref.randomPickCount,
      randomPicksSelected = _ref.randomPicksSelected,
      playerPicksEnabled = _ref.playerPicksEnabled,
      scrollPosition = _ref.scrollPosition,
      teaserIntroTitle = _ref.teaserIntroTitle,
      teaserIntroSubTitle = _ref.teaserIntroSubTitle,
      showReminders = _ref.showReminders,
      showScoutPicks = _ref.showScoutPicks,
      handleNotificationBarCloseClick = _ref.handleNotificationBarCloseClick,
      handleElementHeight = _ref.handleElementHeight,
      advertisingPromotion = _ref.advertisingPromotion,
      playOffTitle = _ref.playOffTitle,
      seasonTitle = _ref.seasonTitle,
      seasonText = _ref.seasonText,
      disclaimer = _ref.disclaimer,
      playOffText = _ref.playOffText,
      playoffHeatStreakBannerTitle = _ref.playoffHeatStreakBannerTitle,
      playoffHeatStreakBannerText = _ref.playoffHeatStreakBannerText,
      playerPicksSectionTitle = _ref.playerPicksSectionTitle,
      heatStreakInfoBannerImgSrc = _ref.heatStreakInfoBannerImgSrc,
      heatStreakInfoBannerTitle = _ref.heatStreakInfoBannerTitle,
      heatStreakInfoBannerText = _ref.heatStreakInfoBannerText,
      disclaimerTerms = _ref.disclaimerTerms;

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      config = _useSelector.config,
      leaderboard = _useSelector.leaderboard;

  var language = config.language;
  var prevRandomPickCountRef = useRef(0);
  var notificationBarRef = useRef(0);
  var gameListRef = useRef(0);
  var theme = useTheme();
  var notificationBarHeight = useElementHeight(notificationBarRef);
  var gameListHeight = useElementHeight(gameListRef);
  var isCurrentlyPlayoffs = leaderboard.isCurrentlyPlayoffs,
      isCurrentlySeason = leaderboard.isCurrentlySeason;
  var noChallenge = !isCurrentlyPlayoffs && !isCurrentlySeason;
  var gamesMissing = false;
  var playOffCardProps = {
    title: playOffTitle,
    logosSrc: [{
      src: "2025_Playoffs_Prize_" + language + ".png",
      width: '100%'
    }],
    challengeDisclaimer: /*#__PURE__*/React.createElement(ChallengeDisclaimer, null, disclaimer),
    background: theme.colors.darkBg + " no-repeat top / 100% 266px url( " + assetSet$6('challengeCardBackground') + ")",
    sponsorText: playOffText,
    analyticsTitle: PLAY_NOW_TERMS_AND_CONDITIONS_CLICKED,
    heatStreak: /*#__PURE__*/React.createElement(PlayoffHeatStreakBanner, {
      heatStreakBannerImg1Src: assetSet$6('heatStreakBannerImg1Src'),
      heatStreakBannerImg2Src: assetSet$6('heatStreakBannerImg2Src'),
      playoffHeatStreakBannerTitle: playoffHeatStreakBannerTitle,
      playoffHeatStreakBannerText: playoffHeatStreakBannerText
    })
  };
  var seasonCardProps = {
    title: seasonTitle,
    logosSrc: [{
      src: "2025-2026_Season_Prize.png",
      width: '100%'
    }],
    challengeDisclaimer: /*#__PURE__*/React.createElement(ChallengeDisclaimer, null, disclaimer),
    background: theme.colors.darkBg + " no-repeat top / 100% url( " + assetSet$6('challengeCardBackground') + ")",
    sponsorText: seasonText,
    analyticsTitle: PLAY_NOW_TERMS_AND_CONDITIONS_CLICKED
  };
  useEffect(function () {
    if (!notificationBarHeight || !gameListHeight) {
      return;
    }

    handleElementHeight({
      notificationBar: notificationBarHeight,
      gameList: gameListHeight
    });
  }, [notificationBarHeight, gameListHeight]);
  useEffect(function () {
    if (!randomPicksSelected || !randomPickCount || prevRandomPickCountRef.current === randomPickCount) {
      return;
    }

    prevRandomPickCountRef.current = randomPickCount;
  }, [slotOpenId, scrollPosition, randomPickCount]);

  if (noChallenge) {
    return /*#__PURE__*/React.createElement(NoChallengeCard$1, null);
  }

  return /*#__PURE__*/React.createElement(Fragment$1, null, showNotificationBar && /*#__PURE__*/React.createElement("div", {
    ref: notificationBarRef
  }, /*#__PURE__*/React.createElement(NotificationBar, {
    title: notificationBarTitle,
    text: notificationBarText,
    onSelect: handleNotificationBarCloseClick
  })), /*#__PURE__*/React.createElement(Fragment$1, null, gameListEnabled && /*#__PURE__*/React.createElement(Fragment$1, null, gamesMissing , /*#__PURE__*/React.createElement("div", {
    ref: gameListRef
  }, /*#__PURE__*/React.createElement(Games, null))), playerPicksEnabled ? /*#__PURE__*/React.createElement(Picks$1, {
    showScoutPicks: showScoutPicks,
    showReminders: showReminders
  }) : /*#__PURE__*/React.createElement(Container$E, null, /*#__PURE__*/React.createElement(Spacing, {
    sizeBottom: "mega"
  }, /*#__PURE__*/React.createElement(SectionTitle, {
    text: playerPicksSectionTitle
  })), /*#__PURE__*/React.createElement(Spacing, {
    sizeTop: "giga",
    sizeLeft: "giga",
    sizeRight: "giga",
    sizeBottom: "tera"
  }, /*#__PURE__*/React.createElement(Teaser, {
    src: assetSet$6(['sticks']),
    introTitle: teaserIntroTitle,
    introSubTitle: teaserIntroSubTitle
  }))), !playerPicksEnabled && /*#__PURE__*/React.createElement(Reminders$1, null), /*#__PURE__*/React.createElement(Offers$1, {
    promotions: advertisingPromotion
  }), !isCurrentlyPlayoffs && /*#__PURE__*/React.createElement(Spacing, {
    sizeTop: "byte"
  }, /*#__PURE__*/React.createElement(CurrentCard, _extends({}, seasonCardProps, {
    active: isCurrentlySeason
  }))), isCurrentlyPlayoffs && /*#__PURE__*/React.createElement(Spacing, {
    sizeTop: "byte"
  }, /*#__PURE__*/React.createElement(CurrentCard, _extends({}, playOffCardProps, {
    active: isCurrentlyPlayoffs
  }))), /*#__PURE__*/React.createElement(HeatStreakInfoBanner, {
    imageSrc: heatStreakInfoBannerImgSrc,
    title: heatStreakInfoBannerTitle,
    text: heatStreakInfoBannerText,
    disclaimerTerms: disclaimerTerms
  }), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginTop: '16px'
    }
  })));
};

PlayNow.propTypes = {
  showNotificationBar: propTypes.bool,
  slotOpenId: propTypes.number,
  notificationBarTitle: propTypes.string,
  notificationBarText: propTypes.string,
  gameListEnabled: propTypes.bool,
  playerPicksEnabled: propTypes.bool,
  randomPickCount: propTypes.number,
  randomPicksSelected: propTypes.bool,
  scrollPosition: propTypes.number,
  teaserIntroTitle: propTypes.string,
  showReminders: propTypes.bool,
  showScoutPicks: propTypes.bool,
  handleNotificationBarCloseClick: propTypes.func,
  handleElementHeight: propTypes.func,
  playerPicksSectionTitle: propTypes.string
};

var mapStateToProps$c = function mapStateToProps(state) {
  var strings = state.strings,
      games = state.games,
      picks = state.picks,
      ui = state.ui,
      config = state.config;
  var allGamesStarted = games.allGamesStarted,
      noGamesStarted = games.noGamesStarted,
      hasGamesToday = games.hasGamesToday;
  var badPickSubmission = picks.fetchError,
      picksSentAlready = picks.picksSentAlready,
      picksLocked = picks.picksLocked,
      randomPickCount = picks.randomPickCount,
      randomPicksSelected = picks.randomPicksSelected,
      slotOpenId = picks.slotOpenId;
  var notificationBarOpen = ui.notificationBarOpen,
      componentSize = ui.componentSize,
      remindersOn = ui.remindersOn,
      hasFetchError = ui.hasFetchError,
      fetchErrorCount = ui.fetchErrorCount;
  var picksScrollPosition = componentSize.picksScrollPosition;
  var advertisingPromotion = config.advertisingPromotion;
  var teaserIntroTitle = hasFetchError && fetchErrorCount >= 3 && strings['global/fetchError/text'] || !hasGamesToday && strings['notifications/games/noGames/text'] || null;
  var teaserIntroSubTitle = strings['notifications/games/noGames/sub-text'];
  var someGamesInProgress = hasGamesToday && !noGamesStarted && !allGamesStarted;
  var notificationBarText;

  if (noGamesStarted) {
    notificationBarText = getNotificationText(strings, 'welcome');
  } else {
    if (!picksSentAlready && someGamesInProgress) notificationBarText = getNotificationText(strings, 'inProgress');
    if (!picksSentAlready && allGamesStarted) notificationBarText = getNotificationText(strings, 'allInProgress');
    if (!picksSentAlready && !hasGamesToday) notificationBarText = getNotificationText(strings, 'noGames');
  }

  var isSubmitted = picksLocked || picksSentAlready;
  var showNotificationBar = !badPickSubmission && !isSubmitted && notificationBarOpen;
  var gameListEnabled = !hasFetchError && fetchErrorCount >= 3 && picksSentAlready || !hasFetchError && hasGamesToday;
  var playerPicksEnabled = !hasFetchError && fetchErrorCount >= 3 && picksSentAlready || !hasFetchError && hasGamesToday && allGamesStarted && picksSentAlready || !hasFetchError && hasGamesToday && !allGamesStarted;
  var showReminders = !hasFetchError;
  var showScoutPicks = !hasFetchError && !isSubmitted && !picksSentAlready && playerPicksEnabled;
  var scrollPosition = notificationBarOpen ? picksScrollPosition.withNotification : picksScrollPosition.withoutNotification;
  var allStrings = {
    disclaimer: strings['challenges/footer/disclaimer'],
    playOffTitle: strings['challenges/playoff/title'],
    playOffText: strings['challenges/playoff/text'],
    playoffPrizes: strings['challenges/playoffs/prizes'],
    playoffHeatStreakBannerTitle: strings['challenges/playoffs/heatstreakbanner/title'],
    playoffHeatStreakBannerText: strings['challenges/playoffs/heatstreakbanner/text'],
    seasonTitle: strings['challenges/season/title/playnow'],
    seasonText: strings['challenges/season/text'],
    playerPicksSectionTitle: strings['titles/section/picks/text'],
    heatStreakInfoBannerImgSrc: strings['challenges/heatstreak/banner/img'],
    heatStreakInfoBannerTitle: strings['challenges/heatstreak/banner/title'],
    heatStreakInfoBannerText: strings['challenges/heatstreak/banner/text'],
    disclaimerTerms: strings['heatstreak/gameinfo/disclaimerTerms']
  };
  return _extends({
    teaserIntroTitle: teaserIntroTitle,
    teaserIntroSubTitle: teaserIntroSubTitle,
    slotOpenId: slotOpenId,
    randomPickCount: randomPickCount,
    randomPicksSelected: randomPicksSelected,
    showNotificationBar: showNotificationBar,
    gameListEnabled: gameListEnabled,
    playerPicksEnabled: playerPicksEnabled,
    showReminders: showReminders,
    showScoutPicks: showScoutPicks,
    scrollPosition: scrollPosition,
    remindersOn: remindersOn,
    advertisingPromotion: advertisingPromotion
  }, notificationBarText, allStrings);
};

var mapDispatchToProps$a = function mapDispatchToProps(dispatch) {
  return {
    handleElementHeight: function handleElementHeight(height) {
      return dispatch(setElementHeight(height));
    },
    handleNotificationBarCloseClick: function handleNotificationBarCloseClick() {
      return dispatch(setNotificationBarToClosed());
    }
  };
};

var PlayNow$1 = connect(mapStateToProps$c, mapDispatchToProps$a)(PlayNow);

var _excluded$q = ["type"];

var _templateObject$1k, _templateObject2$12, _templateObject3$P, _templateObject4$G, _templateObject5$u, _templateObject6$o, _templateObject7$h, _templateObject8$d;

var assetSet$7 = function assetSet(filename) {
  return getAssetSet(useCdnImage, filename);
};

var textByte$2 = textByte,
    textPeta$1 = textPeta,
    textGiga$3 = textGiga,
    textTera$2 = textTera,
    flexCenter$f = flexCenter,
    disableVisually$4 = disableVisually;
var BlurbContainer = styled.div(_templateObject$1k || (_templateObject$1k = _taggedTemplateLiteralLoose(["\n  background: ", " no-repeat top / 100% 266px\n    url(", ");\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.darkBg;
}, assetSet$7('challengeCardBackground'));
var GameInfoList = styled.ol(_templateObject2$12 || (_templateObject2$12 = _taggedTemplateLiteralLoose(["\n  list-style: none;\n  margin: ", " 0 0;\n  padding: 0 0 ", " 0;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacings.mega;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacings.tera;
});
var GameInfoItem = styled.li(_templateObject3$P || (_templateObject3$P = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  margin-top: ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacings.giga;
});
var GameInfoItemImage = styled.div(_templateObject4$G || (_templateObject4$G = _taggedTemplateLiteralLoose(["\n  width: 82px;\n  flex-shrink: 0;\n  margin-right: ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacings.mega;
});
var GameInfoItemText = styled.p(_templateObject5$u || (_templateObject5$u = _taggedTemplateLiteralLoose(["\n  flex-grow: 1;\n  ", "\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.typography.text.tera;
});
var HCLogo = styled(Image)(_templateObject6$o || (_templateObject6$o = _taggedTemplateLiteralLoose(["\n  width: 50%;\n  padding-top: ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacings.giga;
});
var BORDER_WIDTH$1 = '1px';

var baseStyles$B = function baseStyles(_ref8) {
  var theme = _ref8.theme;
  return css(_templateObject7$h || (_templateObject7$h = _taggedTemplateLiteralLoose(["\n  margin: ", " auto;\n  text-decoration: none;\n  font-family: ", ";\n  font-weight: ", ";\n  color: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  cursor: pointer;\n  padding: ", " ", ";\n  position: relative;\n  min-width: 170px;\n\n  ", "\n  ", "\n\n  &:focus,\n  &:active {\n    outline: none;\n  }\n\n  &:disabled,\n  &[disabled] {\n    ", ";\n    background: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n"])), theme.spacings.atom, theme.fontStack.bold.name, theme.fontStack.bold.weight, theme.colors.white, theme.colors.red, theme.colors.red, theme.borderRadius.peta, theme.spacings.kilo, theme.spacings.mega, textPeta$1({
    theme: theme
  }), flexCenter$f(), disableVisually$4(), theme.colors.n700, theme.colors.n700, theme.colors.white);
};

var sizeStyles$9 = function sizeStyles(_ref9) {
  var theme = _ref9.theme,
      _ref9$size = _ref9.size,
      size = _ref9$size === void 0 ? 'tera' : _ref9$size;
  var sizeMap = {
    "byte": {
      padding: theme.spacings.bit + " " + theme.spacings["byte"],
      borderRadius: theme.borderRadius.peta,
      type: textByte$2({
        theme: theme
      })
    },
    giga: {
      padding: theme.spacings.bit + " calc(" + theme.spacings.giga + " - " + BORDER_WIDTH$1 + ")",
      borderRadius: theme.borderRadius.peta,
      type: textGiga$3({
        theme: theme
      })
    },
    peta: {
      padding: "" + theme.spacings.mega,
      borderRadius: theme.borderRadius.peta,
      type: textTera$2({
        theme: theme
      })
    },
    mega: {
      borderRadius: theme.borderRadius.peta,
      maxWidth: '170px'
    },
    tera: {
      borderRadius: theme.borderRadius.peta,
      type: textTera$2({
        theme: theme
      }),
      minWidth: '230px'
    }
  };

  var _ref10 = sizeMap[size] || 'byte',
      type = _ref10.type,
      rest = _objectWithoutPropertiesLoose(_ref10, _excluded$q);

  return css(_templateObject8$d || (_templateObject8$d = _taggedTemplateLiteralLoose(["\n    ", ";\n    ", ";\n  "])), type, rest);
};

var StyledLink = styled(NavLink)(baseStyles$B, sizeStyles$9);
var clickedType$1 = analyticActionMap.clickedType,
    path$2 = analyticActionMap.path,
    buttonType$1 = analyticActionMap.buttonType,
    makeYourPicks$1 = analyticActionMap.makeYourPicks,
    gameInfo = analyticActionMap.gameInfo;

var HowTo = function HowTo(_ref11) {
  var headerSrc = _ref11.headerSrc,
      blurb = _ref11.blurb,
      steps = _ref11.steps,
      btnText = _ref11.btnText,
      handleLinkClick = _ref11.handleLinkClick,
      playNow = _ref11.playNow;
  var cdnUrl = useCdnUrl();

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      config = _useSelector.config;

  var env = config.env,
      platform = config.platform;

  var handleMakeYourPicksClick = function handleMakeYourPicksClick() {
    fireMessageEvent({
      platform: platform,
      env: env,
      title: clickedType$1,
      data: {
        path: path$2,
        modal: gameInfo,
        element: buttonType$1,
        element_name: makeYourPicks$1
      }
    });
    handleLinkClick(playNow);
  };

  return /*#__PURE__*/React.createElement(BlurbContainer, null, /*#__PURE__*/React.createElement(HCLogo, {
    src: "" + cdnUrl + headerSrc
  }), /*#__PURE__*/React.createElement(Spacing, {
    sizeLeft: "tera",
    sizeRight: "tera",
    paddingBottom: "tera"
  }, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: "white"
  }, blurb.map(function (str, i) {
    return /*#__PURE__*/React.createElement(Text, {
      centered: true,
      size: "exa",
      key: "blurb-" + i
    }, str);
  }), /*#__PURE__*/React.createElement(GameInfoList, null, steps.map(function (step, i) {
    return /*#__PURE__*/React.createElement(GameInfoItem, {
      key: "logo-" + (i + 1)
    }, /*#__PURE__*/React.createElement(GameInfoItemImage, null, /*#__PURE__*/React.createElement(Image, {
      src: "" + cdnUrl + step.imgSrc
    })), /*#__PURE__*/React.createElement(GameInfoItemText, {
      dangerouslySetInnerHTML: {
        __html: step.text
      }
    }));
  }))), /*#__PURE__*/React.createElement(StyledLink, {
    disabled: false,
    to: "/",
    size: "mega",
    onClick: handleMakeYourPicksClick
  }, btnText)));
};

HowTo.propTypes = {
  headerSrc: propTypes.string,
  blurb: propTypes.arrayOf(propTypes.string)
};

var mapStateToProps$d = function mapStateToProps(state) {
  var strings = state.strings,
      routing = state.routing;
  var playNow = routing.routeById.playNow;
  var allStrings = {
    blurb: strings['howTo/hockeyChallenge/blurb/text'],
    steps: strings['howTo/hockeyChallenge/blurb/steps'].map(function (str, i) {
      return {
        imgSrc: strings['howTo/hockeyChallenge/steps/image/src'][i],
        text: str
      };
    }),
    btnText: strings['howTo/hockeyChallenge/blurb/button/text']
  };
  return _extends({
    headerSrc: strings['howTo/hockeyChallenge/header/image/src'],
    playNow: playNow.id
  }, allStrings);
};

var mapDispatchToProps$b = function mapDispatchToProps(dispatch) {
  return {
    handleLinkClick: function handleLinkClick(id) {
      return dispatch(setMenuLinkClicked(id));
    }
  };
};

var HowTo$1 = connect(mapStateToProps$d, mapDispatchToProps$b)(HowTo);

var _templateObject$1l, _templateObject2$13, _templateObject3$Q, _templateObject4$H, _templateObject5$v, _templateObject6$p, _templateObject7$i, _templateObject8$e;
var Container$G = styled(ShadowBox)(_templateObject$1l || (_templateObject$1l = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacings.mega;
});
var PrizeContainer = styled.div(_templateObject2$13 || (_templateObject2$13 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: right;\n"])));

var pointHeaderBaseStyles = function pointHeaderBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject3$Q || (_templateObject3$Q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  align-items: center;\n  padding: ", " 0 0;\n  text-align: center;\n  font-family: ", ";\n"])), theme.spacings.kilo, theme.fontStack.bold.name);
};

var PointHeaderContainer = styled('div')(pointHeaderBaseStyles);
var PointNumber = styled.span(_templateObject4$H || (_templateObject4$H = _taggedTemplateLiteralLoose(["\n  display: block;\n  font-size: 50px;\n  line-height: 40px;\n  letter-spacing: -1px;\n  text-align: left;\n  min-width: 60px;\n"])));

var pointTextBaseStyles = function pointTextBaseStyles(_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject5$v || (_templateObject5$v = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  line-height: 20px;\n  letter-spacing: -0.5px;\n  padding-left: ", ";\n  text-align: left;\n  span {\n    color: ", ";\n  }\n"])), theme.typography.text.exa.fontSize, theme.spacings.bit, theme.colors.n900);
};

var PointText = styled('span')(pointTextBaseStyles);

var prizeDotGroupBaseStyles$1 = function prizeDotGroupBaseStyles(_ref4) {
  var theme = _ref4.theme;
  return css(_templateObject6$p || (_templateObject6$p = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: ", ";\n"])), theme.spacings.kilo);
};

var PrizeDotGroup$1 = styled('div')(prizeDotGroupBaseStyles$1);

var prizeDotBaseStyles$1 = function prizeDotBaseStyles(_ref5) {
  var theme = _ref5.theme;
  return css(_templateObject7$i || (_templateObject7$i = _taggedTemplateLiteralLoose(["\n  padding: ", ";\n"])), theme.spacings["byte"]);
};

var PrizeDot$1 = styled('div')(prizeDotBaseStyles$1);

var prizeDescStyles = function prizeDescStyles(_ref6) {
  var theme = _ref6.theme;
  return css(_templateObject8$e || (_templateObject8$e = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  letter-spacing: -0.1px;\n  text-align: center;\n\n  span {\n    display: block;\n    font-family: ", ";\n    color: ", ";\n  }\n"])), theme.typography.text.mega.fontSize, theme.fontStack.bold.name, theme.colors.r500);
};

var PrizeDesc$1 = styled.span(prizeDescStyles);

var RewardItem = function RewardItem(_ref7) {
  var level = _ref7.level,
      instructionText = _ref7.instructionText,
      rewardText = _ref7.rewardText,
      points = _ref7.points,
      isOffer = _ref7.isOffer,
      orText = _ref7.orText,
      offerText = _ref7.offerText,
      anText = _ref7.anText,
      pointsText = _ref7.pointsText;
  return /*#__PURE__*/React.createElement(Container$G, null, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: "red"
  }, /*#__PURE__*/React.createElement(PrizeContainer, null, /*#__PURE__*/React.createElement(PointHeaderContainer, null, /*#__PURE__*/React.createElement(PointNumber, null, points), /*#__PURE__*/React.createElement(PointText, {
    size: "exa",
    bold: true,
    centered: true,
    noMargin: true
  }, pointsText, ' ', isOffer && /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement("span", null, ' ', orText, " ", anText), "\xA0", offerText))), /*#__PURE__*/React.createElement(PrizeDotGroup$1, null, [0, 1, 2].map(function (num, index) {
    return /*#__PURE__*/React.createElement(PrizeDot$1, {
      key: index
    }, /*#__PURE__*/React.createElement(Image, {
      src: "https://cdn.rbi.digital/hockey/" + (num <= level ? 'img_player_active1.png' : 'img_player_inactive1.png')
    }));
  })))), /*#__PURE__*/React.createElement(PrizeDesc$1, null, instructionText, /*#__PURE__*/React.createElement("span", null, rewardText)));
};

RewardItem.propTypes = {
  assetUrl: propTypes.string,
  assetAlt: propTypes.string,
  level: propTypes.number,
  instructionText: propTypes.string,
  rewardText: propTypes.string,
  points: propTypes.number,
  isOffer: propTypes.bool,
  orText: propTypes.string,
  offerText: propTypes.string,
  pointsText: propTypes.string
};

var _excluded$r = ["id", "filename", "isLast"];

var _templateObject$1m;
var PrizeListContainer = styled.div(_templateObject$1m || (_templateObject$1m = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.sectionBg;
});

var PrizeList$1 = function PrizeList(_ref2) {
  var title = _ref2.title,
      blurb = _ref2.blurb,
      rewards = _ref2.rewards;
  var cdnUrl = useCdnUrl();
  return /*#__PURE__*/React.createElement(PrizeListContainer, null, /*#__PURE__*/React.createElement(Spacing, null, /*#__PURE__*/React.createElement(SectionTitle, {
    text: title,
    shadow: true,
    size: "deca"
  })), /*#__PURE__*/React.createElement(Spacing, {
    sizeLeft: "peta",
    sizeRight: "peta",
    sizeTop: "giga",
    sizeBottom: "tera"
  }, /*#__PURE__*/React.createElement(Text, {
    centered: true,
    size: "tera"
  }, blurb)), rewards.map(function (_ref3, index) {
    var filename = _ref3.filename,
        props = _objectWithoutPropertiesLoose(_ref3, _excluded$r);

    return /*#__PURE__*/React.createElement(Spacing, {
      key: index,
      paddingBottom: "byte",
      sizeLeft: "byte",
      sizeRight: "byte"
    }, /*#__PURE__*/React.createElement(Spacing, {
      sizeLeft: "byte",
      sizeRight: "byte",
      sizeBottom: "byte"
    }, /*#__PURE__*/React.createElement(RewardItem, _extends({
      assetUrl: "" + cdnUrl + filename,
      level: index
    }, props))));
  }));
};

PrizeList$1.propTypes = {
  title: propTypes.string,
  rewards: propTypes.array,
  lid: propTypes.string,
  platform: propTypes.string,
  language: propTypes.string
};

var mapStateToProps$e = function mapStateToProps(state) {
  var strings = state.strings,
      prizeList = state.prizeList,
      config = state.config;
  var platform = config.platform,
      language = config.language;
  var rewards = prizeList.rewards;
  var allStrings = {
    title: strings['titles/section/prizes/text'],
    blurb: strings['prizes/hockeyChallenge/blurb']
  };
  var allRewards = rewards.map(function (reward) {
    return _extends({}, reward, {
      filename: strings["prizes/hockeyChallenge/" + reward.id + "/image/src"],
      instructionText: strings["prizes/hockeyChallenge/" + reward.id + "/title"],
      rewardText: strings["prizes/hockeyChallenge/" + reward.id + "/reward"],
      orText: strings['prizes/hockeyChallenge/pointHeader/or'],
      anText: strings['prizes/hockeyChallenge/pointHeader/an'],
      offerText: strings['prizes/hockeyChallenge/pointHeader/offer'],
      pointsText: strings['prizes/hockeyChallenge/pointHeader/points']
    });
  });
  return _extends({}, allStrings, {
    rewards: allRewards,
    platform: platform,
    language: language
  });
};

var PrizeList$2 = connect(mapStateToProps$e)(PrizeList$1);

var _templateObject$1n, _templateObject2$14, _templateObject3$R;
var StreaksContainer = styled.div(_templateObject$1n || (_templateObject$1n = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.sectionBg;
});
var StreaksImageContainer = styled.div(_templateObject2$14 || (_templateObject2$14 = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.sectionBg;
});
var StreaksDisclaimer = styled(Text)(_templateObject3$R || (_templateObject3$R = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  padding: 20px 0;\n  text-align: center;\n  font-size: 14px;\n  margin-top: -55px;\n  a {\n    color: ", ";\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.black;
});

var Streaks = function Streaks(_ref4) {
  var title = _ref4.title,
      blurb = _ref4.blurb,
      streakSrc = _ref4.streakSrc,
      disclaimerTerms = _ref4.disclaimerTerms;
  var cdnUrl = useCdnUrl();
  return /*#__PURE__*/React.createElement(StreaksContainer, null, /*#__PURE__*/React.createElement(Spacing, null, /*#__PURE__*/React.createElement(SectionTitle, {
    text: title,
    shadow: true,
    size: "deca"
  })), /*#__PURE__*/React.createElement(Spacing, {
    sizeLeft: "peta",
    sizeRight: "peta",
    sizeTop: "tera",
    sizeBottom: "tera"
  }, /*#__PURE__*/React.createElement(Text, {
    centered: true,
    size: "tera"
  }, blurb)), /*#__PURE__*/React.createElement(Spacing, {
    sizeLeft: "mega",
    sizeRight: "mega",
    paddingBottom: "tera"
  }, /*#__PURE__*/React.createElement(StreaksImageContainer, null, /*#__PURE__*/React.createElement(Image, {
    src: "" + cdnUrl + streakSrc
  }), /*#__PURE__*/React.createElement(StreaksDisclaimer, null, disclaimerTerms))));
};

Streaks.propTypes = {
  title: propTypes.string,
  blurb: propTypes.string,
  disclaimer: propTypes.string,
  streakSrc: propTypes.string
};

var mapStateToProps$f = function mapStateToProps(state) {
  var strings = state.strings;
  var allStrings = {
    title: strings['titles/section/streaks/text'],
    blurb: strings['heatstreak/gameinfo/blurb'],
    disclaimerTerms: strings['heatstreak/gameinfo/disclaimerTerms']
  };
  return _extends({}, allStrings, {
    streakSrc: strings['heatstreak/gameinfo/image']
  });
};

var Streaks$1 = connect(mapStateToProps$f)(Streaks);

var GameInfo = function GameInfo() {
  return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(HowTo$1, null), /*#__PURE__*/React.createElement(PrizeList$2, null), /*#__PURE__*/React.createElement(Streaks$1, null), /*#__PURE__*/React.createElement(Challenges$1, null), /*#__PURE__*/React.createElement(Divider, null));
};

var _templateObject$1o, _templateObject2$15, _templateObject3$S, _templateObject4$I, _templateObject5$w, _templateObject6$q, _templateObject7$j, _templateObject8$f, _templateObject9$9, _templateObject10$5;

var assetSet$8 = function assetSet(filename) {
  return getAssetSet(useCdnImage, filename);
};

var containerBaseStyles$j = function containerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$1o || (_templateObject$1o = _taggedTemplateLiteralLoose(["\n  padding-top: ", ";\n"])), theme.spacings.exa);
};

var Container$H = styled('div')(containerBaseStyles$j);

var streakItemBaseStyles = function streakItemBaseStyles() {
  return css(_templateObject2$15 || (_templateObject2$15 = _taggedTemplateLiteralLoose(["\n  display: flex;\n"])));
};

var StreakItem = styled('div')(streakItemBaseStyles);

var heatLegendBaseStyles = function heatLegendBaseStyles() {
  return css(_templateObject3$S || (_templateObject3$S = _taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
};

var HeatLegend = styled('div')(heatLegendBaseStyles);

var heatLineBaseStyles = function heatLineBaseStyles(_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant;
  return css(_templateObject4$I || (_templateObject4$I = _taggedTemplateLiteralLoose(["\n  background: black;\n  position: absolute;\n  top: 0;\n  left: 15px;\n  width: 2px;\n  height: 100%;\n\n  background: linear-gradient(\n    360deg,\n    ", " 2%,\n    ", " 47%\n  );\n"])), theme.colors.heatStreak[variant].start, theme.colors.heatStreak[variant].end);
};

var HeatLine = styled('div')(heatLineBaseStyles);

var pickListBaseStyles = function pickListBaseStyles() {
  return css(_templateObject5$w || (_templateObject5$w = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n\n  span span {\n    font-weight: bold;\n  }\n"])));
};

var PickList = styled('div')(pickListBaseStyles);

var heatItemBaseStyles = function heatItemBaseStyles() {
  return css(_templateObject6$q || (_templateObject6$q = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"])));
};

var HeatItem = styled('div')(heatItemBaseStyles);

var heatDateBaseStyles = function heatDateBaseStyles(_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject7$j || (_templateObject7$j = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: -25px;\n  left: 15px;\n  display: flex;\n  justify-content: space-between;\n  align-items: self-end;\n  width: 100%;\n  padding-right: ", ";\n"])), theme.spacings.mega);
};

var HeatDate = styled('div')(heatDateBaseStyles);

var heatDateTextBaseStyles = function heatDateTextBaseStyles() {
  return css(_templateObject8$f || (_templateObject8$f = _taggedTemplateLiteralLoose([""])));
};

var HeatDateText = styled('div')(heatDateTextBaseStyles);

var heatDateStatusBaseStyles = function heatDateStatusBaseStyles(_ref4) {
  var theme = _ref4.theme;
  return css(_templateObject9$9 || (_templateObject9$9 = _taggedTemplateLiteralLoose(["\n  border-radius: ", ";\n  background-color: ", ";\n  padding: 1px ", " 0;\n"])), theme.borderRadius.giga, theme.colors.n900, theme.spacings["byte"]);
};

var HeatDateStatus = styled('div')(heatDateStatusBaseStyles);
var Loyalty3NotificationDate = '2023-02-21';

var imageContainerBaseStyles$5 = function imageContainerBaseStyles() {
  return css(_templateObject10$5 || (_templateObject10$5 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  z-index: 999;\n  width: 32px;\n  height: 32px;\n"])));
};

var ImageContainer$5 = styled('div')(imageContainerBaseStyles$5);

var HeatStreak = function HeatStreak(_ref5) {
  var streakList = _ref5.streakList,
      noPicksText = _ref5.noPicksText,
      gameStatusText = _ref5.gameStatusText,
      todayNoPicksSubText = _ref5.todayNoPicksSubText,
      resultsPendingText = _ref5.resultsPendingText,
      noPicksAggregatedText = _ref5.noPicksAggregatedText,
      loyalty3NotificationTitle = _ref5.loyalty3NotificationTitle,
      loyalty3NotificationText = _ref5.loyalty3NotificationText,
      byPlayerId = _ref5.byPlayerId,
      byTeamId = _ref5.byTeamId,
      gamesInProgress = _ref5.gamesInProgress,
      noPicksAggregated = _ref5.noPicksAggregated,
      yourPicksText = _ref5.yourPicksText;
  var assetList = assetSet$8(['loadingSticks', 'historyUnscored']);
  var slotBuilder = slotItemBuilder({
    playerData: byPlayerId,
    teamData: byTeamId
  });
  var startAggregatedContest = false;
  var isCurrentDateAggregated = false;
  var aggregateDateRangeText = null;
  return /*#__PURE__*/React.createElement(Container$H, null, /*#__PURE__*/React.createElement(Spacing, {
    sizeLeft: "mega",
    sizeRight: "mega"
  }, streakList.map(function (_ref6) {
    var key = _ref6.key,
        contestDate = _ref6.contestDate,
        hasPicks = _ref6.hasPicks,
        hasLoyalty3Notification = _ref6.hasLoyalty3Notification,
        isUnscored = _ref6.isUnscored,
        dateText = _ref6.dateText,
        isToday = _ref6.isToday,
        heatLineStreak = _ref6.heatLineStreak,
        streakText = _ref6.streakText,
        streakVariant = _ref6.streakVariant,
        picks = _ref6.picks,
        pickStatustext = _ref6.pickStatustext,
        statusBgColor = _ref6.statusBgColor;
    var aggregatedDateRange = noPicksAggregated[contestDate];
    var isDateAggregated = !!aggregatedDateRange;
    var aggregatedDateCount = 0;

    if (!startAggregatedContest && isDateAggregated) {
      startAggregatedContest = aggregatedDateRange;
      isCurrentDateAggregated = true;
    }

    if (startAggregatedContest) {
      var aggregateDatesForCurrentDate = startAggregatedContest[contestDate];

      if (aggregateDatesForCurrentDate) {
        var aggregatedDateKeys = Object.keys(startAggregatedContest);
        aggregatedDateCount = aggregatedDateKeys.length - 1;
        var startAggregatedDate = aggregatedDateKeys[0];
        var endAggregatedDate = aggregatedDateKeys[aggregatedDateCount];
        aggregateDateRangeText = getMonthDayDate(endAggregatedDate) + "-" + getDayDate(startAggregatedDate);

        if (contestDate === endAggregatedDate) {
          isCurrentDateAggregated = false;
        }
      } else {
        startAggregatedContest = false;
      }
    }

    var contestDateText = startAggregatedContest ? aggregateDateRangeText : dateText;
    var contestNoPickText = startAggregatedContest ? noPicksAggregatedText(aggregatedDateCount) : noPicksText;
    return isCurrentDateAggregated ? null : /*#__PURE__*/React.createElement(Spacing, {
      key: key
    }, /*#__PURE__*/React.createElement(StreakItem, null, /*#__PURE__*/React.createElement(HeatLegend, null, /*#__PURE__*/React.createElement(Spacing, {
      sizeRight: "bit"
    }, /*#__PURE__*/React.createElement(HeatLine, {
      variant: heatLineStreak
    }), !isUnscored ? /*#__PURE__*/React.createElement(HeatStreakIcon, {
      size: "bit",
      variant: streakVariant,
      assetSrc: assetList.loadingSticks,
      text: streakText
    }) : /*#__PURE__*/React.createElement(ImageContainer$5, null, /*#__PURE__*/React.createElement(Image, {
      src: assetList.historyUnscored
    })))), /*#__PURE__*/React.createElement(PickList, null, /*#__PURE__*/React.createElement(HeatDate, null, /*#__PURE__*/React.createElement(HeatDateText, null, /*#__PURE__*/React.createElement(ColorProvider, {
      variant: "darkGrey"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "kilo"
    }, contestDateText))), isToday && gamesInProgress && /*#__PURE__*/React.createElement(HeatDateStatus, null, /*#__PURE__*/React.createElement(ColorProvider, {
      variant: "white"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "bit",
      upper: true,
      bold: true,
      noMargin: true
    }, gameStatusText)))), /*#__PURE__*/React.createElement(Spacing, {
      sizeLeft: "mega",
      sizeBottom: isToday ? 'peta' : 'exa'
    }, /*#__PURE__*/React.createElement(ShadowBox, {
      centered: !hasPicks,
      active: hasPicks && picks[0].correct,
      arrow: true
    }, hasPicks && /*#__PURE__*/React.createElement(TextBar, {
      variant: statusBgColor,
      text: yourPicksText
    }), hasPicks && picks.map(function (_ref7, index) {
      var playerId = _ref7.playerId,
          _ref7$correct = _ref7.correct,
          correct = _ref7$correct === void 0 ? false : _ref7$correct;

      var _slotBuilder = slotBuilder(playerId),
          text = _slotBuilder.text,
          subText = _slotBuilder.subText,
          assetUrl = _slotBuilder.assetUrl,
          secondaryAssetUrl = _slotBuilder.secondaryAssetUrl;

      var correctIcon = correct ? 'success-lite' : '';
      var icon = isToday ? 'lock' : correctIcon;
      return /*#__PURE__*/React.createElement(HeatItem, {
        key: key + "-" + playerId
      }, /*#__PURE__*/React.createElement(PickItem, {
        variant: "leftSelected",
        assetUrl: assetUrl,
        secondaryAssetUrl: secondaryAssetUrl,
        text: text,
        subText: subText,
        isActive: correct,
        hasIcon: isToday || correct,
        correct: correct,
        isToday: isToday,
        icon: icon
      }), index !== 2 && /*#__PURE__*/React.createElement(Divider, null));
    }), hasPicks && !isToday && pickStatustext && !isUnscored && /*#__PURE__*/React.createElement(TextBar, {
      variant: statusBgColor,
      text: pickStatustext
    }), isUnscored && /*#__PURE__*/React.createElement(TextBar, {
      variant: statusBgColor,
      text: resultsPendingText
    }), !hasPicks && isToday && [0, 1, 2].map(function (number) {
      return /*#__PURE__*/React.createElement(HeatItem, {
        key: "placeholder-" + number
      }, /*#__PURE__*/React.createElement(PickItem, {
        variant: "placeholder",
        assetUrl: assetList.loadingSticks,
        subText: todayNoPicksSubText,
        assetHasPadding: isToday && !hasPicks,
        hasIcon: false
      }), number !== 2 && /*#__PURE__*/React.createElement(Divider, null));
    }), !hasPicks && !isToday && /*#__PURE__*/React.createElement(Spacing, {
      sizeLeft: "mega",
      paddingTop: "bit"
    }, /*#__PURE__*/React.createElement(Text, {
      as: "span",
      size: "mega",
      noMargin: true
    }, contestNoPickText))), hasLoyalty3Notification && /*#__PURE__*/React.createElement(Spacing, {
      paddingTop: "giga"
    }, /*#__PURE__*/React.createElement(NotificationCard, {
      titleText: loyalty3NotificationTitle,
      bodyText: loyalty3NotificationText
    }))))));
  })));
};

HeatStreak.propTypes = {
  streakList: propTypes.array,
  noPicksText: propTypes.string,
  todayNoPicksSubText: propTypes.string,
  gameStatusText: propTypes.string,
  resultsPendingText: propTypes.string,
  noPicksAggregatedText: propTypes.func,
  byPlayerId: propTypes.object,
  byTeamId: propTypes.object,
  gamesInProgress: propTypes.bool,
  noPicksAggregated: propTypes.object,
  platform: propTypes.string,
  language: propTypes.string
};

var mapStateToProps$g = function mapStateToProps(state) {
  var config = state.config,
      strings = state.strings,
      heatStreak = state.heatStreak,
      games = state.games;
  var noGamesStarted = games.noGamesStarted,
      allGamesStarted = games.allGamesStarted;
  var byDate = heatStreak.byDate,
      byPlayerId = heatStreak.byPlayerId,
      byTeamId = heatStreak.byTeamId;
  var isFrench = config.language === 'fr';
  var allStrings = {
    title: strings['titles/section/howToPlay/text'],
    noPicksText: strings['history/noPicks/text'],
    gameStatusText: strings['history/inProgress/text'],
    todayNoPicksSubText: strings['history/noPicks/title'],
    resultsPendingText: strings['history/resultsPending/text'],
    noPicksAggregatedText: strings['history/noPicksAggregated/text'],
    loyalty3NotificationTitle: strings['history/notification/loyalty3/title'],
    loyalty3NotificationText: strings['history/notification/loyalty3/text'],
    yourPicksText: strings['titles/section/yourPicks/text']
  };
  var statusStrings = {
    1: strings['heatstreak/correct/text'],
    2: strings['heatstreak/incorrect/text'],
    3: strings['heatstreak/noPicks/text'],
    4: strings['heatstreak/offers/text']
  };
  var streakList = Object.keys(byDate).map(function (id, index) {
    var date = byDate[id];
    var month = date.month,
        day = date.day,
        points = date.points,
        streak = date.streak,
        offers = date.offers;
    var eventDate = isFrench ? day + " " + strings["dates/month/" + month + "/text"] + " " : strings["dates/month/" + month + "/text"] + " " + day;
    var noPicksText = statusStrings[3];
    var hasPicks = !!date.picks.length;
    var hasLoyalty3Notification = date.contestDate === Loyalty3NotificationDate;
    var isToday = isDateToday(date.contestDate);
    var isYesterday = isDateYesterday(date.contestDate);
    var isUnscored = isYesterday && date.picks[0] && !Object.prototype.hasOwnProperty.call(date.picks[0], 'correct');
    var todayDateText = isToday && strings['dates/today/text'];
    var yesterdayDateText = isYesterday && strings['dates/yesterday/text'];
    var dateText = todayDateText || yesterdayDateText || eventDate;
    var pickStatustext = points !== 0 ? statusStrings[1](points) : offers.length !== 0 ? statusStrings[4] : statusStrings[2];
    var todayVariantWithPicks = isToday && hasPicks && 'locked';
    var todayVariantWithoutPicks = isToday && !hasPicks && 'image';
    var unscoredHeatlineColor = isUnscored && 'h0';
    var coldHeatlineColor = Object.prototype.hasOwnProperty.call(date, 'streak') && !streak && 'cold';
    var streakHeatlineColor = streak && 'h4';
    var heatLineStreak = unscoredHeatlineColor || coldHeatlineColor || streakHeatlineColor || 'h0';
    var otherVariant = streak ? 'hot' : 'cold';
    var streakVariant = todayVariantWithPicks || todayVariantWithoutPicks || otherVariant;
    var pointScoreColor = (points !== 0 || offers.length !== 0) && 'bl900';
    var unscoredColor = isUnscored && 'n900';
    var statusBgColor = pointScoreColor || unscoredColor || 'r500';
    var yourPicksText = allStrings.yourPicksText;
    return _extends({}, date, {
      key: "streak-" + index + "-" + month + "-" + day,
      hasPicks: hasPicks,
      hasLoyalty3Notification: hasLoyalty3Notification,
      dateText: dateText,
      heatLineStreak: heatLineStreak,
      streak: streak,
      streakVariant: streakVariant,
      streakText: streak && date.streak,
      statusBgColor: statusBgColor,
      isToday: isToday,
      isYesterday: isYesterday,
      isUnscored: isUnscored,
      pickStatustext: pickStatustext,
      yourPicksText: yourPicksText,
      noPicksText: noPicksText
    });
  });
  var noPickDateList = Object.keys(byDate).filter(function (id) {
    return !byDate[id].picks.length;
  }).reduce(function (acc, curr) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[curr] = true, _extends2));
  }, {});
  var noPicksAggregated = {};
  var noPickDateListArr = Object.keys(noPickDateList);
  var startAggregateDate = null;
  var dateIndex = noPickDateListArr.indexOf(Loyalty3NotificationDate);

  if (dateIndex > -1) {
    noPickDateListArr.splice(dateIndex, 1);
  }

  for (var i = 0; i < noPickDateListArr.length; i++) {
    var currentDate = noPickDateListArr[i];
    var nextDate = noPickDateListArr[i - 1];
    var prevDate = noPickDateListArr[i + 1];
    var currentMinusOne = getPreviousDay(currentDate);
    var currentPlusOne = getNextDay(currentDate);

    if (!startAggregateDate && currentMinusOne === prevDate && currentPlusOne === nextDate) {
      startAggregateDate = nextDate;
    }

    if (startAggregateDate) {
      var _extends3;

      noPicksAggregated[startAggregateDate] = _extends({}, noPicksAggregated[startAggregateDate], (_extends3 = {}, _extends3[nextDate] = true, _extends3));

      if (currentPlusOne !== nextDate) {
        startAggregateDate = null;
      }
    }
  }

  var gamesInProgress = !noGamesStarted && !allGamesStarted;
  return _extends({}, allStrings, {
    byPlayerId: byPlayerId,
    byTeamId: byTeamId,
    streakList: streakList,
    gamesInProgress: gamesInProgress,
    noPicksAggregated: noPicksAggregated
  });
};

var HeatStreak$1 = connect(mapStateToProps$g)(HeatStreak);

var _templateObject$1p, _templateObject2$16, _templateObject3$T;
var EmptyStateContainer = styled('div')(_templateObject$1p || (_templateObject$1p = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-height: 400px;\n  padding: 70px 20px;\n"])));
var ImageContainer$6 = styled('div')(_templateObject2$16 || (_templateObject2$16 = _taggedTemplateLiteralLoose(["\n  width: 52px;\n  height: 52px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var EmptyStateText = styled(Text)(_templateObject3$T || (_templateObject3$T = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.n650;
});

var History = function History() {
  var _useSelector = useSelector(function (state) {
    return state;
  }),
      strings = _useSelector.strings,
      heatStreak = _useSelector.heatStreak;

  var historyData = (heatStreak === null || heatStreak === void 0 ? void 0 : heatStreak.byDate) || {};
  var historyDates = Object.keys(historyData);
  var resultsMissing = historyDates.length === 0;
  var emptyHistoryMessage = strings['history/empty/title'];
  var cdnImages = useCdnImage(['hockeySticks']);
  return /*#__PURE__*/React.createElement(ColorProvider, {
    cssProp: "background",
    variant: "lightGrey"
  }, resultsMissing ? /*#__PURE__*/React.createElement(EmptyStateContainer, null, /*#__PURE__*/React.createElement(ImageContainer$6, null, /*#__PURE__*/React.createElement(Image, {
    src: cdnImages.hockeySticks,
    alt: "Empty state image"
  })), /*#__PURE__*/React.createElement(EmptyStateText, {
    size: "peta"
  }, emptyHistoryMessage)) : /*#__PURE__*/React.createElement(HeatStreak$1, null));
};

var assetSet$9 = function assetSet(filename) {
  return getAssetSet(useCdnImage, filename);
};

var Loading = function Loading(_ref) {
  var loadingText = _ref.loadingText,
      isFixed = _ref.isFixed;
  return /*#__PURE__*/React.createElement(Loader, {
    assetUrl: assetSet$9('loadingSticks'),
    text: loadingText,
    isFixed: isFixed
  });
};

var mapStateToProps$h = function mapStateToProps(state) {
  var strings = state.strings;
  return {
    loadingText: strings['global/loading/text']
  };
};

Loading.propTypes = {
  loadingText: propTypes.string,
  isFixed: propTypes.bool
};
var Loader$1 = connect(mapStateToProps$h)(Loading);

var _templateObject$1q, _templateObject2$17, _templateObject3$U, _templateObject4$J, _templateObject5$x, _templateObject6$r, _templateObject7$k, _templateObject8$g, _templateObject9$a, _templateObject10$6, _templateObject11$4, _templateObject12$3, _templateObject13$1;

var assetSet$a = function assetSet(filename) {
  return getAssetSet(useCdnImage, filename);
};

var tableStyles = function tableStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$1q || (_templateObject$1q = _taggedTemplateLiteralLoose(["\n  table-layout: fixed;\n  width: 100%;\n  tbody {\n    position: relative;\n  }\n  tbody tr:nth-of-type(odd) {\n    background-color: #f2f2f2;\n  }\n  tbody tr.active {\n    background-color: ", ";\n  }\n  tbody td.devider {\n    padding: 0;\n    overflow: visible;\n  }\n  tbody tr.deviderRow {\n    height: 90px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    position: absolute;\n    width: 100%;\n  }\n  border-collapse: collapse;\n\n  thead th:nth-of-type(1) {\n    width: 17.5%;\n  }\n\n  thead th:nth-of-type(2) {\n    width: 30%;\n  }\n\n  thead th:nth-of-type(3) {\n    width: 17.5%;\n  }\n\n  thead th:nth-of-type(4) {\n    width: 17.5%;\n  }\n\n  thead th:nth-of-type(5) {\n    width: 17.5%;\n  }\n\n  td {\n    padding: 0.9em 0.3em 0.9em 0.3em;\n    font-size: 15px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n  th {\n    padding: 0.9em 0.3em 0.9em 0.3em;\n    word-break: break-word;\n    font-size: 13px;\n    letter-spacing: -0.24px;\n  }\n"])), theme.colors.g100);
};

var Table = styled('table')(_templateObject2$17 || (_templateObject2$17 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), tableStyles);

var theadStyles = function theadStyles() {
  return css(_templateObject3$U || (_templateObject3$U = _taggedTemplateLiteralLoose(["\n  transform: scale(1);\n  box-shadow: 0 4px 6px -4px rgba(0, 0, 0, 0.25);\n  color: #07345c;\n"])));
};

var THead = styled('thead')(_templateObject4$J || (_templateObject4$J = _taggedTemplateLiteralLoose(["\n  ", "\n"])), theadStyles);

var cellStyles = function cellStyles() {
  return css(_templateObject5$x || (_templateObject5$x = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  vertical-align: middle;\n"])));
};

var Cell = styled('td')(_templateObject6$r || (_templateObject6$r = _taggedTemplateLiteralLoose(["\n  ", "\n  text-align: ", "\n"])), cellStyles, function (props) {
  return props.textAlign;
});
var THLeftAlign = styled('th')(_templateObject7$k || (_templateObject7$k = _taggedTemplateLiteralLoose(["\n  text-align: left;\n"])));

var rankStyles = function rankStyles() {
  return css(_templateObject8$g || (_templateObject8$g = _taggedTemplateLiteralLoose(["\n  width: 1.8em;\n  height: 1.8em;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-image: url('https://cdn.rbi.digital/hockey/icon_badge_gold.svg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  padding-top: 2px;\n"])));
};

var Rank$1 = styled('span')(_templateObject9$a || (_templateObject9$a = _taggedTemplateLiteralLoose(["\n  ", "\n"])), rankStyles);
var Caption = styled('caption')(_templateObject10$6 || (_templateObject10$6 = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var FillContainer = styled('div')(_templateObject11$4 || (_templateObject11$4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  background-color: #f2f2f2;\n  height: 70vh;\n  justify-content: center;\n  align-items: center;\n"])));
var TopFade = styled('div')(_templateObject12$3 || (_templateObject12$3 = _taggedTemplateLiteralLoose(["\n  height: 100px;\n  background: linear-gradient(0deg, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 100%);\n"])));
var BottomFade = styled('div')(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteralLoose(["\n  height: 100px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 100%);\n"])));
var LeaderboardTable = React.forwardRef(function (_ref2, ref) {
  var data = _ref2.data,
      options = _ref2.options,
      selectedView = _ref2.selectedView;

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      strings = _useSelector.strings,
      leaderboard = _useSelector.leaderboard,
      config = _useSelector.config;

  var contestants = data.contestants,
      isTopRanked = data.isTopRanked,
      rank = data.rank,
      totalUsers = data.totalUsers;
  var language = config.language;
  var isLoading = leaderboard.isLoading,
      hasUserStats = leaderboard.hasUserStats;

  if (!isLoading && hasUserStats && contestants) {
    var numLowerRankedPlayers = totalUsers - rank;
    var _isLoading = leaderboard.isLoading;
    var challengeErrorText = leaderboard.challengeErrorCode && strings[leaderboard.challengeErrorCode];
    var assetSrc = assetSet$a(['loadingSticks']);
    var view = options.filter(function (opt) {
      return opt.key === selectedView;
    });
    var rankText = strings['leaderboard/table/rank'];
    var playerText = strings['leaderboard/table/player'];
    var correctText = strings['leaderboard/table/correct'];
    var pickText = strings['leaderboard/table/pick'];
    var streakText = strings['leaderboard/table/streak'];
    var numLowerRankedPlayersText = strings['leaderboard/table/endOfPlayerResults'];

    var buildListCells = function buildListCells(_ref3) {
      var key = _ref3.key,
          rank = _ref3.rank,
          username = _ref3.username,
          correctPicks = _ref3.correctPicks,
          pickAccuracy = _ref3.pickAccuracy,
          scoringStreak = _ref3.scoringStreak;
      return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(Cell, {
        key: key + "_" + rank
      }, rank < 6 ? /*#__PURE__*/React.createElement(Rank$1, null, rank) : Number(rank).toLocaleString((language || 'en') + "-CA")), /*#__PURE__*/React.createElement(Cell, {
        textAlign: "left"
      }, username), /*#__PURE__*/React.createElement(Cell, null, correctPicks), /*#__PURE__*/React.createElement(Cell, null, pickAccuracy, "%"), /*#__PURE__*/React.createElement(Cell, null, /*#__PURE__*/React.createElement(HeatStreakText, {
        variant: scoringStreak > 0 ? 'hot' : 'cold',
        showIcon: true,
        size: "giga",
        text: scoringStreak
      })));
    };

    var buildListElm = function buildListElm(_ref4) {
      var selectedView = _ref4.selectedView,
          user = _ref4.user,
          dataSection = _ref4.dataSection,
          playerIndex = _ref4.playerIndex,
          currentContestant = _ref4.currentContestant;

      if (currentContestant) {
        return /*#__PURE__*/React.createElement("tr", {
          key: selectedView + "_" + dataSection + "_" + playerIndex,
          className: currentContestant ? 'active' : '',
          ref: ref
        }, buildListCells({
          key: selectedView + "_" + dataSection + "_" + playerIndex,
          rank: user.rank,
          username: user.username,
          correctPicks: user.correctPicks,
          pickAccuracy: user.pickAccuracy,
          scoringStreak: user.scoringStreak
        }));
      }

      return /*#__PURE__*/React.createElement("tr", {
        key: selectedView + "_" + dataSection + "_" + playerIndex,
        className: currentContestant ? 'current' : '',
        ref: ref
      }, buildListCells({
        key: selectedView + "_" + dataSection + "_" + playerIndex,
        rank: user.rank,
        username: user.username,
        correctPicks: user.correctPicks,
        pickAccuracy: user.pickAccuracy,
        scoringStreak: user.scoringStreak
      }));
    };

    return /*#__PURE__*/React.createElement(Fragment$1, null, (_isLoading || contestants) && /*#__PURE__*/React.createElement(Table, null, view.length > 0 && /*#__PURE__*/React.createElement(Caption, null, view[0].value), /*#__PURE__*/React.createElement(THead, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, rankText), /*#__PURE__*/React.createElement(THLeftAlign, null, playerText), /*#__PURE__*/React.createElement("th", null, correctText), /*#__PURE__*/React.createElement("th", null, pickText), /*#__PURE__*/React.createElement("th", null, streakText))), /*#__PURE__*/React.createElement("tbody", null, !_isLoading && hasUserStats && contestants && contestants.map(function (set, i) {
      return set.map(function (user, j) {
        var currentContestantFlag = user.me === true;

        if (i === 0 && j === 4) {
          return /*#__PURE__*/React.createElement(Fragment$1, {
            key: "row_" + selectedView + "_ad_" + i + "_" + j
          }, buildListElm({
            selectedView: selectedView,
            user: user,
            dataSection: i,
            playerIndex: j,
            currentContestant: currentContestantFlag
          }));
        }

        if (contestants[i + 1] !== undefined && contestants[i + 1].length !== 0 && set.length - 1 === j && !isTopRanked) {
          return /*#__PURE__*/React.createElement(Fragment$1, null, buildListElm({
            selectedView: selectedView,
            user: user,
            dataSection: i,
            playerIndex: j,
            currentContestant: currentContestantFlag
          }), /*#__PURE__*/React.createElement("tr", {
            key: selectedView + "_" + i + "_spacer",
            className: "deviderRow"
          }, /*#__PURE__*/React.createElement(Cell, {
            colSpan: 5,
            className: "devider"
          }, /*#__PURE__*/React.createElement(TopFade, null), /*#__PURE__*/React.createElement(LeaderboardResultsDivider, {
            playerCount: rank - 1
          }), /*#__PURE__*/React.createElement(BottomFade, null))));
        }

        if (contestants[i + 1] === undefined && set.length - 1 === j) {
          return /*#__PURE__*/React.createElement(Fragment$1, {
            key: selectedView + "_" + i + "_players_below_container"
          }, buildListElm({
            selectedView: selectedView,
            user: user,
            dataSection: i,
            playerIndex: j,
            currentContestant: currentContestantFlag
          }), rank && /*#__PURE__*/React.createElement("tr", {
            key: selectedView + "_" + i + "_players_below",
            className: ""
          }, /*#__PURE__*/React.createElement(Cell, {
            colSpan: 5,
            className: ""
          }, /*#__PURE__*/React.createElement(Text, {
            as: "span",
            size: "tera",
            bold: true
          }, numLowerRankedPlayersText(numLowerRankedPlayers)))));
        }

        return buildListElm({
          selectedView: selectedView,
          user: user,
          dataSection: i,
          playerIndex: j,
          currentContestant: currentContestantFlag
        });
      });
    }))), !_isLoading && challengeErrorText && /*#__PURE__*/React.createElement(FillContainer, {
      style: {
        height: '50vh'
      }
    }, /*#__PURE__*/React.createElement(Image, {
      src: assetSrc,
      style: {
        height: '64px',
        width: 'auto',
        margin: '0 0 16px 0'
      }
    }), /*#__PURE__*/React.createElement(Spacing, {
      sizeLeft: "zetta",
      sizeRight: "zetta",
      sizeTop: "giga"
    }, /*#__PURE__*/React.createElement(ColorProvider, {
      variant: "black"
    }, /*#__PURE__*/React.createElement(Text, {
      as: "span",
      size: "giga",
      centered: true
    }, challengeErrorText)))));
  }

  return /*#__PURE__*/React.createElement(FillContainer, null, /*#__PURE__*/React.createElement(Loader$1, {
    isFixed: false
  }));
});
LeaderboardTable.propTypes = {
  isLoading: propTypes.bool,
  data: propTypes.arrayOf(propTypes.array),
  leaderboardAdConfig: propTypes.object,
  lid: propTypes.string,
  platform: propTypes.string,
  language: propTypes.string,
  options: propTypes.arrayOf(propTypes.exact({
    key: propTypes.string,
    value: propTypes.string
  }))
};

var _templateObject$1r, _templateObject2$18, _templateObject3$V, _templateObject4$K, _templateObject5$y;
var NavWrapper = styled.nav(_templateObject$1r || (_templateObject$1r = _taggedTemplateLiteralLoose(["\n  position: sticky;\n  padding: 0px ", " ", ";\n  background: ", ";\n  color: #fff;\n  font-weight: bold;\n  z-index: 1;\n  div {\n    font-size: ", ";\n    font-weight: 700;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacings.giga;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacings.kilo;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.black;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.text.tera.fontSize;
});
var ChallengeList = styled.ol(_templateObject2$18 || (_templateObject2$18 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow-x: scroll;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n"])));
var ChallengeItem = styled.li(_templateObject3$V || (_templateObject3$V = _taggedTemplateLiteralLoose(["\n  flex-grow: 1;\n  padding: ", ";\n  :first-child {\n    padding: ", ";\n  }\n  :last-child {\n    padding: ", ";\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacings["byte"];
}, function (_ref6) {
  var theme = _ref6.theme;
  return "0 " + theme.spacings["byte"] + " 0 0";
}, function (_ref7) {
  var theme = _ref7.theme;
  return "0 0 0 " + theme.spacings["byte"];
});
var ChallengeButton = styled.button(_templateObject4$K || (_templateObject4$K = _taggedTemplateLiteralLoose(["\n  box-sizing: content-box;\n  font-size: ", ";\n  line-height: ", ";\n  padding: ", ";\n  white-space: nowrap;\n  height: 16px;\n  border-radius: 100px;\n  border: 2px ", " solid;\n  background: ", ";\n  color: ", ";\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.text.giga.fontSize;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.typography.text.giga.lineHeight;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.spacings["byte"] + " " + theme.spacings.giga;
}, function (_ref11) {
  var theme = _ref11.theme,
      current = _ref11.current;
  return current ? theme.colors.g900 : theme.colors.white;
}, function (_ref12) {
  var selected = _ref12.selected,
      theme = _ref12.theme,
      current = _ref12.current;
  return current && selected ? theme.colors.g900 : !current && selected ? theme.colors.white : theme.colors.black;
}, function (_ref13) {
  var selected = _ref13.selected,
      theme = _ref13.theme,
      current = _ref13.current;
  return !current && selected ? theme.colors.black : theme.colors.white;
});
var DisabledChallengeButton = styled(ChallengeButton)(_templateObject5$y || (_templateObject5$y = _taggedTemplateLiteralLoose(["\n  box-sizing: content-box;\n  font-size: ", ";\n  line-height: ", ";\n  padding: ", ";\n  white-space: nowrap;\n  height: 16px;\n  border-radius: 100px;\n  background: #131112;\n  color: #aaa;\n  border: 2px solid #aaa;\n"])), function (_ref14) {
  var theme = _ref14.theme;
  return theme.typography.text.giga.fontSize;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.typography.text.giga.lineHeight;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.spacings["byte"] + " " + theme.spacings.giga;
});

var LeaderboardNav = function LeaderboardNav(_ref17) {
  var _ref17$totalChallenge = _ref17.totalChallenges,
      totalChallenges = _ref17$totalChallenge === void 0 ? 8 : _ref17$totalChallenge,
      _ref17$onChange = _ref17.onChange,
      onChange = _ref17$onChange === void 0 ? function () {} : _ref17$onChange;
  var dispatch = useDispatch();

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      config = _useSelector.config,
      strings = _useSelector.strings,
      leaderboard = _useSelector.leaderboard;

  var platform = config.platform,
      env = config.env;
  var pillText = strings['leaderboard/nav/pill'];
  var selectedChallenge = leaderboard.selectedChallenge,
      currentChallenge = leaderboard.currentChallenge;
  var challengeNumber = selectedChallenge || currentChallenge;
  var scrollToView = useCallback(function (node) {
    if (node !== null) {
      var width = 0;

      for (var i = 0; i < currentChallenge - 1; i++) {
        width += node.childNodes[i].offsetWidth;
      }

      node.scrollTo(width, 0);
    }
  }, [currentChallenge]);

  var handleSelection = function handleSelection(selection) {
    fireMessageEvent({
      platform: platform,
      env: env,
      title: MONTHLY_CHALLENGE_TAB_SELECTED(selection)
    });
    onChange(selection);
    dispatch(setChallengeNumber(selection));
  };

  return /*#__PURE__*/React.createElement(NavWrapper, null, /*#__PURE__*/React.createElement(ChallengeList, {
    ref: scrollToView
  }, Array(totalChallenges).fill(0).map(function (_, i) {
    return /*#__PURE__*/React.createElement(ChallengeItem, {
      key: i
    }, i < currentChallenge ? /*#__PURE__*/React.createElement(ChallengeButton, {
      selected: challengeNumber === i + 1,
      current: i === currentChallenge - 1,
      onClick: function onClick() {
        return handleSelection(i + 1);
      }
    }, pillText, " ", i + 1) : /*#__PURE__*/React.createElement(DisabledChallengeButton, {
      disabled: true
    }, pillText, " ", i + 1));
  })));
};

LeaderboardNav.propTypes = {
  totalChallenges: propTypes.number,
  onChange: propTypes.func
};

var _templateObject$1s, _templateObject2$19, _templateObject3$W, _templateObject4$L;
var ToggleButton = styled.button(_templateObject$1s || (_templateObject$1s = _taggedTemplateLiteralLoose(["\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  width: 100%;\n  height: 100%;\n  min-height: ", ";\n  background-color: ", ";\n  padding: ", ";\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacings.peta;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.headerBg;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacings.bit;
}, function (_ref4) {
  var isSelected = _ref4.isSelected,
      theme = _ref4.theme;
  return isSelected && "background-color: " + theme.colors.white;
});
var ButtonList = styled.ul(_templateObject2$19 || (_templateObject2$19 = _taggedTemplateLiteralLoose(["\n  margin: 0;\n  padding: 0;\n  display: flex;\n  width: 100%;\n"])));
var ButtonListItem = styled.li(_templateObject3$W || (_templateObject3$W = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  width: 33.33%;\n  :first-of-type {\n    button {\n      border-radius: 4px 0 0 4px;\n    }\n  }\n  :last-child {\n    button {\n      border-radius: 0 4px 4px 0;\n    }\n  }\n"])));
var Label$1 = styled.label(_templateObject4$L || (_templateObject4$L = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  ", "\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.white;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeight.regular;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.text.giga.fontSize;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.text.giga.lineHeight;
}, function (_ref9) {
  var isSelected = _ref9.isSelected,
      theme = _ref9.theme;
  return isSelected && "color: " + theme.colors.black;
});
var clickedType$2 = analyticActionMap.clickedType,
    path$3 = analyticActionMap.path,
    tabType = analyticActionMap.tabType;

var ToggleViewButton = function ToggleViewButton(_ref10) {
  var options = _ref10.options,
      handleViewToggle = _ref10.handleViewToggle,
      currentView = _ref10.currentView;

  var _useSelector = useSelector(function (state) {
    return state.config;
  }),
      env = _useSelector.env,
      platform = _useSelector.platform;

  var HandleViewChange = function HandleViewChange(key) {
    fireMessageEvent({
      platform: platform,
      env: env,
      title: clickedType$2,
      data: {
        path: path$3,
        element: tabType,
        element_name: "leaderboard_" + key
      }
    });
    handleViewToggle(key);
  };

  return /*#__PURE__*/React.createElement(ButtonList, null, options.map(function (option) {
    return /*#__PURE__*/React.createElement(ButtonListItem, {
      key: option.key
    }, /*#__PURE__*/React.createElement(ToggleButton, {
      onClick: function onClick() {
        return HandleViewChange(option.key);
      },
      isSelected: currentView === option.key
    }, /*#__PURE__*/React.createElement(Label$1, {
      isSelected: currentView === option.key
    }, option.value)));
  }));
};

ToggleViewButton.propTypes = {
  options: propTypes.arrayOf(propTypes.exact({
    key: propTypes.string,
    value: propTypes.string
  })),
  handleViewToggle: propTypes.func,
  currentView: propTypes.string
};

var _templateObject$1t;
var ToggleWrapper = styled.section(_templateObject$1t || (_templateObject$1t = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  ", "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.headerBg;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "padding: " + theme.spacings.mega + " " + theme.spacings.mega + ";";
});

var LeaderboardToggle = function LeaderboardToggle(_ref3) {
  var options = _ref3.options,
      handleViewToggle = _ref3.handleViewToggle,
      currentView = _ref3.currentView;
  return /*#__PURE__*/React.createElement(ToggleWrapper, null, /*#__PURE__*/React.createElement(ToggleViewButton, {
    options: options,
    handleViewToggle: handleViewToggle,
    currentView: currentView
  }));
};

LeaderboardToggle.propTypes = {
  options: propTypes.arrayOf(propTypes.exact({
    key: propTypes.string,
    value: propTypes.string
  })),
  handleViewToggle: propTypes.func,
  currentView: propTypes.string
};

var _templateObject$1u, _templateObject2$1a, _templateObject3$X, _templateObject4$M, _templateObject5$z, _templateObject6$s, _templateObject7$l, _templateObject8$h, _templateObject9$b, _templateObject10$7, _templateObject11$5, _templateObject12$4, _templateObject13$2;
var ImageContainer$7 = styled.div(_templateObject$1u || (_templateObject$1u = _taggedTemplateLiteralLoose(["\n  width: ", ";\n  margin-bottom: ", ";\n  margin-right: ", ";\n  margin-left: ", ";\n"])), function (props) {
  return "" + props.width;
}, function (props) {
  return "" + props.bottomMargin;
}, function (props) {
  return "" + props.rightMargin;
}, function (props) {
  return "" + props.leftMargin;
});
var BannerWrapper = styled.section(_templateObject2$1a || (_templateObject2$1a = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  ", "\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.headerBg;
}, function (_ref2) {
  var theme = _ref2.theme;
  return "padding: 0 0 " + theme.spacings.mega + " 0;";
});
var TextColumn = styled.section(_templateObject3$X || (_templateObject3$X = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  width: 49%;\n  margin-left: ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacings.giga;
});

var headingBaseStyles = function headingBaseStyles(_ref5) {
  var theme = _ref5.theme;
  return css(_templateObject4$M || (_templateObject4$M = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: bold;\n  margin-bottom: ", ";\n  margin-top: 0;\n"])), theme.typography.headings.mega.fontSize, theme.typography.headings.deca.lineHeight, theme.spacings["byte"]);
};

var DateWrapper = styled.section(_templateObject5$z || (_templateObject5$z = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  height: ", ";\n  margin-bottom: ", ";\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacings.giga;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacings["byte"];
});

var dateTextBaseStyles = function dateTextBaseStyles(_ref8) {
  var theme = _ref8.theme;
  return css(_templateObject6$s || (_templateObject6$s = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  font-size: ", ";\n  line-height: ", ";\n  padding-top: ", ";\n"])), theme.typography.subHeadings["byte"].fontSize, theme.typography.subHeadings["byte"].fontSize, theme.spacings.atom);
};

var StatusWrapper = styled.section(_templateObject7$l || (_templateObject7$l = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-self: center;\n  width: 55%;\n  justify-content: space-around;\n"])));
var Badge$1 = styled.div(_templateObject8$h || (_templateObject8$h = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border-radius: 12px;\n  font-size: 10px;\n  font-weight: 900;\n  padding: ", ";\n  display: flex;\n  align-items: center;\n  line-height: 10px;\n  text-align: center;\n"])), function (props) {
  return props.theme.colors[props.color];
}, function (_ref9) {
  var theme = _ref9.theme;
  return "5px " + theme.spacings["byte"] + " 3px " + theme.spacings["byte"];
});
var ImageColumn = styled.section(_templateObject9$b || (_templateObject9$b = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  display: flex;\n  width: 47%;\n  justify-content: center;\n  align-items: center;\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.white;
});

var textBaseStyles = function textBaseStyles(_ref11) {
  var theme = _ref11.theme;
  return css(_templateObject10$7 || (_templateObject10$7 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: 400;\n  margin-bottom: 0;\n"])), theme.colors.white, theme.typography.text.kilo.fontSize, theme.typography.text.bit.lineHeight);
};

var linkBaseStyles = function linkBaseStyles(_ref12) {
  var theme = _ref12.theme;
  return css(_templateObject11$5 || (_templateObject11$5 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n"])), theme.colors.white, theme.typography.text.kilo.fontSize, theme.typography.text.bit.lineHeight);
};

var AllImagesWrapper = styled.div(_templateObject12$4 || (_templateObject12$4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  height: min-content;\n"])));
var StyledDateText = styled(Text)(dateTextBaseStyles);
var StyledHeading$4 = styled(Heading)(headingBaseStyles);
var StyledParagraph = styled(Text)(textBaseStyles);
var StyledLink$1 = styled(NavLink)(linkBaseStyles);
var StyledTextBlock$1 = styled.div(_templateObject13$2 || (_templateObject13$2 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), textBaseStyles);

var LeaderboardBanner = function LeaderboardBanner(_ref13) {
  var text = _ref13.text,
      images = _ref13.images,
      inProgressText = _ref13.inProgressText,
      completedText = _ref13.completedText,
      showAsCompleted = _ref13.showAsCompleted,
      language = _ref13.language;
  return /*#__PURE__*/React.createElement(BannerWrapper, null, /*#__PURE__*/React.createElement(TextColumn, null, /*#__PURE__*/React.createElement(StyledHeading$4, null, text.header), /*#__PURE__*/React.createElement(DateWrapper, null, /*#__PURE__*/React.createElement(StyledDateText, null, text.date), /*#__PURE__*/React.createElement(StatusWrapper, null, showAsCompleted && /*#__PURE__*/React.createElement(Badge$1, {
    color: "n600"
  }, completedText), !showAsCompleted && /*#__PURE__*/React.createElement(Badge$1, {
    color: "g900"
  }, inProgressText))), text.link && /*#__PURE__*/React.createElement(StyledTextBlock$1, null, /*#__PURE__*/React.createElement(StyledParagraph, {
    style: {
      width: "" + (language === 'en' ? '90%' : '100%')
    }
  }, text.paragraph), /*#__PURE__*/React.createElement(StyledLink$1, {
    to: "/game-info"
  }, text.link)), !text.link && /*#__PURE__*/React.createElement(StyledParagraph, null, text.paragraph)), /*#__PURE__*/React.createElement(ImageColumn, null, /*#__PURE__*/React.createElement(AllImagesWrapper, null, images.map(function (image, i) {
    return /*#__PURE__*/React.createElement(ImageContainer$7, {
      key: i,
      width: image.width,
      bottomMargin: image.bottomMargin,
      rightMargin: image.rightMargin,
      leftMargin: image.leftMargin
    }, /*#__PURE__*/React.createElement(Image, {
      src: image.src
    }));
  }))));
};

LeaderboardBanner.propTypes = {
  text: propTypes.shape({
    header: propTypes.string,
    date: propTypes.string,
    paragraph: propTypes.string
  }),
  images: propTypes.arrayOf(propTypes.shape({
    width: propTypes.string,
    bottomMargin: propTypes.string,
    rightMargin: propTypes.string
  })),
  inProgressText: propTypes.string,
  completedText: propTypes.string,
  showAsCompleted: propTypes["boolean"]
};

var _templateObject$1v, _templateObject2$1b, _templateObject3$Y, _templateObject4$N, _templateObject5$A, _templateObject6$t, _templateObject7$m;
var RankingWrapper = styled.div(_templateObject$1v || (_templateObject$1v = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  color: ", ";\n  margin-top: ", ";\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  width: 100%;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.headerBg90;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacings.mega;
});
var StatRow = styled.div(_templateObject2$1b || (_templateObject2$1b = _taggedTemplateLiteralLoose(["\n  flex-grow: 1;\n  padding-top: 4px;\n"])));
var StatTopRow = styled.div(_templateObject3$Y || (_templateObject3$Y = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n\n  > div:nth-of-type(1) {\n    width: 37%;\n  }\n\n  > div:nth-of-type(2) {\n    width: 21%;\n  }\n\n  > div:nth-of-type(3) {\n    width: 21%;\n  }\n\n  > div:nth-of-type(4) {\n    width: 21%;\n  }\n"])));

var cellStyles$1 = function cellStyles(_ref4) {
  var _ref4$textAlign = _ref4.textAlign,
      textAlign = _ref4$textAlign === void 0 ? 'center' : _ref4$textAlign;
  return css(_templateObject4$N || (_templateObject4$N = _taggedTemplateLiteralLoose(["\n    padding: 0 0.3em 0 0.3em;\n    text-align: ", ";\n  "])), textAlign);
};

var Cell$1 = styled('div')(cellStyles$1);
var RankingChangeRow = styled.div(_templateObject5$A || (_templateObject5$A = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n"])));
var IconContainer$6 = styled.div(_templateObject6$t || (_templateObject6$t = _taggedTemplateLiteralLoose(["\n  margin-left: 2px;\n  svg {\n    vertical-align: baseline;\n  }\n"])));
var ScreenReaderText = styled.span(_templateObject7$m || (_templateObject7$m = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));

var PersonalRanking = function PersonalRanking(_ref5) {
  var _userStats$challenges;

  var data = _ref5.data,
      selectedBoard = _ref5.selectedBoard;

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      strings = _useSelector.strings,
      leaderboard = _useSelector.leaderboard,
      config = _useSelector.config;

  var language = config.language;
  var userStats = leaderboard.userStats,
      selectedChallenge = leaderboard.selectedChallenge;
  var correctPicks = data.correctPicks,
      currentChallenge = data.currentChallenge,
      pickAccuracy = data.pickAccuracy,
      rank = data.rank,
      rankChange = data.rankChange;
  var showRankingChange = selectedChallenge === currentChallenge || selectedBoard === 'season';
  var challenge = selectedChallenge || currentChallenge;
  var challengeData = ((_userStats$challenges = userStats.challenges) === null || _userStats$challenges === void 0 ? void 0 : _userStats$challenges[challenge]) || {};
  var rankChangeText = strings['leaderboard/personal-ranking/rank-change'];
  var username = userStats.username,
      scoringStreak = userStats.scoringStreak;

  var _useState = useState(false),
      setForceUpdate = _useState[1];

  useEffect(function () {
    console.log('rerendered!');
    setForceUpdate(function (prev) {
      return !prev;
    });
  }, [selectedBoard]);
  var caretTooltip = !challengeData.rankChange ? strings['leaderboard/personal-ranking/caret-tooltip/none'] : challengeData.rankChange > 0 ? strings['leaderboard/personal-ranking/caret-tooltip/up'] : strings['leaderboard/personal-ranking/caret-tooltip/down'];
  return /*#__PURE__*/React.createElement(RankingWrapper, null, /*#__PURE__*/React.createElement(Spacing, {
    sizeTop: "kilo",
    sizeBottom: "kilo",
    sizeLeft: "byte",
    sizeRight: "byte",
    width: "17.5%"
  }, /*#__PURE__*/React.createElement(CircleText, {
    as: "span",
    color: "#008A15",
    size: "byte",
    width: "45px",
    bold: true
  }, rank != null ? Number(rank).toLocaleString((language || 'en') + "-CA") : '--')), /*#__PURE__*/React.createElement(StatRow, null, /*#__PURE__*/React.createElement(StatTopRow, null, /*#__PURE__*/React.createElement(Cell$1, {
    textAlign: "left"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    noMargin: true,
    size: "tera"
  }, username)), /*#__PURE__*/React.createElement(Cell$1, null, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    noMargin: true,
    size: "tera"
  }, correctPicks)), /*#__PURE__*/React.createElement(Cell$1, null, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    noMargin: true,
    size: "tera"
  }, (pickAccuracy || '--') + '%')), /*#__PURE__*/React.createElement(Cell$1, null, /*#__PURE__*/React.createElement(HeatStreakText, {
    variant: scoringStreak > 0 ? 'hot' : 'cold',
    showIcon: true,
    size: "giga",
    text: scoringStreak
  }))), showRankingChange && /*#__PURE__*/React.createElement(RankingChangeRow, null, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: "grey"
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    size: "mega",
    style: {
      paddingLeft: '0.3em'
    }
  }, rankChangeText)), /*#__PURE__*/React.createElement(Spacing, {
    sizeLeft: "bit",
    width: "auto"
  }, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: rankChange === 0 ? 'grey' : rankChange > 0 ? 'g800' : 'r300'
  }, /*#__PURE__*/React.createElement(Text, {
    as: "span",
    size: "mega"
  }, Math.abs(rankChange)))), /*#__PURE__*/React.createElement(IconContainer$6, null, rankChange !== 0 && /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: rankChange > 0 ? 'g800' : 'r300'
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: rankChange > 0 ? 'caret-up' : 'caret-down',
    size: "sm",
    "aria-hidden": true
  })), /*#__PURE__*/React.createElement(ScreenReaderText, {
    size: "mega"
  }, caretTooltip))))));
};

PersonalRanking.propTypes = {
  showRankingChange: propTypes.bool,
  rankChangeText: propTypes.string,
  caretTooltip: propTypes.string,
  rankChange: propTypes.number,
  correctPicks: propTypes.number,
  pickAccuracy: propTypes.number,
  rank: propTypes.number,
  scoringStreak: propTypes.number,
  username: propTypes.string,
  language: propTypes.string
};

var _templateObject$1w;
var ButtonContainer$2 = styled('div')(_templateObject$1w || (_templateObject$1w = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));

var _templateObject$1x;
var Description = styled(Text)(_templateObject$1x || (_templateObject$1x = _taggedTemplateLiteralLoose(["\n  padding: ", "; 24px;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacings.kilo;
});

var _templateObject$1y, _templateObject2$1c;
var cdnUrl = useCdnUrl();
var ComingSoonContainer = styled('div')(_templateObject$1y || (_templateObject$1y = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  justify-content: flex-start;\n  align-items: center;\n  padding: 18px 40px 30px 40px;\n  p {\n    color: ", ";\n  }\n  button {\n    margin-top: 10px;\n    margin-bottom: 70px;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.black;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
});
var ImageContainer$8 = styled('img')(_templateObject2$1c || (_templateObject2$1c = _taggedTemplateLiteralLoose(["\n  height: 250px;\n  margin-bottom: 21px;\n"])));

var ComingSoon = function ComingSoon() {
  var _useSelector = useSelector(function (state) {
    return state;
  }),
      strings = _useSelector.strings;

  var comingSoonAssetSrc = cdnUrl + "2025-2026_stanley_cup.png";
  var comingSoonTitle = strings['leaderboard/playoffs/coming-soon/title'];
  var comingSoonText = strings['leaderboard/playoffs/coming-soon/text'];
  var comingSoonbtn1 = strings['leaderboard/playoffs/coming-soon/btn1'];
  var comingSoonbtn2 = strings['leaderboard/playoffs/coming-soon/btn2'];
  var dispatch = useDispatch();
  var navigate = useNavigate();

  var handleHeatStreakPanelClick = function handleHeatStreakPanelClick() {
    return dispatch(setHeatStreakPanelToOpen());
  };

  return /*#__PURE__*/React.createElement(ComingSoonContainer, null, /*#__PURE__*/React.createElement(ImageContainer$8, {
    src: comingSoonAssetSrc
  }), /*#__PURE__*/React.createElement(Text, {
    size: "peta",
    centered: true,
    heading: true,
    bold: true
  }, comingSoonTitle), /*#__PURE__*/React.createElement(Description, {
    size: "tera",
    centered: true,
    style: {
      padding: '0 0 12px 0'
    }
  }, comingSoonText), /*#__PURE__*/React.createElement(ButtonContainer$2, null, /*#__PURE__*/React.createElement(Button, {
    size: "peta",
    variant: "primary",
    style: {
      padding: '12px 16px',
      width: '100%',
      fontSize: '18px',
      marginBottom: '0'
    },
    onSelect: function onSelect() {
      navigate('/');
    },
    stretch: true
  }, comingSoonbtn1), /*#__PURE__*/React.createElement(Button, {
    size: "peta",
    variant: "primary",
    style: {
      padding: '12px 16px',
      width: '100%',
      fontSize: '18px'
    },
    onSelect: handleHeatStreakPanelClick,
    stretch: true
  }, comingSoonbtn2)));
};

var _templateObject$1z, _templateObject2$1d;
var StyledLeaderboardFooter = styled.div(_templateObject$1z || (_templateObject$1z = _taggedTemplateLiteralLoose(["\n  position: sticky;\n  bottom: 0px;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var ErrorState = styled.div(_templateObject2$1d || (_templateObject2$1d = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  color: ", ";\n  font-weight: ", ";\n  text-align: center;\n  padding: ", ";\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.r500;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeight.bold;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacings.giga;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.text.giga;
});

var Leaderboard = function Leaderboard() {
  var cdnUrl = useCdnUrl();
  var theme = useTheme();
  var listItemRef = useRef();
  var boardToggleRef = useRef();
  var dispatch = useDispatch();

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      strings = _useSelector.strings,
      leaderboard = _useSelector.leaderboard,
      config = _useSelector.config;

  var platform = config.platform,
      env = config.env,
      language = config.language;
  var currentChallenge = leaderboard.currentChallenge,
      isCurrentlyPlayoffs = leaderboard.isCurrentlyPlayoffs,
      isCurrentlySeason = leaderboard.isCurrentlySeason,
      localLeaderboardData = leaderboard.localLeaderboardData,
      leaderboardData = leaderboard.leaderboardData,
      selectedBoard = leaderboard.selectedBoard,
      error = leaderboard.error,
      userStats = leaderboard.userStats,
      selectedChallenge = leaderboard.selectedChallenge;
  var clickedType = analyticActionMap.clickedType,
      path = analyticActionMap.path,
      buttonType = analyticActionMap.buttonType,
      seeYourPosition = analyticActionMap.seeYourPosition,
      scrollToTop = analyticActionMap.scrollToTop;
  var username = userStats.username,
      scoringStreak = userStats.scoringStreak;
  var challengeNumber = selectedChallenge || currentChallenge;

  var _useState = useState(challengeNumber),
      viewedChallenge = _useState[0],
      setViewedChallenge = _useState[1];

  var currentView = selectedBoard;
  var contestantData = leaderboardData.users || [];
  var localContestantData = localLeaderboardData.users || [];
  var currentChallengeUserRank;
  var isTopRanked = contestantData && contestantData.some(function (contestant) {
    return contestant.me === true;
  });
  var displayedLocalData;
  var displayedRankData;
  var fetchError = error;
  var leaderboardBtnText = strings['button/leaderboard/showPosition'];
  var scrollToTopText = strings['button/leaderboard/scrollToTop'];
  var errorStateText = strings['leaderboard/error/error-state'];
  var seasonText = strings['leaderboard/toggle/season'];
  var monthlyText = strings['leaderboard/toggle/monthly'];
  var playoffsText = strings['leaderboard/toggle/playoffs'];
  var seasonBannerText = {
    header: strings['leaderboard/banner/season/header'],
    date: strings['leaderboard/banner/season/date'],
    paragraph: strings['leaderboard/banner/season/paragraph'],
    link: strings['leaderboard/banner/season/link']
  };
  var monthlyBannerText = {
    header: strings['leaderboard/banner/monthly/header'],
    date: strings['leaderboard/banner/monthly/date'][challengeNumber - 1],
    paragraph: strings['leaderboard/banner/monthly/paragraph'],
    link: strings['leaderboard/banner/season/link']
  };
  var playoffsBannerText = {
    header: strings['leaderboard/banner/playoffs/header'],
    date: strings['leaderboard/banner/playoffs/date'],
    paragraph: strings['leaderboard/banner/playoffs/paragraph'],
    link: strings['leaderboard/banner/playoffs/link'],
    route: strings['leaderboard/banner/playoffs/route']
  };
  var inProgressText = strings['leaderboard/inProgress/text'];
  var completedText = strings['leaderboard/completed/text'];
  var imageOptions = {
    season: [{
      src: cdnUrl + "2025-2026_Season_Prize.png",
      width: '100%',
      rightMargin: theme.spacings.kilo
    }],
    monthly: [{
      src: cdnUrl + "2026_monthly_prizes_" + language + ".png",
      width: '100%',
      rightMargin: theme.spacings.mega,
      leftMargin: theme.spacings.mega
    }],
    playoffs: [{
      src: cdnUrl + "2025_Playoffs_Prize_" + language + ".png",
      width: '100%',
      bottomMargin: theme.spacings.kilo
    }]
  };

  var _useState2 = useState(leaderboardBtnText),
      btnText = _useState2[0],
      setBtnText = _useState2[1];

  var _useState3 = useState('standard'),
      leaderBoardPos = _useState3[0],
      setLeaderBoardPos = _useState3[1];

  var options = [{
    key: 'season',
    value: seasonText
  }, {
    key: 'monthly',
    value: monthlyText
  }, {
    key: 'playoffs',
    value: playoffsText
  }];

  var displayedLeaderboardData = function displayedLeaderboardData(chosenBoard) {
    switch (chosenBoard) {
      case 'season':
        currentChallengeUserRank = userStats.season && userStats.season.rank;

        if (!isTopRanked && currentChallengeUserRank) {
          displayedLocalData = localContestantData || [];
        } else {
          displayedLocalData = [];
        }

        displayedRankData = [contestantData, displayedLocalData];
        return _extends({}, userStats.season, {
          contestants: displayedRankData,
          isTopRanked: isTopRanked
        });

      case 'monthly':
        currentChallengeUserRank = userStats.challenges && userStats.challenges[challengeNumber].rank;

        if (!isTopRanked && currentChallengeUserRank) {
          displayedLocalData = localContestantData || [];
        } else {
          displayedLocalData = [];
        }

        displayedRankData = [contestantData, displayedLocalData];
        return _extends({}, userStats.challenges[challengeNumber], {
          contestants: displayedRankData,
          isTopRanked: isTopRanked
        });

      case 'playoffs':
        currentChallengeUserRank = userStats.postseason && userStats.postseason.rank;

        if (!isTopRanked && currentChallengeUserRank) {
          displayedLocalData = localContestantData || [];
        } else {
          displayedLocalData = [];
        }

        displayedRankData = [contestantData, displayedLocalData];
        return _extends({}, userStats.postseason, {
          contestants: displayedRankData,
          isTopRanked: isTopRanked
        });
    }
  };

  var personalRankData = function personalRankData(chosenBoard) {
    var shownChallengeIndex = selectedChallenge || currentChallenge;

    switch (chosenBoard) {
      case 'season':
        return _extends({}, userStats.season, {
          selectedBoard: selectedBoard,
          currentChallenge: null,
          scoringStreak: scoringStreak,
          selectedChallenge: selectedChallenge,
          username: username
        });

      case 'monthly':
        return _extends({}, userStats.challenges[shownChallengeIndex], {
          selectedBoard: selectedBoard,
          currentChallenge: currentChallenge,
          scoringStreak: scoringStreak,
          selectedChallenge: selectedChallenge,
          username: username
        });

      case 'playoffs':
        return _extends({}, userStats.postseason, {
          contestants: displayedRankData,
          isTopRanked: isTopRanked
        });
    }
  };

  var bannerTextOptions = {
    season: seasonBannerText,
    monthly: monthlyBannerText,
    playoffs: playoffsBannerText
  };
  useEffect(function () {
    boardToggleRef.current.scrollIntoView({
      block: 'center'
    });
  }, [challengeNumber]);

  var batchFetchLeaderboardData = function batchFetchLeaderboardData(board, challengeNumber) {
    var season = board === 'monthly' && isCurrentlyPlayoffs && !isCurrentlySeason ? SEASON_CODE : undefined;
    batch(function () {
      dispatch(fetchLeaderboardData(board, challengeNumber, season));
      dispatch(fetchLocalLeaderboardData(board, true, challengeNumber, season));
    });
  };

  useEffect(function () {
    if ((selectedBoard === 'season' || selectedBoard === 'monthly') && leaderboardData.status === 'closed') {
      dispatch(setBoardView('playoffs'));
      batchFetchLeaderboardData('playoffs');
    }
  }, []);

  var handleViewLeaderboardTab = function handleViewLeaderboardTab(viewId) {
    dispatch(setBoardView(viewId));

    switch (viewId) {
      case 'monthly':
        batchFetchLeaderboardData(viewId, viewedChallenge);
        break;

      case 'playoffs':
        batchFetchLeaderboardData(viewId);
        break;

      default:
        batchFetchLeaderboardData(viewId);
        break;
    }
  };

  var handleChallengeChange = function handleChallengeChange(selection) {
    setViewedChallenge(selection);
    batchFetchLeaderboardData(currentView, selection);
  };

  var scrollToPosition = function scrollToPosition() {
    var analyticsTitle = btnText === scrollToTopText ? scrollToTop : seeYourPosition;
    fireMessageEvent({
      platform: platform,
      env: env,
      title: clickedType,
      data: {
        path: path,
        element: buttonType,
        element_name: analyticsTitle
      }
    });

    if (leaderBoardPos === 'standard') {
      setLeaderBoardPos('local');
      setBtnText(scrollToTopText);
      listItemRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    } else {
      setLeaderBoardPos('standard');
      setBtnText(leaderboardBtnText);
      boardToggleRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };

  var LeaderBoardContent = function LeaderBoardContent(chosenboard) {
    return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(LeaderboardBanner, {
      text: bannerTextOptions[currentView],
      images: imageOptions[currentView],
      inProgressText: inProgressText,
      completedText: completedText,
      showAsCompleted: leaderboardData.status !== 'current',
      language: language
    }), chosenboard === 'monthly' && /*#__PURE__*/React.createElement(LeaderboardNav, {
      currentChallenge: currentChallenge,
      totalChallenges: 6,
      onChange: handleChallengeChange
    }), fetchError && /*#__PURE__*/React.createElement(ErrorState, null, errorStateText), /*#__PURE__*/React.createElement(LeaderboardTable, {
      data: displayedLeaderboardData(selectedBoard),
      selectedView: currentView,
      options: options,
      ref: listItemRef
    }), /*#__PURE__*/React.createElement(StyledLeaderboardFooter, null, currentChallengeUserRank && /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      onSelect: scrollToPosition
    }, btnText), /*#__PURE__*/React.createElement(PersonalRanking, {
      data: personalRankData(selectedBoard),
      selectedBoard: selectedBoard
    }))));
  };

  var seasonOrMonthly = function seasonOrMonthly() {
    if (selectedBoard === 'season') {
      return LeaderBoardContent('season');
    } else if (selectedBoard === 'monthly') {
      return LeaderBoardContent('monthly');
    }
  };

  var playoffPage = function playoffPage() {
    if (!isCurrentlyPlayoffs && !isCurrentlySeason) {
      return LeaderBoardContent();
    }

    return !isCurrentlyPlayoffs ? /*#__PURE__*/React.createElement(ComingSoon, null) : LeaderBoardContent();
  };

  return /*#__PURE__*/React.createElement(Fragment$1, null, /*#__PURE__*/React.createElement("div", {
    ref: boardToggleRef
  }, /*#__PURE__*/React.createElement(LeaderboardToggle, {
    options: options,
    handleViewToggle: handleViewLeaderboardTab,
    currentView: currentView
  })), selectedBoard !== 'playoffs' ? seasonOrMonthly() : playoffPage());
};

var PageManager = {
  onboarding: Onboarding$1,
  playNow: PlayNow$1,
  gameInfo: GameInfo,
  history: History,
  leaderboard: Leaderboard
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
var getPageById = function getPageById(id) {
  return PageManager[id];
};

var withTracking = function withTracking(WrappedComponent) {
  var WithTracking = function WithTracking(_ref) {
    var props = _extends({}, _ref);

    var config = props.config,
        onboarding = props.onboarding,
        isFetching = props.isFetching,
        heatStreakPanelOpen = props.heatStreakPanelOpen,
        currentRoute = props.currentRoute,
        correctAnswer = props.correctAnswer,
        selectedAnswer = props.selectedAnswer,
        randomPicksSelected = props.randomPicksSelected,
        picksSubmitted = props.picksSubmitted,
        isOffersClicked = props.isOffersClicked,
        isActive = props.isActive,
        reminderHasUpdated = props.reminderHasUpdated;
    var platform = config.platform,
        env = config.env;
    var viewedType = analyticActionMap.viewedType,
        clickedType = analyticActionMap.clickedType,
        modalOpenedType = analyticActionMap.modalOpenedType,
        path = analyticActionMap.path,
        tabType = analyticActionMap.tabType,
        randomlySelectPlayers = analyticActionMap.randomlySelectPlayers,
        buttonType = analyticActionMap.buttonType,
        userStats = analyticActionMap.userStats,
        submitPicks = analyticActionMap.submitPicks,
        toggleType = analyticActionMap.toggleType,
        popupType = analyticActionMap.popupType,
        onValue = analyticActionMap.onValue,
        offValue = analyticActionMap.offValue,
        skillTestQuestion = analyticActionMap.skillTestQuestion,
        submitElement = analyticActionMap.submitElement,
        notifications = analyticActionMap.notifications;
    var onboardingStep = onboarding.onboardingStep,
        hasAnswered = onboarding.hasAnswered;
    useEffect(function () {
      if ((currentRoute !== 'playNow' || currentRoute !== 'onboarding') && reminderHasUpdated === false) {
        return;
      }

      fireMessageEvent({
        platform: platform,
        env: env,
        title: clickedType,
        data: {
          path: path,
          modal: notifications,
          element: toggleType,
          element_name: analyticActionMap[currentRoute] + "_" + notifications + "_" + (isActive ? onValue : offValue),
          element_action: isActive ? onValue : offValue
        }
      });
    }, [reminderHasUpdated, isActive]);
    useEffect(function () {
      if (currentRoute === 'onboarding' && !selectedAnswer && correctAnswer) {
        return;
      }

      if (currentRoute === 'onboarding' && !selectedAnswer) {
        fireMessageEvent({
          platform: platform,
          env: env,
          title: modalOpenedType,
          data: {
            path: path,
            modal: skillTestQuestion,
            modal_type: popupType
          }
        });
        return;
      }

      fireMessageEvent({
        platform: platform,
        env: env,
        title: viewedType,
        data: {
          path: path,
          element: tabType,
          element_name: analyticActionMap[currentRoute]
        }
      });
    }, [currentRoute, correctAnswer]);
    useEffect(function () {
      if (isFetching || currentRoute !== 'onboarding' || !selectedAnswer || onboardingStep !== 0 || !hasAnswered) {
        return;
      }

      fireMessageEvent({
        platform: platform,
        env: env,
        title: clickedType,
        data: {
          path: path,
          modal: skillTestQuestion,
          element: buttonType,
          element_name: submitElement
        }
      });
    }, [isFetching, correctAnswer, selectedAnswer]);
    useEffect(function () {
      if (isFetching || currentRoute !== 'playNow' || !randomPicksSelected) {
        return;
      }

      fireMessageEvent({
        platform: platform,
        env: env,
        title: clickedType,
        data: {
          path: path,
          element: buttonType,
          element_name: randomlySelectPlayers
        }
      });
    }, [isFetching, randomPicksSelected]);
    useEffect(function () {
      if (isFetching || currentRoute !== 'playNow' || !picksSubmitted) {
        return;
      }

      fireMessageEvent({
        platform: platform,
        env: env,
        title: clickedType,
        data: {
          path: path,
          element: buttonType,
          element_name: submitPicks
        }
      });
    }, [isFetching, picksSubmitted]);
    useEffect(function () {
      if (isFetching || !heatStreakPanelOpen) {
        return;
      }

      fireMessageEvent({
        platform: platform,
        env: env,
        title: clickedType,
        data: {
          path: path,
          element: tabType,
          element_name: userStats
        }
      });
    }, [isFetching, heatStreakPanelOpen]);
    useEffect(function () {
      if (isFetching || !heatStreakPanelOpen) {
        return;
      }

      fireMessageEvent({
        platform: platform,
        env: env,
        title: viewedType,
        data: {
          path: path,
          element: tabType,
          element_name: userStats
        }
      });
    }, [isFetching, currentRoute, heatStreakPanelOpen]);
    useEffect(function () {
      if (isFetching || currentRoute !== 'playNow' || !isOffersClicked) {
        return;
      }

      fireMessageEvent({
        platform: platform,
        env: env,
        title: 'Test!'
      });
    }, [isFetching, isOffersClicked]);
    return /*#__PURE__*/React.createElement(WrappedComponent, props);
  };

  WithTracking.displayName = "WithTracking(" + getDisplayName(WrappedComponent) + ")";
  return WithTracking;
};

var _templateObject$1A;

var baseStyles$C = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$1A || (_templateObject$1A = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-width: ", ";\n"])), theme.elementSize.content);
};

var Wrapper$7 = styled('div')(baseStyles$C);
Wrapper$7.propTypes = {
  children: propTypes.node
};

var _templateObject$1B, _templateObject2$1e, _templateObject3$Z;

var baseStyles$D = function baseStyles() {
  return css(_templateObject$1B || (_templateObject$1B = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n"])));
};

var marginStyles$2 = function marginStyles(_ref) {
  var theme = _ref.theme,
      hasMargin = _ref.hasMargin;
  return hasMargin && css(_templateObject2$1e || (_templateObject2$1e = _taggedTemplateLiteralLoose(["\n    margin-bottom: ", ";\n  "])), theme.spacings.giga);
};

var alignStyles$1 = function alignStyles(_ref2) {
  var alignTop = _ref2.alignTop;
  return alignTop && css(_templateObject3$Z || (_templateObject3$Z = _taggedTemplateLiteralLoose(["\n    align-items: flex-start;\n  "])));
};

var Row$1 = styled('div')(baseStyles$D, marginStyles$2, alignStyles$1);
Row$1.propTypes = {
  children: propTypes.node
};

var _templateObject$1C;

var baseStyles$E = function baseStyles() {
  return css(_templateObject$1C || (_templateObject$1C = _taggedTemplateLiteralLoose(["\n  width: 100%;\n"])));
};

var Header = styled('div')(baseStyles$E);
Header.propTypes = {
  children: propTypes.node
};

var _templateObject$1D;

var baseStyles$F = function baseStyles(_ref) {
  var theme = _ref.theme,
      showHeader = _ref.showHeader;
  return css(_templateObject$1D || (_templateObject$1D = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  margin-top: ", ";\n"])), showHeader && theme.component.headerSize || 0);
};

var Wrapper$8 = styled('main')(baseStyles$F);
Wrapper$8.propTypes = {
  children: propTypes.node
};

var mapStateToProps$i = function mapStateToProps(state) {
  var ui = state.ui;
  var showHeader = ui.showHeader;
  return {
    showHeader: showHeader
  };
};

var Body = connect(mapStateToProps$i)(Wrapper$8);

var _templateObject$1E;

var baseStyles$G = function baseStyles() {
  return css(_templateObject$1E || (_templateObject$1E = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n"])));
};

var Footer = styled('div')(baseStyles$G);
Footer.propTypes = {
  children: propTypes.node
};

var _templateObject$1F, _templateObject2$1f;

var containerBaseStyles$k = function containerBaseStyles() {
  return css(_templateObject$1F || (_templateObject$1F = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow-y: scroll;\n  z-index: 999999;\n"])));
};

var Container$I = styled('div')(containerBaseStyles$k);

var innerBaseStyles = function innerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject2$1f || (_templateObject2$1f = _taggedTemplateLiteralLoose(["\n  background: ", ";\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n"])), theme.colors.white);
};

var Inner = styled('div')(innerBaseStyles);

var Layout = function Layout(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(Container$I, {
    id: "thLayout"
  }, /*#__PURE__*/React.createElement(Inner, null, children));
};

Layout.propTypes = {
  children: propTypes.node
};
Layout.defaultProps = {
  children: ''
};
Layout.Wrapper = Wrapper$7;
Layout.Row = Row$1;
Layout.Header = Header;
Layout.Body = Body;
Layout.Footer = Footer;

var _templateObject$1G;
var flexCenter$g = flexCenter;

var baseStyles$H = function baseStyles() {
  return css(_templateObject$1G || (_templateObject$1G = _taggedTemplateLiteralLoose(["\n  ", "\n  list-style: none;\n  padding: 0 0 6px 0;\n  margin: 0;\n  width: 100%;\n  justify-content: space-between;\n"])), flexCenter$g());
};

var NavMenuList = styled('ul')(baseStyles$H);
NavMenuList.propTypes = {
  children: propTypes.node
};

var _excluded$s = ["children"];

var NavMenuLabel = function NavMenuLabel(_ref) {
  var children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded$s);

  return /*#__PURE__*/React.createElement(Text, _extends({}, rest, {
    noMargin: true,
    bold: true
  }), children);
};

NavMenuLabel.propTypes = {
  children: propTypes.oneOfType([propTypes.arrayOf(propTypes.node), propTypes.node]).isRequired
};

var _templateObject$1H, _templateObject2$1g, _templateObject3$_;

var disabledLinkStyles = function disabledLinkStyles(_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled && css(_templateObject$1H || (_templateObject$1H = _taggedTemplateLiteralLoose(["\n    pointer-events: none;\n  "])));
};

var StyledListItem = styled('li')(disabledLinkStyles);

var baseLinkStyles = function baseLinkStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject2$1g || (_templateObject2$1g = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  opacity: 0.6;\n  transition: color 0.1s ease-in;\n  text-decoration: none;\n  padding: ", ";\n  display: block;\n"])), theme.colors.white, theme.spacings["byte"]);
};

var activeLinkStyles = function activeLinkStyles(_ref3) {
  var theme = _ref3.theme,
      isDisabled = _ref3.isDisabled;
  return !isDisabled && css(_templateObject3$_ || (_templateObject3$_ = _taggedTemplateLiteralLoose(["\n    &.active {\n      opacity: 1;\n      color: ", ";\n      text-decoration: underline !important;\n      text-decoration-color: white !important;\n      -webkit-text-decoration-color: white;\n      text-decoration-style: solid;\n      text-underline-offset: 5px;\n    }\n  "])), theme.colors.white);
};

var StyledLink$2 = styled(NavLink)(baseLinkStyles, activeLinkStyles);

var NavMenuItem = function NavMenuItem(_ref4) {
  var routeId = _ref4.routeId,
      label = _ref4.label,
      path = _ref4.path,
      search = _ref4.search,
      isDisabled = _ref4.isDisabled,
      handleLinkClick = _ref4.handleLinkClick,
      navigationGuard = _ref4.navigationGuard;

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      config = _useSelector.config,
      routing = _useSelector.routing;

  var platform = config.platform,
      env = config.env;
  var currentRoute = routing.currentRoute;

  var handleNavMenuItemClick = function handleNavMenuItemClick(e) {
    if (navigationGuard !== null && navigationGuard !== void 0 && navigationGuard.hasPartialPicks && currentRoute === 'playNow' && routeId !== 'playNow') {
      e.preventDefault();
      navigationGuard.handleNavigationAttempt(routeId);
      return;
    }

    var history = analyticActionMap.history,
        leaderboard = analyticActionMap.leaderboard,
        gameInfo = analyticActionMap.gameInfo,
        playNow = analyticActionMap.playNow,
        path = analyticActionMap.path,
        clickedType = analyticActionMap.clickedType,
        tabType = analyticActionMap.tabType;
    var name;

    switch (routeId) {
      case 'history':
        name = history;
        break;

      case 'leaderboard':
        name = leaderboard;
        break;

      case 'gameInfo':
        name = gameInfo;
        break;

      case 'playNow':
        name = playNow;
        break;
    }

    fireMessageEvent({
      platform: platform,
      env: env,
      title: clickedType,
      data: {
        path: path,
        element: tabType,
        element_name: name
      }
    });
    handleLinkClick(routeId);
  };

  return /*#__PURE__*/React.createElement(StyledListItem, {
    isDisabled: isDisabled
  }, /*#__PURE__*/React.createElement(StyledLink$2, {
    to: "" + path + search,
    onClick: handleNavMenuItemClick,
    end: true
  }, /*#__PURE__*/React.createElement(NavMenuLabel, {
    as: "span",
    size: "giga"
  }, label)));
};

NavMenuItem.propTypes = {
  routeId: propTypes.string,
  location: propTypes.object,
  isDisabled: propTypes.bool,
  label: propTypes.string,
  path: propTypes.string,
  handleLinkClick: propTypes.func
};

var _templateObject$1I;

var baseStyles$I = function baseStyles() {
  return css$1(_templateObject$1I || (_templateObject$1I = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  padding: 0 16px;\n"])));
};

var NavMenu = styled('nav')(baseStyles$I);
NavMenu.List = NavMenuList;
NavMenu.Item = NavMenuItem;

var _excluded$t = ["showNavLinks", "routes"],
    _excluded2$2 = ["id"];

var NavMenuBuilder = function NavMenuBuilder(_ref) {
  var showNavLinks = _ref.showNavLinks,
      routes = _ref.routes,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$t);

  var dispatch = useDispatch();

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      picks = _useSelector.picks,
      routing = _useSelector.routing;

  var picked = picks.picked,
      incompletePicksModalOpen = picks.incompletePicksModalOpen,
      picksSubmitted = picks.picksSubmitted,
      picksLocked = picks.picksLocked;
  var currentRoute = routing.currentRoute;
  var slotsPicked = Object.keys(picked).map(function (id) {
    return picked[id];
  }).filter(function (id) {
    return id;
  });
  var hasPartialPicks = slotsPicked.length > 0 && !picksSubmitted && !picksLocked;
  useEffect(function () {
    if (currentRoute !== 'playNow' && incompletePicksModalOpen) {
      dispatch(resetNavigationModalState());
    }
  }, [currentRoute, incompletePicksModalOpen, dispatch]);
  var navigationGuard = {
    hasPartialPicks: hasPartialPicks,
    incompletePicksModalOpen: incompletePicksModalOpen,
    handleNavigationAttempt: function handleNavigationAttempt(routeId) {
      dispatch(setPendingNavigation(routeId));
      dispatch(setIncompletePicksModalToOpen());
    }
  };
  return /*#__PURE__*/React.createElement(NavMenu, null, showNavLinks && /*#__PURE__*/React.createElement(NavMenu.List, null, routes.map(function (_ref2) {
    var id = _ref2.id,
        rest = _objectWithoutPropertiesLoose(_ref2, _excluded2$2);

    return /*#__PURE__*/React.createElement(NavMenu.Item, _extends({
      key: id,
      routeId: id,
      navigationGuard: navigationGuard
    }, props, rest));
  })));
};

NavMenuBuilder.propTypes = {
  routes: propTypes.array,
  showNavLinks: propTypes.bool
};
NavMenuBuilder.defaultProps = {
  routes: [{
    key: 'link1',
    label: 'Link 1',
    path: '/link1'
  }, {
    key: 'link2',
    label: 'Link 2',
    path: '/link2'
  }, {
    key: 'link3',
    label: 'Link 3',
    path: '/link3'
  }],
  showNavLinks: true
};

var _excluded$u = ["showClose", "showNav", "closeUrl", "logoUrl", "hasNotificationAlert", "notificationBarTitle", "notificationBarText", "handleNotificationBarCloseClick", "prefix"];

var _templateObject$1J, _templateObject2$1h, _templateObject3$$, _templateObject4$O, _templateObject5$B, _templateObject6$u;
var flexCenter$h = flexCenter;

var baseStyles$J = function baseStyles(_ref) {
  var theme = _ref.theme;
  return css$1(_templateObject$1J || (_templateObject$1J = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  min-height: 51px;\n  padding-top: env(safe-area-inset-top);\n  padding-top: constant(safe-area-inset-top);\n\n  ", "\n  flex-wrap: wrap;\n"])), theme.colors.black, flexCenter$h());
};

var Container$J = styled('div')(baseStyles$J);

var headerRowBaseStyles = function headerRowBaseStyles() {
  return css$1(_templateObject2$1h || (_templateObject2$1h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n"])));
};

var headerRowCenteredStyles = function headerRowCenteredStyles(_ref2) {
  var centered = _ref2.centered;
  return centered && css$1(_templateObject3$$ || (_templateObject3$$ = _taggedTemplateLiteralLoose(["\n    justify-content: center;\n  "])));
};

var HeaderRow = styled('div')(headerRowBaseStyles, headerRowCenteredStyles);

var closeContainerBaseStyles = function closeContainerBaseStyles() {
  return css$1(_templateObject4$O || (_templateObject4$O = _taggedTemplateLiteralLoose([""])));
};

var CloseContainer = styled('div')(closeContainerBaseStyles);

var imageContainerBaseStyles$6 = function imageContainerBaseStyles() {
  return css$1(_templateObject5$B || (_templateObject5$B = _taggedTemplateLiteralLoose(["\n  max-width: 170px;\n  margin: 0 auto;\n"])));
};

var ImageContainer$9 = styled('div')(imageContainerBaseStyles$6);

var spacerBaseStyles$1 = function spacerBaseStyles() {
  return css$1(_templateObject6$u || (_templateObject6$u = _taggedTemplateLiteralLoose(["\n  width: 30px;\n  visibility: hidden;\n"])));
};

var Spacer$1 = styled('div')(spacerBaseStyles$1);

var TimsHeader = function TimsHeader(_ref3) {
  var showClose = _ref3.showClose,
      showNav = _ref3.showNav,
      closeUrl = _ref3.closeUrl,
      logoUrl = _ref3.logoUrl,
      hasNotificationAlert = _ref3.hasNotificationAlert,
      notificationBarTitle = _ref3.notificationBarTitle,
      notificationBarText = _ref3.notificationBarText,
      handleNotificationBarCloseClick = _ref3.handleNotificationBarCloseClick,
      PrefixComponent = _ref3.prefix,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded$u);

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      strings = _useSelector.strings;

  var logoAlt = strings['roles/img/hockeyChallengeLogo/alt'];
  var hasCloseWithNoLogo = showClose && !logoUrl;
  return /*#__PURE__*/React.createElement(Container$J, null, logoUrl && /*#__PURE__*/React.createElement(Spacing, {
    sizeLeft: "mega",
    sizeRight: "mega",
    sizeTop: "kilo",
    sizeBottom: "kilo"
  }, /*#__PURE__*/React.createElement(HeaderRow, null, showClose && /*#__PURE__*/React.createElement(CloseContainer, null, /*#__PURE__*/React.createElement(CloseApp, {
    href: closeUrl
  })), /*#__PURE__*/React.createElement(ImageContainer$9, null, /*#__PURE__*/React.createElement(Image, {
    alt: logoAlt,
    src: logoUrl
  })), PrefixComponent && /*#__PURE__*/React.createElement(PrefixComponent, null))), showNav && /*#__PURE__*/React.createElement(Spacing, null, /*#__PURE__*/React.createElement(HeaderRow, {
    centered: !showClose || logoUrl
  }, hasCloseWithNoLogo && /*#__PURE__*/React.createElement(CloseContainer, null, /*#__PURE__*/React.createElement(CloseApp, {
    href: closeUrl
  })), /*#__PURE__*/React.createElement(NavMenuBuilder, props), hasCloseWithNoLogo && /*#__PURE__*/React.createElement(Spacer$1, null))), hasNotificationAlert && /*#__PURE__*/React.createElement(HeaderRow, null, /*#__PURE__*/React.createElement(NotificationBar, {
    title: notificationBarTitle,
    text: notificationBarText,
    onSelect: handleNotificationBarCloseClick,
    size: "tera"
  })));
};

TimsHeader.propTypes = {
  showClose: propTypes.bool,
  showNav: propTypes.bool,
  closeUrl: propTypes.string,
  logoUrl: propTypes.string,
  hasNotificationAlert: propTypes.bool,
  notificationBarTitle: propTypes.string,
  notificationBarText: propTypes.string,
  handleNotificationBarCloseClick: propTypes.func,
  prefix: propTypes.oneOfType([propTypes.object, propTypes.func])
};
TimsHeader.defaultProps = {
  closeUrl: 'timhortons:///',
  showClose: false
};

var _templateObject$1K, _templateObject2$1i, _templateObject3$10, _templateObject4$P, _templateObject5$C, _templateObject6$v, _templateObject7$n, _templateObject8$i;

var ContainerBaseStyles = function ContainerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$1K || (_templateObject$1K = _taggedTemplateLiteralLoose(["\n  background: #2c2c2c;\n  border-radius: ", ";\n  margin-bottom: ", ";\n  overflow: hidden;\n"])), theme.spacings.kilo, theme.spacings.mega);
};

var Container$K = styled('div')(ContainerBaseStyles);

var styledHeadingBaseStyles$3 = function styledHeadingBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject2$1i || (_templateObject2$1i = _taggedTemplateLiteralLoose(["\n  padding: ", ";\n  color: white;\n"])), theme.spacings.giga);
};

var StyledHeading$5 = styled(Heading)(styledHeadingBaseStyles$3);

var nameEntryStyles$1 = function nameEntryStyles(_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject3$10 || (_templateObject3$10 = _taggedTemplateLiteralLoose(["\n  padding: 0px ", " ", ";\n  margin-bottom: ", ";\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n"])), theme.spacings.giga, theme.spacings.kilo, theme.spacings.mega);
};

var NameEntryContainer$1 = styled('div')(nameEntryStyles$1);

var InputContainerStyles = function InputContainerStyles(_ref4) {
  var theme = _ref4.theme;
  return css(_templateObject4$P || (_templateObject4$P = _taggedTemplateLiteralLoose(["\n  flex-grow: 1;\n  margin-right: ", ";\n"])), theme.spacings.mega);
};

var InputContainer$1 = styled('div')(InputContainerStyles);

var ButtonContainerStyles = function ButtonContainerStyles(_ref5) {
  var theme = _ref5.theme;
  return css(_templateObject5$C || (_templateObject5$C = _taggedTemplateLiteralLoose(["\n  flex-shrink: 0;\n  margin-top: ", ";\n"])), theme.spacings.bit);
};

var ButtonContainer$3 = styled('div')(ButtonContainerStyles);

var successMessageContainerStyles = function successMessageContainerStyles(_ref6) {
  var theme = _ref6.theme;
  return css(_templateObject6$v || (_templateObject6$v = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  background-color: #d1fae5;\n  min-height: ", ";\n  padding: ", ";\n  justify-content: flex-start;\n  align-items: center;\n"])), theme.spacings.zetta, theme.spacings.kilo);
};

var SuccessMessage = styled('div')(successMessageContainerStyles);

var iconWrapperBaseStyles$1 = function iconWrapperBaseStyles(_ref7) {
  var theme = _ref7.theme;
  return css(_templateObject7$n || (_templateObject7$n = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin: 0 ", ";\n  height: ", ";\n"])), theme.spacings["byte"], theme.spacings.mega);
};

var IconWrapper$1 = styled('div')(iconWrapperBaseStyles$1);

var styledIconBaseStyles = function styledIconBaseStyles(_ref8) {
  var theme = _ref8.theme;
  return css(_templateObject8$i || (_templateObject8$i = _taggedTemplateLiteralLoose(["\n    border-radius: ", ";\n    padding: ", ";\n    background-color: #3f2021;\n    color: #d1fae5;\n  "])), theme.borderRadius.circle, theme.spacings.atom);
};

var StyledIcon$3 = styled(Icon)(styledIconBaseStyles);

var UpdateUserName = function UpdateUserName() {
  var _useSelector = useSelector(function (state) {
    return state;
  }),
      strings = _useSelector.strings,
      onboarding = _useSelector.onboarding,
      ui = _useSelector.ui;

  var dispatch = useDispatch();
  var usernameValidationErr = onboarding.usernameValidationErr,
      isFetching = onboarding.isFetching,
      updateUsernameStatus = onboarding.updateUsernameStatus,
      resetUserNameAttemptStatus = onboarding.resetUserNameAttemptStatus;

  var _useState = useState(''),
      currentUsername = _useState[0],
      setUsername = _useState[1];

  var inputRef = useRef();
  var hasFetchError = ui.hasFetchError;

  var executeScroll = function executeScroll() {
    inputRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };

  useEffect(function () {
    if (usernameValidationErr || onboarding.errorCode) inputRef.current.focus();
  }, [usernameValidationErr, onboarding.errorCode]);

  var handleUsernameSubmit = function handleUsernameSubmit() {
    dispatch(submitUsername(currentUsername));
  };

  useEffect(function () {
    if (!hasFetchError && resetUserNameAttemptStatus) {
      dispatch(submitUsername(currentUsername));
    }
  }, [hasFetchError, resetUserNameAttemptStatus]);
  var heading = strings['update/username/heading'];
  var buttonText = strings['update/username/buttonText'];
  var errorText = usernameValidationErr ? strings['username/usernameLengthError/text'] : onboarding.errorCode ? strings['username/boomError/text'](onboarding.errorCode) : '';
  var successText = strings['update/username/success'];
  return /*#__PURE__*/React.createElement(Container$K, null, /*#__PURE__*/React.createElement(StyledHeading$5, {
    as: "h3",
    size: "mega",
    noMarginBoth: true
  }, heading), /*#__PURE__*/React.createElement(NameEntryContainer$1, null, /*#__PURE__*/React.createElement(InputContainer$1, null, /*#__PURE__*/React.createElement(Input, {
    minWidth: 10,
    spellCheck: false,
    type: "text",
    id: "username",
    value: currentUsername,
    submitUsername: true,
    onChange: function onChange(e) {
      setUsername(e.target.value);
      batch(function () {
        dispatch(setUsernameValidationErr(false));
        dispatch(resetErrorCodeStatus());
      });
    },
    onFocus: function onFocus() {
      return executeScroll();
    },
    validationHint: errorText,
    invalid: errorText.length > 0,
    maxLength: "15",
    ref: inputRef,
    noMargin: true
  })), /*#__PURE__*/React.createElement(ButtonContainer$3, null, /*#__PURE__*/React.createElement(SubmitButton, {
    size: "kilo",
    isLoading: isFetching,
    text: buttonText,
    variant: "primary",
    onSelect: handleUsernameSubmit,
    stretch: true
  }))), updateUsernameStatus && /*#__PURE__*/React.createElement(SuccessMessage, null, /*#__PURE__*/React.createElement(IconWrapper$1, null, /*#__PURE__*/React.createElement(StyledIcon$3, {
    icon: "check"
  })), /*#__PURE__*/React.createElement(Text, {
    noMargin: true
  }, successText)));
};

var _templateObject$1L, _templateObject2$1j, _templateObject3$11, _templateObject4$Q, _templateObject5$D, _templateObject6$w, _templateObject7$o, _templateObject8$j, _templateObject9$c, _templateObject10$8, _templateObject11$6, _templateObject12$5, _templateObject13$3, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;

var assetSet$b = function assetSet(filename) {
  return getAssetSet(useCdnImage, filename);
};

var containerBaseStyles$l = function containerBaseStyles(_ref) {
  var theme = _ref.theme;
  return css(_templateObject$1L || (_templateObject$1L = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  width: 100%;\n  padding-top: ", ";\n  border-top: 1px solid #444444;\n"])), theme.colors.black, theme.spacings.kilo);
};

var Container$L = styled('div')(containerBaseStyles$l);

var subContainerBaseStyles = function subContainerBaseStyles(_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject2$1j || (_templateObject2$1j = _taggedTemplateLiteralLoose(["\n  background: #2c2c2c;\n  border-radius: 11px;\n  padding: ", ";\n  margin-bottom: ", ";\n"])), theme.spacings.giga, theme.spacings.mega);
};

var SubContainer = styled('div')(subContainerBaseStyles);

var dividerBaseStyles = function dividerBaseStyles(_ref3) {
  var theme = _ref3.theme;
  return css(_templateObject3$11 || (_templateObject3$11 = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid #444444;\n  margin-left: -", ";\n  margin-right: -", ";\n"])), theme.spacings.giga, theme.spacings.giga);
};

var Divider$1 = styled('div')(dividerBaseStyles);

var statusBadgeBaseStyles = function statusBadgeBaseStyles(props) {
  return css(_templateObject4$Q || (_templateObject4$Q = _taggedTemplateLiteralLoose(["\n  border-radius: 10.5px;\n  border: 0 solid #666;\n  background: ", ";\n  padding: 2px 7.5px;\n  text-align: center;\n  display: inline-block;\n  white-space: nowrap;\n  width: 100%;\n"])), props.color);
};

var StatusBadge = styled(Text)(statusBadgeBaseStyles);

var streakDatesBaseStyles = function streakDatesBaseStyles() {
  return css(_templateObject5$D || (_templateObject5$D = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n"])));
};

var StreakDates = styled('div')(streakDatesBaseStyles);

var heatStreakItemBaseStyles = function heatStreakItemBaseStyles(_ref4) {
  return css(_templateObject6$w || (_templateObject6$w = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  > div {\n    display: inline-block;\n  }\n"])));
};

var HeatStreakItem = styled('div')(heatStreakItemBaseStyles);

var winStreakBaseStyles = function winStreakBaseStyles() {
  return css(_templateObject7$o || (_templateObject7$o = _taggedTemplateLiteralLoose(["\n  display: flex;\n"])));
};

var WinStreak = styled('div')(winStreakBaseStyles);
var WinStreakGraph = styled('div')();

var winStreakTextBaseStyles = function winStreakTextBaseStyles(_ref5) {
  var theme = _ref5.theme;
  return css(_templateObject8$j || (_templateObject8$j = _taggedTemplateLiteralLoose(["\n  margin-left: ", ";\n"])), theme.spacings.mega);
};

var WinStreakText = styled('div')(winStreakTextBaseStyles);

var styledHeadingBaseStyles$4 = function styledHeadingBaseStyles(_ref6) {
  var theme = _ref6.theme;
  return css(_templateObject9$c || (_templateObject9$c = _taggedTemplateLiteralLoose(["\n  line-height: 20px;\n  margin-bottom: ", ";\n"])), theme.spacings["byte"]);
};

var StyledHeading$6 = styled(Heading)(styledHeadingBaseStyles$4);

var styledTextBaseStyles = function styledTextBaseStyles() {
  return css(_templateObject10$8 || (_templateObject10$8 = _taggedTemplateLiteralLoose(["\n  line-height: 18px;\n"])));
};

var StyledText$3 = styled(Text)(styledTextBaseStyles);
var MiniBannerContainer = styled.div(_templateObject11$6 || (_templateObject11$6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  padding: ", ";\n  margin: 0 auto;\n  background: ", " no-repeat top / 100% 266px url(", ");\n  color: ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacings.giga + " " + theme.spacings.kilo;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.darkBg;
}, assetSet$b('miniBannerBackground'), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.white;
});
var MiniBannerStatus = styled.div(_templateObject12$5 || (_templateObject12$5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  margin-top: 5px;\n  line-height: 8px;\n"])));
var MiniBannerTitle = styled(Heading)(_templateObject13$3 || (_templateObject13$3 = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  line-height: 20px;\n  width: 166px;\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.typography.text.peta.fontSize;
});
var MiniBannerDate = styled(Text)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  margin: 0px;\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return theme.typography.subHeadings["byte"].fontSize;
});
var MiniBannerBadge = styled.span(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  border-radius: ", ";\n  text-transform: uppercase;\n  font-size: ", ";\n  font-weight: 900;\n  margin-left: 5px;\n  padding: ", ";\n"])), function (props) {
  return props.theme.colors[props.color];
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.spacings.kilo;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.text.bit.fontSize;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.spacings.bit + " " + theme.spacings.kilo;
});
var MiniBannerText = styled(Text)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  line-height: ", ";\n  margin-top: 7px;\n  margin-bottom: 0px;\n"])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.typography.text.kilo.fontSize;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.typography.text.bit.lineHeight;
});
var MiniBannerImage = styled(Image)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  width: 45%;\n"])));
var MiniBannerLink = styled(NavLink)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteralLoose(["\n  color: ", ";\n  font-size: ", ";\n"])), function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.white;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.typography.text["byte"].fontSize;
});
var MiniBannerInformationContainer = styled.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  padding-right: 9px;\n"])));

function convertToFrenchDateRange(dateRange) {
  var monthMapping = {
    Jan: 'janv',
    Feb: 'févr',
    Mar: 'mars',
    Apr: 'avr',
    May: 'mai',
    Jun: 'juin',
    Jul: 'juil',
    Aug: 'août',
    Sep: 'sept',
    Oct: 'oct',
    Nov: 'nov',
    Dec: 'déc'
  };
  var regex = /([A-Za-z]{3})\s*(\d+)\s*-\s*(?:[A-Za-z]{3})?\s*(\d+)/;
  var matches = dateRange.match(regex);

  if (!matches) {
    return dateRange;
  }

  var month = matches[1],
      day1 = matches[2],
      day2 = matches[3];
  var frenchMonth = monthMapping[month];
  return day1 + " " + frenchMonth + " - " + day2 + " " + frenchMonth;
}

var HeatStreakPanel = function HeatStreakPanel() {
  var theme = useTheme();
  var cdnUrl = useCdnUrl();
  var dispatch = useDispatch();

  var _useSelector = useSelector(function (state) {
    return state;
  }),
      config = _useSelector.config,
      strings = _useSelector.strings,
      leaderboard = _useSelector.leaderboard,
      heatStreak = _useSelector.heatStreak;

  var language = config.language;
  var heatStreakPercentage = heatStreak.percentage,
      streak = heatStreak.streak;
  var currentChallenge = leaderboard.currentChallenge,
      userStats = leaderboard.userStats,
      isCurrentlySeason = leaderboard.isCurrentlySeason,
      isCurrentlyPlayoffs = leaderboard.isCurrentlyPlayoffs;
  var challenges = userStats.challenges,
      season = userStats.season,
      postseason = userStats.postseason;
  var displayedChallenge = challenges[currentChallenge];
  var isFrench = language === 'fr';
  var remainingDays = 7 - streak;
  var winStreakTitle = strings['heatstreak/panel/winStreak/title'](streak);
  var winStreakHeader = strings['heatstreak/panel/winStreak/header'];
  var streakBadge = strings['heatstreak/panel/winStreak/badge'];
  var winStreakText = streak && !remainingDays ? strings['heatstreak/panel/winStreak/complete/text'] : strings['heatstreak/panel/winStreak/text'](remainingDays);
  var challengeStatsTitle = strings['heatstreak/statistic/challengeStats/title'];
  var seasonStatsTitle = strings['heatstreak/statistic/seasonStats/title'];
  var postseasonStatsTitle = strings['heatstreak/statistic/postseasonStats/title'];
  var myChallengesTitle = strings['heatstreak/statistic/mychallenges/title'];
  var statusInProgressText = strings['heatstreak/statistic/status/progress'];
  var statusCompleteText = strings['heatstreak/statistic/status/completed'];
  var challengeDescriptions = strings['challenges/dates'];
  var challengeMonthlyTitle = strings['challenges/monthly/heatstreak/title'];
  var seasonTitle = strings['challenges/season/heatstreak/title'];
  var seasonDates = strings['challenges/season/dates'];
  var playoffDates = strings['challenges/playoffs/dates'];
  var miniBannerLinkText = strings['heatstreak/minibanner/link'];
  var miniBannerLinkRoute = strings['heatstreak/minibanner/route'];
  var seasonBannerTitle = seasonTitle;
  var seasonBannerDate = strings['leaderboard/banner/season/date'];
  var seasonBannerText = strings['leaderboard/banner/season/paragraph'];
  var seasonBannerIMG = "2025-2026_Season_Prize.png";
  var monthlyBannerTitle = challengeMonthlyTitle;
  var monthlyBannerDate = strings['heatstreak/minibanner/monthly/date'];
  var monthlyBannerText = strings['leaderboard/banner/monthly/paragraph'];
  var monthlyBannerIMG = "2026_monthly_prizes_" + language + ".png";
  var playoffsBannerTitle = strings['heatstreak/minibanner/title'];
  var playoffsBannerDate = strings['heatstreak/minibanner/playoffs/date'];
  var playoffsBannerText = strings['heatstreak/minibanner/text'];
  var playoffsBannerIMG = "2025_Playoffs_Prize_" + language + ".png";
  var streakMapVariant = {
    0: 'h0',
    1: 'h1',
    2: 'h2',
    3: 'h3',
    4: 'h4',
    5: 'h5',
    6: 'h6',
    7: 'h7'
  };
  var heatStreakVariant = streakMapVariant[streak];
  var streakList = [];

  for (var i = 1; i <= 7; i++) {
    streakList.push({
      primaryTextOrder: isFrench ? 2 : 1,
      secondaryTextOrder: isFrench ? 1 : 2,
      graphVariant: streak && streak >= i && streakMapVariant[streak] || 'h0'
    });
  }

  var carouselData = [_extends({}, season, {
    title: seasonStatsTitle
  }), _extends({}, displayedChallenge, {
    title: challengeStatsTitle + " " + displayedChallenge.challengeNumber + " " + (language === 'en' ? 'Stats' : '')
  })];

  if (!isCurrentlySeason) {
    carouselData.length = 0;
    carouselData.push(_extends({}, postseason, {
      title: postseasonStatsTitle
    }));
  }

  var numberOfChallenges = strings['challenges/dates'].length;
  var challengesWithoutPlayoffs = Object.values(challenges);
  challengesWithoutPlayoffs.length = numberOfChallenges;
  var myChallenges = Object.assign(challengesWithoutPlayoffs, {
    season: season
  });
  if (isCurrentlyPlayoffs) Object.assign(myChallenges, {
    postseason: postseason
  });

  var MiniBanner = function MiniBanner(props) {
    var title;
    var date;
    var statusColor;
    var statusText;
    var text;
    var img;
    Object.keys(myChallenges).forEach(function (challengeItem) {
      if (myChallenges[challengeItem].status === 'current') {
        monthlyBannerDate = myChallenges[challengeItem].description;
      }

      return monthlyBannerDate;
    });

    switch (props.variant) {
      case 'playoffs':
        title = playoffsBannerTitle;
        date = playoffsBannerDate;
        statusColor = isCurrentlyPlayoffs ? 'g600' : 'n850';
        statusText = isCurrentlyPlayoffs ? statusInProgressText : statusCompleteText;
        text = playoffsBannerText;
        img = playoffsBannerIMG;
        break;

      case 'monthly':
        title = monthlyBannerTitle;
        date = isFrench ? convertToFrenchDateRange(monthlyBannerDate) : monthlyBannerDate;
        statusColor = isCurrentlySeason ? 'g600' : 'n850';
        statusText = isCurrentlySeason ? statusInProgressText : statusCompleteText;
        text = monthlyBannerText;
        img = monthlyBannerIMG;
        break;

      case 'season':
        title = seasonBannerTitle;
        date = seasonBannerDate;
        statusColor = isCurrentlySeason ? 'g600' : 'n850';
        statusText = isCurrentlySeason ? statusInProgressText : statusCompleteText;
        text = seasonBannerText;
        img = seasonBannerIMG;
        break;
    }

    return /*#__PURE__*/React.createElement(MiniBannerContainer, null, /*#__PURE__*/React.createElement(MiniBannerInformationContainer, null, /*#__PURE__*/React.createElement(MiniBannerTitle, {
      as: "h5",
      noMarginTop: true,
      noMarginBottom: true
    }, title), /*#__PURE__*/React.createElement(MiniBannerStatus, null, /*#__PURE__*/React.createElement(MiniBannerDate, null, date), /*#__PURE__*/React.createElement(MiniBannerBadge, {
      color: statusColor
    }, statusText)), /*#__PURE__*/React.createElement(MiniBannerText, null, text), /*#__PURE__*/React.createElement(MiniBannerLink, {
      onClick: function onClick() {
        return dispatch(setHeatStreakPanelToClosed());
      },
      to: miniBannerLinkRoute
    }, miniBannerLinkText)), /*#__PURE__*/React.createElement(MiniBannerImage, {
      src: "" + cdnUrl + img
    }));
  };

  var getSeasonOrPostseasonProperty = function getSeasonOrPostseasonProperty(challengeItem, property) {
    var _properties$property;

    var properties = {
      color: {
        postseason: isCurrentlyPlayoffs ? theme.colors.g900 : theme.colors.n850,
        season: isCurrentlySeason ? theme.colors.g900 : theme.colors.n850
      },
      rank: {
        postseason: postseason.rank || '--',
        season: season.rank || '--'
      },
      title: {
        postseason: postseasonStatsTitle,
        season: seasonTitle
      },
      dates: {
        postseason: playoffDates,
        season: seasonDates
      },
      status: {
        postseason: isCurrentlyPlayoffs ? statusInProgressText.toUpperCase() : statusCompleteText.toUpperCase(),
        season: isCurrentlySeason ? statusInProgressText.toUpperCase() : statusCompleteText.toUpperCase()
      },
      rankRatio: {
        postseason: (postseason.rank || '--') + "/" + (postseason.totalUsers || '--'),
        season: (season.rank || '--') + "/" + (season.totalUsers || '--')
      }
    };
    return ((_properties$property = properties[property]) === null || _properties$property === void 0 ? void 0 : _properties$property[challengeItem]) || '--';
  };

  var renderProperty = function renderProperty(challengeItem, property) {
    if (challengeItem === 'postseason' || challengeItem === 'season') {
      return getSeasonOrPostseasonProperty(challengeItem, property);
    } else {
      switch (property) {
        case 'color':
          return myChallenges[challengeItem].status === 'current' ? theme.colors.g900 : theme.colors.n850;

        case 'rank':
          return myChallenges[challengeItem].rank || '--';

        case 'title':
          return challengeMonthlyTitle + " " + myChallenges[challengeItem].challengeNumber;

        case 'dates':
          return challengeDescriptions[challengeItem];

        case 'status':
          return myChallenges[challengeItem].status === 'current' ? statusInProgressText.toUpperCase() : statusCompleteText.toUpperCase();

        case 'rankRatio':
          return (myChallenges[challengeItem].rank || '--') + "/" + (myChallenges[challengeItem].totalUsers || '--');

        default:
          return '--';
      }
    }
  };

  return /*#__PURE__*/React.createElement(Container$L, null, /*#__PURE__*/React.createElement(Spacing, {
    sizeLeft: "mega",
    sizeRight: "mega",
    sizeBottom: "giga"
  }, currentChallenge && /*#__PURE__*/React.createElement(Spacing, {
    sizeBottom: "mega"
  }, /*#__PURE__*/React.createElement(Carousel, {
    data: carouselData
  })), /*#__PURE__*/React.createElement(SubContainer, null, /*#__PURE__*/React.createElement(Spacing, {
    sizeBottom: "mega"
  }, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: "white"
  }, /*#__PURE__*/React.createElement(StyledHeading$6, {
    as: "h3",
    size: "mega",
    noMarginBoth: true
  }, winStreakHeader))), /*#__PURE__*/React.createElement(Spacing, {
    sizeBottom: "mega"
  }, /*#__PURE__*/React.createElement(WinStreak, null, /*#__PURE__*/React.createElement(WinStreakGraph, null, /*#__PURE__*/React.createElement(HeatStreakGraph, {
    showIcon: true,
    assetSrc: "https://cdn.rbi.digital/hockey/icon_flame_large.png",
    gradientId: "heatStreakChart",
    graphVariant: heatStreakVariant,
    variant: "image",
    percentage: heatStreakPercentage
  })), /*#__PURE__*/React.createElement(WinStreakText, null, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: "white"
  }, /*#__PURE__*/React.createElement(StyledHeading$6, {
    as: "h3",
    size: "mega",
    noMarginBoth: true
  }, winStreakTitle)), /*#__PURE__*/React.createElement(ColorProvider, {
    variant: "n800"
  }, /*#__PURE__*/React.createElement(StyledText$3, {
    size: "giga",
    noMargin: true
  }, winStreakText))))), /*#__PURE__*/React.createElement(Spacing, null, /*#__PURE__*/React.createElement(StreakDates, null, streakList.map(function (_ref19, index) {
    var props = _extends({}, _ref19);

    return /*#__PURE__*/React.createElement(HeatStreakItem, {
      key: "streak-" + index
    }, /*#__PURE__*/React.createElement(HeatStreakGraph, _extends({
      gradientId: "h" + index + "-streak-chart",
      percentage: "100",
      text: streakBadge,
      secondaryText: index + 1,
      size: "bit",
      isFrench: isFrench
    }, props)));
  })))), myChallenges && /*#__PURE__*/React.createElement(SubContainer, null, /*#__PURE__*/React.createElement(Spacing, {
    sizeBottom: "mega"
  }, /*#__PURE__*/React.createElement(ColorProvider, {
    variant: "white"
  }, /*#__PURE__*/React.createElement(StyledHeading$6, {
    as: "h3",
    size: "mega",
    noMarginBoth: true
  }, myChallengesTitle))), Object.keys(myChallenges).reverse().map(function (challengeItem, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: challengeItem
    }, /*#__PURE__*/React.createElement(Grid, {
      style: {
        paddingTop: '10px',
        paddingBottom: '10px',
        alignItems: 'flex-start'
      }
    }, /*#__PURE__*/React.createElement(Col, {
      columns: "8",
      style: {
        display: 'flex',
        alignItems: 'flex-start'
      }
    }, /*#__PURE__*/React.createElement(ColorProvider, {
      variant: "white",
      style: {
        paddingRight: '10px'
      }
    }, /*#__PURE__*/React.createElement(CircleText, {
      color: renderProperty(challengeItem, 'color'),
      size: "byte",
      width: "35px",
      bold: true
    }, renderProperty(challengeItem, 'rank'))), /*#__PURE__*/React.createElement(ColorProvider, {
      variant: "white"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "giga",
      bold: true
    }, renderProperty(challengeItem, 'title')), /*#__PURE__*/React.createElement(ColorProvider, {
      variant: "n550"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "giga"
    }, renderProperty(challengeItem, 'dates'))))), /*#__PURE__*/React.createElement(Col, {
      columns: "3.5"
    }, /*#__PURE__*/React.createElement(Spacing, null, /*#__PURE__*/React.createElement(ColorProvider, {
      variant: "white",
      style: {
        textAlign: 'right'
      }
    }, /*#__PURE__*/React.createElement(StatusBadge, {
      color: renderProperty(challengeItem, 'color'),
      size: "byte",
      bold: true
    }, renderProperty(challengeItem, 'status')), /*#__PURE__*/React.createElement(Text, {
      size: "giga"
    }, renderProperty(challengeItem, 'rankRatio')))))), index < Object.keys(myChallenges).length && /*#__PURE__*/React.createElement(Divider$1, null));
  })), /*#__PURE__*/React.createElement(Spacing, {
    sizeBottom: "mega"
  }, isCurrentlyPlayoffs && /*#__PURE__*/React.createElement(MiniBanner, {
    variant: "playoffs"
  }), !isCurrentlyPlayoffs && /*#__PURE__*/React.createElement(MiniBanner, {
    variant: "season"
  })), /*#__PURE__*/React.createElement(Spacing, {
    sizeBottom: "mega"
  }, !isCurrentlyPlayoffs && /*#__PURE__*/React.createElement(MiniBanner, {
    variant: "monthly"
  })), /*#__PURE__*/React.createElement(UpdateUserName, null)));
};

var _templateObject$1M, _templateObject2$1k, _templateObject3$12;
var fixTop$2 = fixTop;

var assetSet$c = function assetSet(filename) {
  return getAssetSet(useCdnImage, filename);
};

var containerBaseStyles$m = function containerBaseStyles(_ref) {
  var theme = _ref.theme,
      expanded = _ref.expanded;
  return css(_templateObject$1M || (_templateObject$1M = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  box-shadow: 0 1px 7px 0 ", ";\n  z-index: ", ";\n  ", ";\n  ", "\n"])), theme.colors.headerBg, theme.colors.shadow, theme.zIndex.header, fixTop$2(), expanded ? 'position: fixed; top: 0; bottom: 0; overflow: scroll;' : 'position: sticky;');
};

var Container$M = styled('header')(containerBaseStyles$m);

var streakContainerBaseStyles = function streakContainerBaseStyles() {
  return css(_templateObject2$1k || (_templateObject2$1k = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n"])));
};

var StreakContainer = styled('div')(streakContainerBaseStyles);

var prefixComponent = function prefixComponent(_ref2) {
  var level = _ref2.level,
      percentage = _ref2.percentage,
      onSelect = _ref2.onSelect;
  return /*#__PURE__*/React.createElement(StreakContainer, {
    onClick: onSelect
  }, /*#__PURE__*/React.createElement(HeatStreakGraph, {
    size: "bit",
    gradientId: "h" + level + "Chart",
    graphVariant: "h" + level,
    variant: "hot",
    percentage: percentage,
    text: level,
    showIcon: true
  }));
};

var TimsHeaderContainer = styled.div(_templateObject3$12 || (_templateObject3$12 = _taggedTemplateLiteralLoose(["\n  position: sticky;\n  top: 0;\n  z-index: 10;\n"])));

var Header$1 = function Header(_ref3) {
  var showClose = _ref3.showClose,
      showLogo = _ref3.showLogo,
      showPrefix = _ref3.showPrefix,
      disableHeatstreakClick = _ref3.disableHeatstreakClick,
      showHeatStreakPanel = _ref3.showHeatStreakPanel,
      heatStreakVariant = _ref3.heatStreakVariant,
      heatStreakPercentage = _ref3.heatStreakPercentage,
      showHeader = _ref3.showHeader,
      logoUrl = _ref3.logoUrl,
      menuLinks = _ref3.menuLinks,
      showNotificationBar = _ref3.showNotificationBar,
      notificationBarTitle = _ref3.notificationBarTitle,
      notificationBarText = _ref3.notificationBarText,
      handleNotificationBarCloseClick = _ref3.handleNotificationBarCloseClick,
      handleHeatStreakPanelClick = _ref3.handleHeatStreakPanelClick,
      handleHeatStreakPanelClickWithModal = _ref3.handleHeatStreakPanelClickWithModal,
      _handleLinkClick = _ref3.handleLinkClick,
      handleElementHeight = _ref3.handleElementHeight,
      env = _ref3.env,
      platform = _ref3.platform,
      picks = _ref3.picks;
  var headerRef = useRef(0);
  var componentHeight = useElementHeight(headerRef);
  var clickedType = analyticActionMap.clickedType,
      path = analyticActionMap.path,
      buttonType = analyticActionMap.buttonType,
      heatStreakPanelSelected = analyticActionMap.heatStreakPanelSelected;
  useEffect(function () {
    if (!componentHeight) return;
    handleElementHeight({
      header: componentHeight
    });
  }, [componentHeight]);
  useEffect(function () {
    if (showHeatStreakPanel) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      return function () {
        document.documentElement.style.overflow = 'initial';
        document.body.style.overflow = 'initial';
      };
    }
  }, [showHeatStreakPanel]);

  var handleHeatStreakIconClick = function handleHeatStreakIconClick() {
    var picked = picks.picked,
        picksSubmitted = picks.picksSubmitted,
        picksLocked = picks.picksLocked;
    var slotsPicked = Object.keys(picked).map(function (id) {
      return picked[id];
    }).filter(function (id) {
      return id;
    });
    var hasUnsubmittedPicks = slotsPicked.length > 0 && !picksSubmitted && !picksLocked;

    if (hasUnsubmittedPicks) {
      handleHeatStreakPanelClickWithModal();
      return;
    }

    if (!showHeatStreakPanel) {
      fireMessageEvent({
        platform: platform,
        env: env,
        title: clickedType,
        data: {
          path: path,
          element: buttonType,
          element_name: heatStreakPanelSelected
        }
      });
    }

    handleHeatStreakPanelClick();
  };

  return showHeader ? /*#__PURE__*/React.createElement(Container$M, {
    ref: headerRef,
    expanded: showHeatStreakPanel
  }, /*#__PURE__*/React.createElement(TimsHeaderContainer, null, /*#__PURE__*/React.createElement(TimsHeader, {
    showClose: showClose,
    showNav: !showHeatStreakPanel,
    routes: menuLinks,
    logoUrl: showLogo && assetSet$c([logoUrl]),
    hasNotificationAlert: showNotificationBar,
    notificationBarTitle: notificationBarTitle,
    notificationBarText: notificationBarText,
    handleLinkClick: function handleLinkClick(id) {
      return _handleLinkClick(id);
    },
    handleNotificationBarCloseClick: handleNotificationBarCloseClick,
    prefix: function prefix() {
      return showPrefix && prefixComponent({
        level: heatStreakVariant,
        percentage: heatStreakPercentage,
        onSelect: disableHeatstreakClick ? undefined : handleHeatStreakIconClick
      });
    }
  })), showHeatStreakPanel && /*#__PURE__*/React.createElement(HeatStreakPanel, null)) : null;
};

Header$1.propTypes = {
  showClose: propTypes.bool,
  showHeader: propTypes.bool,
  menuLinks: propTypes.array,
  showLogo: propTypes.bool,
  showPrefix: propTypes.bool,
  showHeatStreakPanel: propTypes.bool,
  logoUrl: propTypes.string,
  showNotificationBar: propTypes.bool,
  heatStreakVariant: propTypes.string,
  heatStreakPercentage: propTypes.number,
  notificationBarTitle: propTypes.string,
  notificationBarText: propTypes.string,
  handleHeatStreakPanelClick: propTypes.func,
  handleHeatStreakPanelClickWithModal: propTypes.func,
  handleLinkClick: propTypes.func,
  handleElementHeight: propTypes.func,
  handleNotificationBarCloseClick: propTypes.func,
  disableHeatstreakClick: propTypes.bool,
  picks: propTypes.object
};

var mapStateToProps$j = function mapStateToProps(state) {
  var config = state.config,
      strings = state.strings,
      routing = state.routing,
      onboarding = state.onboarding,
      ui = state.ui,
      heatStreak = state.heatStreak,
      picks = state.picks;
  var routeBase = config.routeBase,
      language = config.language,
      userId = config.userId,
      env = config.env,
      platform = config.platform;
  var allRouteIds = routing.allRouteIds,
      routeById = routing.routeById,
      currentRoute = routing.currentRoute;
  var attempts = onboarding.attempts,
      correctAnswer = onboarding.correctAnswer;
  var heatStreakPanelOpen = ui.heatStreakPanelOpen,
      hasFetchError = ui.hasFetchError,
      fetchErrorCount = ui.fetchErrorCount;
  var streak = heatStreak.streak,
      heatStreakPercentage = heatStreak.percentage;
  var _routeById$currentRou = routeById[currentRoute].displaySettings,
      showNavLinks = _routeById$currentRou.showNavLinks,
      showClose = _routeById$currentRou.showClose,
      showLogo = _routeById$currentRou.showLogo,
      showPrefix = _routeById$currentRou.showPrefix;
  var logoUrl = language === 'fr' ? 'hockeyChallengeLogoFr' : 'hockeyChallengeLogo';

  if (!showNavLinks) {
    return {
      showHeader: showClose,
      logoUrl: logoUrl,
      showClose: showClose,
      showLogo: showLogo,
      showPrefix: showPrefix,
      menuLinks: [],
      showNotificationBar: attempts > 0 && !correctAnswer,
      notificationBarTitle: strings['notifications/quiz/wrongAnswer/title'],
      notificationBarText: strings['notifications/quiz/wrongAnswer/text']
    };
  }

  var heatStreakVariant = streak.toString();
  var menuLinks = allRouteIds.map(function (id) {
    var route = routeById[id];
    return _extends({}, route, {
      path: "" + routeBase + route.path,
      search: "?timsLang=" + language + "&userId=" + userId + "&env=" + env,
      isDisabled: hasFetchError && fetchErrorCount < 3,
      label: strings["routes/" + route.id + "/label"] || route.label
    });
  }).filter(function (_ref4) {
    var hideInNav = _ref4.hideInNav;
    return !hideInNav;
  });
  var notificationBarSettings = {
    showNotificationBar: false,
    notificationBarTitle: '',
    notificationBarText: ''
  };
  return _extends({
    env: env,
    platform: platform,
    strings: strings,
    logoUrl: logoUrl,
    showClose: showClose,
    showLogo: showLogo,
    showPrefix: showPrefix,
    disableHeatstreakClick: hasFetchError,
    showHeader: showClose || !!menuLinks.length,
    showHeatStreakPanel: heatStreakPanelOpen,
    heatStreakVariant: heatStreakVariant,
    heatStreakPercentage: heatStreakPercentage,
    menuLinks: menuLinks,
    picks: picks
  }, notificationBarSettings);
};

var mapDispatchToProps$c = function mapDispatchToProps(dispatch) {
  return {
    handleElementHeight: function handleElementHeight(height) {
      return dispatch(setElementHeight(height));
    },
    handleNotificationBarCloseClick: function handleNotificationBarCloseClick() {
      return dispatch(setNotificationBarToClosed());
    },
    handleHeatStreakPanelClick: function handleHeatStreakPanelClick() {
      return dispatch(setHeatStreakPanelToOpen());
    },
    handleHeatStreakPanelClickWithModal: function handleHeatStreakPanelClickWithModal() {
      dispatch(setPendingNavigation('heatstreak'));
      dispatch(setIncompletePicksModalToOpen());
    },
    handleLinkClick: function handleLinkClick(id) {
      return dispatch(setMenuLinkClicked(id));
    }
  };
};

var Header$2 = connect(mapStateToProps$j, mapDispatchToProps$c)(Header$1);

var _excluded$v = ["id"];

var getPage = function getPage(id) {
  var Component = getPageById(id);
  return /*#__PURE__*/React.createElement(Component, null);
};

var Content = function Content(_ref) {
  var allRoutes = _ref.allRoutes,
      defaultPage = _ref.defaultPage,
      quizDisabled = _ref.quizDisabled,
      routeFilter = _ref.routeFilter;
  return /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    key: defaultPage.id,
    path: "/",
    pageId: defaultPage.id,
    element: getPage(defaultPage.id),
    isHome: true,
    end: true
  }), allRoutes.filter(routeFilter).map(function (_ref2) {
    var id = _ref2.id,
        routeProps = _objectWithoutPropertiesLoose(_ref2, _excluded$v);

    return /*#__PURE__*/React.createElement(Route, _extends({
      key: id,
      pageId: id,
      element: getPage(id),
      isAuthenticated: quizDisabled
    }, routeProps));
  }));
};

Content.propTypes = {
  allRoutes: propTypes.array,
  defaultPage: propTypes.object,
  quizDisabled: propTypes.bool,
  routeFilter: propTypes.func
};

var _templateObject$1N, _templateObject2$1l, _templateObject3$13;
var LogoList = styled.div(_templateObject$1N || (_templateObject$1N = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n"])));
var LogoItem = styled.div(_templateObject2$1l || (_templateObject2$1l = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: ", ";\n  max-height: 40px;\n  width: calc(100% / 7);\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacings.kilo;
});
var flexCenter$i = flexCenter;
var Container$N = styled.div(_templateObject3$13 || (_templateObject3$13 = _taggedTemplateLiteralLoose(["\n  width: 35px;\n  height: 35px;\n  margin: ", " ", ";\n  ", ";\n  svg {\n    width: 35px;\n    height: 35px;\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacings.bit;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacings["byte"];
}, flexCenter$i());

var LogoImage = function LogoImage(_ref4) {
  var src = _ref4.src,
      alt = _ref4.alt;
  return /*#__PURE__*/React.createElement(Container$N, null, /*#__PURE__*/React.createElement(Image, {
    src: src,
    alt: alt
  }));
};

var TeamLogos = function TeamLogos(_ref5) {
  var cdnUrl = _ref5.cdnUrl,
      logos = _ref5.logos;
  return /*#__PURE__*/React.createElement(LogoList, null, Object.values(logos).map(function (_ref6) {
    var filename = _ref6.filename,
        name = _ref6.name;
    return /*#__PURE__*/React.createElement(LogoItem, {
      key: name
    }, /*#__PURE__*/React.createElement(LogoImage, {
      src: "" + cdnUrl + filename,
      alt: name
    }));
  }));
};

TeamLogos.propTypes = {
  cdnUrl: propTypes.string,
  logos: propTypes.object
};
TeamLogos.defaultProps = {
  logos: {
    anaheim: {
      filename: 'anahiemducks2024.svg',
      name: 'Anaheim'
    },
    boston: {
      filename: 'boston_2025.svg',
      name: 'Boston'
    },
    buffalo: {
      filename: 'buffalo.svg',
      name: 'Buffalo'
    },
    calgary: {
      filename: 'calgary.svg',
      name: 'Calgary'
    },
    carolina: {
      filename: 'carolina.svg',
      name: 'Carolina'
    },
    chicago: {
      filename: 'chicago.svg',
      name: 'Chicago'
    },
    colorado: {
      filename: 'colorado.svg',
      name: 'Colorado'
    },
    columbus: {
      filename: 'columbus.svg',
      name: 'Columbus'
    },
    dallas: {
      filename: 'dallas.svg',
      name: 'Dallas'
    },
    detroit: {
      filename: 'detroit.svg',
      name: 'Detroit'
    },
    edmonton: {
      filename: 'edmonton.svg',
      name: 'Edmonton'
    },
    florida: {
      filename: 'florida.svg',
      name: 'Florida'
    },
    losAngeles: {
      filename: 'losangeleskings2024.svg',
      name: 'Los Angeles'
    },
    minnesota: {
      filename: 'minnesota.svg',
      name: 'Minnesota'
    },
    montreal: {
      filename: 'montreal.svg',
      name: 'Montreal'
    },
    nashville: {
      filename: 'nashville.svg',
      name: 'Nashville'
    },
    newJersey: {
      filename: 'newjersey.svg',
      name: 'New Jersey'
    },
    newYorkIslanders: {
      filename: 'ny_islanders.svg',
      name: 'NY Islanders'
    },
    newYorkRangers: {
      filename: 'ny_rangers.svg',
      name: 'NY Rangers'
    },
    ottawa: {
      filename: 'ottawa.svg',
      name: 'Ottawa'
    },
    philadelphia: {
      filename: 'philadelphia.svg',
      name: 'Philadelphia'
    },
    pittsburgh: {
      filename: 'pittsburghpenguins2024.svg',
      name: 'Pittsburgh'
    },
    sanJose: {
      filename: 'sanjose.svg',
      name: 'San Jose'
    },
    seattle: {
      filename: 'seattle.svg',
      name: 'Seattle'
    },
    stLouis: {
      filename: 'stlouis.svg',
      name: 'St Louis'
    },
    tampaBay: {
      filename: 'tampabay.svg',
      name: 'Tampa Bay'
    },
    toronto: {
      filename: 'toronto.svg',
      name: 'Toronto'
    },
    utah: {
      filename: 'utahhc_2025.svg',
      name: 'Utah'
    },
    vancouver: {
      filename: 'vancouver.svg',
      name: 'Vancouver'
    },
    vegas: {
      filename: 'vegas.svg',
      name: 'Vegas'
    },
    washington: {
      filename: 'washington.svg',
      name: 'Washington'
    },
    winnipeg: {
      filename: 'winnipeg.svg',
      name: 'Winnipeg'
    }
  }
};

var _templateObject$1O, _templateObject2$1m, _templateObject3$14, _templateObject4$R, _templateObject5$E;
var flexStack$6 = flexStack;
var Container$O = styled.div(_templateObject$1O || (_templateObject$1O = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  padding: ", ";\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.spacings.kilo;
}, flexStack$6());
var ImageList = styled.div(_templateObject2$1m || (_templateObject2$1m = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  margin: ", " 0;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacings.mega;
});
var ImageItem = styled.div(_templateObject3$14 || (_templateObject3$14 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin: 0 ", ";\n\n  img {\n    width: auto;\n    max-height: 35px;\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacings.mega;
});
var TextWrapper$6 = styled.div(_templateObject4$R || (_templateObject4$R = _taggedTemplateLiteralLoose(["\n  padding: ", " 0;\n  width: 100%;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.spacings.kilo;
});
var ClickHandler = styled.div(_templateObject5$E || (_templateObject5$E = _taggedTemplateLiteralLoose(["\n  pointer-events: none;\n  span {\n    text-decoration: underline;\n    cursor: pointer;\n    pointer-events: auto;\n  }\n"])));

var customStylesFooter$1 = function customStylesFooter(theme) {
  return "\n  a {\n    color: " + theme.colors.r500 + ";\n    text-decoration: underline;\n  }\n";
};

var Footer$1 = function Footer(_ref5) {
  var cdnUrl = _ref5.cdnUrl,
      sponsorLogos = _ref5.sponsorLogos,
      content = _ref5.content,
      link = _ref5.link,
      onLinkSelect = _ref5.onLinkSelect;
  var showSponsorLogos = sponsorLogos && !!sponsorLogos.length;
  return /*#__PURE__*/React.createElement(Container$O, null, showSponsorLogos && /*#__PURE__*/React.createElement(ImageList, null, sponsorLogos.map(function (_ref6) {
    var id = _ref6.id,
        src = _ref6.src,
        alt = _ref6.alt;
    return /*#__PURE__*/React.createElement(ImageItem, {
      key: id
    }, /*#__PURE__*/React.createElement(Image, {
      src: "" + cdnUrl + src,
      alt: alt
    }));
  })), content && /*#__PURE__*/React.createElement(TextWrapper$6, null, /*#__PURE__*/React.createElement(Spacing, {
    bottom: true
  }, /*#__PURE__*/React.createElement(TeamLogos, {
    cdnUrl: cdnUrl
  })), /*#__PURE__*/React.createElement(TextBlock, {
    styles: customStylesFooter$1,
    text: content,
    size: "kilo",
    light: true
  }), link && /*#__PURE__*/React.createElement(ClickHandler, {
    onClick: onLinkSelect
  }, /*#__PURE__*/React.createElement(TextBlock, {
    text: link,
    size: "kilo",
    light: true
  }))));
};

Footer$1.propTypes = {
  sponsorLogos: propTypes.array,
  content: propTypes.string,
  link: propTypes.string,
  onLinkSelect: propTypes.func
};
Footer$1.defaultProps = {
  sponsorLogos: [{
    id: 'nhl-logo',
    src: 'NHL.png',
    alt: 'NHL Logo'
  }, {
    id: 'tims-logo',
    src: 'TimLogo2024.svg',
    alt: 'Tim Hortons Logo'
  }, {
    id: 'nhlpa-logo',
    src: 'NHLPA.png',
    alt: 'NHLPA Logo'
  }],
  content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n            Mauris malesuada porta dapibus. Ut ac risus dui. Donec id\n            tellus sit amet felis vestibulum pulvinar. Sed suscipit,\n            augue a mattis maximus, enim magna tempus nulla, ac sagittis\n            magna mauris sed felis. Suspendisse potenti. Fusce tincidunt\n            velit eleifend tincidunt faucibus. Etiam non placerat arcu.",
  onLinkSelect: function onLinkSelect() {
    return console.log('Clicked!');
  }
};

var Footer$2 = function Footer(_ref) {
  var termsText = _ref.termsText;
  return /*#__PURE__*/React.createElement(Footer$1, {
    cdnUrl: useCdnUrl(),
    content: termsText
  });
};

Footer$2.propTypes = {
  termsText: propTypes.string
};

var mapStateToProps$k = function mapStateToProps(state) {
  var leaderboard = state.leaderboard,
      strings = state.strings;
  var currentChallenge = leaderboard.currentChallenge;
  return {
    termsText: strings && currentChallenge && strings['global/legalText']
  };
};

var Footer$3 = connect(mapStateToProps$k)(Footer$2);

var _excluded$w = ["showFooter", "crashError"];

var CoreLayout = function CoreLayout(_ref) {
  var showFooter = _ref.showFooter,
      crashError = _ref.crashError,
      props = _objectWithoutPropertiesLoose(_ref, _excluded$w);

  return /*#__PURE__*/React.createElement(Layout, null, crashError && /*#__PURE__*/React.createElement(Modal$1, null), /*#__PURE__*/React.createElement(Header$2, null), /*#__PURE__*/React.createElement(Layout.Body, null, /*#__PURE__*/React.createElement(Layout.Wrapper, null, /*#__PURE__*/React.createElement(Content, props))), showFooter && /*#__PURE__*/React.createElement(Footer$3, null));
};

CoreLayout.propTypes = {
  showFooter: propTypes.bool
};

var mapStateToProps$l = function mapStateToProps(state) {
  var config = state.config,
      routing = state.routing,
      onboarding = state.onboarding,
      ui = state.ui,
      picks = state.picks,
      offers = state.offers,
      reminders = state.reminders;
  var isActive = reminders.isActive,
      reminderHasUpdated = reminders.reminderHasUpdated;
  var routeBase = config.routeBase;
  var isFetching = ui.isFetching,
      heatStreakPanelOpen = ui.heatStreakPanelOpen,
      hasFetchError = ui.hasFetchError,
      fetchErrorCount = ui.fetchErrorCount,
      crashError = ui.crashError;
  var onboardingStep = onboarding.onboardingStep,
      initialStep = onboarding.initialStep,
      correctAnswer = onboarding.correctAnswer,
      selectedAnswer = onboarding.selectedAnswer,
      quizAttempts = onboarding.quizAttempts;
  var allRouteIds = routing.allRouteIds,
      routeById = routing.routeById,
      currentRoute = routing.currentRoute;
  var randomPicksSelected = picks.randomPicksSelected,
      playerPicks = picks.picked,
      picksSubmitted = picks.picksSubmitted;
  var isOffersClicked = offers.isClicked;
  var displaySettings = routeById[currentRoute].displaySettings;
  var initialPage = hasFetchError && fetchErrorCount < 3 || initialStep >= 3 || onboardingStep >= 4 ? 1 : 0;
  var allRoutes = allRouteIds.map(function (id) {
    var route = routeById[id];
    return _extends({}, route, {
      pageId: id
    });
  });
  var quizDisabled = !!initialPage;

  var routeFilter = function routeFilter(_ref2) {
    var id = _ref2.id;
    return !quizDisabled ? id !== 'onboarding' : id !== 'onboarding' && id !== 'playNow';
  };

  return _extends({}, displaySettings, {
    allRoutes: allRoutes,
    routeBase: routeBase,
    routeFilter: routeFilter,
    defaultPage: allRoutes[initialPage],
    quizDisabled: quizDisabled,
    config: config,
    onboarding: onboarding,
    isFetching: isFetching,
    heatStreakPanelOpen: heatStreakPanelOpen,
    currentRoute: currentRoute,
    correctAnswer: correctAnswer,
    selectedAnswer: selectedAnswer,
    quizAttempts: quizAttempts,
    randomPicksSelected: randomPicksSelected,
    playerPicks: playerPicks,
    isOffersClicked: isOffersClicked,
    picksSubmitted: picksSubmitted,
    isActive: isActive,
    reminderHasUpdated: reminderHasUpdated,
    crashError: crashError
  });
};

var Layout$1 = connect(mapStateToProps$l)(withTracking(CoreLayout));

var _templateObject$1P, _templateObject2$1n, _templateObject3$15, _templateObject4$S, _templateObject5$F, _templateObject6$x, _templateObject7$p, _templateObject8$k, _templateObject9$d, _templateObject10$9;
var GetNewAppContainer = styled.div(_templateObject$1P || (_templateObject$1P = _taggedTemplateLiteralLoose(["\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  background-color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.darkBg;
});
var HeaderContainer = styled.div(_templateObject2$1n || (_templateObject2$1n = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var HeaderLogoContainer = styled.div(_templateObject3$15 || (_templateObject3$15 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-left: 31px;\n"])));
var Header1 = styled.h1(_templateObject4$S || (_templateObject4$S = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  line-height: 35px;\n  font-weight: ", ";\n  color: white;\n  margin: unset;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.subHeadings.tera.fontSize;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeight.bold;
});
var Header2 = styled.h1(_templateObject5$F || (_templateObject5$F = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  line-height: 35px;\n  font-weight: ", ";\n  color: white;\n  margin: unset;\n  margin-left: 31px;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.subHeadings.tera.fontSize;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeight.bold;
});
var TimsLogo = styled.img(_templateObject6$x || (_templateObject6$x = _taggedTemplateLiteralLoose(["\n  height: 30px;\n  max-width: 100%;\n  object-fit: contain;\n  margin-left: ", ";\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacings["byte"];
});
var Description$1 = styled(Text)(_templateObject7$p || (_templateObject7$p = _taggedTemplateLiteralLoose(["\n  color: white;\n  text-align: center;\n  font-size: ", ";\n  line-height: 18px;\n  margin: 30px 60px 0px 60px;\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.text.tera.fontSize;
});
var StoreLogoContainer = styled.div(_templateObject8$k || (_templateObject8$k = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin-top: 49px;\n"])));
var StoreLogo = styled.img(_templateObject9$d || (_templateObject9$d = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  max-width: 100%;\n  object-fit: contain;\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.spacings.exa;
});
var CloseContainer$1 = styled.div(_templateObject10$9 || (_templateObject10$9 = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: 20px;\n  left: 20px;\n  z-index: 1000;\n"])));

var GetNewApp = function GetNewApp() {
  var _useSelector = useSelector(function (state) {
    return state;
  }),
      strings = _useSelector.strings;

  var cdnUrl = useCdnUrl();
  var timsLogoSrc = "" + cdnUrl + strings['getNewApp/timsLogo'];
  var googleStoreLogoSrc = "" + cdnUrl + strings['getNewApp/googleLogo'];
  var appleStoreLogoSrc = "" + cdnUrl + strings['getNewApp/appleLogo'];
  var header1 = strings['getNewApp/header1'];
  var header2 = strings['getNewApp/header2'];
  var text = strings['getNewApp/text'];
  var appleStoreLink = strings['getNewApp/appleLink'];
  var googleStoreLink = strings['getNewApp/googleLink'];
  return /*#__PURE__*/React.createElement(GetNewAppContainer, null, /*#__PURE__*/React.createElement(CloseContainer$1, null, /*#__PURE__*/React.createElement(CloseApp, {
    href: "timhortons:///"
  })), /*#__PURE__*/React.createElement(HeaderContainer, null, /*#__PURE__*/React.createElement(HeaderLogoContainer, null, /*#__PURE__*/React.createElement(Header1, null, header1), /*#__PURE__*/React.createElement(TimsLogo, {
    src: timsLogoSrc
  })), /*#__PURE__*/React.createElement(Header2, null, header2)), /*#__PURE__*/React.createElement(Description$1, null, text), /*#__PURE__*/React.createElement(StoreLogoContainer, null, /*#__PURE__*/React.createElement("a", {
    href: appleStoreLink,
    target: "_parent",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(StoreLogo, {
    src: appleStoreLogoSrc
  })), /*#__PURE__*/React.createElement("a", {
    href: googleStoreLink,
    target: "_parent",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(StoreLogo, {
    style: {
      marginLeft: '16px'
    },
    src: googleStoreLogoSrc
  }))));
};

var App = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(App, _PureComponent);

  function App() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;
    _this.scrollTimeout = 100;

    _this.componentDidMount = function () {
      var _this$props = _this.props,
          config = _this$props.config,
          handleSetCurrentLanguage = _this$props.handleSetCurrentLanguage,
          hasFetchError = _this$props.hasFetchError,
          handleBrowserIsActive = _this$props.handleBrowserIsActive;
      window.addEventListener('scroll', throttle(_this.handlePageScroll, _this.scrollTimeout));
      document.addEventListener('visibilitychange', handleVisibilityChange, false);
      window.addEventListener('message', _this.handleMessage);

      function handleVisibilityChange() {
        if (document.visibilityState === 'hidden') {
          handleBrowserIsActive(false);
        } else {
          handleBrowserIsActive(true);
        }
      }

      if (hasFetchError) {
        return null;
      }

      handleSetCurrentLanguage(config.language);

      if (!config.currentSession) {
        fireMessageEvent({
          type: 'AUTH_FAILURE',
          platform: _this.props.platform,
          env: _this.props.env,
          title: 'fireMessageEvent',
          data: {}
        });
      }
    };

    _this.componentWillUnmount = function () {
      window.removeEventListener('scroll', _this.handlePageScroll);
      window.removeEventListener('message', _this.handleMessage);
    };

    _this.handleMessage = function (evt) {
      var data = evt.data;
      var dObj;

      try {
        if (data && typeof data === 'string') {
          dObj = JSON.parse(data);
        }

        switch (dObj.type) {
          case 'AUTH_REFRESH':
            if (_this.props.fetchErrorCount < 3) {
              batch(function () {
                _this.props.handleIncrementFetchErrorCount(_this.props.fetchErrorCount + 1);

                _this.props.handleSessionIsCurrent(dObj.message);

                _this.props.handleHasFetchError();
              });
            }

            break;

          default:
            break;
        }
      } catch (err) {}
    };

    _this.handlePageScroll = function () {
      var _this$props2 = _this.props,
          isFocused = _this$props2.isFocused,
          scrollPositionForPicks = _this$props2.scrollPositionForPicks,
          handleSetElementFocused = _this$props2.handleSetElementFocused;
      var scrollDelta = Math.abs(Math.floor(window.pageYOffset) - scrollPositionForPicks);
      var scrollAtPicks = Math.floor(window.pageYOffset) === scrollPositionForPicks || scrollDelta >= 0 && scrollDelta <= 5;

      if (scrollAtPicks) {
        handleSetElementFocused({
          picks: true
        });
      } else if (isFocused.picks) {
        handleSetElementFocused({
          picks: false
        });
      }
    };

    _this.componentDidUpdate = function (prevProps) {
      try {
        var _this$props3 = _this.props,
            config = _this$props3.config,
            handleFetchUserData = _this$props3.handleFetchUserData,
            handlefetchedConfig = _this$props3.handlefetchedConfig,
            handleFetchQuizData = _this$props3.handleFetchQuizData,
            handleFetchNotificationStatus = _this$props3.handleFetchNotificationStatus,
            handleSetIsFetching = _this$props3.handleSetIsFetching,
            handleSetIsNotFetching = _this$props3.handleSetIsNotFetching,
            handleFetchHistoryData = _this$props3.handleFetchHistoryData,
            handleFetchUserStats = _this$props3.handleFetchUserStats,
            handleFetchPlayerData = _this$props3.handleFetchPlayerData,
            handleFetchLeaderboardData = _this$props3.handleFetchLeaderboardData,
            handleFetchIsCurrentlyPlayoffs = _this$props3.handleFetchIsCurrentlyPlayoffs,
            handleFetchIsCurrentlySeason = _this$props3.handleFetchIsCurrentlySeason,
            handlefetchLocalLeaderboardData = _this$props3.handlefetchLocalLeaderboardData,
            handleSetCurrentRoute = _this$props3.handleSetCurrentRoute,
            isOnboardingActive = _this$props3.isOnboardingActive,
            hasBadPlayerData = _this$props3.hasBadPlayerData,
            _browserIsActive = _this$props3.browserIsActive,
            menuLinkClicked = _this$props3.menuLinkClicked,
            _hasFetchError = _this$props3.hasFetchError,
            hasFetchedConfig = _this$props3.hasFetchedConfig,
            selectedBoard = _this$props3.selectedBoard,
            selectedChallenge = _this$props3.selectedChallenge,
            fetchErrorCount = _this$props3.fetchErrorCount,
            heatStreakPanelOpen = _this$props3.heatStreakPanelOpen;

        if (hasFetchedConfig && _hasFetchError && fetchErrorCount < 3) {
          fireMessageEvent({
            type: 'AUTH_FAILURE',
            title: 'fireMessageEvent',
            data: {}
          });
        }

        return Promise.resolve(function () {
          if (config.currentSession) {
            var _temp8 = function _temp8() {
              function _temp5() {
                function _temp3() {
                  var _temp = function () {
                    if (prevProps.hasBadPlayerData !== hasBadPlayerData || prevProps.isOnboardingActive && !isOnboardingActive || prevProps.hasFetchError !== _hasFetchError && !_hasFetchError && !heatStreakPanelOpen) {
                      handleSetCurrentRoute(pathMap(config.routeBase)[window.location.pathname.replace(/\/$/, '')]);
                      handleSetIsFetching();
                      return Promise.resolve(Promise.all([handleFetchHistoryData(), handleFetchUserStats(), handleFetchPlayerData(), handleFetchLeaderboardData(selectedBoard, selectedChallenge, season), handleFetchIsCurrentlySeason(), handleFetchIsCurrentlyPlayoffs()])).then(function () {
                        handleSetIsNotFetching();
                      });
                    }
                  }();

                  if (_temp && _temp.then) return _temp.then(function () {});
                }

                var _temp2 = function () {
                  if (prevProps.menuLinkClicked !== menuLinkClicked) {
                    handleSetCurrentRoute(pathMap(config.routeBase)[window.location.pathname.replace(/\/$/, '')]);
                    return Promise.resolve(Promise.all([handleFetchHistoryData(), handleFetchUserStats(), handleFetchPlayerData()])).then(function () {});
                  }
                }();

                return _temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2);
              }

              if (isOnboardingActive && prevProps.currentRoute === 'onboarding') {
                return null;
              }

              if (prevProps.menuLinkClicked !== menuLinkClicked) {
                document.getElementById('thLayout').scrollTo(0, 0);
              }

              var seasonEnded = isDateAfter(SEASON_END_DATE);
              var season = selectedBoard === 'monthly' && seasonEnded ? SEASON_CODE : null;

              var _temp4 = function () {
                if (!isOnboardingActive && _browserIsActive && _browserIsActive !== prevProps.browserIsActive) {
                  handleSetCurrentRoute(pathMap(config.routeBase)[window.location.pathname.replace(/\/$/, '')]);
                  var challenge = selectedBoard === 'monthly' ? selectedChallenge : null;
                  return Promise.resolve(Promise.all([handleFetchHistoryData(), handleFetchUserStats(), handleFetchPlayerData(), handleFetchLeaderboardData(selectedBoard, challenge, season), handlefetchLocalLeaderboardData(selectedBoard, true, challenge, season)])).then(function () {});
                }
              }();

              return _temp4 && _temp4.then ? _temp4.then(_temp5) : _temp5(_temp4);
            };

            var _temp9 = function () {
              if (config.userId && config.currentSession && !hasFetchedConfig) {
                handlefetchedConfig();
                return Promise.resolve(Promise.all([handleFetchQuizData(), handleFetchUserData(), handleFetchNotificationStatus()])).then(function () {
                  handleSetIsNotFetching();
                });
              }
            }();

            return _temp9 && _temp9.then ? _temp9.then(_temp8) : _temp8(_temp9);
          }
        }());
      } catch (e) {
        return Promise.reject(e);
      }
    };

    _this.render = function () {
      var _this$props4 = _this.props,
          theme = _this$props4.theme,
          config = _this$props4.config,
          isFetching = _this$props4.isFetching,
          dfpNetworkId = _this$props4.dfpNetworkId;
      var platform = config.platform,
          env = config.env;
      return /*#__PURE__*/React.createElement(ThemeProvider, {
        theme: theme
      }, /*#__PURE__*/React.createElement(DFPSlotsProvider, {
        "data-testid": "google-ad-manager-provider",
        dfpNetworkId: dfpNetworkId || '',
        lazyLoad: true,
        personalizedAds: false,
        collapseEmptyDivs: true
      }, /*#__PURE__*/React.createElement(ConfigProvider, {
        config: config
      }, /*#__PURE__*/React.createElement(BaseStyles, null), isFetching ? /*#__PURE__*/React.createElement(Loader$1, {
        isFixed: true
      }) : platform === 'web' && env !== 'dev' ? /*#__PURE__*/React.createElement(GetNewApp, null) : /*#__PURE__*/React.createElement(Layout$1, null))));
    };

    return _this;
  }

  return App;
}(PureComponent);

App.propTypes = {
  isFetching: propTypes.number,
  theme: propTypes.object.isRequired,
  config: propTypes.object.isRequired,
  isFocused: propTypes.object,
  scrollPositionForPicks: propTypes.number,
  hasFetchError: propTypes.bool,
  hasBadPlayerData: propTypes.bool,
  handleSetCurrentLanguage: propTypes.func.isRequired,
  handleFetchUserData: propTypes.func.isRequired,
  handleFetchQuizData: propTypes.func.isRequired,
  handleSetIsFetching: propTypes.func,
  handleSetIsNotFetching: propTypes.func,
  handleFetchPlayerData: propTypes.func,
  handleFetchHistoryData: propTypes.func,
  handleFetchUserStats: propTypes.func,
  handleFetchLeaderboardData: propTypes.func,
  handleFetchIsCurrentlySeason: propTypes.func,
  handleFetchIsCurrentlyPlayoffs: propTypes.func,
  handlefetchLocalLeaderboardData: propTypes.func,
  handleSetCurrentRoute: propTypes.func,
  handleSetElementFocused: propTypes.func,
  handleFetchNotificationStatus: propTypes.func,
  currentRoute: propTypes.string,
  token: propTypes.string,
  handleCurrentRoute: propTypes.string,
  isOnboardingActive: propTypes.bool,
  dfpNetworkId: propTypes.string,
  handleSessionIsCurrent: propTypes.func,
  heatStreakPanelOpen: propTypes.bool
};

var mapStateToProps$m = function mapStateToProps(state) {
  var config = state.config,
      ui = state.ui,
      routing = state.routing,
      onboarding = state.onboarding,
      picks = state.picks,
      leaderboard = state.leaderboard;
  var initialStep = onboarding.initialStep,
      onboardingStep = onboarding.onboardingStep;
  var menuLinkClicked = routing.menuLinkClicked;
  var fetchError = picks.fetchError;
  var isFetching = ui.isFetching,
      hasFetchError = ui.hasFetchError,
      isScrolling = ui.isScrolling,
      notificationBarOpen = ui.notificationBarOpen,
      componentSize = ui.componentSize,
      isFocused = ui.isFocused,
      browserIsActive = ui.browserIsActive,
      fetchErrorCount = ui.fetchErrorCount,
      heatStreakPanelOpen = ui.heatStreakPanelOpen;
  var platform = config.platform,
      hasFetchedConfig = config.hasFetchedConfig,
      env = config.env;
  var picksScrollPosition = componentSize.picksScrollPosition;
  var withNotification = picksScrollPosition.withNotification,
      withoutNotification = picksScrollPosition.withoutNotification;
  var selectedChallenge = leaderboard.selectedChallenge,
      selectedBoard = leaderboard.selectedBoard,
      error = leaderboard.error;
  var scrollPositionForPicks = notificationBarOpen ? withNotification : withoutNotification;
  return {
    isFetching: isFetching,
    hasFetchError: hasFetchError,
    isScrolling: isScrolling,
    config: config,
    menuLinkClicked: menuLinkClicked,
    isOnboardingActive: !(hasFetchError || initialStep >= 3 || onboardingStep >= 4),
    hasBadPlayerData: !!fetchError || error,
    scrollPositionForPicks: scrollPositionForPicks,
    isFocused: isFocused,
    browserIsActive: browserIsActive,
    selectedChallenge: selectedChallenge,
    platform: platform,
    env: env,
    hasFetchedConfig: hasFetchedConfig,
    selectedBoard: selectedBoard,
    fetchErrorCount: fetchErrorCount,
    heatStreakPanelOpen: heatStreakPanelOpen
  };
};

var mapDispatchToProps$d = function mapDispatchToProps(dispatch) {
  return {
    handleFetchUserData: function handleFetchUserData() {
      return dispatch(fetchUserData());
    },
    handleFetchQuizData: function handleFetchQuizData() {
      return dispatch(fetchQuizData());
    },
    handlefetchedConfig: function handlefetchedConfig() {
      return dispatch(fetchedConfig());
    },
    handleSetIsFetching: function handleSetIsFetching() {
      return dispatch(setIsFetching());
    },
    handleSetIsNotFetching: function handleSetIsNotFetching() {
      return dispatch(setIsNotFetching());
    },
    handleSetCurrentLanguage: function handleSetCurrentLanguage(language) {
      return dispatch(setLanguage(language));
    },
    handleSetCurrentRoute: function handleSetCurrentRoute(id) {
      return dispatch(setCurrentRoute(id));
    },
    handleFetchHistoryData: function handleFetchHistoryData() {
      return dispatch(fetchHistoryData());
    },
    handleFetchUserStats: function handleFetchUserStats() {
      return dispatch(fetchUserStats());
    },
    handleFetchPlayerData: function handleFetchPlayerData() {
      return dispatch(fetchPlayerData());
    },
    handleFetchLeaderboardData: function handleFetchLeaderboardData(board, challengeNumber, season) {
      return dispatch(fetchLeaderboardData(board, challengeNumber, season));
    },
    handleFetchIsCurrentlySeason: function handleFetchIsCurrentlySeason() {
      return dispatch(fetchIsCurrentlySeason());
    },
    handleFetchIsCurrentlyPlayoffs: function handleFetchIsCurrentlyPlayoffs() {
      return dispatch(fetchIsCurrentlyPlayoffs());
    },
    handlefetchLocalLeaderboardData: function handlefetchLocalLeaderboardData(board, isLocal, challengeNumber) {
      return dispatch(fetchLocalLeaderboardData(board, isLocal, challengeNumber));
    },
    handleSetElementFocused: function handleSetElementFocused(element) {
      return dispatch(setElementFocused(element));
    },
    handleFetchNotificationStatus: function handleFetchNotificationStatus() {
      return dispatch(fetchNotificationStatus());
    },
    handleBrowserIsActive: function handleBrowserIsActive(isActive) {
      return dispatch(browserIsActive$1(isActive));
    },
    handleSessionIsCurrent: function handleSessionIsCurrent(jwt) {
      return dispatch(sessionIsCurrent(jwt));
    },
    handleHasFetchError: function handleHasFetchError() {
      return dispatch(hasFetchError$1());
    },
    handleIncrementFetchErrorCount: function handleIncrementFetchErrorCount(value) {
      return dispatch(incrementFetchErrorCount(value));
    }
  };
};

var App$1 = connect(mapStateToProps$m, mapDispatchToProps$d)(App);

var Root = function Root(_ref) {
  var store = _ref.store,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(App$1, {
    theme: theme
  }));
};

Root.propTypes = {
  theme: propTypes.object.isRequired,
  store: propTypes.object.isRequired
};

var THHockeyChallenge = function THHockeyChallenge() {
  var urlParams = new URLSearchParams(window.location.search);
  var platform = urlParams.get('isNative') === 'true' ? 'mobile' : 'web';
  var env = urlParams.get('env') ? urlParams.get('env') : 'staging';
  var userId = urlParams.get('userId');
  var language = urlParams.get('timsLang') ? urlParams.get('timsLang') : 'en';
  var routeBase = '';
  var apiUrl;

  switch (env) {
    case 'dev':
      apiUrl = 'https://th.campaigns.dev.rbictg.com/v1';
      break;

    case 'staging':
      apiUrl = 'https://th.campaigns.staging.rbictg.com/v1';
      break;

    default:
      apiUrl = 'https://th.campaigns.rbictg.com/v1';
      break;
  }

  var store = React.useMemo(function () {
    return configureStore({
      config: {
        fetchErrorCount: 0,
        routeBase: routeBase,
        userId: userId,
        currentSession: null,
        language: language,
        apiUrl: apiUrl,
        env: env,
        platform: platform
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement(Root, {
    store: store,
    theme: Theme.challenge20
  });
};

export default THHockeyChallenge;
//# sourceMappingURL=index.modern.js.map
